import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Any: string | number | undefined;
  Base64: any;
  Date: string;
  DateTime: string;
  JSONString: any;
  UUID: string;
  Upload: File | false | undefined;
};

export type AccountExportType = {
  __typename?: 'AccountExportType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  file?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type AccountFileFormInput = {
  file: Scalars['Upload'];
  id?: InputMaybe<Scalars['ID']>;
};

export type AccountFileType = {
  __typename?: 'AccountFileType';
  account: AccountType;
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  file: Scalars['String'];
  id: Scalars['UUID'];
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type AccountListOptionsInputType = {
  ordering?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  registrationStatus?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  user?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type AccountListType = {
  __typename?: 'AccountListType';
  count: Scalars['Int'];
  items: Array<AccountType>;
  page: Scalars['Int'];
};

export type AccountRegionType = {
  __typename?: 'AccountRegionType';
  accountSet: Array<AccountType>;
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  order: Scalars['Int'];
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type AccountRegistrationReviewType = {
  __typename?: 'AccountRegistrationReviewType';
  account: AccountType;
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  externalId: Scalars['String'];
  id: Scalars['UUID'];
  notes: Scalars['String'];
  status: AccountsAccountRegistrationReviewStatusChoices;
  statusDisplay: Scalars['String'];
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type AccountType = {
  __typename?: 'AccountType';
  contacts: Array<ContactType>;
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  externalId: Scalars['String'];
  extraLocation?: Maybe<Scalars['String']>;
  files: Array<AccountFileType>;
  id: Scalars['UUID'];
  lastRegistrationReview?: Maybe<AccountRegistrationReviewType>;
  location?: Maybe<LocationType>;
  name: Scalars['String'];
  opportunities: Array<Maybe<OpportunityType>>;
  owner?: Maybe<OrganizationType>;
  quotes: Array<Maybe<QuoteType>>;
  region?: Maybe<AccountRegionType>;
  registrationCanReview: Scalars['Boolean'];
  registrationReviews: Array<AccountRegistrationReviewType>;
  seeders: Array<SeederType>;
  taxId?: Maybe<Scalars['String']>;
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export const AccountsAccountRegistrationReviewStatusChoices = {
  Approved: 'APPROVED',
  Pending: 'PENDING',
  Rejected: 'REJECTED'
} as const;

export type AccountsAccountRegistrationReviewStatusChoices = typeof AccountsAccountRegistrationReviewStatusChoices[keyof typeof AccountsAccountRegistrationReviewStatusChoices];
export type AddOrderedProduct = {
  __typename?: 'AddOrderedProduct';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type AddProductsToOemOrganization = {
  __typename?: 'AddProductsToOemOrganization';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type AddStockToProductFormInput = {
  id?: InputMaybe<Scalars['ID']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stock: Scalars['Int'];
};

export type AddStockToProductMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stock: Scalars['Int'];
};

export type AddStockToProductMutationPayload = {
  __typename?: 'AddStockToProductMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  organizationGroupOemThrough?: Maybe<OrganizationGroupOemThroughType>;
};

export type AmountDatum = {
  __typename?: 'AmountDatum';
  amount: Scalars['Float'];
  count: Scalars['Int'];
  label: Scalars['String'];
  multiplier?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
};

export type AnalyticsFilters = {
  dateFrom: Scalars['String'];
  dateTo: Scalars['String'];
  organization: Scalars['String'];
  products?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  region: Scalars['String'];
};

export type ApproveWarrantyClaimRequestMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  notes?: InputMaybe<Scalars['String']>;
  productWarrantyClaim: Scalars['ID'];
};

export type ApproveWarrantyClaimRequestMutationPayload = {
  __typename?: 'ApproveWarrantyClaimRequestMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  productWarrantyClaimReview?: Maybe<ProductWarrantyClaimReviewType>;
};

export type AutomaticReviewRejectionRuleType = {
  __typename?: 'AutomaticReviewRejectionRuleType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  description: Scalars['String'];
  id: Scalars['UUID'];
  message: Scalars['String'];
  supplyOrderReview?: Maybe<SupplyOrderReviewType>;
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type BankInvoicePdfDisclaimerType = {
  __typename?: 'BankInvoicePDFDisclaimerType';
  adress: Scalars['String'];
  disclaimer: Scalars['String'];
  id: Scalars['ID'];
  legalName: Scalars['String'];
  startOfActivities: Scalars['String'];
  taxId: Scalars['String'];
  taxpayerType: Scalars['String'];
};

export type BankInvoicePdfType = {
  __typename?: 'BankInvoicePDFType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  file?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  paymentMethod?: Maybe<QuotedPaymentMethodType>;
  quote?: Maybe<QuoteType>;
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type BillingTypeType = {
  __typename?: 'BillingTypeType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  order: Scalars['Int'];
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type ByStatusDatum = {
  __typename?: 'ByStatusDatum';
  count: Scalars['Int'];
  label: Scalars['String'];
};

export type CancelEcn = {
  __typename?: 'CancelEcn';
  ok?: Maybe<Scalars['Boolean']>;
};

export type CancelWarrantyClaimRequestMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  productWarrantyClaim: Scalars['ID'];
};

export type CancelWarrantyClaimRequestMutationPayload = {
  __typename?: 'CancelWarrantyClaimRequestMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  productWarrantyClaimReview?: Maybe<ProductWarrantyClaimReviewType>;
};

export type CategoriesYearlyForecasts = {
  __typename?: 'CategoriesYearlyForecasts';
  categoriesYearlyForecasts: Array<Maybe<CategoryYearlyForecastType>>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type CategoryYearlyForecastType = {
  __typename?: 'CategoryYearlyForecastType';
  category: ProductCategoryType;
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  id: Scalars['UUID'];
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
  value?: Maybe<Scalars['Int']>;
  year: Scalars['Int'];
};

export type CloseQuoteMutation = {
  __typename?: 'CloseQuoteMutation';
  status: Scalars['Boolean'];
};

export type CloseReasonType = {
  __typename?: 'CloseReasonType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  description: Scalars['String'];
  id: Scalars['UUID'];
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type ContactListOptionsInputType = {
  account?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  accountOwner?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  ordering?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  user?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type ContactListType = {
  __typename?: 'ContactListType';
  count: Scalars['Int'];
  items: Array<ContactType>;
  page: Scalars['Int'];
};

export type ContactType = {
  __typename?: 'ContactType';
  account: AccountType;
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  displayName: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  externalId: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['UUID'];
  isRemoved: Scalars['Boolean'];
  lastName: Scalars['String'];
  machineStartUps: Array<MachineStartUpType>;
  mobilePhone: Scalars['String'];
  opportunities: Array<OpportunityType>;
  phone: Scalars['String'];
  quotes: Array<QuoteType>;
  type: ContactTypeType;
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
  warrantyClaims: Array<ProductWarrantyClaimType>;
};

export type ContactTypeType = {
  __typename?: 'ContactTypeType';
  contactSet: Array<ContactType>;
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  order: Scalars['Int'];
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type ContentTypeType = {
  __typename?: 'ContentTypeType';
  appLabel: Scalars['String'];
  gefcodeliverSet: Array<GefcoDeliverType>;
  id: Scalars['ID'];
  model: Scalars['String'];
};

export type CreateAccountExportMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  file?: InputMaybe<Scalars['Upload']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type CreateAccountExportMutationPayload = {
  __typename?: 'CreateAccountExportMutationPayload';
  accountExport?: Maybe<AccountExportType>;
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type CreateAccountMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  extraLocation?: InputMaybe<Scalars['String']>;
  files?: InputMaybe<Array<AccountFileFormInput>>;
  id?: InputMaybe<Scalars['ID']>;
  lastRegistrationReview?: InputMaybe<Scalars['ID']>;
  location?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  owner: Scalars['ID'];
  region?: InputMaybe<Scalars['ID']>;
  taxId?: InputMaybe<Scalars['String']>;
};

export type CreateAccountMutationPayload = {
  __typename?: 'CreateAccountMutationPayload';
  account?: Maybe<AccountType>;
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type CreateBankInvoicePdf = {
  __typename?: 'CreateBankInvoicePdf';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  job?: Maybe<ExportJobType>;
};

export type CreateContactMutationInput = {
  account: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  isRemoved?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  mobilePhone?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  type: Scalars['ID'];
};

export type CreateContactMutationPayload = {
  __typename?: 'CreateContactMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  contact?: Maybe<ContactType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type CreateEcnListExport = {
  __typename?: 'CreateEcnListExport';
  job: ExportJobType;
};

export type CreateEcnMutationInput = {
  blueprints?: InputMaybe<Array<EcnBlueprintFormInput>>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  draftBlueprints?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  draftEcn?: InputMaybe<Scalars['UUID']>;
  effectiveDate?: InputMaybe<Scalars['Date']>;
  fyi?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  id?: InputMaybe<Scalars['ID']>;
  notes?: InputMaybe<Scalars['String']>;
  oems?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  parts: Array<EcnPartFormInput>;
  recipient?: InputMaybe<Scalars['String']>;
  seasonPriority: Scalars['String'];
  tasks?: InputMaybe<Array<EcnTaskFormInput>>;
  warrantyPriority?: InputMaybe<Scalars['Boolean']>;
};

export type CreateEcnMutationPayload = {
  __typename?: 'CreateEcnMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  ecn?: Maybe<EcnType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type CreateMachineStartUpMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  contact: Scalars['UUID'];
  dealerFactoryInvoice?: InputMaybe<Scalars['Upload']>;
  dealerFactoryNotes?: InputMaybe<Scalars['String']>;
  dealerFieldInvoice?: InputMaybe<Scalars['Upload']>;
  dealerFieldNotes?: InputMaybe<Scalars['String']>;
  dealerStartUpPrice: Scalars['Float'];
  estimatedDeliveryDate?: InputMaybe<Scalars['Date']>;
  expirationDate?: InputMaybe<Scalars['Date']>;
  factoryInspectionComment?: InputMaybe<Scalars['String']>;
  factoryPlaqueImage?: InputMaybe<Scalars['Upload']>;
  factoryProtocolImage?: InputMaybe<Scalars['Upload']>;
  factoryStep?: InputMaybe<Scalars['String']>;
  factoryTermsImage?: InputMaybe<Scalars['Upload']>;
  factoryWorkflowNumber?: InputMaybe<Scalars['String']>;
  fieldInspectionComment?: InputMaybe<Scalars['String']>;
  fieldPlaqueImage?: InputMaybe<Scalars['Upload']>;
  fieldProtocolImage?: InputMaybe<Scalars['Upload']>;
  fieldStep?: InputMaybe<Scalars['String']>;
  fieldTermsImage?: InputMaybe<Scalars['Upload']>;
  fieldWorkflowNumber?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  installationPrice: Scalars['Float'];
  isFieldStepPending?: InputMaybe<Scalars['Boolean']>;
  notificationDate?: InputMaybe<Scalars['Date']>;
  oemOrganization: Scalars['UUID'];
  organizationFactory?: InputMaybe<Scalars['UUID']>;
  organizationField?: InputMaybe<Scalars['UUID']>;
  pemRule?: InputMaybe<Scalars['UUID']>;
  productCategories?: InputMaybe<Array<ProductCategoryIdsFormInput>>;
  productionDateFrom?: InputMaybe<Scalars['Date']>;
  productionDateTo?: InputMaybe<Scalars['Date']>;
  racks?: InputMaybe<Scalars['Boolean']>;
  seederBrand: Scalars['UUID'];
  seederModel: Scalars['UUID'];
  seederRowCount: Scalars['Int'];
  seederSerialNumber?: InputMaybe<Scalars['String']>;
  seederYear: Scalars['Int'];
  startUpPrice?: InputMaybe<Scalars['Float']>;
  step: Scalars['String'];
  totalPriceMachine: Scalars['Float'];
  withPostFieldRevision?: InputMaybe<Scalars['Boolean']>;
};

export type CreateMachineStartUpMutationPayload = {
  __typename?: 'CreateMachineStartUpMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  machineStartUp?: Maybe<MachineStartUpType>;
};

export type CreateOemOrderPdf = {
  __typename?: 'CreateOemOrderPDF';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  job?: Maybe<ExportJobType>;
};

export type CreateOpportunityMutationInput = {
  channel: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  contact: Scalars['ID'];
  date: Scalars['Date'];
  id?: InputMaybe<Scalars['ID']>;
  notes?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<Scalars['String']>;
  reason: Scalars['ID'];
  situation: Scalars['ID'];
};

export type CreateOpportunityMutationPayload = {
  __typename?: 'CreateOpportunityMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  opportunity?: Maybe<OpportunityType>;
};

export type CreateOrderOemMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  notes?: InputMaybe<Scalars['String']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  organization: Scalars['UUID'];
  paymentMethod: Scalars['UUID'];
  products: Array<OrderOemProductFormInput>;
  targetDate?: InputMaybe<Scalars['Date']>;
};

export type CreateOrderOemMutationPayload = {
  __typename?: 'CreateOrderOEMMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  orderOEM?: Maybe<OrderOemType>;
};

export type CreateOrderedProductMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  commissionMultiplier: Scalars['Float'];
  enableDiscount?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  quantity: Scalars['Int'];
  quantityLeft: Scalars['Int'];
  quotedProduct: Scalars['UUID'];
};

export type CreateOrderedProductMutationPayload = {
  __typename?: 'CreateOrderedProductMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  orderedProduct?: Maybe<OrderedProductType>;
};

export type CreateProductWarrantyClaimExport = {
  __typename?: 'CreateProductWarrantyClaimExport';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  job?: Maybe<ExportJobType>;
};

export type CreateQuoteMutationInput = {
  additionalChargesDescription?: InputMaybe<Scalars['String']>;
  additionalChargesValue?: InputMaybe<Scalars['Float']>;
  billingType: Scalars['String'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  contact: Scalars['ID'];
  id?: InputMaybe<Scalars['ID']>;
  kitMultiplier?: InputMaybe<Scalars['ID']>;
  notes?: InputMaybe<Scalars['String']>;
  oemOrder?: InputMaybe<Scalars['Boolean']>;
  originalQuote?: InputMaybe<Scalars['ID']>;
  paymentMethods: Array<QuotedPaymentMethodFormInput>;
  products: Array<QuotedProductFormInput>;
  rowCount?: InputMaybe<Scalars['Int']>;
  seeder?: InputMaybe<Scalars['ID']>;
};

export type CreateQuoteMutationPayload = {
  __typename?: 'CreateQuoteMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  quote?: Maybe<QuoteType>;
};

export type CreateQuotePdf = {
  __typename?: 'CreateQuotePdf';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  job?: Maybe<ExportJobType>;
};

export type CreateSaleExport = {
  __typename?: 'CreateSaleExport';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  job?: Maybe<ExportJobType>;
};

export type CreateSaleMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  paymentMethod: Scalars['ID'];
  quote: Scalars['ID'];
};

export type CreateSaleMutationPayload = {
  __typename?: 'CreateSaleMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  sale?: Maybe<SaleType>;
};

export type CreateSeederExportMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  file?: InputMaybe<Scalars['Upload']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type CreateSeederExportMutationPayload = {
  __typename?: 'CreateSeederExportMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  seederExport?: Maybe<SeederExportType>;
};

export type CreateSeederMutationInput = {
  account: Scalars['ID'];
  brand: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  installedProductCategories?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  meterType: Scalars['String'];
  model?: InputMaybe<Scalars['ID']>;
  rowCount: Scalars['Int'];
  year: Scalars['Int'];
};

export type CreateSeederMutationPayload = {
  __typename?: 'CreateSeederMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  seeder?: Maybe<SeederType>;
};

export type CreateShipmentMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  exchangeRate: Scalars['Float'];
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  invoice?: InputMaybe<Scalars['Upload']>;
  onHoldDescription?: InputMaybe<Scalars['String']>;
  productsShipped: Array<ShipmentProductFormInput>;
  status?: InputMaybe<Scalars['String']>;
  supplyOrder: Scalars['UUID'];
};

export type CreateShipmentMutationPayload = {
  __typename?: 'CreateShipmentMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  shipment?: Maybe<ShipmentType>;
};

export type CreateShipmentOemMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  invoice?: InputMaybe<Scalars['Upload']>;
  orderOem: Scalars['UUID'];
  productsShipped: Array<ShipmentProductOemFormInput>;
  status?: InputMaybe<Scalars['String']>;
};

export type CreateShipmentOemMutationPayload = {
  __typename?: 'CreateShipmentOEMMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  shipmentOEM?: Maybe<ShipmentOemType>;
};

export type CreateShipmentProductWarrantyClaimMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type CreateShipmentProductWarrantyClaimMutationPayload = {
  __typename?: 'CreateShipmentProductWarrantyClaimMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  productWarrantyClaim?: Maybe<ProductWarrantyClaimType>;
};

export type CreateShipmentsMutation = {
  __typename?: 'CreateShipmentsMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  shipments: Array<Maybe<ShipmentType>>;
};

export type CreateShipmentsOemMutation = {
  __typename?: 'CreateShipmentsOEMMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  shipments: Array<Maybe<ShipmentOemType>>;
};

export type CreateSupplyOrderExport = {
  __typename?: 'CreateSupplyOrderExport';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  job?: Maybe<ExportJobType>;
};

export type CreateSupplyOrderMutationInput = {
  billingType?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  emailMessages?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  id?: InputMaybe<Scalars['ID']>;
  paymentMethod?: InputMaybe<Scalars['UUID']>;
  products: Array<OrderedProductFormInput>;
  quote: Scalars['UUID'];
  reviewStart?: InputMaybe<Scalars['DateTime']>;
  status: Scalars['String'];
  targetDate?: InputMaybe<Scalars['Date']>;
};

export type CreateSupplyOrderMutationPayload = {
  __typename?: 'CreateSupplyOrderMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  supplyOrder?: Maybe<SupplyOrderType>;
};

export type CreateSupplyOrderPdf = {
  __typename?: 'CreateSupplyOrderPDF';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  job?: Maybe<ExportJobType>;
};

export type CreateWarrantyClaimInspectionReviewMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  failureDescription?: InputMaybe<Scalars['String']>;
  files?: InputMaybe<Array<WarrantyClaimInspectionFileFormInput>>;
  id?: InputMaybe<Scalars['ID']>;
  inWarranty?: InputMaybe<Scalars['Boolean']>;
  inspected?: InputMaybe<Scalars['Boolean']>;
  inspectedDate?: InputMaybe<Scalars['DateTime']>;
  received?: InputMaybe<Scalars['Boolean']>;
  receivedDate?: InputMaybe<Scalars['DateTime']>;
  status: Scalars['String'];
  warrantyClaim: Scalars['ID'];
};

export type CreateWarrantyClaimInspectionReviewMutationPayload = {
  __typename?: 'CreateWarrantyClaimInspectionReviewMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  warrantyClaimInspectionReview?: Maybe<WarrantyClaimInspectionReviewType>;
};

export type CreateWarrantyClaimMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  contact: Scalars['ID'];
  deliveryDate: Scalars['Date'];
  description: Scalars['String'];
  externalId?: InputMaybe<Scalars['String']>;
  failureDate: Scalars['Date'];
  finalClient?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  images?: InputMaybe<Array<WarrantyClaimImageFormInput>>;
  lastReview?: InputMaybe<Scalars['ID']>;
  phone: Scalars['String'];
  product: Scalars['ID'];
  quantity: Scalars['Int'];
  seeder?: InputMaybe<Scalars['ID']>;
  seederKilometers: Scalars['Int'];
  serialNumber: Scalars['String'];
  videos?: InputMaybe<Array<WarrantyClaimVideoFormInput>>;
};

export type CreateWarrantyClaimMutationPayload = {
  __typename?: 'CreateWarrantyClaimMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  productWarrantyClaim?: Maybe<ProductWarrantyClaimType>;
};

export type CreateWarrantyClaimPdf = {
  __typename?: 'CreateWarrantyClaimPDF';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  job?: Maybe<ExportJobType>;
};

export type CustomerAssistantFormInput = {
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  phone: Scalars['String'];
};

export type CustomerAssistantType = {
  __typename?: 'CustomerAssistantType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  id: Scalars['UUID'];
  machineStartUp: MachineStartUpType;
  name: Scalars['String'];
  phone: Scalars['String'];
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type DateSeriesDatum = {
  __typename?: 'DateSeriesDatum';
  amount?: Maybe<Scalars['Float']>;
  count: Scalars['Int'];
  date: Scalars['Date'];
};

export type DefaultTaskType = {
  __typename?: 'DefaultTaskType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  description?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  ecnTypes?: Maybe<Array<EcnsDefaultTaskEcnTypesChoices>>;
  id: Scalars['UUID'];
  name: EcnsDefaultTaskNameChoices;
  roles: Array<EcnRoleType>;
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type DeleteAccountMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type DeleteAccountMutationPayload = {
  __typename?: 'DeleteAccountMutationPayload';
  account?: Maybe<AccountType>;
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type DeleteContactMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type DeleteContactMutationPayload = {
  __typename?: 'DeleteContactMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  contact?: Maybe<ContactType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type DeleteDraftEcnMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type DeleteDraftEcnMutationPayload = {
  __typename?: 'DeleteDraftEcnMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  draftEcn?: Maybe<DraftEcnType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type DeleteEcnFile = {
  __typename?: 'DeleteEcnFile';
  id: Scalars['UUID'];
  ok?: Maybe<Scalars['Boolean']>;
};

export type DeleteOpportunityMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type DeleteOpportunityMutationPayload = {
  __typename?: 'DeleteOpportunityMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  opportunity?: Maybe<OpportunityType>;
};

export type DeleteOrderOemMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type DeleteOrderOemMutationPayload = {
  __typename?: 'DeleteOrderOEMMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  orderOEM?: Maybe<OrderOemType>;
};

export type DeleteQuoteMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type DeleteQuoteMutationPayload = {
  __typename?: 'DeleteQuoteMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  quote?: Maybe<QuoteType>;
};

export type DeleteSeederMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type DeleteSeederMutationPayload = {
  __typename?: 'DeleteSeederMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  seeder?: Maybe<SeederType>;
};

export type DeleteShipmentMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type DeleteShipmentMutationPayload = {
  __typename?: 'DeleteShipmentMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  shipment?: Maybe<ShipmentType>;
};

export type DeleteShipmentOemMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type DeleteShipmentOemMutationPayload = {
  __typename?: 'DeleteShipmentOEMMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  shipmentOEM?: Maybe<ShipmentOemType>;
};

export type DeleteShipmentProductMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type DeleteShipmentProductMutationPayload = {
  __typename?: 'DeleteShipmentProductMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  shipmentProduct?: Maybe<ShipmentProductType>;
};

export type DeleteShipmentProductOemMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type DeleteShipmentProductOemMutationPayload = {
  __typename?: 'DeleteShipmentProductOEMMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  shipmentOEMProduct?: Maybe<ShipmentOemProductType>;
};

export type DownloadType = {
  __typename?: 'DownloadType';
  contentType: Scalars['String'];
  data: Scalars['Base64'];
  filename: Scalars['String'];
};

export type DraftBlueprintEcnFormInput = {
  file?: InputMaybe<Scalars['Upload']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type DraftBlueprintEcnType = {
  __typename?: 'DraftBlueprintEcnType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  draftEcn: DraftEcnType;
  file?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type DraftEcnListOptionsInputType = {
  ordering?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};

export type DraftEcnListType = {
  __typename?: 'DraftEcnListType';
  count: Scalars['Int'];
  items: Array<DraftEcnType>;
  page: Scalars['Int'];
};

export type DraftEcnMutationInput = {
  blueprints?: InputMaybe<Array<DraftBlueprintEcnFormInput>>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  step: Scalars['Int'];
};

export type DraftEcnMutationPayload = {
  __typename?: 'DraftEcnMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  draftEcn?: Maybe<DraftEcnType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type DraftEcnType = {
  __typename?: 'DraftEcnType';
  blueprints: Array<DraftBlueprintEcnType>;
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  data?: Maybe<Scalars['JSONString']>;
  ecnNumberDuplicated?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  step: Scalars['Int'];
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type EcnAnalyticsType = {
  __typename?: 'EcnAnalyticsType';
  accumulatedInProgress?: Maybe<KpiDatum>;
  accumulatedInProgressByEcn?: Maybe<Array<Maybe<ByStatusDatum>>>;
  accumulatedWithoutEffectiveDate?: Maybe<KpiDatum>;
  accumulatedWithoutEffectiveDateByEcn?: Maybe<Array<Maybe<ByStatusDatum>>>;
  byEffectiveDate?: Maybe<Array<Maybe<ByStatusDatum>>>;
  byEffectiveDateAndSeasonPriority?: Maybe<Array<Maybe<PriotityDatum>>>;
  byPartType?: Maybe<Array<Maybe<ByStatusDatum>>>;
  bySeasonPriority?: Maybe<Array<Maybe<ByStatusDatum>>>;
  byStatus?: Maybe<Array<Maybe<ByStatusDatum>>>;
  byWarrantyPriority?: Maybe<Array<Maybe<ByStatusDatum>>>;
  byWarrantyPriorityInProgress?: Maybe<Array<Maybe<ByStatusDatum>>>;
};

export type EcnBlueprintFormInput = {
  file?: InputMaybe<Scalars['Upload']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type EcnBlueprintType = {
  __typename?: 'EcnBlueprintType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  ecn: EcnType;
  file: Scalars['String'];
  id: Scalars['UUID'];
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type EcnCancelledPartFormInput = {
  betaQuantity?: InputMaybe<Scalars['Float']>;
  buyingDate?: InputMaybe<Scalars['Date']>;
  buyingPrice?: InputMaybe<Scalars['Float']>;
  currentVersion?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  estimatedDateArrival?: InputMaybe<Scalars['Date']>;
  forecastUpdated?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  origin?: InputMaybe<Scalars['UUID']>;
  part: Scalars['UUID'];
  partsArrived?: InputMaybe<Scalars['Boolean']>;
  pricing?: InputMaybe<Scalars['Float']>;
  replace: Scalars['String'];
  supplier?: InputMaybe<Scalars['String']>;
  supportLink?: InputMaybe<Scalars['String']>;
  supportNotes?: InputMaybe<Scalars['String']>;
  targetDate?: InputMaybe<Scalars['Date']>;
  targetVersion?: InputMaybe<Scalars['String']>;
  tariffPosition?: InputMaybe<Scalars['Boolean']>;
  tariffPositionNotes?: InputMaybe<Scalars['String']>;
  yearlyForecast?: InputMaybe<Scalars['Float']>;
  zpCheck?: InputMaybe<Scalars['Boolean']>;
  zpQuantity?: InputMaybe<Scalars['Float']>;
};

export type EcnCancelledPartType = {
  __typename?: 'EcnCancelledPartType';
  betaQuantity?: Maybe<Scalars['Float']>;
  buyingDate?: Maybe<Scalars['Date']>;
  buyingPrice?: Maybe<Scalars['Float']>;
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  currentVersion?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  displayReplace: Scalars['String'];
  ecnPart: EcnPartType;
  estimatedDateArrival?: Maybe<Scalars['Date']>;
  forecastUpdated?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  origin?: Maybe<ProductOriginType>;
  part: ProductType;
  partsArrived: Scalars['Boolean'];
  pricing?: Maybe<Scalars['Float']>;
  product?: Maybe<ProductType>;
  replace: EcnsEcnCancelledPartReplaceChoices;
  supplier?: Maybe<Scalars['String']>;
  supportLink?: Maybe<Scalars['String']>;
  supportNotes?: Maybe<Scalars['String']>;
  targetDate?: Maybe<Scalars['Date']>;
  targetVersion?: Maybe<Scalars['String']>;
  tariffPosition?: Maybe<Scalars['Boolean']>;
  tariffPositionNotes?: Maybe<Scalars['String']>;
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
  yearlyForecast?: Maybe<Scalars['Float']>;
  zpCheck?: Maybe<Scalars['Boolean']>;
  zpQuantity?: Maybe<Scalars['Float']>;
};

export type EcnConfigType = {
  __typename?: 'EcnConfigType';
  anualForecastEndMonth: Scalars['Int'];
  editLockedEcnTasksRoles: Array<EcnRoleType>;
  id: Scalars['ID'];
  notificateUsersOnFinish: Array<UserType>;
  pendingTaskReminderDays: Scalars['Int'];
  ppInternalRoles: Array<RoleType>;
};

export type EcnFileType = {
  __typename?: 'EcnFileType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  ecn: EcnType;
  file: Scalars['String'];
  id: Scalars['UUID'];
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type EcnFiles = {
  __typename?: 'EcnFiles';
  ecnFiles: Array<EcnFileType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type EcnListType2 = {
  __typename?: 'EcnListType2';
  count: Scalars['Int'];
  items: Array<EcnType>;
  page: Scalars['Int'];
};

export type EcnListType2OptionsInputType2 = {
  createdByExact?: InputMaybe<Scalars['UUID']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  createdDateGte?: InputMaybe<Scalars['Date']>;
  createdDateLte?: InputMaybe<Scalars['Date']>;
  ecnNumberExact?: InputMaybe<Scalars['String']>;
  ecnNumberIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  effectiveDateDateGte?: InputMaybe<Scalars['Date']>;
  effectiveDateDateLte?: InputMaybe<Scalars['Date']>;
  isFavorite?: InputMaybe<Scalars['Boolean']>;
  ordering?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  partsCancelledPartsPartExternalIdExact?: InputMaybe<Scalars['String']>;
  partsCancelledPartsPartExternalIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  partsNewPartsExternalIdExact?: InputMaybe<Scalars['String']>;
  partsNewPartsExternalIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  partsNewPartsTypeExact?: InputMaybe<EcnsEcnNewPartTypeChoices>;
  partsNewPartsTypeIn?: InputMaybe<Array<InputMaybe<EcnsEcnNewPartTypeChoices>>>;
  partsNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  partsTypeExact?: InputMaybe<EcnsEcnPartTypeChoices>;
  partsTypeIn?: InputMaybe<Array<InputMaybe<EcnsEcnPartTypeChoices>>>;
  pendingTasksName?: InputMaybe<EcnsEcnTaskNameChoices>;
  pendingTasksNameIn?: InputMaybe<Array<InputMaybe<EcnsEcnTaskNameChoices>>>;
  query?: InputMaybe<Scalars['String']>;
  realesedByExact?: InputMaybe<Scalars['UUID']>;
  realesedByIn?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  recipientExact?: InputMaybe<EcnsEcnRecipientChoices>;
  recipientIn?: InputMaybe<Array<InputMaybe<EcnsEcnRecipientChoices>>>;
  seasonPriorityExact?: InputMaybe<EcnsEcnSeasonPriorityChoices>;
  statusExact?: InputMaybe<EcnsEcnStatusChoices>;
  statusIn?: InputMaybe<Array<InputMaybe<EcnsEcnStatusChoices>>>;
  tasksDoneByExact?: InputMaybe<Scalars['UUID']>;
  tasksDoneByIn?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  tasksDoneExact?: InputMaybe<Scalars['Boolean']>;
  tasksNameIexact?: InputMaybe<EcnsEcnTaskNameChoices>;
  tasksPendingForUsers?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  tasksRolesUsersExact?: InputMaybe<Scalars['UUID']>;
  tasksRolesUsersIn?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  warrantyPriorityExact?: InputMaybe<Scalars['Boolean']>;
};

export type EcnMarkAsSeenMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type EcnMarkAsSeenMutationPayload = {
  __typename?: 'EcnMarkAsSeenMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  ecn?: Maybe<EcnType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type EcnNewPartFormInput = {
  betaQuantity?: InputMaybe<Scalars['Float']>;
  buyingDate?: InputMaybe<Scalars['Date']>;
  buyingPrice?: InputMaybe<Scalars['Float']>;
  description?: InputMaybe<Scalars['String']>;
  estimatedDateArrival?: InputMaybe<Scalars['Date']>;
  externalId: Scalars['String'];
  forecastUpdated?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  origin?: InputMaybe<Scalars['UUID']>;
  partsArrived?: InputMaybe<Scalars['Boolean']>;
  pricing?: InputMaybe<Scalars['Float']>;
  subcategory: Scalars['UUID'];
  supplier?: InputMaybe<Scalars['String']>;
  supportLink?: InputMaybe<Scalars['String']>;
  supportNotes?: InputMaybe<Scalars['String']>;
  targetDate?: InputMaybe<Scalars['Date']>;
  tariffPosition?: InputMaybe<Scalars['Boolean']>;
  tariffPositionNotes?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
  yearlyForecast?: InputMaybe<Scalars['Float']>;
  zpCheck?: InputMaybe<Scalars['Boolean']>;
  zpQuantity?: InputMaybe<Scalars['Float']>;
};

export type EcnNewPartType = {
  __typename?: 'EcnNewPartType';
  betaQuantity?: Maybe<Scalars['Float']>;
  buyingDate?: Maybe<Scalars['Date']>;
  buyingPrice?: Maybe<Scalars['Float']>;
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  description: Scalars['String'];
  displayType: Scalars['String'];
  ecnPart: EcnPartType;
  estimatedDateArrival?: Maybe<Scalars['Date']>;
  externalId: Scalars['String'];
  forecastUpdated?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  origin?: Maybe<ProductOriginType>;
  partsArrived: Scalars['Boolean'];
  pricing?: Maybe<Scalars['Float']>;
  product?: Maybe<ProductType>;
  subcategory: ProductSubcategoryType;
  supplier?: Maybe<Scalars['String']>;
  supportLink?: Maybe<Scalars['String']>;
  supportNotes?: Maybe<Scalars['String']>;
  targetDate?: Maybe<Scalars['Date']>;
  tariffPosition?: Maybe<Scalars['Boolean']>;
  tariffPositionNotes?: Maybe<Scalars['String']>;
  type: EcnsEcnNewPartTypeChoices;
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
  yearlyForecast?: Maybe<Scalars['Float']>;
  zpCheck?: Maybe<Scalars['Boolean']>;
  zpQuantity?: Maybe<Scalars['Float']>;
};

export type EcnPartFormInput = {
  cancelledParts?: InputMaybe<Array<EcnCancelledPartFormInput>>;
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  newParts?: InputMaybe<Array<EcnNewPartFormInput>>;
  type: Scalars['String'];
};

export type EcnPartType = {
  __typename?: 'EcnPartType';
  cancelledParts: Array<EcnCancelledPartType>;
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  displayType: Scalars['String'];
  ecn: EcnType;
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  newParts: Array<EcnNewPartType>;
  type: EcnsEcnPartTypeChoices;
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type EcnRoleType = {
  __typename?: 'EcnRoleType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  defaultTasks: Array<DefaultTaskType>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  tasks: Array<EcnTaskType>;
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
  users: Array<UserType>;
};

export type EcnTaskCommentListOptionsInputType = {
  ordering?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  taskIdExact?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type EcnTaskCommentListType = {
  __typename?: 'EcnTaskCommentListType';
  count: Scalars['Int'];
  items: Array<EcnTaskCommentType>;
  page: Scalars['Int'];
};

export type EcnTaskCommentMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  content: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  task: Scalars['UUID'];
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type EcnTaskCommentMutationPayload = {
  __typename?: 'EcnTaskCommentMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  ecnTaskComment?: Maybe<EcnTaskCommentType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type EcnTaskCommentType = {
  __typename?: 'EcnTaskCommentType';
  content: Scalars['String'];
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  id: Scalars['UUID'];
  task: EcnTaskType;
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type EcnTaskFormInput = {
  done?: InputMaybe<Scalars['Boolean']>;
  doneBy?: InputMaybe<Scalars['UUID']>;
  ecnTypes: Array<InputMaybe<Scalars['String']>>;
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  originalTask?: InputMaybe<Scalars['UUID']>;
  roles: Array<InputMaybe<Scalars['ID']>>;
};

export type EcnTaskType = {
  __typename?: 'EcnTaskType';
  comments: Array<EcnTaskCommentType>;
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  displayName: Scalars['String'];
  done: Scalars['Boolean'];
  doneBy?: Maybe<UserType>;
  ecn: EcnType;
  ecnTypes?: Maybe<Array<EcnsEcnTaskEcnTypesChoices>>;
  id: Scalars['UUID'];
  lastPendingNotificationAt?: Maybe<Scalars['DateTime']>;
  name: EcnsEcnTaskNameChoices;
  notes: Scalars['String'];
  originalTask?: Maybe<DefaultTaskType>;
  roles: Array<EcnRoleType>;
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
  users: Array<UserType>;
};

export type EcnType = {
  __typename?: 'EcnType';
  blueprints: Array<EcnBlueprintType>;
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  displayId: Scalars['Int'];
  displayRecipient: Scalars['String'];
  displaySeasonPriority: Scalars['String'];
  displayStatus: Scalars['String'];
  ecnNumber: Scalars['String'];
  effectiveDate?: Maybe<Scalars['Date']>;
  favoritedByUsers: Array<UserType>;
  files: Array<EcnFileType>;
  fyi: Array<RoleType>;
  histories: Array<HistoricalEcnType>;
  id: Scalars['UUID'];
  informedUsers: Array<UserType>;
  isFavorite: Scalars['Boolean'];
  nextEcnId?: Maybe<Scalars['String']>;
  notes: Scalars['String'];
  oems: Array<OrganizationType>;
  parts: Array<EcnPartType>;
  previousEcnId?: Maybe<Scalars['String']>;
  realesedBy?: Maybe<UserType>;
  recipient?: Maybe<EcnsEcnRecipientChoices>;
  seasonPriority: EcnsEcnSeasonPriorityChoices;
  status?: Maybe<EcnsEcnStatusChoices>;
  tasks: Array<EcnTaskType>;
  totalInformedUsers?: Maybe<Scalars['Int']>;
  totalNotInformedUsers?: Maybe<Scalars['Int']>;
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
  viewed?: Maybe<Scalars['Boolean']>;
  warrantyPriority: Scalars['Boolean'];
};

export const EcnsDefaultTaskEcnTypesChoices = {
  NewPart: 'NEW_PART',
  PartCancelation: 'PART_CANCELATION',
  PartReplacement: 'PART_REPLACEMENT',
  PartRevision: 'PART_REVISION'
} as const;

export type EcnsDefaultTaskEcnTypesChoices = typeof EcnsDefaultTaskEcnTypesChoices[keyof typeof EcnsDefaultTaskEcnTypesChoices];
export const EcnsDefaultTaskNameChoices = {
  Forecast: 'FORECAST',
  NewModCancelParts: 'NEW_MOD_CANCEL_PARTS',
  PartsArrival: 'PARTS_ARRIVAL',
  Pricing: 'PRICING',
  ProductSupport: 'PRODUCT_SUPPORT',
  Purchases: 'PURCHASES'
} as const;

export type EcnsDefaultTaskNameChoices = typeof EcnsDefaultTaskNameChoices[keyof typeof EcnsDefaultTaskNameChoices];
export const EcnsEcnCancelledPartReplaceChoices = {
  Immediate: 'IMMEDIATE',
  ToSegregate: 'TO_SEGREGATE',
  UntilStockLast: 'UNTIL_STOCK_LAST'
} as const;

export type EcnsEcnCancelledPartReplaceChoices = typeof EcnsEcnCancelledPartReplaceChoices[keyof typeof EcnsEcnCancelledPartReplaceChoices];
export const EcnsEcnNewPartTypeChoices = {
  Beta: 'BETA',
  Commercial: 'COMMERCIAL',
  InternalBeta: 'INTERNAL_BETA',
  Tooling: 'TOOLING'
} as const;

export type EcnsEcnNewPartTypeChoices = typeof EcnsEcnNewPartTypeChoices[keyof typeof EcnsEcnNewPartTypeChoices];
export const EcnsEcnPartTypeChoices = {
  NewPart: 'NEW_PART',
  PartCancelation: 'PART_CANCELATION',
  PartReplacement: 'PART_REPLACEMENT',
  PartRevision: 'PART_REVISION'
} as const;

export type EcnsEcnPartTypeChoices = typeof EcnsEcnPartTypeChoices[keyof typeof EcnsEcnPartTypeChoices];
export const EcnsEcnRecipientChoices = {
  All: 'ALL',
  Oem: 'OEM',
  OnlyDealers: 'ONLY_DEALERS',
  PpInternal: 'PP_INTERNAL'
} as const;

export type EcnsEcnRecipientChoices = typeof EcnsEcnRecipientChoices[keyof typeof EcnsEcnRecipientChoices];
export const EcnsEcnSeasonPriorityChoices = {
  High: 'HIGH',
  Low: 'LOW',
  Medium: 'MEDIUM'
} as const;

export type EcnsEcnSeasonPriorityChoices = typeof EcnsEcnSeasonPriorityChoices[keyof typeof EcnsEcnSeasonPriorityChoices];
export const EcnsEcnStatusChoices = {
  Cancelled: 'CANCELLED',
  Effective: 'EFFECTIVE',
  Finished: 'FINISHED',
  InProgress: 'IN_PROGRESS'
} as const;

export type EcnsEcnStatusChoices = typeof EcnsEcnStatusChoices[keyof typeof EcnsEcnStatusChoices];
export const EcnsEcnTaskEcnTypesChoices = {
  NewPart: 'NEW_PART',
  PartCancelation: 'PART_CANCELATION',
  PartReplacement: 'PART_REPLACEMENT',
  PartRevision: 'PART_REVISION'
} as const;

export type EcnsEcnTaskEcnTypesChoices = typeof EcnsEcnTaskEcnTypesChoices[keyof typeof EcnsEcnTaskEcnTypesChoices];
export const EcnsEcnTaskNameChoices = {
  Forecast: 'FORECAST',
  NewModCancelParts: 'NEW_MOD_CANCEL_PARTS',
  PartsArrival: 'PARTS_ARRIVAL',
  Pricing: 'PRICING',
  ProductSupport: 'PRODUCT_SUPPORT',
  Purchases: 'PURCHASES'
} as const;

export type EcnsEcnTaskNameChoices = typeof EcnsEcnTaskNameChoices[keyof typeof EcnsEcnTaskNameChoices];
export type ErrorType = {
  __typename?: 'ErrorType';
  field: Scalars['String'];
  messages: Array<Scalars['String']>;
};

export const EventStatus = {
  Delivered: 'delivered',
  Dispatch: 'dispatch',
  InterbaseDelivery: 'interbase_delivery',
  OrderReceipt: 'order_receipt',
  PartialDelivery: 'partial_delivery',
  Preparation: 'preparation',
  RenderedToClient: 'rendered_to_client',
  ReturnedRejected: 'returned_rejected',
  Routing: 'routing'
} as const;

export type EventStatus = typeof EventStatus[keyof typeof EventStatus];
export type ExportJobType = {
  __typename?: 'ExportJobType';
  id: Scalars['UUID'];
  result?: Maybe<DownloadType>;
  status: JobStatus;
};

export type ExportOems = {
  __typename?: 'ExportOems';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  job?: Maybe<ExportJobType>;
};

export type FactoryAssistantFormInput = {
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  phone: Scalars['String'];
};

export type FactoryAssistantType = {
  __typename?: 'FactoryAssistantType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  id: Scalars['UUID'];
  machineStartUp: MachineStartUpType;
  name: Scalars['String'];
  phone: Scalars['String'];
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type FailureType = {
  __typename?: 'FailureType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  description: Scalars['String'];
  id: Scalars['UUID'];
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type ForecastTaskEcnCancelledPartFormInput = {
  betaQuantity?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['ID']>;
  targetDate?: InputMaybe<Scalars['Date']>;
  yearlyForecast?: InputMaybe<Scalars['Float']>;
  zpCheck?: InputMaybe<Scalars['Boolean']>;
  zpQuantity?: InputMaybe<Scalars['Float']>;
};

export type ForecastTaskEcnNewPartFormInput = {
  betaQuantity?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['ID']>;
  targetDate?: InputMaybe<Scalars['Date']>;
  yearlyForecast?: InputMaybe<Scalars['Float']>;
  zpCheck?: InputMaybe<Scalars['Boolean']>;
  zpQuantity?: InputMaybe<Scalars['Float']>;
};

export type ForecastTaskMutationInput = {
  cancelledParts?: InputMaybe<Array<ForecastTaskEcnCancelledPartFormInput>>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  newParts?: InputMaybe<Array<ForecastTaskEcnNewPartFormInput>>;
};

export type ForecastTaskMutationPayload = {
  __typename?: 'ForecastTaskMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  ecn?: Maybe<EcnType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type GefcoDeliverContentObject = ShipmentType;

export type GefcoDeliverType = {
  __typename?: 'GefcoDeliverType';
  contentObject?: Maybe<GefcoDeliverContentObject>;
  contentType: ContentTypeType;
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  deliverId: Scalars['Int'];
  documentId?: Maybe<Scalars['String']>;
  events: Array<GefcoEventType>;
  id: Scalars['UUID'];
  objectUuid: Scalars['UUID'];
  reference: Scalars['String'];
  tmsStatus: Scalars['String'];
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
  wmsStatus: Scalars['String'];
};

export type GefcoEvent = {
  __typename?: 'GefcoEvent';
  baseEvent: Scalars['String'];
  date: Scalars['DateTime'];
  event: EventStatus;
  eventDisplay?: Maybe<Scalars['String']>;
  rejectReason?: Maybe<Scalars['String']>;
};

export type GefcoEventType = {
  __typename?: 'GefcoEventType';
  baseEvent: Scalars['String'];
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  date: Scalars['DateTime'];
  deliver: GefcoDeliverType;
  event: GefcoGefcoEventEventChoices;
  eventDisplay: Scalars['String'];
  id: Scalars['UUID'];
  rejectReason: Scalars['String'];
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export const GefcoGefcoEventEventChoices = {
  A_1: 'A_1',
  A_2: 'A_2',
  A_3: 'A_3',
  A_4: 'A_4',
  A_5: 'A_5',
  A_6: 'A_6',
  A_7: 'A_7',
  A_8: 'A_8',
  A_9: 'A_9'
} as const;

export type GefcoGefcoEventEventChoices = typeof GefcoGefcoEventEventChoices[keyof typeof GefcoGefcoEventEventChoices];
export type GefcoHistogramDatum = {
  __typename?: 'GefcoHistogramDatum';
  daysSinceShipmentUntilDelivered?: Maybe<Scalars['Int']>;
  daysSinceShipmentUntilDispatch?: Maybe<Scalars['Int']>;
  daysSinceShipmentUntilInterbaseDelivery?: Maybe<Scalars['Int']>;
  daysSinceShipmentUntilOrderReceipt?: Maybe<Scalars['Int']>;
  daysSinceShipmentUntilPartialDelivery?: Maybe<Scalars['Int']>;
  daysSinceShipmentUntilPreparation?: Maybe<Scalars['Int']>;
  daysSinceShipmentUntilRenderedToClient?: Maybe<Scalars['Int']>;
  daysSinceShipmentUntilReturnedRejected?: Maybe<Scalars['Int']>;
  daysSinceShipmentUntilRouting?: Maybe<Scalars['Int']>;
  daysSinceSupplyOrderUntilDelivered?: Maybe<Scalars['Int']>;
  daysSinceSupplyOrderUntilDispatch?: Maybe<Scalars['Int']>;
  daysSinceSupplyOrderUntilInterbaseDelivery?: Maybe<Scalars['Int']>;
  daysSinceSupplyOrderUntilOrderReceipt?: Maybe<Scalars['Int']>;
  daysSinceSupplyOrderUntilPartialDelivery?: Maybe<Scalars['Int']>;
  daysSinceSupplyOrderUntilPreparation?: Maybe<Scalars['Int']>;
  daysSinceSupplyOrderUntilRenderedToClient?: Maybe<Scalars['Int']>;
  daysSinceSupplyOrderUntilReturnedRejected?: Maybe<Scalars['Int']>;
  daysSinceSupplyOrderUntilRouting?: Maybe<Scalars['Int']>;
};

export type GefcoShipmentResponse = {
  __typename?: 'GefcoShipmentResponse';
  error?: Maybe<Scalars['String']>;
  shipments: Array<GefcoShipmentStatus>;
};

export type GefcoShipmentStatus = {
  __typename?: 'GefcoShipmentStatus';
  deliverId: Scalars['ID'];
  documentId?: Maybe<Scalars['String']>;
  events: Array<GefcoEvent>;
  shipmentExternalId: Scalars['ID'];
  tmsStatus: TmsStatus;
  tmsStatusDisplay?: Maybe<Scalars['String']>;
  wmsStatus: WmsStatus;
  wmsStatusDisplay?: Maybe<Scalars['String']>;
};

export type HistoricalEcnListOptionsInputType = {
  ordering?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};

export type HistoricalEcnListType = {
  __typename?: 'HistoricalEcnListType';
  count: Scalars['Int'];
  items: Array<HistoricalEcnType>;
  page: Scalars['Int'];
};

export type HistoricalEcnType = {
  __typename?: 'HistoricalEcnType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  displayId: Scalars['Int'];
  ecnNumber: Scalars['String'];
  effectiveDate?: Maybe<Scalars['Date']>;
  historyChangeReason?: Maybe<Scalars['String']>;
  historyDate: Scalars['DateTime'];
  historyId: Scalars['UUID'];
  historyRelation: EcnType;
  historyTypeDisplay: Scalars['String'];
  historyUser?: Maybe<UserType>;
  id: Scalars['UUID'];
  notes: Scalars['String'];
  realesedBy?: Maybe<UserType>;
  recipient: Scalars['String'];
  seasonPriority: Scalars['String'];
  status: Scalars['String'];
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
  warrantyPriority: Scalars['Boolean'];
};

export type ImportError = {
  __typename?: 'ImportError';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  row?: Maybe<Scalars['Int']>;
};

export type ImportOrderOem = {
  __typename?: 'ImportOrderOem';
  errors?: Maybe<Array<Maybe<ImportError>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type ImportProductFactors = {
  __typename?: 'ImportProductFactors';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type ImportProductFactorsMutationInput = {
  currentYearFactor: Scalars['Float'];
  externalId: Scalars['String'];
};

export const JobStatus = {
  Canceled: 'CANCELED',
  Deferred: 'DEFERRED',
  Failed: 'FAILED',
  Finished: 'FINISHED',
  Queued: 'QUEUED',
  Scheduled: 'SCHEDULED',
  Started: 'STARTED',
  Stopped: 'STOPPED'
} as const;

export type JobStatus = typeof JobStatus[keyof typeof JobStatus];
export type JobType = {
  __typename?: 'JobType';
  id: Scalars['UUID'];
  result?: Maybe<Scalars['String']>;
  status: JobStatus;
};

export type KpiDatum = {
  __typename?: 'KpiDatum';
  avg: Scalars['Int'];
  max: Scalars['Int'];
  min: Scalars['Int'];
};

export type ListCategoryYearlyForecastFormInput = {
  category: Scalars['UUID'];
  id?: InputMaybe<Scalars['ID']>;
  value?: InputMaybe<Scalars['Int']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type LocationType = {
  __typename?: 'LocationType';
  accountSet: Array<AccountType>;
  children: Array<LocationType>;
  codename: Scalars['String'];
  id: Scalars['ID'];
  level: Scalars['Int'];
  lft: Scalars['Int'];
  name: Scalars['String'];
  organizationSet: Array<OrganizationType>;
  parent?: Maybe<LocationType>;
  path?: Maybe<Scalars['String']>;
  rght: Scalars['Int'];
  treeId: Scalars['Int'];
};

export type LoginInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  password: Scalars['String'];
};

export type LoginPayload = {
  __typename?: 'LoginPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  password: Scalars['String'];
  user?: Maybe<UserType>;
};

export type Logout = {
  __typename?: 'Logout';
  success?: Maybe<Scalars['Boolean']>;
};

export type MsuMissingProductsExcelExport = {
  __typename?: 'MSUMissingProductsExcelExport';
  job: ExportJobType;
};

export type MachineStartUpListOptionsInputType = {
  contactAccount?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  contactAccountOwner?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  createdDateGte?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  createdDateLte?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  factoryStepIexact?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  fieldStepIexact?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  missingProductsExternalIdIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  oemOrganization?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  ordering?: InputMaybe<Scalars['String']>;
  organizationFactory?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  organizationField?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  seederBrand?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  seederModel?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  stepIexact?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type MachineStartUpListType = {
  __typename?: 'MachineStartUpListType';
  count: Scalars['Int'];
  items: Array<MachineStartUpType>;
  page: Scalars['Int'];
};

export type MachineStartUpProductCategoryType = {
  __typename?: 'MachineStartUpProductCategoryType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  engineQuantity: Scalars['Int'];
  estimatedAmount: Scalars['Float'];
  id: Scalars['UUID'];
  machineStartUp: MachineStartUpType;
  multiplyByEngine: Scalars['Boolean'];
  multiplyBySeederRows: Scalars['Boolean'];
  name: Scalars['String'];
  payOnlyFieldReview: Scalars['Boolean'];
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
  useInTotalPrice: Scalars['Boolean'];
};

export type MachineStartUpType = {
  __typename?: 'MachineStartUpType';
  contact: ContactType;
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  customerAssistants: Array<CustomerAssistantType>;
  dealerFactoryInvoice?: Maybe<Scalars['String']>;
  dealerFactoryNotes?: Maybe<Scalars['String']>;
  dealerFieldInvoice?: Maybe<Scalars['String']>;
  dealerFieldNotes?: Maybe<Scalars['String']>;
  dealerStartUpPrice: Scalars['Float'];
  displayId: Scalars['Int'];
  estimatedDeliveryDate?: Maybe<Scalars['Date']>;
  expirationDate?: Maybe<Scalars['Date']>;
  factoryAssistants: Array<FactoryAssistantType>;
  factoryInspectionComment?: Maybe<Scalars['String']>;
  factoryPlaqueImage?: Maybe<Scalars['String']>;
  factoryProtocolImage?: Maybe<Scalars['String']>;
  factoryStep?: Maybe<MachineStartUpsMachineStartUpFactoryStepChoices>;
  factoryStepDisplay?: Maybe<Scalars['String']>;
  factoryTermsImage?: Maybe<Scalars['String']>;
  factoryWorkflowNumber?: Maybe<Scalars['String']>;
  fieldInspectionComment?: Maybe<Scalars['String']>;
  fieldPlaqueImage?: Maybe<Scalars['String']>;
  fieldProtocolImage?: Maybe<Scalars['String']>;
  fieldStep?: Maybe<MachineStartUpsMachineStartUpFieldStepChoices>;
  fieldStepDisplay?: Maybe<Scalars['String']>;
  fieldTermsImage?: Maybe<Scalars['String']>;
  fieldWorkflowNumber?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  installationPrice: Scalars['Float'];
  isFieldStepPending: Scalars['Boolean'];
  missingProducts: Array<MissingProductType>;
  notificationDate?: Maybe<Scalars['Date']>;
  oemOrganization?: Maybe<OrganizationType>;
  organizationFactory?: Maybe<OrganizationType>;
  organizationField?: Maybe<OrganizationType>;
  pemRule?: Maybe<PemRuleType>;
  productCategories: Array<MachineStartUpProductCategoryType>;
  productionDateFrom?: Maybe<Scalars['Date']>;
  productionDateTo?: Maybe<Scalars['Date']>;
  racks: Scalars['Boolean'];
  review: Scalars['Boolean'];
  seederBrand: SeederBrandType;
  seederModel: SeederModelType;
  seederRowCount: Scalars['Int'];
  seederSerialNumber?: Maybe<Scalars['String']>;
  seederYear: Scalars['Int'];
  startUpPrice?: Maybe<Scalars['Float']>;
  step: MachineStartUpsMachineStartUpStepChoices;
  stepDisplay: Scalars['String'];
  totalPriceMachine: Scalars['Float'];
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
  withPostFieldRevision: Scalars['Boolean'];
};

export type MachineStartUpsExcelExport = {
  __typename?: 'MachineStartUpsExcelExport';
  job: ExportJobType;
};

export const MachineStartUpsMachineStartUpFactoryStepChoices = {
  AdministrativeRevision: 'ADMINISTRATIVE_REVISION',
  Billing: 'BILLING',
  Completed: 'COMPLETED',
  Invoice: 'INVOICE',
  Review: 'REVIEW',
  Workflow: 'WORKFLOW'
} as const;

export type MachineStartUpsMachineStartUpFactoryStepChoices = typeof MachineStartUpsMachineStartUpFactoryStepChoices[keyof typeof MachineStartUpsMachineStartUpFactoryStepChoices];
export const MachineStartUpsMachineStartUpFieldStepChoices = {
  AdministrativeRevision: 'ADMINISTRATIVE_REVISION',
  Billing: 'BILLING',
  Completed: 'COMPLETED',
  Invoice: 'INVOICE',
  Review: 'REVIEW',
  Workflow: 'WORKFLOW'
} as const;

export type MachineStartUpsMachineStartUpFieldStepChoices = typeof MachineStartUpsMachineStartUpFieldStepChoices[keyof typeof MachineStartUpsMachineStartUpFieldStepChoices];
export const MachineStartUpsMachineStartUpStepChoices = {
  Completed: 'COMPLETED',
  Control: 'CONTROL',
  Expired: 'EXPIRED',
  Reviews: 'REVIEWS'
} as const;

export type MachineStartUpsMachineStartUpStepChoices = typeof MachineStartUpsMachineStartUpStepChoices[keyof typeof MachineStartUpsMachineStartUpStepChoices];
export type MakeEcnEffectiveMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type MakeEcnEffectiveMutationPayload = {
  __typename?: 'MakeEcnEffectiveMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  ecn?: Maybe<EcnType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type MarkAllNotificationsAsRead = {
  __typename?: 'MarkAllNotificationsAsRead';
  status?: Maybe<Scalars['Boolean']>;
};

export type MarkNotificationAsReadMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  isRead?: InputMaybe<Scalars['Boolean']>;
};

export type MarkNotificationAsReadMutationPayload = {
  __typename?: 'MarkNotificationAsReadMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  notification?: Maybe<NotificationType>;
};

export type MaterialMasterExport = {
  __typename?: 'MaterialMasterExport';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  job?: Maybe<ExportJobType>;
};

export type MissingProductType = {
  __typename?: 'MissingProductType';
  description: Scalars['String'];
  externalId: Scalars['String'];
  id: Scalars['ID'];
  machineStartUp: MachineStartUpType;
  name: Scalars['String'];
  price: Scalars['Float'];
  productOemId?: Maybe<Scalars['String']>;
  quantity: Scalars['Int'];
  subcategory: ProductSubcategoryType;
  untilStockRunsOut: Scalars['Boolean'];
};

export type MissingProductTypeList = {
  __typename?: 'MissingProductTypeList';
  count: Scalars['Int'];
  items: Array<MissingProductType>;
  page: Scalars['Int'];
};

export type MissingProductTypeListOptionsInputType = {
  ordering?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};

export type MissingProductsFormInput = {
  description?: InputMaybe<Scalars['String']>;
  externalId: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  price: Scalars['Float'];
  productOemId?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Int'];
  subcategory: Scalars['UUID'];
  untilStockRunsOut?: InputMaybe<Scalars['Boolean']>;
};

export type ModelChangeType = {
  __typename?: 'ModelChangeType';
  field: Scalars['String'];
  new?: Maybe<Scalars['Any']>;
  old?: Maybe<Scalars['Any']>;
  verboseField: Scalars['String'];
};

export type ModelDeltaType = {
  __typename?: 'ModelDeltaType';
  changedFields?: Maybe<Array<Maybe<Scalars['String']>>>;
  changes?: Maybe<Array<Maybe<ModelChangeType>>>;
  date: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addOrderedProductMutation?: Maybe<AddOrderedProduct>;
  addProductsToOemOrganization?: Maybe<AddProductsToOemOrganization>;
  addStockToProduct?: Maybe<AddStockToProductMutationPayload>;
  approveWarrantyClaim?: Maybe<ApproveWarrantyClaimRequestMutationPayload>;
  cancelEcn?: Maybe<CancelEcn>;
  cancelWarrantyClaim?: Maybe<CancelWarrantyClaimRequestMutationPayload>;
  categoriesYearlyForecasts?: Maybe<CategoriesYearlyForecasts>;
  closeQuotes?: Maybe<CloseQuoteMutation>;
  createAccount?: Maybe<CreateAccountMutationPayload>;
  createAccountExport?: Maybe<CreateAccountExportMutationPayload>;
  createBankInvoicePdf?: Maybe<CreateBankInvoicePdf>;
  createContact?: Maybe<CreateContactMutationPayload>;
  createEcn?: Maybe<CreateEcnMutationPayload>;
  createEcnListExport?: Maybe<CreateEcnListExport>;
  createMultipleShipments?: Maybe<CreateShipmentsMutation>;
  createOemOrderPdf?: Maybe<CreateOemOrderPdf>;
  createOpportunity?: Maybe<CreateOpportunityMutationPayload>;
  createOrderOem?: Maybe<CreateOrderOemMutationPayload>;
  createOrderedProduct?: Maybe<CreateOrderedProductMutationPayload>;
  createProductComment?: Maybe<ProductCommentMutationPayload>;
  createProductWarrantyClaimExport?: Maybe<CreateProductWarrantyClaimExport>;
  createQuote?: Maybe<CreateQuoteMutationPayload>;
  createQuotePdf?: Maybe<CreateQuotePdf>;
  createSale?: Maybe<CreateSaleMutationPayload>;
  createSaleExport?: Maybe<CreateSaleExport>;
  createSeeder?: Maybe<CreateSeederMutationPayload>;
  createSeederExport?: Maybe<CreateSeederExportMutationPayload>;
  createShipment?: Maybe<CreateShipmentMutationPayload>;
  createShipmentOem?: Maybe<CreateShipmentOemMutationPayload>;
  createShipmentProductWarrantyClaim?: Maybe<CreateShipmentProductWarrantyClaimMutationPayload>;
  createShipmentsOem?: Maybe<CreateShipmentsOemMutation>;
  createSupplyOrder?: Maybe<CreateSupplyOrderMutationPayload>;
  createSupplyOrderExport?: Maybe<CreateSupplyOrderExport>;
  createSupplyOrderPDF?: Maybe<CreateSupplyOrderPdf>;
  createWarrantyClaim?: Maybe<CreateWarrantyClaimMutationPayload>;
  createWarrantyClaimInspectionReview?: Maybe<CreateWarrantyClaimInspectionReviewMutationPayload>;
  createWarrantyClaimPdf?: Maybe<CreateWarrantyClaimPdf>;
  deleteAccount?: Maybe<DeleteAccountMutationPayload>;
  deleteContact?: Maybe<DeleteContactMutationPayload>;
  deleteDraftEcn?: Maybe<DeleteDraftEcnMutationPayload>;
  deleteEcnFile?: Maybe<DeleteEcnFile>;
  deleteOpportunity?: Maybe<DeleteOpportunityMutationPayload>;
  deleteOrderOem?: Maybe<DeleteOrderOemMutationPayload>;
  deleteQuote?: Maybe<DeleteQuoteMutationPayload>;
  deleteSeeder?: Maybe<DeleteSeederMutationPayload>;
  deleteShipment?: Maybe<DeleteShipmentMutationPayload>;
  deleteShipmentOem?: Maybe<DeleteShipmentOemMutationPayload>;
  deleteShipmentProduct?: Maybe<DeleteShipmentProductMutationPayload>;
  deleteShipmentProductOem?: Maybe<DeleteShipmentProductOemMutationPayload>;
  draftEcn?: Maybe<DraftEcnMutationPayload>;
  ecnFiles?: Maybe<EcnFiles>;
  ecnForecastTask?: Maybe<ForecastTaskMutationPayload>;
  ecnMarkAsSeen?: Maybe<EcnMarkAsSeenMutationPayload>;
  ecnPricingTask?: Maybe<PricingTaskMutationPayload>;
  ecnTaskComment?: Maybe<EcnTaskCommentMutationPayload>;
  exportOems?: Maybe<ExportOems>;
  importOrderOem?: Maybe<ImportOrderOem>;
  importProductFactors?: Maybe<ImportProductFactors>;
  login?: Maybe<LoginPayload>;
  logout?: Maybe<Logout>;
  machineStartUpsExcelExport?: Maybe<MachineStartUpsExcelExport>;
  makeEcnEffective?: Maybe<MakeEcnEffectiveMutationPayload>;
  markAllNotificationsAsRead?: Maybe<MarkAllNotificationsAsRead>;
  markNotificationAsRead?: Maybe<MarkNotificationAsReadMutationPayload>;
  materialMasterExport?: Maybe<MaterialMasterExport>;
  msuMissingProductExport?: Maybe<MsuMissingProductsExcelExport>;
  newModCancelPartsTask?: Maybe<NewModCancelPartsTaskMutationPayload>;
  newModCancelledPartsPurchaseTask?: Maybe<NewModCancelledPartsPurchaseTaskMutationPayload>;
  notificateTasksForUser?: Maybe<NotificateTasksForUserPayload>;
  oemOrderBankInvoicePdfExport?: Maybe<OemOrderBankInvoicePdfExport>;
  partsArrivalTask?: Maybe<PartsArrivalTaskMutationPayload>;
  pemAdministrativeRevision?: Maybe<PemAdministrativeRevisionMutationPayload>;
  pemAdministrativeRevisionUpdate?: Maybe<PemAdministrativeRevisionUpdateMutationPayload>;
  pemCreate?: Maybe<CreateMachineStartUpMutationPayload>;
  pemFactoryImages?: Maybe<PemFactoryImagesMutationPayload>;
  pemFactoryReview?: Maybe<PemFactoryReviewMutationPayload>;
  pemFieldImages?: Maybe<PemFieldImagesMutationPayload>;
  pemFieldReview?: Maybe<PemFieldReviewMutationPayload>;
  pemInspectionRevision?: Maybe<PemInspectionRevisionMutationPayload>;
  pemPdfExport?: Maybe<PemPdfExport>;
  pemWorkflow?: Maybe<PemWorkflowMutationPayload>;
  productSupportTask?: Maybe<ProductSupportTaskMutationPayload>;
  productYearlyFactor?: Maybe<ProductYearlyFactorMutationPayload>;
  quoteExcelExport?: Maybe<QuoteExcelExport>;
  rejectWarrantyClaim?: Maybe<RejectWarrantyClaimRequestMutationPayload>;
  resetPassword?: Maybe<ResetPasswordMutationPayload>;
  reviewAccountRegistration?: Maybe<ReviewAccountRegistrationMutationPayload>;
  reviewOemOrder?: Maybe<ReviewOemOrderMutationPayload>;
  reviewSupplyOrder?: Maybe<SupplyOrderReviewMutationPayload>;
  setEcnFavorite?: Maybe<SetEcnFavorite>;
  setPassword?: Maybe<SetPasswordMutationPayload>;
  startAccountRegistration?: Maybe<StartAccountRegistrationMutationPayload>;
  startOemOrderReview?: Maybe<StartOemOrderReviewMutationPayload>;
  startSupplyOrderReview?: Maybe<StartSupplyOrderReviewMutationPayload>;
  toggleNotificationConfig?: Maybe<NotificationConfigMutationPayload>;
  updateAccount?: Maybe<UpdateAccountMutationPayload>;
  updateAccountExternalId?: Maybe<UpdateAccountExternalIdMutationPayload>;
  updateAccountFiles?: Maybe<UpdateAccountFiles>;
  updateContact?: Maybe<UpdateContactMutationPayload>;
  updateEcn?: Maybe<UpdateEcnMutationPayload>;
  updateEffectiveDate?: Maybe<UpdateEcnEffectiveDateMutation>;
  updateOpportunity?: Maybe<UpdateOpportunityMutationPayload>;
  updateOrderOem?: Maybe<UpdateOrderOemMutationPayload>;
  updateOrderOemPrices?: Maybe<UpdateOrderOemPricesMutationPayload>;
  updateOrderedProduct?: Maybe<UpdateOrderedProductMutationPayload>;
  updatePassword?: Maybe<UpdatePasswordMutationPayload>;
  updateProduct?: Maybe<UpdateProductMutationPayload>;
  updateProductPublishedMutation?: Maybe<UpdateProductPublished>;
  updateProductUntilStockRunsOutMutation?: Maybe<UpdateProductUntilStockRunsOut>;
  updateQuote?: Maybe<UpdateQuoteMutationPayload>;
  updateQuotePrices?: Maybe<UpdateQuotePricesMutationPayload>;
  updateSale?: Maybe<UpdateSaleMutationPayload>;
  updateSeeder?: Maybe<UpdateSeederMutationPayload>;
  updateShipment?: Maybe<UpdateShipmentMutationPayload>;
  updateShipmentOem?: Maybe<UpdateShipmentOemMutationPayload>;
  updateSupplyOrder?: Maybe<UpdateSupplyOrderMutationPayload>;
  updateUser?: Maybe<UpdateUserMutationPayload>;
  updateWarrantyClaim?: Maybe<UpdateWarrantyClaimMutationPayload>;
  uploadInvoice?: Maybe<UploadInvoiceMutationPayload>;
  uploadInvoiceOem?: Maybe<UploadInvoiceOemMutationPayload>;
};


export type MutationAddOrderedProductMutationArgs = {
  input: OrderedProductSupplyOrderFormInput;
  orderedProducts: Array<OrderedProductOrderedProductFormInput>;
};


export type MutationAddProductsToOemOrganizationArgs = {
  products: Array<AddStockToProductFormInput>;
};


export type MutationAddStockToProductArgs = {
  input: AddStockToProductMutationInput;
};


export type MutationApproveWarrantyClaimArgs = {
  input: ApproveWarrantyClaimRequestMutationInput;
};


export type MutationCancelEcnArgs = {
  id: Scalars['UUID'];
};


export type MutationCancelWarrantyClaimArgs = {
  input: CancelWarrantyClaimRequestMutationInput;
};


export type MutationCategoriesYearlyForecastsArgs = {
  inputs: Array<ListCategoryYearlyForecastFormInput>;
};


export type MutationCloseQuotesArgs = {
  input: Array<InputMaybe<QuoteCloseReasonInputType>>;
};


export type MutationCreateAccountArgs = {
  input: CreateAccountMutationInput;
};


export type MutationCreateAccountExportArgs = {
  input: CreateAccountExportMutationInput;
};


export type MutationCreateBankInvoicePdfArgs = {
  paymentMethodId: Scalars['UUID'];
  quoteId: Scalars['UUID'];
};


export type MutationCreateContactArgs = {
  input: CreateContactMutationInput;
};


export type MutationCreateEcnArgs = {
  input: CreateEcnMutationInput;
};


export type MutationCreateEcnListExportArgs = {
  filters?: InputMaybe<EcnListType2OptionsInputType2>;
};


export type MutationCreateMultipleShipmentsArgs = {
  shipments: Array<ShipmentFormInput>;
};


export type MutationCreateOemOrderPdfArgs = {
  id: Scalars['UUID'];
};


export type MutationCreateOpportunityArgs = {
  input: CreateOpportunityMutationInput;
};


export type MutationCreateOrderOemArgs = {
  input: CreateOrderOemMutationInput;
};


export type MutationCreateOrderedProductArgs = {
  input: CreateOrderedProductMutationInput;
};


export type MutationCreateProductCommentArgs = {
  input: ProductCommentMutationInput;
};


export type MutationCreateProductWarrantyClaimExportArgs = {
  filters?: InputMaybe<ProductWarrantyClaimListOptionsInputType>;
  id?: InputMaybe<Scalars['UUID']>;
};


export type MutationCreateQuoteArgs = {
  input: CreateQuoteMutationInput;
};


export type MutationCreateQuotePdfArgs = {
  paymentMethodId?: InputMaybe<Scalars['String']>;
  productDisplay?: InputMaybe<Scalars['String']>;
  quoteId: Scalars['UUID'];
  recipient?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};


export type MutationCreateSaleArgs = {
  input: CreateSaleMutationInput;
};


export type MutationCreateSaleExportArgs = {
  filters?: InputMaybe<SaleListOptionsInputType>;
  saleId?: InputMaybe<Scalars['UUID']>;
};


export type MutationCreateSeederArgs = {
  input: CreateSeederMutationInput;
};


export type MutationCreateSeederExportArgs = {
  input: CreateSeederExportMutationInput;
};


export type MutationCreateShipmentArgs = {
  input: CreateShipmentMutationInput;
};


export type MutationCreateShipmentOemArgs = {
  input: CreateShipmentOemMutationInput;
};


export type MutationCreateShipmentProductWarrantyClaimArgs = {
  input: CreateShipmentProductWarrantyClaimMutationInput;
};


export type MutationCreateShipmentsOemArgs = {
  shipments: Array<ShipmentOemFormInput>;
};


export type MutationCreateSupplyOrderArgs = {
  input: CreateSupplyOrderMutationInput;
};


export type MutationCreateSupplyOrderExportArgs = {
  filters?: InputMaybe<SupplyOrderListOptionsInputType>;
  supplyOrderId?: InputMaybe<Scalars['UUID']>;
};


export type MutationCreateSupplyOrderPdfArgs = {
  supplyOrderId: Scalars['UUID'];
};


export type MutationCreateWarrantyClaimArgs = {
  input: CreateWarrantyClaimMutationInput;
};


export type MutationCreateWarrantyClaimInspectionReviewArgs = {
  input: CreateWarrantyClaimInspectionReviewMutationInput;
};


export type MutationCreateWarrantyClaimPdfArgs = {
  warrantyClaimId: Scalars['UUID'];
};


export type MutationDeleteAccountArgs = {
  input: DeleteAccountMutationInput;
};


export type MutationDeleteContactArgs = {
  input: DeleteContactMutationInput;
};


export type MutationDeleteDraftEcnArgs = {
  input: DeleteDraftEcnMutationInput;
};


export type MutationDeleteEcnFileArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteOpportunityArgs = {
  input: DeleteOpportunityMutationInput;
};


export type MutationDeleteOrderOemArgs = {
  input: DeleteOrderOemMutationInput;
};


export type MutationDeleteQuoteArgs = {
  input: DeleteQuoteMutationInput;
};


export type MutationDeleteSeederArgs = {
  input: DeleteSeederMutationInput;
};


export type MutationDeleteShipmentArgs = {
  input: DeleteShipmentMutationInput;
};


export type MutationDeleteShipmentOemArgs = {
  input: DeleteShipmentOemMutationInput;
};


export type MutationDeleteShipmentProductArgs = {
  input: DeleteShipmentProductMutationInput;
};


export type MutationDeleteShipmentProductOemArgs = {
  input: DeleteShipmentProductOemMutationInput;
};


export type MutationDraftEcnArgs = {
  input: DraftEcnMutationInput;
};


export type MutationEcnFilesArgs = {
  ecnId: Scalars['UUID'];
  files: Array<Scalars['Upload']>;
};


export type MutationEcnForecastTaskArgs = {
  input: ForecastTaskMutationInput;
};


export type MutationEcnMarkAsSeenArgs = {
  input: EcnMarkAsSeenMutationInput;
};


export type MutationEcnPricingTaskArgs = {
  input: PricingTaskMutationInput;
};


export type MutationEcnTaskCommentArgs = {
  input: EcnTaskCommentMutationInput;
};


export type MutationExportOemsArgs = {
  filters?: InputMaybe<OrderOemListOptionsInputType>;
  orderOemId?: InputMaybe<Scalars['UUID']>;
};


export type MutationImportOrderOemArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']>;
  rows?: InputMaybe<Array<RowInput>>;
};


export type MutationImportProductFactorsArgs = {
  inputs: Array<ImportProductFactorsMutationInput>;
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationMachineStartUpsExcelExportArgs = {
  options?: InputMaybe<MachineStartUpListOptionsInputType>;
};


export type MutationMakeEcnEffectiveArgs = {
  input: MakeEcnEffectiveMutationInput;
};


export type MutationMarkNotificationAsReadArgs = {
  input: MarkNotificationAsReadMutationInput;
};


export type MutationMaterialMasterExportArgs = {
  options?: InputMaybe<ProductListOptionsInputType>;
};


export type MutationMsuMissingProductExportArgs = {
  options?: InputMaybe<MachineStartUpListOptionsInputType>;
};


export type MutationNewModCancelPartsTaskArgs = {
  input: NewModCancelPartsTaskMutationInput;
};


export type MutationNewModCancelledPartsPurchaseTaskArgs = {
  input: NewModCancelledPartsPurchaseTaskMutationInput;
};


export type MutationNotificateTasksForUserArgs = {
  input: NotificateTasksForUserInput;
};


export type MutationOemOrderBankInvoicePdfExportArgs = {
  id: Scalars['UUID'];
};


export type MutationPartsArrivalTaskArgs = {
  input: PartsArrivalTaskMutationInput;
};


export type MutationPemAdministrativeRevisionArgs = {
  input: PemAdministrativeRevisionMutationInput;
};


export type MutationPemAdministrativeRevisionUpdateArgs = {
  input: PemAdministrativeRevisionUpdateMutationInput;
};


export type MutationPemCreateArgs = {
  input: CreateMachineStartUpMutationInput;
};


export type MutationPemFactoryImagesArgs = {
  input: PemFactoryImagesMutationInput;
};


export type MutationPemFactoryReviewArgs = {
  input: PemFactoryReviewMutationInput;
};


export type MutationPemFieldImagesArgs = {
  input: PemFieldImagesMutationInput;
};


export type MutationPemFieldReviewArgs = {
  input: PemFieldReviewMutationInput;
};


export type MutationPemInspectionRevisionArgs = {
  input: PemInspectionRevisionMutationInput;
};


export type MutationPemPdfExportArgs = {
  dealerType: Scalars['String'];
  id: Scalars['UUID'];
};


export type MutationPemWorkflowArgs = {
  input: PemWorkflowMutationInput;
};


export type MutationProductSupportTaskArgs = {
  input: ProductSupportTaskMutationInput;
};


export type MutationProductYearlyFactorArgs = {
  input: ProductYearlyFactorMutationInput;
};


export type MutationQuoteExcelExportArgs = {
  filters?: InputMaybe<QuoteListOptionsInputType>;
  id?: InputMaybe<Scalars['UUID']>;
  paymentMethod?: InputMaybe<Scalars['String']>;
};


export type MutationRejectWarrantyClaimArgs = {
  input: RejectWarrantyClaimRequestMutationInput;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordMutationInput;
};


export type MutationReviewAccountRegistrationArgs = {
  input: ReviewAccountRegistrationMutationInput;
};


export type MutationReviewOemOrderArgs = {
  input: ReviewOemOrderMutationInput;
};


export type MutationReviewSupplyOrderArgs = {
  input: SupplyOrderReviewMutationInput;
};


export type MutationSetEcnFavoriteArgs = {
  favorite: Scalars['Boolean'];
  id: Scalars['UUID'];
};


export type MutationSetPasswordArgs = {
  input: SetPasswordMutationInput;
};


export type MutationStartAccountRegistrationArgs = {
  input: StartAccountRegistrationMutationInput;
};


export type MutationStartOemOrderReviewArgs = {
  input: StartOemOrderReviewMutationInput;
};


export type MutationStartSupplyOrderReviewArgs = {
  input: StartSupplyOrderReviewMutationInput;
};


export type MutationToggleNotificationConfigArgs = {
  input: NotificationConfigMutationInput;
};


export type MutationUpdateAccountArgs = {
  input: UpdateAccountMutationInput;
};


export type MutationUpdateAccountExternalIdArgs = {
  input: UpdateAccountExternalIdMutationInput;
};


export type MutationUpdateAccountFilesArgs = {
  files: Array<InputMaybe<Scalars['Upload']>>;
  id: Scalars['UUID'];
};


export type MutationUpdateContactArgs = {
  input: UpdateContactMutationInput;
};


export type MutationUpdateEcnArgs = {
  input: UpdateEcnMutationInput;
};


export type MutationUpdateEffectiveDateArgs = {
  effectiveDate: Scalars['Date'];
  id: Scalars['UUID'];
};


export type MutationUpdateOpportunityArgs = {
  input: UpdateOpportunityMutationInput;
};


export type MutationUpdateOrderOemArgs = {
  input: UpdateOrderOemMutationInput;
};


export type MutationUpdateOrderOemPricesArgs = {
  input: UpdateOrderOemPricesMutationInput;
};


export type MutationUpdateOrderedProductArgs = {
  input: UpdateOrderedProductMutationInput;
};


export type MutationUpdatePasswordArgs = {
  input: UpdatePasswordMutationInput;
};


export type MutationUpdateProductArgs = {
  input: UpdateProductMutationInput;
};


export type MutationUpdateProductPublishedMutationArgs = {
  id: Scalars['UUID'];
  published: Scalars['Boolean'];
};


export type MutationUpdateProductUntilStockRunsOutMutationArgs = {
  id: Scalars['UUID'];
  untilStockRunsOut: Scalars['Boolean'];
};


export type MutationUpdateQuoteArgs = {
  input: UpdateQuoteMutationInput;
};


export type MutationUpdateQuotePricesArgs = {
  input: UpdateQuotePricesMutationInput;
};


export type MutationUpdateSaleArgs = {
  input: UpdateSaleMutationInput;
};


export type MutationUpdateSeederArgs = {
  input: UpdateSeederMutationInput;
};


export type MutationUpdateShipmentArgs = {
  input: UpdateShipmentMutationInput;
};


export type MutationUpdateShipmentOemArgs = {
  input: UpdateShipmentOemMutationInput;
};


export type MutationUpdateSupplyOrderArgs = {
  input: UpdateSupplyOrderMutationInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserMutationInput;
};


export type MutationUpdateWarrantyClaimArgs = {
  input: UpdateWarrantyClaimMutationInput;
};


export type MutationUploadInvoiceArgs = {
  input: UploadInvoiceMutationInput;
};


export type MutationUploadInvoiceOemArgs = {
  input: UploadInvoiceOemMutationInput;
};

export type NewModCancelPartsTaskEcnPartFormInput = {
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type NewModCancelPartsTaskMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  parts: Array<NewModCancelPartsTaskEcnPartFormInput>;
};

export type NewModCancelPartsTaskMutationPayload = {
  __typename?: 'NewModCancelPartsTaskMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  ecn?: Maybe<EcnType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type NewModCancelledPartsPurchaseTaskMutationInput = {
  cancelledParts?: InputMaybe<Array<PurchaseTaskEcnCancelledPartFormInput>>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  newParts?: InputMaybe<Array<PurchaseTaskEcnNewPartFormInput>>;
};

export type NewModCancelledPartsPurchaseTaskMutationPayload = {
  __typename?: 'NewModCancelledPartsPurchaseTaskMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  ecn?: Maybe<EcnType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type NotificateTasksForUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  user: Scalars['UUID'];
};

export type NotificateTasksForUserPayload = {
  __typename?: 'NotificateTasksForUserPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  ecn?: Maybe<EcnType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export const NotificationConfigChoices = {
  Accounts: 'accounts',
  Ecns: 'ecns',
  MachineStartUps: 'machine_start_ups',
  MaterialMaster: 'material_master',
  Oem: 'oem',
  SupplyOrders: 'supply_orders',
  WarrantyClaims: 'warranty_claims'
} as const;

export type NotificationConfigChoices = typeof NotificationConfigChoices[keyof typeof NotificationConfigChoices];
export type NotificationConfigMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  emailEnabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  inAppEnabled?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  user: Scalars['ID'];
};

export type NotificationConfigMutationPayload = {
  __typename?: 'NotificationConfigMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  notificationConfig?: Maybe<NotificationConfigType>;
};

export type NotificationConfigNameType = {
  __typename?: 'NotificationConfigNameType';
  label: Scalars['String'];
  value: NotificationConfigChoices;
};

export type NotificationConfigType = {
  __typename?: 'NotificationConfigType';
  displayName: Scalars['String'];
  emailEnabled: Scalars['Boolean'];
  id: Scalars['UUID'];
  inAppEnabled: Scalars['Boolean'];
  name: UsersNotificationConfigNameChoices;
  user: UserType;
};

export type NotificationListOptionsInputType = {
  ordering?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};

export type NotificationListType = {
  __typename?: 'NotificationListType';
  count: Scalars['Int'];
  items: Array<NotificationType>;
  page: Scalars['Int'];
};

export type NotificationType = {
  __typename?: 'NotificationType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  id: Scalars['UUID'];
  isRead: Scalars['Boolean'];
  message: Scalars['String'];
  path: Scalars['String'];
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
  user: UserType;
};

export type NotificationsType = {
  __typename?: 'NotificationsType';
  notifications: NotificationListType;
  unreadCount: Scalars['Int'];
};


export type NotificationsTypeNotificationsArgs = {
  options?: InputMaybe<NotificationListOptionsInputType>;
};

export type OemOrganizationType = {
  __typename?: 'OEMOrganizationType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  externalId: Scalars['String'];
  id: Scalars['UUID'];
  name: Scalars['String'];
  orderOem: OrderOemType;
  originalOrganization?: Maybe<OrganizationType>;
  taxId: Scalars['String'];
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type OemOrderBankInvoicePdfExport = {
  __typename?: 'OemOrderBankInvoicePdfExport';
  job: ExportJobType;
};

export const OemsOrderOemReviewStatusChoices = {
  Approved: 'APPROVED',
  Rejected: 'REJECTED'
} as const;

export type OemsOrderOemReviewStatusChoices = typeof OemsOrderOemReviewStatusChoices[keyof typeof OemsOrderOemReviewStatusChoices];
export const OemsOrderOemStatusChoices = {
  Approved: 'APPROVED',
  Draft: 'DRAFT',
  Finished: 'FINISHED',
  InProgress: 'IN_PROGRESS',
  InReview: 'IN_REVIEW'
} as const;

export type OemsOrderOemStatusChoices = typeof OemsOrderOemStatusChoices[keyof typeof OemsOrderOemStatusChoices];
export const OemsShipmentOemStatusChoices = {
  Cancelled: 'CANCELLED',
  Confirmed: 'CONFIRMED'
} as const;

export type OemsShipmentOemStatusChoices = typeof OemsShipmentOemStatusChoices[keyof typeof OemsShipmentOemStatusChoices];
export type OpportunityChannelType = {
  __typename?: 'OpportunityChannelType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  opportunitySet: Array<OpportunityType>;
  order: Scalars['Int'];
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type OpportunityListOptionsInputType = {
  channel?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  contact?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  contactAccount?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  contactAccountOwner?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  ordering?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  situation?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  user?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type OpportunityListType = {
  __typename?: 'OpportunityListType';
  count: Scalars['Int'];
  items: Array<OpportunityType>;
  page: Scalars['Int'];
};

export type OpportunityReasonType = {
  __typename?: 'OpportunityReasonType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  opportunitySet: Array<OpportunityType>;
  order: Scalars['Int'];
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type OpportunitySituationType = {
  __typename?: 'OpportunitySituationType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  opportunitySet: Array<OpportunityType>;
  order: Scalars['Int'];
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type OpportunityType = {
  __typename?: 'OpportunityType';
  channel: OpportunityChannelType;
  contact: ContactType;
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  date: Scalars['Date'];
  displayName: Scalars['String'];
  id: Scalars['UUID'];
  notes: Scalars['String'];
  products: Scalars['String'];
  reason: OpportunityReasonType;
  situation: OpportunitySituationType;
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type OrderOemListOptionsInputType = {
  createdBy?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  createdDateGte?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  createdDateLte?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  ordering?: InputMaybe<Scalars['String']>;
  organizationOriginalOrganization?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};

export type OrderOemListType = {
  __typename?: 'OrderOEMListType';
  count: Scalars['Int'];
  items: Array<OrderOemType>;
  page: Scalars['Int'];
};

export type OrderOemPaymentMethodType = {
  __typename?: 'OrderOEMPaymentMethodType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  currencyCode?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  multiplier: Scalars['Float'];
  name: Scalars['String'];
  order: Scalars['Int'];
  orderOem: OrderOemType;
  originalPaymentMethod?: Maybe<PaymentMethodType>;
  slug: Scalars['String'];
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type OrderOemProductFormInput = {
  description?: InputMaybe<Scalars['String']>;
  externalId: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  order: Scalars['Int'];
  price: Scalars['Float'];
  productOemId?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Int'];
  quantityLeft: Scalars['Int'];
  rowCount: Scalars['Int'];
  ruleCategories?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  ruleGroup?: InputMaybe<Scalars['UUID']>;
  subcategory: Scalars['UUID'];
  untilStockRunsOut?: InputMaybe<Scalars['Boolean']>;
};

export type OrderOemReviewType = {
  __typename?: 'OrderOEMReviewType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  notes: Scalars['String'];
  orderOem: OrderOemType;
  status: OemsOrderOemReviewStatusChoices;
  statusDisplay: Scalars['String'];
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type OrderOemType = {
  __typename?: 'OrderOEMType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  displayId: Scalars['Int'];
  id: Scalars['UUID'];
  notes?: Maybe<Scalars['String']>;
  orderNumber?: Maybe<Scalars['String']>;
  organization?: Maybe<OemOrganizationType>;
  paymentMethod?: Maybe<OrderOemPaymentMethodType>;
  products: Array<OrderedOemProductType>;
  productsWithoutShipment: Array<OrderedOemProductType>;
  reviewStart?: Maybe<Scalars['DateTime']>;
  reviews: Array<OrderOemReviewType>;
  shipments: Array<ShipmentOemType>;
  status?: Maybe<OemsOrderOemStatusChoices>;
  statusDisplay: Scalars['String'];
  targetDate?: Maybe<Scalars['Date']>;
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type OrderedOemProductType = {
  __typename?: 'OrderedOEMProductType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  description: Scalars['String'];
  externalId: Scalars['String'];
  id: Scalars['UUID'];
  name: Scalars['String'];
  order: Scalars['Int'];
  orderOem: OrderOemType;
  price: Scalars['Float'];
  productOemId?: Maybe<Scalars['String']>;
  productsShipped: Array<ShipmentOemProductType>;
  quantity: Scalars['Int'];
  quantityLeft: Scalars['Int'];
  rowCount: Scalars['Int'];
  ruleCategories: Array<ProductCategoryType>;
  ruleGroup?: Maybe<RuleGroupType>;
  subcategory: ProductSubcategoryType;
  untilStockRunsOut: Scalars['Boolean'];
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type OrderedProductFormInput = {
  commissionMultiplier: Scalars['Float'];
  enableDiscount?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  quantity: Scalars['Int'];
  quantityLeft: Scalars['Int'];
  quotedProduct: Scalars['ID'];
};

export type OrderedProductOrderedProductFormInput = {
  commissionMultiplier: Scalars['Float'];
  enableDiscount?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  quantity: Scalars['Int'];
  quantityLeft: Scalars['Int'];
  quotedProduct: OrderedProductQuotedProductFormInput;
};

export type OrderedProductQuotedProductFormInput = {
  commissionMultiplier: Scalars['Float'];
  description?: InputMaybe<Scalars['String']>;
  enableDiscount?: InputMaybe<Scalars['Boolean']>;
  externalId: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  order: Scalars['Int'];
  price: Scalars['Float'];
  quantity: Scalars['Int'];
  rowCount: Scalars['Int'];
  ruleCategories?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  ruleGroup?: InputMaybe<Scalars['UUID']>;
  subcategory: Scalars['UUID'];
  untilStockRunsOut?: InputMaybe<Scalars['Boolean']>;
};

export type OrderedProductSupplyOrderFormInput = {
  billingType?: InputMaybe<Scalars['String']>;
  emailMessages?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  id?: InputMaybe<Scalars['ID']>;
  paymentMethod?: InputMaybe<Scalars['UUID']>;
  products: Array<OrderedProductFormInput>;
  quote: Scalars['UUID'];
  reviewStart?: InputMaybe<Scalars['DateTime']>;
  status: Scalars['String'];
  targetDate?: InputMaybe<Scalars['Date']>;
};

export type OrderedProductType = {
  __typename?: 'OrderedProductType';
  commissionMultiplier: Scalars['Float'];
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  displayName: Scalars['String'];
  enableDiscount: Scalars['Boolean'];
  id: Scalars['UUID'];
  price: Scalars['Float'];
  productsShipped: Array<ShipmentProductType>;
  quantity: Scalars['Int'];
  quantityLeft: Scalars['Int'];
  quotedProduct: QuotedProductType;
  supplyOrder: SupplyOrderType;
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type OrganizationGroupListOptionsInputType = {
  isOemBool?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  ordering?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};

export type OrganizationGroupListType = {
  __typename?: 'OrganizationGroupListType';
  count: Scalars['Int'];
  items: Array<OrganizationGroupType>;
  page: Scalars['Int'];
};

export type OrganizationGroupOemThroughListOptionsInputType = {
  ordering?: InputMaybe<Scalars['String']>;
  organizationGroupOrganizationsIdExact?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  publishedBool?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  query?: InputMaybe<Scalars['String']>;
};

export type OrganizationGroupOemThroughListType = {
  __typename?: 'OrganizationGroupOemThroughListType';
  count: Scalars['Int'];
  items: Array<OrganizationGroupOemThroughType>;
  page: Scalars['Int'];
};

export type OrganizationGroupOemThroughType = {
  __typename?: 'OrganizationGroupOemThroughType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  displayName: Scalars['String'];
  externalId: Scalars['String'];
  id: Scalars['UUID'];
  organizationGroup: OrganizationGroupType;
  price: Scalars['Float'];
  product: ProductType;
  published: Scalars['Boolean'];
  requestedQuantity: Scalars['Int'];
  stock: Scalars['Int'];
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};


export type OrganizationGroupOemThroughTypeRequestedQuantityArgs = {
  organizationId?: InputMaybe<Scalars['UUID']>;
};

export type OrganizationGroupType = {
  __typename?: 'OrganizationGroupType';
  dealerCommission?: Maybe<Scalars['Float']>;
  factoryControlOrganizations: Array<OrganizationType>;
  id: Scalars['UUID'];
  isOem: Scalars['Boolean'];
  name: Scalars['String'];
  newProducts: Array<ProductType>;
  oemProducts: Array<OrganizationGroupOemThroughType>;
  organizations: Array<OrganizationType>;
  paymentMethods: Array<PaymentMethodType>;
  priceModifiers: Array<ProductPriceModifierType>;
  products: Array<ProductType>;
  subcategories: Array<ProductSubcategoryType>;
};

export type OrganizationListOptionsInputType = {
  groupIsOemBool?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  ordering?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};

export type OrganizationListType = {
  __typename?: 'OrganizationListType';
  count: Scalars['Int'];
  items: Array<OrganizationType>;
  page: Scalars['Int'];
};

export type OrganizationType = {
  __typename?: 'OrganizationType';
  accountSet: Array<AccountType>;
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  ecns: Array<EcnType>;
  externalId: Scalars['String'];
  factoryMachineStartUps: Array<MachineStartUpType>;
  fieldMachineStartUps: Array<MachineStartUpType>;
  group: OrganizationGroupType;
  id: Scalars['UUID'];
  location?: Maybe<LocationType>;
  name: Scalars['String'];
  oemMachineStartUps: Array<MachineStartUpType>;
  organizationgroupSet: Array<OrganizationGroupType>;
  seederbrandSet: Array<SeederBrandType>;
  taxId: Scalars['String'];
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type PartNumberType = {
  __typename?: 'PartNumberType';
  displayName: Scalars['String'];
  externalId: Scalars['String'];
};

export type PartsArrivalTaskEcnCancelledPartFormInput = {
  id?: InputMaybe<Scalars['ID']>;
  partsArrived?: InputMaybe<Scalars['Boolean']>;
};

export type PartsArrivalTaskEcnNewPartFormInput = {
  id?: InputMaybe<Scalars['ID']>;
  partsArrived?: InputMaybe<Scalars['Boolean']>;
};

export type PartsArrivalTaskMutationInput = {
  cancelledParts?: InputMaybe<Array<PartsArrivalTaskEcnCancelledPartFormInput>>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  newParts?: InputMaybe<Array<PartsArrivalTaskEcnNewPartFormInput>>;
};

export type PartsArrivalTaskMutationPayload = {
  __typename?: 'PartsArrivalTaskMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  ecn?: Maybe<EcnType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type PaymentMethodCategoryType = {
  __typename?: 'PaymentMethodCategoryType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  finnancied: Scalars['Boolean'];
  id: Scalars['UUID'];
  name: Scalars['String'];
  order: Scalars['Int'];
  paymentMethods: Array<PaymentMethodType>;
  published: Scalars['Boolean'];
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type PaymentMethodType = {
  __typename?: 'PaymentMethodType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  currencyCode?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['Date']>;
  id: Scalars['UUID'];
  multiplier: Scalars['Float'];
  name: Scalars['String'];
  order: Scalars['Int'];
  organizationsGroups: Array<OrganizationGroupType>;
  originalPaymentMethod: Array<QuotedPaymentMethodType>;
  paymentmethodcategorySet: Array<PaymentMethodCategoryType>;
  published: Scalars['Boolean'];
  slug: Scalars['String'];
  startDate?: Maybe<Scalars['Date']>;
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type PemAdministrativeRevisionMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  dealerStartUpPrice: Scalars['Float'];
  id?: InputMaybe<Scalars['ID']>;
  installationPrice: Scalars['Float'];
  isFieldStepPending?: InputMaybe<Scalars['Boolean']>;
  organizationFactory?: InputMaybe<Scalars['UUID']>;
  organizationField?: InputMaybe<Scalars['UUID']>;
  withPostFieldRevision?: InputMaybe<Scalars['Boolean']>;
};

export type PemAdministrativeRevisionMutationPayload = {
  __typename?: 'PemAdministrativeRevisionMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  machineStartUp?: Maybe<MachineStartUpType>;
};

export type PemAdministrativeRevisionUpdateMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  organizationField?: InputMaybe<Scalars['UUID']>;
};

export type PemAdministrativeRevisionUpdateMutationPayload = {
  __typename?: 'PemAdministrativeRevisionUpdateMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  machineStartUp?: Maybe<MachineStartUpType>;
};

export type PemCalculationTypeAdditionalType = {
  __typename?: 'PemCalculationTypeAdditionalType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  id: Scalars['UUID'];
  partialHours: Scalars['Float'];
  subCategories: Array<ProductSubcategoryType>;
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type PemCalculationTypeFixedType = {
  __typename?: 'PemCalculationTypeFixedType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  id: Scalars['UUID'];
  partialHours: Scalars['Float'];
  pemRule: PemRuleType;
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type PemCalculationTypeVariableType = {
  __typename?: 'PemCalculationTypeVariableType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  id: Scalars['UUID'];
  minutesPerRow: Scalars['Int'];
  pemRule: PemRuleType;
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type PemCalculationTypeVisitType = {
  __typename?: 'PemCalculationTypeVisitType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  partialHours: Scalars['Float'];
  pemRule: PemRuleType;
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type PemFactoryImagesMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  dealerFactoryInvoice?: InputMaybe<Scalars['Upload']>;
  factoryPlaqueImage?: InputMaybe<Scalars['Upload']>;
  factoryProtocolImage?: InputMaybe<Scalars['Upload']>;
  factoryTermsImage?: InputMaybe<Scalars['Upload']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type PemFactoryImagesMutationPayload = {
  __typename?: 'PemFactoryImagesMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  machineStartUp?: Maybe<MachineStartUpType>;
};

export type PemFactoryReviewMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  dealerFactoryInvoice?: InputMaybe<Scalars['Upload']>;
  dealerFactoryNotes?: InputMaybe<Scalars['String']>;
  estimatedDeliveryDate?: InputMaybe<Scalars['Date']>;
  factoryPlaqueImage?: InputMaybe<Scalars['Upload']>;
  factoryProtocolImage?: InputMaybe<Scalars['Upload']>;
  factoryTermsImage?: InputMaybe<Scalars['Upload']>;
  id?: InputMaybe<Scalars['ID']>;
  missingProducts?: InputMaybe<Array<MissingProductsFormInput>>;
  productCategories?: InputMaybe<Array<ProductCategoryIdsFormInput>>;
  productionDateFrom?: InputMaybe<Scalars['Date']>;
  productionDateTo?: InputMaybe<Scalars['Date']>;
  seederSerialNumber?: InputMaybe<Scalars['String']>;
};

export type PemFactoryReviewMutationPayload = {
  __typename?: 'PemFactoryReviewMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  machineStartUp?: Maybe<MachineStartUpType>;
};

export type PemFieldImagesMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  dealerFieldInvoice?: InputMaybe<Scalars['Upload']>;
  fieldPlaqueImage?: InputMaybe<Scalars['Upload']>;
  fieldProtocolImage?: InputMaybe<Scalars['Upload']>;
  fieldTermsImage?: InputMaybe<Scalars['Upload']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type PemFieldImagesMutationPayload = {
  __typename?: 'PemFieldImagesMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  machineStartUp?: Maybe<MachineStartUpType>;
};

export type PemFieldReviewMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  customerAssistants: Array<CustomerAssistantFormInput>;
  dealerFieldInvoice?: InputMaybe<Scalars['Upload']>;
  dealerFieldNotes?: InputMaybe<Scalars['String']>;
  estimatedDeliveryDate?: InputMaybe<Scalars['Date']>;
  factoryAssistants?: InputMaybe<Array<FactoryAssistantFormInput>>;
  factoryPlaqueImage?: InputMaybe<Scalars['Upload']>;
  factoryProtocolImage?: InputMaybe<Scalars['Upload']>;
  factoryTermsImage?: InputMaybe<Scalars['Upload']>;
  fieldPlaqueImage?: InputMaybe<Scalars['Upload']>;
  fieldProtocolImage?: InputMaybe<Scalars['Upload']>;
  fieldTermsImage?: InputMaybe<Scalars['Upload']>;
  id?: InputMaybe<Scalars['ID']>;
  productCategories?: InputMaybe<Array<ProductCategoryIdsFormInput>>;
  seederSerialNumber?: InputMaybe<Scalars['String']>;
};

export type PemFieldReviewMutationPayload = {
  __typename?: 'PemFieldReviewMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  machineStartUp?: Maybe<MachineStartUpType>;
};

export const PemInspectionRevisionInspection = {
  Factory: 'factory',
  Field: 'field'
} as const;

export type PemInspectionRevisionInspection = typeof PemInspectionRevisionInspection[keyof typeof PemInspectionRevisionInspection];
export type PemInspectionRevisionMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  inspection: PemInspectionRevisionInspection;
  state: PemInspectionRevisionState;
};

export type PemInspectionRevisionMutationPayload = {
  __typename?: 'PemInspectionRevisionMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  machineStartUp?: Maybe<MachineStartUpType>;
};

export const PemInspectionRevisionState = {
  Approved: 'approved',
  Rejected: 'rejected'
} as const;

export type PemInspectionRevisionState = typeof PemInspectionRevisionState[keyof typeof PemInspectionRevisionState];
export type PemPdfExport = {
  __typename?: 'PemPdfExport';
  job: ExportJobType;
};

export type PemRuleType = {
  __typename?: 'PemRuleType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  fixed?: Maybe<PemCalculationTypeFixedType>;
  id: Scalars['UUID'];
  machineStartUps: Array<MachineStartUpType>;
  name: Scalars['String'];
  subCategories: Array<ProductSubcategoryType>;
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
  variable?: Maybe<PemCalculationTypeVariableType>;
  visit?: Maybe<PemCalculationTypeVisitType>;
};

export type PemWorkflowMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  factoryWorkflowNumber?: InputMaybe<Scalars['String']>;
  fieldWorkflowNumber?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type PemWorkflowMutationPayload = {
  __typename?: 'PemWorkflowMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  machineStartUp?: Maybe<MachineStartUpType>;
};

export type PricingTaskEcnCancelledPartFormInput = {
  id?: InputMaybe<Scalars['ID']>;
  pricing?: InputMaybe<Scalars['Float']>;
};

export type PricingTaskEcnNewPartFormInput = {
  id?: InputMaybe<Scalars['ID']>;
  pricing?: InputMaybe<Scalars['Float']>;
};

export type PricingTaskMutationInput = {
  cancelledParts?: InputMaybe<Array<PricingTaskEcnCancelledPartFormInput>>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  newParts?: InputMaybe<Array<PricingTaskEcnNewPartFormInput>>;
};

export type PricingTaskMutationPayload = {
  __typename?: 'PricingTaskMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  ecn?: Maybe<EcnType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type PriotityDatum = {
  __typename?: 'PriotityDatum';
  highCount: Scalars['Int'];
  label: Scalars['String'];
  lowCount: Scalars['Int'];
  mediumCount: Scalars['Int'];
};

export type ProductCategoryIdsFormInput = {
  engineQuantity?: InputMaybe<Scalars['Int']>;
  id: Scalars['UUID'];
};

export type ProductCategoryType = {
  __typename?: 'ProductCategoryType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  enabledForAssistedQuote: Scalars['Boolean'];
  enabledForMachineStartUp: Scalars['Boolean'];
  enabledForSeeder: Scalars['Boolean'];
  estimatedAmount: Scalars['Float'];
  id: Scalars['UUID'];
  multiplyByEngine: Scalars['Boolean'];
  multiplyBySeederRows: Scalars['Boolean'];
  name: Scalars['String'];
  order: Scalars['Int'];
  orderedoemproductSet: Array<OrderedOemProductType>;
  payOnlyFieldReview: Scalars['Boolean'];
  payToSeederBrands: Array<SeederBrandType>;
  productSet: Array<ProductType>;
  quotedproductSet: Array<QuotedProductType>;
  rules: Array<QuoteRuleType>;
  seederSet: Array<SeederType>;
  subcategories: Array<ProductSubcategoryType>;
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
  warrantyproductSet: Array<WarrantyProductType>;
  yearlyForecast: Array<CategoryYearlyForecastType>;
};

export type ProductCommentListOptionsInputType = {
  ordering?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  productIdExact?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  query?: InputMaybe<Scalars['String']>;
};

export type ProductCommentListType = {
  __typename?: 'ProductCommentListType';
  count: Scalars['Int'];
  items: Array<ProductCommentType>;
  page: Scalars['Int'];
};

export type ProductCommentMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  content: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  product: Scalars['ID'];
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type ProductCommentMutationPayload = {
  __typename?: 'ProductCommentMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  productComment?: Maybe<ProductCommentType>;
};

export type ProductCommentType = {
  __typename?: 'ProductCommentType';
  content: Scalars['String'];
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  id: Scalars['UUID'];
  product: ProductType;
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type ProductImageRequestType = {
  products: Array<InputMaybe<Scalars['String']>>;
};

export type ProductListOptionsInputType = {
  effectiveDateGreater?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  effectiveDateLower?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  externalIdIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  mmStatusIexact?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  ordering?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  publishedBool?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  query?: InputMaybe<Scalars['String']>;
  subcategoryCategory?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  untilStockRunsOutBool?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type ProductListType = {
  __typename?: 'ProductListType';
  count: Scalars['Int'];
  items: Array<ProductType>;
  page: Scalars['Int'];
};

export type ProductListTypeV2 = {
  __typename?: 'ProductListTypeV2';
  count: Scalars['Int'];
  items: Array<ProductType>;
  page: Scalars['Int'];
};

export type ProductListTypeV2OptionsInputType2 = {
  externalIdExact?: InputMaybe<Scalars['String']>;
  externalIdIcontains?: InputMaybe<Scalars['String']>;
  externalIdIexact?: InputMaybe<Scalars['String']>;
  mmStatusExact?: InputMaybe<ProductsProductMmStatusChoices>;
  ordering?: InputMaybe<Scalars['String']>;
  organizationGroupsExact?: InputMaybe<Scalars['UUID']>;
  organizationGroupsIn?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  publishedExact?: InputMaybe<Scalars['Boolean']>;
  query?: InputMaybe<Scalars['String']>;
  subcategoryCategoryExact?: InputMaybe<Scalars['UUID']>;
  subcategoryCategoryIn?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  subcategoryExact?: InputMaybe<Scalars['UUID']>;
  subcategoryIn?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  typeExact?: InputMaybe<ProductsProductTypeChoices>;
};

export type ProductOriginType = {
  __typename?: 'ProductOriginType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  order: Scalars['Int'];
  products: Array<ProductType>;
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type ProductPriceModifierType = {
  __typename?: 'ProductPriceModifierType';
  billingType: ProductsProductPriceModifierBillingTypeChoices;
  commissionMultiplier: Scalars['Float'];
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  enableDiscount: Scalars['Boolean'];
  id: Scalars['UUID'];
  organizationGroup: OrganizationGroupType;
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type ProductRankingDatum = {
  __typename?: 'ProductRankingDatum';
  amount?: Maybe<Scalars['Float']>;
  count: Scalars['Int'];
  product: ProductType;
  ranking: Scalars['Int'];
};

export type ProductSubcategoryType = {
  __typename?: 'ProductSubcategoryType';
  category: ProductCategoryType;
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  ecnnewpartSet: Array<EcnNewPartType>;
  id: Scalars['UUID'];
  missingproductSet: Array<MissingProductType>;
  name: Scalars['String'];
  order: Scalars['Int'];
  orderedoemproductSet: Array<OrderedOemProductType>;
  organizationgroupSet: Array<OrganizationGroupType>;
  pemAdditionals: Array<PemCalculationTypeAdditionalType>;
  pemRules: Array<PemRuleType>;
  productSet: Array<ProductType>;
  quotedproductSet: Array<QuotedProductType>;
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
  warrantyproductSet: Array<WarrantyProductType>;
};

export type ProductSupportTaskEcnCancelledPartFormInput = {
  id?: InputMaybe<Scalars['ID']>;
  supportLink?: InputMaybe<Scalars['String']>;
  supportNotes?: InputMaybe<Scalars['String']>;
};

export type ProductSupportTaskEcnNewPartFormInput = {
  id?: InputMaybe<Scalars['ID']>;
  supportLink?: InputMaybe<Scalars['String']>;
  supportNotes?: InputMaybe<Scalars['String']>;
};

export type ProductSupportTaskMutationInput = {
  cancelledParts?: InputMaybe<Array<ProductSupportTaskEcnCancelledPartFormInput>>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  newParts?: InputMaybe<Array<ProductSupportTaskEcnNewPartFormInput>>;
};

export type ProductSupportTaskMutationPayload = {
  __typename?: 'ProductSupportTaskMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  ecn?: Maybe<EcnType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type ProductType = {
  __typename?: 'ProductType';
  comments: Array<ProductCommentType>;
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  currentProduct?: Maybe<ProductType>;
  description: Scalars['String'];
  displayMmStatus: Scalars['String'];
  displayName: Scalars['String'];
  displayType: Scalars['String'];
  ecnId?: Maybe<Scalars['UUID']>;
  effectiveDate?: Maybe<Scalars['Date']>;
  externalId: Scalars['String'];
  history: Array<ProductType>;
  id: Scalars['UUID'];
  image?: Maybe<Scalars['String']>;
  isRemoved: Scalars['Boolean'];
  mmStatus: ProductsProductMmStatusChoices;
  name: Scalars['String'];
  oemProducts: Array<OrganizationGroupOemThroughType>;
  order: Scalars['Int'];
  organizationGroup?: Maybe<OrganizationGroupType>;
  organizationGroups: Array<OrganizationGroupType>;
  origin?: Maybe<ProductOriginType>;
  price: Scalars['Float'];
  published: Scalars['Boolean'];
  rowCount: Scalars['Int'];
  ruleCategories: Array<ProductCategoryType>;
  ruleGroup?: Maybe<RuleGroupType>;
  rules: Array<QuoteRuleType>;
  subcategory: ProductSubcategoryType;
  type: ProductsProductTypeChoices;
  untilStockRunsOut: Scalars['Boolean'];
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
  yearlyFactors: Array<ProductYearlyFactorType>;
};

export type ProductWarrantyClaimListOptionsInputType = {
  contactAccount?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  contactAccountOwner?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  createdBy?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  createdGte?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  createdLte?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  idExact?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  inspectionReviewStatus?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  ordering?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type ProductWarrantyClaimListType = {
  __typename?: 'ProductWarrantyClaimListType';
  count: Scalars['Int'];
  items: Array<ProductWarrantyClaimType>;
  page: Scalars['Int'];
};

export type ProductWarrantyClaimPdfExportType = {
  __typename?: 'ProductWarrantyClaimPdfExportType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  file?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
  warrantyClaim: ProductWarrantyClaimType;
};

export type ProductWarrantyClaimReviewType = {
  __typename?: 'ProductWarrantyClaimReviewType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  id: Scalars['UUID'];
  notes: Scalars['String'];
  productWarrantyClaim: ProductWarrantyClaimType;
  productwarrantyclaimSet: Array<ProductWarrantyClaimType>;
  status: ProductsProductWarrantyClaimReviewStatusChoices;
  statusDisplay: Scalars['String'];
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type ProductWarrantyClaimType = {
  __typename?: 'ProductWarrantyClaimType';
  contact: ContactType;
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  deliveryDate: Scalars['Date'];
  description: Scalars['String'];
  displayId: Scalars['Int'];
  externalId?: Maybe<Scalars['String']>;
  failureDate: Scalars['Date'];
  finalClient: Scalars['String'];
  id: Scalars['UUID'];
  images?: Maybe<Array<Maybe<WarrantyClaimImageType>>>;
  inspectionReview?: Maybe<WarrantyClaimInspectionReviewType>;
  inspectionReviewHistories: Array<WarrantyClaimInspectionReviewHistoryType>;
  lastReview?: Maybe<ProductWarrantyClaimReviewType>;
  pdfs: Array<ProductWarrantyClaimPdfExportType>;
  phone: Scalars['String'];
  product?: Maybe<WarrantyProductType>;
  quantity: Scalars['Int'];
  reviews: Array<ProductWarrantyClaimReviewType>;
  seeder?: Maybe<SeederType>;
  seederKilometers: Scalars['Int'];
  serialNumber: Scalars['String'];
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
  videos: Array<WarrantyClaimVideoType>;
};

export type ProductYearlyFactorMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  product: Scalars['UUID'];
  value?: InputMaybe<Scalars['Int']>;
};

export type ProductYearlyFactorMutationPayload = {
  __typename?: 'ProductYearlyFactorMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  productYearlyFactor?: Maybe<ProductYearlyFactorType>;
};

export type ProductYearlyFactorType = {
  __typename?: 'ProductYearlyFactorType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  id: Scalars['UUID'];
  product: ProductType;
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
  value?: Maybe<Scalars['Int']>;
  year: Scalars['Int'];
};

export const ProductsProductMmStatusChoices = {
  Active: 'ACTIVE',
  Cancel: 'CANCEL',
  New: 'NEW',
  Revision: 'REVISION'
} as const;

export type ProductsProductMmStatusChoices = typeof ProductsProductMmStatusChoices[keyof typeof ProductsProductMmStatusChoices];
export const ProductsProductPriceModifierBillingTypeChoices = {
  Direct: 'DIRECT',
  FastTrack: 'FAST_TRACK',
  Indirect: 'INDIRECT'
} as const;

export type ProductsProductPriceModifierBillingTypeChoices = typeof ProductsProductPriceModifierBillingTypeChoices[keyof typeof ProductsProductPriceModifierBillingTypeChoices];
export const ProductsProductTypeChoices = {
  Beta: 'BETA',
  Commercial: 'COMMERCIAL',
  InternalBeta: 'INTERNAL_BETA',
  Tooling: 'TOOLING'
} as const;

export type ProductsProductTypeChoices = typeof ProductsProductTypeChoices[keyof typeof ProductsProductTypeChoices];
export const ProductsProductWarrantyClaimReviewStatusChoices = {
  Approved: 'APPROVED',
  Cancelled: 'CANCELLED',
  Pending: 'PENDING',
  Rejected: 'REJECTED',
  Sent: 'SENT'
} as const;

export type ProductsProductWarrantyClaimReviewStatusChoices = typeof ProductsProductWarrantyClaimReviewStatusChoices[keyof typeof ProductsProductWarrantyClaimReviewStatusChoices];
export const ProductsWarrantyClaimInspectionReviewStatusChoices = {
  Finished: 'FINISHED',
  Received: 'RECEIVED'
} as const;

export type ProductsWarrantyClaimInspectionReviewStatusChoices = typeof ProductsWarrantyClaimInspectionReviewStatusChoices[keyof typeof ProductsWarrantyClaimInspectionReviewStatusChoices];
export type PurchaseTaskEcnCancelledPartFormInput = {
  buyingDate?: InputMaybe<Scalars['Date']>;
  buyingPrice?: InputMaybe<Scalars['Float']>;
  estimatedDateArrival?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['ID']>;
  origin?: InputMaybe<Scalars['UUID']>;
  supplier?: InputMaybe<Scalars['String']>;
  tariffPosition?: InputMaybe<Scalars['Boolean']>;
  tariffPositionNotes?: InputMaybe<Scalars['String']>;
};

export type PurchaseTaskEcnNewPartFormInput = {
  buyingDate?: InputMaybe<Scalars['Date']>;
  buyingPrice?: InputMaybe<Scalars['Float']>;
  estimatedDateArrival?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['ID']>;
  origin?: InputMaybe<Scalars['UUID']>;
  supplier?: InputMaybe<Scalars['String']>;
  tariffPosition?: InputMaybe<Scalars['Boolean']>;
  tariffPositionNotes?: InputMaybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  account: AccountType;
  accountRegions: Array<AccountRegionType>;
  accounts: AccountListType;
  analyticsPdfExport: DownloadType;
  bankInvoicePdf: BankInvoicePdfType;
  bankInvoicePdfDisclaimer: BankInvoicePdfDisclaimerType;
  billingTypes: Array<BillingTypeType>;
  childOrganizations: Array<OrganizationType>;
  childUsers: Array<UserType>;
  closeReasons: Array<CloseReasonType>;
  closedQuotes: QuoteListType;
  contact: ContactType;
  contactTypes: Array<ContactTypeType>;
  contacts: ContactListType;
  defaultTask: DefaultTaskType;
  defaultTasks: Array<DefaultTaskType>;
  draftEcn: DraftEcnType;
  draftsEcns: DraftEcnListType;
  ecn: EcnType;
  ecnAnalytics?: Maybe<EcnAnalyticsType>;
  ecnConfig: EcnConfigType;
  ecnHistory: HistoricalEcnListType;
  ecnHistoryDiff: Array<Maybe<ModelDeltaType>>;
  ecns: EcnListType2;
  expiredQuotes: QuoteListType;
  exportFileJob?: Maybe<ExportJobType>;
  externalIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  factoryControlOrganizations: Array<OrganizationType>;
  failures: Array<FailureType>;
  gefcoDelivers: Array<GefcoDeliverType>;
  /** @deprecated Deprecated */
  gefcoShipment: GefcoShipmentResponse;
  getCurrentEcnNumber: Scalars['String'];
  job?: Maybe<JobType>;
  location?: Maybe<LocationType>;
  locations?: Maybe<Array<LocationType>>;
  machineStartUp: MachineStartUpType;
  machineStartUps: MachineStartUpListType;
  materialMasterProducts?: Maybe<ProductListType>;
  missingProducts: MissingProductTypeList;
  notifications: NotificationsType;
  notificationsConfigNames: Array<Maybe<NotificationConfigNameType>>;
  oemOrders: QuoteListType;
  oemProducts: Array<OrganizationGroupOemThroughType>;
  opportunities: OpportunityListType;
  opportunity: OpportunityType;
  opportunityChannels: Array<OpportunityChannelType>;
  opportunityReasons: Array<OpportunityReasonType>;
  opportunitySituations: Array<OpportunitySituationType>;
  orderOem: OrderOemType;
  orderedProduct: OrderedProductType;
  ordersOem: OrderOemListType;
  ordersOemPaymentMethod: OrderOemPaymentMethodType;
  organizationOemStock: OrganizationGroupOemThroughListType;
  organizations: OrganizationListType;
  organizationsGroups: OrganizationGroupListType;
  partsNumbers: Array<PartNumberType>;
  paymentMethod: PaymentMethodType;
  paymentMethodCategories: Array<PaymentMethodCategoryType>;
  paymentMethodCategory: Array<PaymentMethodCategoryType>;
  paymentMethods: Array<PaymentMethodType>;
  pemRule?: Maybe<PemRuleType>;
  pemRuleAdditionals?: Maybe<Array<Maybe<PemCalculationTypeAdditionalType>>>;
  pemRuleAdditionalsById?: Maybe<Array<Maybe<PemCalculationTypeAdditionalType>>>;
  pemRules: Array<Maybe<PemRuleType>>;
  product: ProductType;
  productCategories: Array<ProductCategoryType>;
  productCategoriesEnabledForMachineStartUp: Array<ProductCategoryType>;
  productCategoriesEnabledForSeeder: Array<ProductCategoryType>;
  productCategoriesForAssistedQuote: Array<ProductCategoryType>;
  productComments: ProductCommentListType;
  productOrigins: Array<ProductOriginType>;
  productPriceModifiers: Array<ProductPriceModifierType>;
  productSubcategories: Array<ProductSubcategoryType>;
  productWarrantyClaim: ProductWarrantyClaimType;
  productWarrantyClaims: ProductWarrantyClaimListType;
  products: Array<ProductType>;
  productsImages: Array<ProductType>;
  productsStocks?: Maybe<StockResponseType>;
  productsV2: ProductListTypeV2;
  quote: QuoteType;
  quoteKitMultiplier: QuoteKitMultiplierType;
  quoteKitMultipliers: Array<QuoteKitMultiplierType>;
  quoteRules: Array<QuoteRuleType>;
  quotedPaymentMethod: QuotedPaymentMethodType;
  quotes: QuoteListType;
  quotesAnalytics?: Maybe<QuotesAnalyticsType>;
  roles: Array<RoleType>;
  rulesGroups: Array<RuleGroupType>;
  runtimeSettings: RuntimeSettingsType;
  sale: SaleType;
  sales: SaleListType;
  salesAnalytics?: Maybe<SalesAnalyticsType>;
  salesPotentialAnalytics?: Maybe<SalesPotentialAnalyticsType>;
  seeder: SeederType;
  seederBrands: Array<SeederBrandType>;
  seederModels: Array<Maybe<SeederModelType>>;
  seeders: Array<Maybe<SeederType>>;
  shipment: ShipmentType;
  shipmentOEM: ShipmentOemType;
  shipments: Array<ShipmentType>;
  shipmentsAnalytics?: Maybe<ShipmentsAnalyticsType>;
  shipmentsOEM: Array<ShipmentOemType>;
  supplyOrder: SupplyOrderType;
  supplyOrders: SupplyOrderListType;
  supplyOrdersAnalytics?: Maybe<SupplyOrdersAnalyticsType>;
  taskComments: EcnTaskCommentListType;
  unpublishedProducts: Array<ProductType>;
  user?: Maybe<UserType>;
  userNotificationsConfigs: Array<NotificationConfigType>;
  users: Array<UserType>;
  usersList: UserListType;
  validExternalId: Scalars['Boolean'];
  warrantyClaimsAnalytics?: Maybe<WarrantyClaimsAnalyticsType>;
};


export type QueryAccountArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryAccountsArgs = {
  filterByUser?: InputMaybe<Scalars['Boolean']>;
  options?: InputMaybe<AccountListOptionsInputType>;
};


export type QueryAnalyticsPdfExportArgs = {
  path: Scalars['String'];
  waitForSelector: Scalars['String'];
};


export type QueryBankInvoicePdfArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryClosedQuotesArgs = {
  options?: InputMaybe<QuoteListOptionsInputType>;
};


export type QueryContactArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryContactsArgs = {
  filterByUser?: InputMaybe<Scalars['Boolean']>;
  options?: InputMaybe<ContactListOptionsInputType>;
};


export type QueryDefaultTaskArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryDraftEcnArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryDraftsEcnsArgs = {
  options?: InputMaybe<DraftEcnListOptionsInputType>;
};


export type QueryEcnArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryEcnAnalyticsArgs = {
  filters: AnalyticsFilters;
};


export type QueryEcnHistoryArgs = {
  id: Scalars['UUID'];
  options?: InputMaybe<HistoricalEcnListOptionsInputType>;
};


export type QueryEcnHistoryDiffArgs = {
  id: Scalars['UUID'];
};


export type QueryEcnsArgs = {
  options?: InputMaybe<EcnListType2OptionsInputType2>;
};


export type QueryExpiredQuotesArgs = {
  options?: InputMaybe<QuoteListOptionsInputType>;
};


export type QueryExportFileJobArgs = {
  id: Scalars['String'];
};


export type QueryFactoryControlOrganizationsArgs = {
  organizationGroupId?: InputMaybe<Scalars['UUID']>;
};


export type QueryGefcoDeliversArgs = {
  appLabel: Scalars['String'];
  model: Scalars['String'];
  objectUuid: Scalars['String'];
};


export type QueryGefcoShipmentArgs = {
  disableCache?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


export type QueryJobArgs = {
  id: Scalars['String'];
};


export type QueryLocationArgs = {
  id: Scalars['ID'];
};


export type QueryLocationsArgs = {
  id?: InputMaybe<Scalars['Int']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryMachineStartUpArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryMachineStartUpsArgs = {
  options?: InputMaybe<MachineStartUpListOptionsInputType>;
};


export type QueryMaterialMasterProductsArgs = {
  options?: InputMaybe<ProductListOptionsInputType>;
};


export type QueryMissingProductsArgs = {
  options?: InputMaybe<MissingProductTypeListOptionsInputType>;
};


export type QueryOemOrdersArgs = {
  options?: InputMaybe<QuoteListOptionsInputType>;
};


export type QueryOemProductsArgs = {
  organizationId: Scalars['UUID'];
};


export type QueryOpportunitiesArgs = {
  options?: InputMaybe<OpportunityListOptionsInputType>;
};


export type QueryOpportunityArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryOrderOemArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryOrderedProductArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryOrdersOemArgs = {
  options?: InputMaybe<OrderOemListOptionsInputType>;
};


export type QueryOrdersOemPaymentMethodArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryOrganizationOemStockArgs = {
  options?: InputMaybe<OrganizationGroupOemThroughListOptionsInputType>;
};


export type QueryOrganizationsArgs = {
  options?: InputMaybe<OrganizationListOptionsInputType>;
};


export type QueryOrganizationsGroupsArgs = {
  options?: InputMaybe<OrganizationGroupListOptionsInputType>;
};


export type QueryPaymentMethodArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryPaymentMethodCategoriesArgs = {
  categoryId?: InputMaybe<Scalars['UUID']>;
};


export type QueryPaymentMethodsArgs = {
  categoryId?: InputMaybe<Scalars['UUID']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
};


export type QueryPemRuleArgs = {
  id: Scalars['UUID'];
};


export type QueryPemRuleAdditionalsByIdArgs = {
  id: Scalars['UUID'];
};


export type QueryProductArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryProductCategoriesArgs = {
  seederId?: InputMaybe<Scalars['UUID']>;
};


export type QueryProductCommentsArgs = {
  options?: InputMaybe<ProductCommentListOptionsInputType>;
};


export type QueryProductWarrantyClaimArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryProductWarrantyClaimsArgs = {
  options?: InputMaybe<ProductWarrantyClaimListOptionsInputType>;
};


export type QueryProductsArgs = {
  categoryId?: InputMaybe<Scalars['UUID']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
};


export type QueryProductsImagesArgs = {
  req?: InputMaybe<ProductImageRequestType>;
};


export type QueryProductsStocksArgs = {
  externalIds: Array<InputMaybe<Scalars['String']>>;
};


export type QueryProductsV2Args = {
  options?: InputMaybe<ProductListTypeV2OptionsInputType2>;
};


export type QueryQuoteArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryQuoteKitMultiplierArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryQuotedPaymentMethodArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryQuotesArgs = {
  options?: InputMaybe<QuoteListOptionsInputType>;
};


export type QueryQuotesAnalyticsArgs = {
  filters: AnalyticsFilters;
};


export type QuerySaleArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QuerySalesArgs = {
  options?: InputMaybe<SaleListOptionsInputType>;
};


export type QuerySalesAnalyticsArgs = {
  filters: AnalyticsFilters;
};


export type QuerySalesPotentialAnalyticsArgs = {
  filters: AnalyticsFilters;
};


export type QuerySeederArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QuerySeederBrandsArgs = {
  organizationId?: InputMaybe<Scalars['UUID']>;
};


export type QuerySeederModelsArgs = {
  seederBrandId?: InputMaybe<Scalars['UUID']>;
};


export type QuerySeedersArgs = {
  accountId?: InputMaybe<Scalars['UUID']>;
};


export type QueryShipmentArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryShipmentOemArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryShipmentsAnalyticsArgs = {
  filters: AnalyticsFilters;
};


export type QuerySupplyOrderArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QuerySupplyOrdersArgs = {
  options?: InputMaybe<SupplyOrderListOptionsInputType>;
  user?: InputMaybe<Scalars['UUID']>;
};


export type QuerySupplyOrdersAnalyticsArgs = {
  filters: AnalyticsFilters;
};


export type QueryTaskCommentsArgs = {
  options?: InputMaybe<EcnTaskCommentListOptionsInputType>;
};


export type QueryUsersListArgs = {
  options?: InputMaybe<UserListOptionsInputType>;
};


export type QueryValidExternalIdArgs = {
  externalId: Scalars['String'];
  ignoreId?: InputMaybe<Scalars['UUID']>;
};


export type QueryWarrantyClaimsAnalyticsArgs = {
  filters: AnalyticsFilters;
};

export type QuoteCloseReasonInputType = {
  description: Scalars['String'];
  quote: Scalars['String'];
};

export type QuoteCloseReasonType = {
  __typename?: 'QuoteCloseReasonType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  description: Scalars['String'];
  id: Scalars['UUID'];
  quote: QuoteType;
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type QuoteExcelExport = {
  __typename?: 'QuoteExcelExport';
  job: ExportJobType;
};

export type QuoteKitMultiplierType = {
  __typename?: 'QuoteKitMultiplierType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  id: Scalars['UUID'];
  multiplier: Scalars['Float'];
  name: Scalars['String'];
  order: Scalars['Int'];
  published: Scalars['Boolean'];
  quoteSet: Array<QuoteType>;
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type QuoteListOptionsInputType = {
  billingType?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  contact?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  contactAccount?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  contactAccountOwner?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  createdDateGte?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  createdDateLte?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  ordering?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  statusIexact?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  user?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type QuoteListType = {
  __typename?: 'QuoteListType';
  count: Scalars['Int'];
  items: Array<QuoteType>;
  page: Scalars['Int'];
};

export type QuotePdfType = {
  __typename?: 'QuotePDFType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  emailStatus?: Maybe<Scalars['String']>;
  file?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  paymentMethod?: Maybe<QuotedPaymentMethodType>;
  productDisplay: QuotesQuotePdfProductDisplayChoices;
  quote: QuoteType;
  recipient: Scalars['String'];
  type: QuotesQuotePdfTypeChoices;
  typeDisplay?: Maybe<Scalars['String']>;
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type QuoteRuleType = {
  __typename?: 'QuoteRuleType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  description?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  group?: Maybe<RuleGroupType>;
  id: Scalars['UUID'];
  image?: Maybe<Scalars['String']>;
  operator: QuotesQuoteRuleOperatorChoices;
  order: Scalars['Int'];
  prioritizeRule: Scalars['Boolean'];
  product?: Maybe<ProductType>;
  productCategory?: Maybe<ProductCategoryType>;
  referenceMultiplier: Scalars['Float'];
  referenceSource: QuotesQuoteRuleReferenceSourceChoices;
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
  useForInitialValue: Scalars['Boolean'];
  useForValidation: Scalars['Boolean'];
  valueSource: QuotesQuoteRuleValueSourceChoices;
};

export type QuoteType = {
  __typename?: 'QuoteType';
  additionalChargesDescription?: Maybe<Scalars['String']>;
  additionalChargesValue?: Maybe<Scalars['Float']>;
  bankInvoices: Array<BankInvoicePdfType>;
  billingType: QuotesQuoteBillingTypeChoices;
  clonedQuotes: Array<QuoteType>;
  closeReason?: Maybe<QuoteCloseReasonType>;
  contact: ContactType;
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  displayBillingType: Scalars['String'];
  displayId: Scalars['Int'];
  displayName: Scalars['String'];
  id: Scalars['UUID'];
  kitMultiplier?: Maybe<QuoteKitMultiplierType>;
  notes?: Maybe<Scalars['String']>;
  oemOrder?: Maybe<Scalars['Boolean']>;
  originalQuote?: Maybe<QuoteType>;
  paymentMethods: Array<QuotedPaymentMethodType>;
  pdfs: Array<QuotePdfType>;
  products: Array<QuotedProductType>;
  rowCount?: Maybe<Scalars['Int']>;
  sale?: Maybe<SaleType>;
  seeder?: Maybe<SeederType>;
  status?: Maybe<QuotesQuoteStatusChoices>;
  statusDisplay: Scalars['String'];
  supplyOrder?: Maybe<SupplyOrderType>;
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type QuotedPaymentMethodFormInput = {
  currencyCode?: InputMaybe<Scalars['String']>;
  dealerCommission?: InputMaybe<Scalars['Float']>;
  extraMultiplier: Scalars['Float'];
  finnancied?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  isCustom?: InputMaybe<Scalars['Boolean']>;
  multiplier: Scalars['Float'];
  name: Scalars['String'];
  order: Scalars['Int'];
  originalPaymentMethod?: InputMaybe<Scalars['ID']>;
  slug: Scalars['String'];
};

export type QuotedPaymentMethodType = {
  __typename?: 'QuotedPaymentMethodType';
  bankInvoices: Array<BankInvoicePdfType>;
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  currencyCode?: Maybe<Scalars['String']>;
  dealerCommission?: Maybe<Scalars['Float']>;
  extraMultiplier: Scalars['Float'];
  finnancied: Scalars['Boolean'];
  id: Scalars['UUID'];
  isCustom: Scalars['Boolean'];
  multiplier: Scalars['Float'];
  name: Scalars['String'];
  order: Scalars['Int'];
  originalPaymentMethod?: Maybe<PaymentMethodType>;
  quote: QuoteType;
  quotepdfSet: Array<QuotePdfType>;
  sale?: Maybe<SaleType>;
  slug: Scalars['String'];
  supplyOrderPaymentMethod?: Maybe<SupplyOrderType>;
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type QuotedProductFormInput = {
  commissionMultiplier: Scalars['Float'];
  description?: InputMaybe<Scalars['String']>;
  enableDiscount?: InputMaybe<Scalars['Boolean']>;
  externalId: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  order: Scalars['Int'];
  price: Scalars['Float'];
  quantity: Scalars['Int'];
  rowCount: Scalars['Int'];
  ruleCategories?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  ruleGroup?: InputMaybe<Scalars['ID']>;
  subcategory: Scalars['ID'];
  untilStockRunsOut?: InputMaybe<Scalars['Boolean']>;
};

export type QuotedProductType = {
  __typename?: 'QuotedProductType';
  commissionMultiplier: Scalars['Float'];
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  description: Scalars['String'];
  enableDiscount: Scalars['Boolean'];
  externalId: Scalars['String'];
  id: Scalars['UUID'];
  name: Scalars['String'];
  order: Scalars['Int'];
  orderedproductSet: Array<OrderedProductType>;
  price: Scalars['Float'];
  quantity: Scalars['Int'];
  quote: QuoteType;
  rowCount: Scalars['Int'];
  ruleCategories: Array<ProductCategoryType>;
  ruleGroup?: Maybe<RuleGroupType>;
  subcategory: ProductSubcategoryType;
  untilStockRunsOut: Scalars['Boolean'];
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type QuotesAnalyticsType = {
  __typename?: 'QuotesAnalyticsType';
  amount: Scalars['Float'];
  byBillingType: Array<AmountDatum>;
  byDate: Array<DateSeriesDatum>;
  byPaymentMethod: Array<AmountDatum>;
  bySeederBrand: Array<AmountDatum>;
  bySeederModel: Array<AmountDatum>;
  byStatus: Array<AmountDatum>;
  count: Scalars['Int'];
  productRanking: Array<ProductRankingDatum>;
};

export const QuotesQuoteBillingTypeChoices = {
  Direct: 'DIRECT',
  FastTrack: 'FAST_TRACK',
  Indirect: 'INDIRECT'
} as const;

export type QuotesQuoteBillingTypeChoices = typeof QuotesQuoteBillingTypeChoices[keyof typeof QuotesQuoteBillingTypeChoices];
export const QuotesQuotePdfProductDisplayChoices = {
  ByCategory: 'BY_CATEGORY',
  Default: 'DEFAULT'
} as const;

export type QuotesQuotePdfProductDisplayChoices = typeof QuotesQuotePdfProductDisplayChoices[keyof typeof QuotesQuotePdfProductDisplayChoices];
export const QuotesQuotePdfTypeChoices = {
  Client: 'CLIENT',
  Internal: 'INTERNAL'
} as const;

export type QuotesQuotePdfTypeChoices = typeof QuotesQuotePdfTypeChoices[keyof typeof QuotesQuotePdfTypeChoices];
export const QuotesQuoteRuleOperatorChoices = {
  Eq: 'EQ',
  Gt: 'GT',
  Gte: 'GTE',
  Lt: 'LT',
  Lte: 'LTE'
} as const;

export type QuotesQuoteRuleOperatorChoices = typeof QuotesQuoteRuleOperatorChoices[keyof typeof QuotesQuoteRuleOperatorChoices];
export const QuotesQuoteRuleReferenceSourceChoices = {
  Constant: 'CONSTANT',
  HarnessCount: 'HARNESS_COUNT',
  SeederRowCount: 'SEEDER_ROW_COUNT',
  UnusedSeederRowCount: 'UNUSED_SEEDER_ROW_COUNT',
  UsedSeederRowCount: 'USED_SEEDER_ROW_COUNT'
} as const;

export type QuotesQuoteRuleReferenceSourceChoices = typeof QuotesQuoteRuleReferenceSourceChoices[keyof typeof QuotesQuoteRuleReferenceSourceChoices];
export const QuotesQuoteRuleValueSourceChoices = {
  Quantity: 'QUANTITY',
  RowCount: 'ROW_COUNT'
} as const;

export type QuotesQuoteRuleValueSourceChoices = typeof QuotesQuoteRuleValueSourceChoices[keyof typeof QuotesQuoteRuleValueSourceChoices];
export const QuotesQuoteStatusChoices = {
  Closed: 'CLOSED',
  InProgress: 'IN_PROGRESS',
  InSale: 'IN_SALE',
  InSupplyOrder: 'IN_SUPPLY_ORDER'
} as const;

export type QuotesQuoteStatusChoices = typeof QuotesQuoteStatusChoices[keyof typeof QuotesQuoteStatusChoices];
export type RejectWarrantyClaimRequestMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  notes?: InputMaybe<Scalars['String']>;
  productWarrantyClaim: Scalars['ID'];
};

export type RejectWarrantyClaimRequestMutationPayload = {
  __typename?: 'RejectWarrantyClaimRequestMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  productWarrantyClaimReview?: Maybe<ProductWarrantyClaimReviewType>;
};

export type ResetPasswordMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
};

export type ResetPasswordMutationPayload = {
  __typename?: 'ResetPasswordMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type ReviewAccountRegistrationMutationInput = {
  account: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  notes?: InputMaybe<Scalars['String']>;
  status: Scalars['String'];
};

export type ReviewAccountRegistrationMutationPayload = {
  __typename?: 'ReviewAccountRegistrationMutationPayload';
  accountRegistrationReview?: Maybe<AccountRegistrationReviewType>;
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type ReviewOemOrderMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  notes?: InputMaybe<Scalars['String']>;
  orderOem: Scalars['UUID'];
  status: Scalars['String'];
};

export type ReviewOemOrderMutationPayload = {
  __typename?: 'ReviewOemOrderMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  orderOEMReview?: Maybe<OrderOemReviewType>;
};

export type RoleType = {
  __typename?: 'RoleType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  ecns: Array<EcnType>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
  userSet: Array<UserType>;
};

export type RowInput = {
  externalId?: InputMaybe<Scalars['String']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<Scalars['String']>;
  paymentMethod?: InputMaybe<Scalars['String']>;
  productOemId?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['String']>;
  targetDate?: InputMaybe<Scalars['String']>;
};

export type RuleGroupType = {
  __typename?: 'RuleGroupType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  orderedoemproductSet: Array<OrderedOemProductType>;
  productSet: Array<ProductType>;
  quotedproductSet: Array<QuotedProductType>;
  rules: Array<QuoteRuleType>;
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
  warrantyproductSet: Array<WarrantyProductType>;
};

export type RuntimeSettingsType = {
  __typename?: 'RuntimeSettingsType';
  datastudioUrl?: Maybe<Scalars['String']>;
  datePaymentMethodCalculationV2: Scalars['Date'];
  driveDirectoryId?: Maybe<Scalars['String']>;
  expireQuoteTime: Scalars['Int'];
  id: Scalars['ID'];
  legalPersonsDocumentation?: Maybe<Scalars['String']>;
  machineStartUpInstallationPercentage: Scalars['Int'];
  machineStartUpPercentage: Scalars['Int'];
  maxVideoSize: Scalars['Int'];
  ordersOemTemplate?: Maybe<Scalars['String']>;
  pemProtocolTemplate?: Maybe<Scalars['String']>;
  pemTermsTemplate?: Maybe<Scalars['String']>;
  physicalPersonsDocumentation?: Maybe<Scalars['String']>;
  pricePerHour: Scalars['Float'];
  quoteExportHeader?: Maybe<Scalars['String']>;
  quotePdfDisclaimer: Scalars['String'];
  signaturesInDisclaimer: Scalars['Boolean'];
  spreadsheetId?: Maybe<Scalars['String']>;
  spreadsheetRange: Scalars['String'];
  spreadsheetSheetName?: Maybe<Scalars['String']>;
  spreedsheetAvailableQuantityColumnName?: Maybe<Scalars['String']>;
  spreedsheetExternalIdColumnName?: Maybe<Scalars['String']>;
  stockSpreadsheetUrl?: Maybe<Scalars['String']>;
  supplyOrderExportHeader?: Maybe<Scalars['String']>;
  taxIdLabel: Scalars['String'];
  templateOfAffidavit?: Maybe<Scalars['String']>;
  tinymceUrl?: Maybe<Scalars['String']>;
};

export type SaleListOptionsInputType = {
  createdDateGte?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  createdDateLte?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  ordering?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  quoteContact?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  quoteContactAccount?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  quoteContactAccountOwner?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  user?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type SaleListType = {
  __typename?: 'SaleListType';
  count: Scalars['Int'];
  items: Array<SaleType>;
  page: Scalars['Int'];
};

export type SaleType = {
  __typename?: 'SaleType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  displayName: Scalars['String'];
  id: Scalars['UUID'];
  paymentMethod: QuotedPaymentMethodType;
  quote: QuoteType;
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type SalesAnalyticsType = {
  __typename?: 'SalesAnalyticsType';
  amount: Scalars['Float'];
  byBillingType: Array<AmountDatum>;
  byDate: Array<DateSeriesDatum>;
  byPaymentMethod: Array<AmountDatum>;
  bySeederBrand: Array<AmountDatum>;
  bySeederModel: Array<AmountDatum>;
  count: Scalars['Int'];
  productRanking: Array<ProductRankingDatum>;
};

export type SalesPotentialAnalyticsType = {
  __typename?: 'SalesPotentialAnalyticsType';
  byMeterType: Array<SalesPotentialDatum>;
  byProductCategory: Array<SalesPotentialDatum>;
  bySeederBrand: Array<SalesPotentialDatum>;
  rowsCount: Scalars['Int'];
  seedersCount: Scalars['Int'];
};

export type SalesPotentialDatum = {
  __typename?: 'SalesPotentialDatum';
  count: Scalars['Int'];
  label: Scalars['String'];
  percentage: Scalars['Float'];
};

export type SeederBrandType = {
  __typename?: 'SeederBrandType';
  categoriesToPay: Array<ProductCategoryType>;
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  id: Scalars['UUID'];
  machinestartupSet: Array<MachineStartUpType>;
  models: Array<SeederModelType>;
  name: Scalars['String'];
  order: Scalars['Int'];
  organizations: Array<OrganizationType>;
  seederSet: Array<SeederType>;
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type SeederExportType = {
  __typename?: 'SeederExportType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  file?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type SeederModelType = {
  __typename?: 'SeederModelType';
  brand: SeederBrandType;
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  id: Scalars['UUID'];
  machinestartupSet: Array<MachineStartUpType>;
  name: Scalars['String'];
  order: Scalars['Int'];
  seederSet: Array<SeederType>;
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type SeederType = {
  __typename?: 'SeederType';
  account: AccountType;
  brand: SeederBrandType;
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  displayName: Scalars['String'];
  id: Scalars['UUID'];
  installedProductCategories: Array<ProductCategoryType>;
  meterType: SeedersSeederMeterTypeChoices;
  meterTypeDisplay?: Maybe<Scalars['String']>;
  model?: Maybe<SeederModelType>;
  quotes: Array<QuoteType>;
  rowCount: Scalars['Int'];
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
  warrantyClaims: Array<ProductWarrantyClaimType>;
  year: Scalars['Int'];
};

export const SeedersSeederMeterTypeChoices = {
  Mechanic: 'MECHANIC',
  Pneumatic: 'PNEUMATIC'
} as const;

export type SeedersSeederMeterTypeChoices = typeof SeedersSeederMeterTypeChoices[keyof typeof SeedersSeederMeterTypeChoices];
export type SetEcnFavorite = {
  __typename?: 'SetEcnFavorite';
  ok?: Maybe<Scalars['Boolean']>;
};

export type SetPasswordMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  token: Scalars['String'];
  user: Scalars['UUID'];
};

export type SetPasswordMutationPayload = {
  __typename?: 'SetPasswordMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  password: Scalars['String'];
  token: Scalars['String'];
  user: Scalars['UUID'];
};

export type ShipmentFormInput = {
  exchangeRate: Scalars['Float'];
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  invoice?: InputMaybe<Scalars['Upload']>;
  onHoldDescription?: InputMaybe<Scalars['String']>;
  productsShipped: Array<ShipmentProductFormInput>;
  status?: InputMaybe<Scalars['String']>;
  supplyOrder: Scalars['UUID'];
};

export type ShipmentOemProductType = {
  __typename?: 'ShipmentOEMProductType';
  batch?: Maybe<Scalars['String']>;
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  id: Scalars['UUID'];
  orderOem: OrderOemType;
  orderedProduct: OrderedOemProductType;
  quantity: Scalars['Int'];
  shipment: ShipmentOemType;
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type ShipmentOemType = {
  __typename?: 'ShipmentOEMType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  externalId: Scalars['String'];
  id: Scalars['UUID'];
  invoice?: Maybe<Scalars['String']>;
  orderOem: OrderOemType;
  productsShipped: Array<ShipmentOemProductType>;
  status?: Maybe<OemsShipmentOemStatusChoices>;
  statusDisplay: Scalars['String'];
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type ShipmentOemFormInput = {
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  invoice?: InputMaybe<Scalars['Upload']>;
  orderOem: Scalars['UUID'];
  productsShipped: Array<ShipmentProductOemFormInput>;
  status?: InputMaybe<Scalars['String']>;
};

export type ShipmentProductFormInput = {
  batch?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  orderedProduct: Scalars['ID'];
  quantity: Scalars['Int'];
  supplyOrder: Scalars['ID'];
};

export type ShipmentProductOemFormInput = {
  batch?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  orderOem: Scalars['UUID'];
  orderedProduct: Scalars['UUID'];
  quantity: Scalars['Int'];
};

export type ShipmentProductType = {
  __typename?: 'ShipmentProductType';
  batch?: Maybe<Scalars['String']>;
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  id: Scalars['UUID'];
  orderedProduct: OrderedProductType;
  quantity: Scalars['Int'];
  shipment: ShipmentType;
  supplyOrder: SupplyOrderType;
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type ShipmentType = {
  __typename?: 'ShipmentType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  exchangeRate: Scalars['Float'];
  externalId: Scalars['String'];
  id: Scalars['UUID'];
  invoice?: Maybe<Scalars['String']>;
  onHoldDescription?: Maybe<Scalars['String']>;
  productsShipped: Array<ShipmentProductType>;
  status?: Maybe<SupplyOrdersShipmentStatusChoices>;
  statusDisplay: Scalars['String'];
  supplyOrder: SupplyOrderType;
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type ShipmentsAnalyticsType = {
  __typename?: 'ShipmentsAnalyticsType';
  gefcoHistogram: Array<GefcoHistogramDatum>;
};

export type StartAccountRegistrationMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type StartAccountRegistrationMutationPayload = {
  __typename?: 'StartAccountRegistrationMutationPayload';
  account?: Maybe<AccountType>;
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type StartOemOrderReviewMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type StartOemOrderReviewMutationPayload = {
  __typename?: 'StartOemOrderReviewMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  orderOEM?: Maybe<OrderOemType>;
};

export type StartSupplyOrderReviewMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type StartSupplyOrderReviewMutationPayload = {
  __typename?: 'StartSupplyOrderReviewMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  supplyOrder?: Maybe<SupplyOrderType>;
};

export type StockErrorType = {
  __typename?: 'StockErrorType';
  code?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type StockResponseType = {
  __typename?: 'StockResponseType';
  errors: Array<StockErrorType>;
  stocks: Array<StockType>;
};

export type StockType = {
  __typename?: 'StockType';
  availableQuantity: Scalars['Int'];
  externalId: Scalars['String'];
  found: Scalars['Boolean'];
};

export type SupplyOrderListOptionsInputType = {
  createdDateGte?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  createdDateLte?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  ordering?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  quoteContact?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  quoteContactAccount?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  quoteContactAccountOwner?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  statusIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  user?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type SupplyOrderListType = {
  __typename?: 'SupplyOrderListType';
  count: Scalars['Int'];
  items: Array<SupplyOrderType>;
  page: Scalars['Int'];
};

export type SupplyOrderPdfType = {
  __typename?: 'SupplyOrderPDFType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  file?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  supplyOrder: SupplyOrderType;
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type SupplyOrderReviewMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  notes?: InputMaybe<Scalars['String']>;
  status: Scalars['String'];
  supplyOrder: Scalars['UUID'];
  targetDate?: InputMaybe<Scalars['Date']>;
  type: Scalars['String'];
};

export type SupplyOrderReviewMutationPayload = {
  __typename?: 'SupplyOrderReviewMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  supplyOrderReview?: Maybe<SupplyOrderReviewType>;
};

export type SupplyOrderReviewType = {
  __typename?: 'SupplyOrderReviewType';
  automaticReviewRejectionRules: Array<AutomaticReviewRejectionRuleType>;
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  notes: Scalars['String'];
  status: SupplyOrdersSupplyOrderReviewStatusChoices;
  statusDisplay: Scalars['String'];
  supplyOrder: SupplyOrderType;
  type: SupplyOrdersSupplyOrderReviewTypeChoices;
  typeDisplay: Scalars['String'];
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type SupplyOrderType = {
  __typename?: 'SupplyOrderType';
  billingType?: Maybe<SupplyOrdersSupplyOrderBillingTypeChoices>;
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  displayId: Scalars['Int'];
  displayName: Scalars['String'];
  id: Scalars['UUID'];
  orderedProducts: Array<OrderedProductType>;
  paymentMethod?: Maybe<QuotedPaymentMethodType>;
  pdfs: Array<SupplyOrderPdfType>;
  productsWithoutShipment: Array<OrderedProductType>;
  quote: QuoteType;
  reviewStart?: Maybe<Scalars['DateTime']>;
  reviews: Array<SupplyOrderReviewType>;
  salesCanReview: Scalars['Boolean'];
  shipments: Array<ShipmentType>;
  status: SupplyOrdersSupplyOrderStatusChoices;
  statusDisplay: Scalars['String'];
  targetDate?: Maybe<Scalars['Date']>;
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type SupplyOrdersAnalyticsType = {
  __typename?: 'SupplyOrdersAnalyticsType';
  amount: Scalars['Float'];
  byDate: Array<DateSeriesDatum>;
  byOrganization: Array<AmountDatum>;
  byPaymentMethod: Array<AmountDatum>;
  bySeederBrand: Array<AmountDatum>;
  bySeederModel: Array<AmountDatum>;
  byStatus: Array<AmountDatum>;
  count: Scalars['Int'];
  rankingByProduct: Array<ProductRankingDatum>;
};

export const SupplyOrdersShipmentStatusChoices = {
  Cancelled: 'CANCELLED',
  Confirmed: 'CONFIRMED',
  OnHold: 'ON_HOLD'
} as const;

export type SupplyOrdersShipmentStatusChoices = typeof SupplyOrdersShipmentStatusChoices[keyof typeof SupplyOrdersShipmentStatusChoices];
export const SupplyOrdersSupplyOrderBillingTypeChoices = {
  Direct: 'DIRECT',
  FastTrack: 'FAST_TRACK',
  Indirect: 'INDIRECT'
} as const;

export type SupplyOrdersSupplyOrderBillingTypeChoices = typeof SupplyOrdersSupplyOrderBillingTypeChoices[keyof typeof SupplyOrdersSupplyOrderBillingTypeChoices];
export const SupplyOrdersSupplyOrderReviewStatusChoices = {
  Approved: 'APPROVED',
  Rejected: 'REJECTED'
} as const;

export type SupplyOrdersSupplyOrderReviewStatusChoices = typeof SupplyOrdersSupplyOrderReviewStatusChoices[keyof typeof SupplyOrdersSupplyOrderReviewStatusChoices];
export const SupplyOrdersSupplyOrderReviewTypeChoices = {
  Credits: 'CREDITS',
  Sales: 'SALES'
} as const;

export type SupplyOrdersSupplyOrderReviewTypeChoices = typeof SupplyOrdersSupplyOrderReviewTypeChoices[keyof typeof SupplyOrdersSupplyOrderReviewTypeChoices];
export const SupplyOrdersSupplyOrderStatusChoices = {
  Approved: 'APPROVED',
  Draft: 'DRAFT',
  Finished: 'FINISHED',
  InProgress: 'IN_PROGRESS',
  OnHold: 'ON_HOLD',
  SalesReview: 'SALES_REVIEW'
} as const;

export type SupplyOrdersSupplyOrderStatusChoices = typeof SupplyOrdersSupplyOrderStatusChoices[keyof typeof SupplyOrdersSupplyOrderStatusChoices];
export const TmsStatus = {
  ArrivalAtExpress: 'arrival_at_express',
  Assigned: 'assigned',
  AssignedToRetirement: 'assigned_to_retirement',
  Cancelled: 'cancelled',
  Delivered: 'delivered',
  ExpressDelivery: 'express_delivery',
  NotDelivered: 'not_delivered',
  OnTrip: 'on_trip',
  Partial: 'partial',
  Pending: 'pending'
} as const;

export type TmsStatus = typeof TmsStatus[keyof typeof TmsStatus];
export type UpdateAccountExternalIdMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type UpdateAccountExternalIdMutationPayload = {
  __typename?: 'UpdateAccountExternalIdMutationPayload';
  account?: Maybe<AccountType>;
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type UpdateAccountFiles = {
  __typename?: 'UpdateAccountFiles';
  errors?: Maybe<ErrorType>;
};

export type UpdateAccountMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  extraLocation?: InputMaybe<Scalars['String']>;
  files?: InputMaybe<Array<AccountFileFormInput>>;
  id?: InputMaybe<Scalars['ID']>;
  lastRegistrationReview?: InputMaybe<Scalars['ID']>;
  location?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  owner: Scalars['ID'];
  region?: InputMaybe<Scalars['ID']>;
  taxId?: InputMaybe<Scalars['String']>;
};

export type UpdateAccountMutationPayload = {
  __typename?: 'UpdateAccountMutationPayload';
  account?: Maybe<AccountType>;
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type UpdateContactMutationInput = {
  account: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  isRemoved?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  mobilePhone?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  type: Scalars['ID'];
};

export type UpdateContactMutationPayload = {
  __typename?: 'UpdateContactMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  contact?: Maybe<ContactType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type UpdateEcnEffectiveDateMutation = {
  __typename?: 'UpdateEcnEffectiveDateMutation';
  ecn?: Maybe<EcnType>;
};

export type UpdateEcnMutationInput = {
  blueprints?: InputMaybe<Array<EcnBlueprintFormInput>>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  draftBlueprints?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  draftEcn?: InputMaybe<Scalars['UUID']>;
  effectiveDate?: InputMaybe<Scalars['Date']>;
  fyi?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  id?: InputMaybe<Scalars['ID']>;
  notes?: InputMaybe<Scalars['String']>;
  oems?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  parts: Array<EcnPartFormInput>;
  recipient?: InputMaybe<Scalars['String']>;
  resendFyi?: InputMaybe<Scalars['Boolean']>;
  resendTasks?: InputMaybe<Scalars['Boolean']>;
  seasonPriority: Scalars['String'];
  tasks?: InputMaybe<Array<EcnTaskFormInput>>;
  warrantyPriority?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateEcnMutationPayload = {
  __typename?: 'UpdateEcnMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  ecn?: Maybe<EcnType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type UpdateOpportunityMutationInput = {
  channel: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  contact: Scalars['ID'];
  date: Scalars['Date'];
  id?: InputMaybe<Scalars['ID']>;
  notes?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<Scalars['String']>;
  reason: Scalars['ID'];
  situation: Scalars['ID'];
};

export type UpdateOpportunityMutationPayload = {
  __typename?: 'UpdateOpportunityMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  opportunity?: Maybe<OpportunityType>;
};

export type UpdateOrderOemMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  notes?: InputMaybe<Scalars['String']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  organization: Scalars['UUID'];
  paymentMethod: Scalars['UUID'];
  products: Array<OrderOemProductFormInput>;
  targetDate?: InputMaybe<Scalars['Date']>;
};

export type UpdateOrderOemMutationPayload = {
  __typename?: 'UpdateOrderOEMMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  orderOEM?: Maybe<OrderOemType>;
};

export type UpdateOrderOemPricesMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type UpdateOrderOemPricesMutationPayload = {
  __typename?: 'UpdateOrderOemPricesMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  orderOEM?: Maybe<OrderOemType>;
};

export type UpdateOrderedProductMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  commissionMultiplier: Scalars['Float'];
  enableDiscount?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  quantity: Scalars['Int'];
  quantityLeft: Scalars['Int'];
  quotedProduct: Scalars['UUID'];
};

export type UpdateOrderedProductMutationPayload = {
  __typename?: 'UpdateOrderedProductMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  orderedProduct?: Maybe<OrderedProductType>;
};

export type UpdatePasswordMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  currentPassword: Scalars['String'];
  newPassword: Scalars['String'];
};

export type UpdatePasswordMutationPayload = {
  __typename?: 'UpdatePasswordMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  currentPassword: Scalars['String'];
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  newPassword: Scalars['String'];
};

export type UpdateProductMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  externalId: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  image?: InputMaybe<Scalars['Upload']>;
  name: Scalars['String'];
  order: Scalars['Int'];
  organizationGroup?: InputMaybe<Scalars['ID']>;
  origin?: InputMaybe<Scalars['ID']>;
  price: Scalars['Float'];
  published?: InputMaybe<Scalars['Boolean']>;
  rowCount: Scalars['Int'];
  ruleCategories?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  ruleGroup?: InputMaybe<Scalars['ID']>;
  subcategory: Scalars['ID'];
  type: Scalars['String'];
};

export type UpdateProductMutationPayload = {
  __typename?: 'UpdateProductMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  product?: Maybe<ProductType>;
};

export type UpdateProductPublished = {
  __typename?: 'UpdateProductPublished';
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  product?: Maybe<ProductType>;
};

export type UpdateProductUntilStockRunsOut = {
  __typename?: 'UpdateProductUntilStockRunsOut';
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  product?: Maybe<ProductType>;
};

export type UpdateQuoteMutationInput = {
  additionalChargesDescription?: InputMaybe<Scalars['String']>;
  additionalChargesValue?: InputMaybe<Scalars['Float']>;
  billingType: Scalars['String'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  contact: Scalars['ID'];
  id?: InputMaybe<Scalars['ID']>;
  kitMultiplier?: InputMaybe<Scalars['ID']>;
  notes?: InputMaybe<Scalars['String']>;
  oemOrder?: InputMaybe<Scalars['Boolean']>;
  originalQuote?: InputMaybe<Scalars['ID']>;
  paymentMethods: Array<QuotedPaymentMethodFormInput>;
  products: Array<QuotedProductFormInput>;
  rowCount?: InputMaybe<Scalars['Int']>;
  seeder?: InputMaybe<Scalars['ID']>;
};

export type UpdateQuoteMutationPayload = {
  __typename?: 'UpdateQuoteMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  quote?: Maybe<QuoteType>;
};

export type UpdateQuotePricesMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type UpdateQuotePricesMutationPayload = {
  __typename?: 'UpdateQuotePricesMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  quote?: Maybe<QuoteType>;
};

export type UpdateSaleMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  paymentMethod: Scalars['ID'];
  quote: Scalars['ID'];
};

export type UpdateSaleMutationPayload = {
  __typename?: 'UpdateSaleMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  sale?: Maybe<SaleType>;
};

export type UpdateSeederMutationInput = {
  account: Scalars['ID'];
  brand: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  installedProductCategories?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  meterType: Scalars['String'];
  model?: InputMaybe<Scalars['ID']>;
  rowCount: Scalars['Int'];
  year: Scalars['Int'];
};

export type UpdateSeederMutationPayload = {
  __typename?: 'UpdateSeederMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  seeder?: Maybe<SeederType>;
};

export type UpdateShipmentMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  exchangeRate: Scalars['Float'];
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  invoice?: InputMaybe<Scalars['Upload']>;
  onHoldDescription?: InputMaybe<Scalars['String']>;
  productsShipped: Array<UpdateShipmentProductFormInput>;
  status?: InputMaybe<Scalars['String']>;
  supplyOrder: Scalars['UUID'];
};

export type UpdateShipmentMutationPayload = {
  __typename?: 'UpdateShipmentMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  shipment?: Maybe<ShipmentType>;
};

export type UpdateShipmentOemMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  invoice?: InputMaybe<Scalars['Upload']>;
  orderOem: Scalars['UUID'];
  productsShipped: Array<UpdateShipmentProductOemFormInput>;
  status?: InputMaybe<Scalars['String']>;
};

export type UpdateShipmentOemMutationPayload = {
  __typename?: 'UpdateShipmentOEMMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  shipmentOEM?: Maybe<ShipmentOemType>;
};

export type UpdateShipmentProductFormInput = {
  batch?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  orderedProduct: Scalars['ID'];
  quantity: Scalars['Int'];
  supplyOrder: Scalars['ID'];
};

export type UpdateShipmentProductOemFormInput = {
  batch?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  orderOem: Scalars['UUID'];
  orderedProduct: Scalars['UUID'];
  quantity: Scalars['Int'];
};

export type UpdateSupplyOrderMutationInput = {
  billingType?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  emailMessages?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  id?: InputMaybe<Scalars['ID']>;
  paymentMethod?: InputMaybe<Scalars['UUID']>;
  products: Array<OrderedProductFormInput>;
  quote: Scalars['UUID'];
  reviewStart?: InputMaybe<Scalars['DateTime']>;
  status: Scalars['String'];
  targetDate?: InputMaybe<Scalars['Date']>;
};

export type UpdateSupplyOrderMutationPayload = {
  __typename?: 'UpdateSupplyOrderMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  supplyOrder?: Maybe<SupplyOrderType>;
};

export type UpdateUserMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  emailNotifications?: InputMaybe<Scalars['Boolean']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  inAppNotifications?: InputMaybe<Scalars['Boolean']>;
  language: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
};

export type UpdateUserMutationPayload = {
  __typename?: 'UpdateUserMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  user?: Maybe<UserType>;
};

export type UpdateWarrantyClaimMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  product: Scalars['ID'];
  serialNumber: Scalars['String'];
};

export type UpdateWarrantyClaimMutationPayload = {
  __typename?: 'UpdateWarrantyClaimMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  productWarrantyClaim?: Maybe<ProductWarrantyClaimType>;
};

export type UploadInvoiceMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  invoice?: InputMaybe<Scalars['Upload']>;
};

export type UploadInvoiceMutationPayload = {
  __typename?: 'UploadInvoiceMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  shipment?: Maybe<ShipmentType>;
};

export type UploadInvoiceOemMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  invoice?: InputMaybe<Scalars['Upload']>;
};

export type UploadInvoiceOemMutationPayload = {
  __typename?: 'UploadInvoiceOemMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  shipmentOEM?: Maybe<ShipmentOemType>;
};

export type UserListOptionsInputType = {
  hasEcnRole?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  ordering?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};

export type UserListType = {
  __typename?: 'UserListType';
  count: Scalars['Int'];
  items: Array<UserType>;
  page: Scalars['Int'];
};

export type UserPermissions = {
  __typename?: 'UserPermissions';
  assignAccountOwner: Scalars['Boolean'];
  createMachineStartUps: Scalars['Boolean'];
  manageAccounts: Scalars['Boolean'];
  manageEcns: Scalars['Boolean'];
  manageMachineStartUps: Scalars['Boolean'];
  manageMaterialMaster: Scalars['Boolean'];
  manageOem: Scalars['Boolean'];
  manageQuotes: Scalars['Boolean'];
  manageSales: Scalars['Boolean'];
  manageShipments: Scalars['Boolean'];
  manageSupplyOrders: Scalars['Boolean'];
  manageWarrantyClaims: Scalars['Boolean'];
  performTechnicalReview: Scalars['Boolean'];
  receiveAccountRegistrationApprovedNotification: Scalars['Boolean'];
  receiveOemOrderApprovedNotification: Scalars['Boolean'];
  receiveOldWarrantyClaimNotification: Scalars['Boolean'];
  receiveSupplyOrderApprovedNotification: Scalars['Boolean'];
  requestAccountRegistration: Scalars['Boolean'];
  requestOemOrderReview: Scalars['Boolean'];
  requestSupplyOrderReview: Scalars['Boolean'];
  submitAccountRegistrationReview: Scalars['Boolean'];
  submitCreditsSupplyOrderReview: Scalars['Boolean'];
  submitOemOrderReview: Scalars['Boolean'];
  submitSalesSupplyOrderReview: Scalars['Boolean'];
  viewAccounts: Scalars['Boolean'];
  viewAnalytics: Scalars['Boolean'];
  viewContacts: Scalars['Boolean'];
  viewDatastudio: Scalars['Boolean'];
  viewEcns: Scalars['Boolean'];
  viewMachineStartUps: Scalars['Boolean'];
  viewMaterialMaster: Scalars['Boolean'];
  viewOemOrderBankInvoices: Scalars['Boolean'];
  viewOemStock: Scalars['Boolean'];
  viewOems: Scalars['Boolean'];
  viewOpportunities: Scalars['Boolean'];
  viewQuotes: Scalars['Boolean'];
  viewSales: Scalars['Boolean'];
  viewSeeders: Scalars['Boolean'];
  viewStock: Scalars['Boolean'];
  viewSupplyOrders: Scalars['Boolean'];
  viewUnpublishedProducts: Scalars['Boolean'];
  viewWarrantyClaims: Scalars['Boolean'];
  viewWarrantyClaimsAnalytics: Scalars['Boolean'];
};

export type UserType = {
  __typename?: 'UserType';
  canEditLockedEcnTasks: Scalars['Boolean'];
  dateJoined: Scalars['DateTime'];
  displayName: Scalars['String'];
  ecnRoles: Array<EcnRoleType>;
  email: Scalars['String'];
  emailNotifications: Scalars['Boolean'];
  favoriteEcns: Array<EcnType>;
  firstName: Scalars['String'];
  id: Scalars['UUID'];
  inAppNotifications: Scalars['Boolean'];
  isActive: Scalars['Boolean'];
  isStaff: Scalars['Boolean'];
  isSuperuser: Scalars['Boolean'];
  language: Scalars['String'];
  lastLogin?: Maybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
  notificationConfigs: Array<NotificationConfigType>;
  notifications: Array<NotificationType>;
  organization?: Maybe<OrganizationType>;
  password: Scalars['String'];
  permissions: UserPermissions;
  role?: Maybe<RoleType>;
  viewedEcns: Array<EcnType>;
};

export const UsersNotificationConfigNameChoices = {
  Accounts: 'ACCOUNTS',
  Ecns: 'ECNS',
  MachineStartUps: 'MACHINE_START_UPS',
  MaterialMaster: 'MATERIAL_MASTER',
  Oem: 'OEM',
  SupplyOrders: 'SUPPLY_ORDERS',
  WarrantyClaims: 'WARRANTY_CLAIMS'
} as const;

export type UsersNotificationConfigNameChoices = typeof UsersNotificationConfigNameChoices[keyof typeof UsersNotificationConfigNameChoices];
export type WarrantyClaimImageFormInput = {
  file: Scalars['Upload'];
  id?: InputMaybe<Scalars['ID']>;
};

export type WarrantyClaimImageType = {
  __typename?: 'WarrantyClaimImageType';
  file: Scalars['String'];
  id: Scalars['UUID'];
  warrantyClaim: ProductWarrantyClaimType;
};

export type WarrantyClaimInspectionFileFormInput = {
  file?: InputMaybe<Scalars['Upload']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type WarrantyClaimInspectionFileType = {
  __typename?: 'WarrantyClaimInspectionFileType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  file?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  inspection: WarrantyClaimInspectionReviewType;
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
};

export type WarrantyClaimInspectionReviewHistoryType = {
  __typename?: 'WarrantyClaimInspectionReviewHistoryType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  failureDescription: Scalars['String'];
  id: Scalars['UUID'];
  inWarranty: Scalars['Boolean'];
  inWarrantyDisplay: Scalars['String'];
  previousFailureDescription: Scalars['String'];
  previousInWarranty?: Maybe<Scalars['Boolean']>;
  previousInWarrantyDisplay?: Maybe<Scalars['String']>;
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
  warrantyClaim: ProductWarrantyClaimType;
};

export type WarrantyClaimInspectionReviewType = {
  __typename?: 'WarrantyClaimInspectionReviewType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  failureDescription: Scalars['String'];
  files: Array<WarrantyClaimInspectionFileType>;
  id: Scalars['UUID'];
  inWarranty: Scalars['Boolean'];
  inspected: Scalars['Boolean'];
  inspectedDate?: Maybe<Scalars['DateTime']>;
  received: Scalars['Boolean'];
  receivedDate?: Maybe<Scalars['DateTime']>;
  status: ProductsWarrantyClaimInspectionReviewStatusChoices;
  statusDisplay: Scalars['String'];
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
  warrantyClaim: ProductWarrantyClaimType;
};

export type WarrantyClaimStatusHistogramDatum = {
  __typename?: 'WarrantyClaimStatusHistogramDatum';
  daysInApprovedUntilSent?: Maybe<Scalars['Int']>;
  daysInPendingUntilApproved?: Maybe<Scalars['Int']>;
  daysInPendingUntilRejected?: Maybe<Scalars['Int']>;
  daysUntilInspected?: Maybe<Scalars['Int']>;
  daysUntilReceived?: Maybe<Scalars['Int']>;
  daysUntilSent?: Maybe<Scalars['Int']>;
};

export type WarrantyClaimVideoFormInput = {
  file: Scalars['Upload'];
  id?: InputMaybe<Scalars['ID']>;
};

export type WarrantyClaimVideoType = {
  __typename?: 'WarrantyClaimVideoType';
  file: Scalars['String'];
  id: Scalars['UUID'];
  warrantyClaim: ProductWarrantyClaimType;
};

export type WarrantyClaimsAnalyticsType = {
  __typename?: 'WarrantyClaimsAnalyticsType';
  approvedCount: Scalars['Int'];
  byDate: Array<DateSeriesDatum>;
  byInspectionStatus: Array<SalesPotentialDatum>;
  cancelledCount: Scalars['Int'];
  count: Scalars['Int'];
  pendingCount: Scalars['Int'];
  productRanking: Array<WarrantyProductRankingDatum>;
  rejectedCount: Scalars['Int'];
  sentCount: Scalars['Int'];
  statusHistogram: Array<WarrantyClaimStatusHistogramDatum>;
};

export type WarrantyProductRankingDatum = {
  __typename?: 'WarrantyProductRankingDatum';
  amount?: Maybe<Scalars['Float']>;
  count: Scalars['Int'];
  product: WarrantyProductType;
  ranking: Scalars['Int'];
};

export type WarrantyProductType = {
  __typename?: 'WarrantyProductType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  description: Scalars['String'];
  displayName: Scalars['String'];
  externalId: Scalars['String'];
  id: Scalars['UUID'];
  name: Scalars['String'];
  order: Scalars['Int'];
  originalProduct?: Maybe<ProductType>;
  price: Scalars['Float'];
  rowCount: Scalars['Int'];
  ruleCategories: Array<ProductCategoryType>;
  ruleGroup?: Maybe<RuleGroupType>;
  subcategory: ProductSubcategoryType;
  untilStockRunsOut: Scalars['Boolean'];
  updated: Scalars['DateTime'];
  updatedBy?: Maybe<UserType>;
  warrantyClaim: ProductWarrantyClaimType;
};

export const WmsStatus = {
  ArrivalAtExpress: 'arrival_at_express',
  Cancelled: 'cancelled',
  CompletedPick: 'completed_pick',
  Confirmed: 'confirmed',
  InArmed: 'in_armed',
  NoConfirmation: 'no_confirmation',
  Pending: 'pending',
  PendingPreparation: 'pending_preparation',
  Prepared: 'prepared'
} as const;

export type WmsStatus = typeof WmsStatus[keyof typeof WmsStatus];
export type QuotesAnalyticsFragment = { __typename?: 'QuotesAnalyticsType', count: number, amount: number, bySeederBrand: Array<{ __typename?: 'AmountDatum', label: string, count: number, percentage?: number, amount: number }>, bySeederModel: Array<{ __typename?: 'AmountDatum', label: string, count: number, percentage?: number, amount: number }>, byPaymentMethod: Array<{ __typename?: 'AmountDatum', label: string, count: number, percentage?: number, amount: number, multiplier?: number }>, byDate: Array<{ __typename?: 'DateSeriesDatum', date: string, count: number, amount?: number }>, byBillingType: Array<{ __typename?: 'AmountDatum', label: string, count: number, percentage?: number, amount: number }>, productRanking: Array<{ __typename?: 'ProductRankingDatum', count: number, ranking: number, product: { __typename?: 'ProductType', name: string, subcategory: { __typename?: 'ProductSubcategoryType', name: string, category: { __typename?: 'ProductCategoryType', name: string } } } }>, byStatus: Array<{ __typename?: 'AmountDatum', label: string, count: number, amount: number }> };

export type GetQuotesAnalyticsQueryVariables = Exact<{
  filters: AnalyticsFilters;
}>;


export type GetQuotesAnalyticsQuery = { __typename?: 'Query', quotesAnalytics?: { __typename?: 'QuotesAnalyticsType', count: number, amount: number, bySeederBrand: Array<{ __typename?: 'AmountDatum', label: string, count: number, percentage?: number, amount: number }>, bySeederModel: Array<{ __typename?: 'AmountDatum', label: string, count: number, percentage?: number, amount: number }>, byPaymentMethod: Array<{ __typename?: 'AmountDatum', label: string, count: number, percentage?: number, amount: number, multiplier?: number }>, byDate: Array<{ __typename?: 'DateSeriesDatum', date: string, count: number, amount?: number }>, byBillingType: Array<{ __typename?: 'AmountDatum', label: string, count: number, percentage?: number, amount: number }>, productRanking: Array<{ __typename?: 'ProductRankingDatum', count: number, ranking: number, product: { __typename?: 'ProductType', name: string, subcategory: { __typename?: 'ProductSubcategoryType', name: string, category: { __typename?: 'ProductCategoryType', name: string } } } }>, byStatus: Array<{ __typename?: 'AmountDatum', label: string, count: number, amount: number }> } };

export type SalesPotentialAnalyticsFragment = { __typename?: 'SalesPotentialAnalyticsType', rowsCount: number, seedersCount: number, bySeederBrand: Array<{ __typename?: 'SalesPotentialDatum', label: string, count: number, percentage: number }>, byMeterType: Array<{ __typename?: 'SalesPotentialDatum', label: string, count: number, percentage: number }>, byProductCategory: Array<{ __typename?: 'SalesPotentialDatum', label: string, count: number, percentage: number }> };

export type GetSalesPotentialAnalyticsQueryVariables = Exact<{
  filters: AnalyticsFilters;
}>;


export type GetSalesPotentialAnalyticsQuery = { __typename?: 'Query', salesPotentialAnalytics?: { __typename?: 'SalesPotentialAnalyticsType', rowsCount: number, seedersCount: number, bySeederBrand: Array<{ __typename?: 'SalesPotentialDatum', label: string, count: number, percentage: number }>, byMeterType: Array<{ __typename?: 'SalesPotentialDatum', label: string, count: number, percentage: number }>, byProductCategory: Array<{ __typename?: 'SalesPotentialDatum', label: string, count: number, percentage: number }> } };

export type SalesAnalyticsFragment = { __typename?: 'SalesAnalyticsType', count: number, amount: number, byDate: Array<{ __typename?: 'DateSeriesDatum', date: string, count: number, amount?: number }>, productRanking: Array<{ __typename?: 'ProductRankingDatum', count: number, ranking: number, product: { __typename?: 'ProductType', name: string, subcategory: { __typename?: 'ProductSubcategoryType', name: string, category: { __typename?: 'ProductCategoryType', name: string } } } }>, byPaymentMethod: Array<{ __typename?: 'AmountDatum', label: string, count: number, percentage?: number, amount: number, multiplier?: number }>, bySeederBrand: Array<{ __typename?: 'AmountDatum', label: string, count: number, percentage?: number, amount: number }>, bySeederModel: Array<{ __typename?: 'AmountDatum', label: string, count: number, percentage?: number, amount: number }>, byBillingType: Array<{ __typename?: 'AmountDatum', label: string, count: number, percentage?: number, amount: number }> };

export type GetSalesAnalyticsQueryVariables = Exact<{
  filters: AnalyticsFilters;
}>;


export type GetSalesAnalyticsQuery = { __typename?: 'Query', salesAnalytics?: { __typename?: 'SalesAnalyticsType', count: number, amount: number, byDate: Array<{ __typename?: 'DateSeriesDatum', date: string, count: number, amount?: number }>, productRanking: Array<{ __typename?: 'ProductRankingDatum', count: number, ranking: number, product: { __typename?: 'ProductType', name: string, subcategory: { __typename?: 'ProductSubcategoryType', name: string, category: { __typename?: 'ProductCategoryType', name: string } } } }>, byPaymentMethod: Array<{ __typename?: 'AmountDatum', label: string, count: number, percentage?: number, amount: number, multiplier?: number }>, bySeederBrand: Array<{ __typename?: 'AmountDatum', label: string, count: number, percentage?: number, amount: number }>, bySeederModel: Array<{ __typename?: 'AmountDatum', label: string, count: number, percentage?: number, amount: number }>, byBillingType: Array<{ __typename?: 'AmountDatum', label: string, count: number, percentage?: number, amount: number }> } };

export type SupplyOrdersAnalyticsFragment = { __typename?: 'SupplyOrdersAnalyticsType', count: number, amount: number, byStatus: Array<{ __typename?: 'AmountDatum', label: string, count: number, amount: number, percentage?: number, multiplier?: number }>, byDate: Array<{ __typename?: 'DateSeriesDatum', date: string, count: number, amount?: number }>, rankingByProduct: Array<{ __typename?: 'ProductRankingDatum', count: number, amount?: number, ranking: number, product: { __typename?: 'ProductType', name: string, subcategory: { __typename?: 'ProductSubcategoryType', name: string, category: { __typename?: 'ProductCategoryType', name: string } } } }>, bySeederBrand: Array<{ __typename?: 'AmountDatum', label: string, count: number, amount: number, percentage?: number, multiplier?: number }>, bySeederModel: Array<{ __typename?: 'AmountDatum', label: string, count: number, amount: number, percentage?: number, multiplier?: number }>, byOrganization: Array<{ __typename?: 'AmountDatum', label: string, count: number, amount: number, percentage?: number, multiplier?: number }>, byPaymentMethod: Array<{ __typename?: 'AmountDatum', label: string, count: number, amount: number, percentage?: number, multiplier?: number }> };

export type DateSeriesDatumFragment = { __typename?: 'DateSeriesDatum', date: string, count: number, amount?: number };

export type ProductRankingDatumFragment = { __typename?: 'ProductRankingDatum', count: number, amount?: number, ranking: number, product: { __typename?: 'ProductType', name: string, subcategory: { __typename?: 'ProductSubcategoryType', name: string, category: { __typename?: 'ProductCategoryType', name: string } } } };

export type AmountDatumFragment = { __typename?: 'AmountDatum', label: string, count: number, amount: number, percentage?: number, multiplier?: number };

export type GetSupplyOrdersAnalyticsQueryVariables = Exact<{
  filters: AnalyticsFilters;
}>;


export type GetSupplyOrdersAnalyticsQuery = { __typename?: 'Query', supplyOrdersAnalytics?: { __typename?: 'SupplyOrdersAnalyticsType', count: number, amount: number, byStatus: Array<{ __typename?: 'AmountDatum', label: string, count: number, amount: number, percentage?: number, multiplier?: number }>, byDate: Array<{ __typename?: 'DateSeriesDatum', date: string, count: number, amount?: number }>, rankingByProduct: Array<{ __typename?: 'ProductRankingDatum', count: number, amount?: number, ranking: number, product: { __typename?: 'ProductType', name: string, subcategory: { __typename?: 'ProductSubcategoryType', name: string, category: { __typename?: 'ProductCategoryType', name: string } } } }>, bySeederBrand: Array<{ __typename?: 'AmountDatum', label: string, count: number, amount: number, percentage?: number, multiplier?: number }>, bySeederModel: Array<{ __typename?: 'AmountDatum', label: string, count: number, amount: number, percentage?: number, multiplier?: number }>, byOrganization: Array<{ __typename?: 'AmountDatum', label: string, count: number, amount: number, percentage?: number, multiplier?: number }>, byPaymentMethod: Array<{ __typename?: 'AmountDatum', label: string, count: number, amount: number, percentage?: number, multiplier?: number }> } };

export type GetShipmentAnalyticsQueryVariables = Exact<{
  filters: AnalyticsFilters;
}>;


export type GetShipmentAnalyticsQuery = { __typename?: 'Query', shipmentsAnalytics?: { __typename?: 'ShipmentsAnalyticsType', gefcoHistogram: Array<{ __typename?: 'GefcoHistogramDatum', daysSinceShipmentUntilOrderReceipt?: number, daysSinceShipmentUntilPreparation?: number, daysSinceShipmentUntilRouting?: number, daysSinceShipmentUntilDispatch?: number, daysSinceShipmentUntilInterbaseDelivery?: number, daysSinceShipmentUntilPartialDelivery?: number, daysSinceShipmentUntilDelivered?: number, daysSinceShipmentUntilReturnedRejected?: number, daysSinceShipmentUntilRenderedToClient?: number, daysSinceSupplyOrderUntilOrderReceipt?: number, daysSinceSupplyOrderUntilPreparation?: number, daysSinceSupplyOrderUntilRouting?: number, daysSinceSupplyOrderUntilDispatch?: number, daysSinceSupplyOrderUntilInterbaseDelivery?: number, daysSinceSupplyOrderUntilPartialDelivery?: number, daysSinceSupplyOrderUntilDelivered?: number, daysSinceSupplyOrderUntilReturnedRejected?: number, daysSinceSupplyOrderUntilRenderedToClient?: number }> } };

export type GefcoShipmentHistogramFragment = { __typename?: 'GefcoHistogramDatum', daysSinceShipmentUntilOrderReceipt?: number, daysSinceShipmentUntilPreparation?: number, daysSinceShipmentUntilRouting?: number, daysSinceShipmentUntilDispatch?: number, daysSinceShipmentUntilInterbaseDelivery?: number, daysSinceShipmentUntilPartialDelivery?: number, daysSinceShipmentUntilDelivered?: number, daysSinceShipmentUntilReturnedRejected?: number, daysSinceShipmentUntilRenderedToClient?: number };

export type GefcoSupplyOrderHistogramFragment = { __typename?: 'GefcoHistogramDatum', daysSinceSupplyOrderUntilOrderReceipt?: number, daysSinceSupplyOrderUntilPreparation?: number, daysSinceSupplyOrderUntilRouting?: number, daysSinceSupplyOrderUntilDispatch?: number, daysSinceSupplyOrderUntilInterbaseDelivery?: number, daysSinceSupplyOrderUntilPartialDelivery?: number, daysSinceSupplyOrderUntilDelivered?: number, daysSinceSupplyOrderUntilReturnedRejected?: number, daysSinceSupplyOrderUntilRenderedToClient?: number };

export type WarrantyClaimsAnalyticsFragment = { __typename?: 'WarrantyClaimsAnalyticsType', count: number, approvedCount: number, pendingCount: number, cancelledCount: number, rejectedCount: number, sentCount: number, byDate: Array<{ __typename?: 'DateSeriesDatum', date: string, count: number }>, productRanking: Array<{ __typename?: 'WarrantyProductRankingDatum', count: number, ranking: number, amount?: number, product: { __typename?: 'WarrantyProductType', name: string, subcategory: { __typename?: 'ProductSubcategoryType', name: string, category: { __typename?: 'ProductCategoryType', name: string } } } }>, byInspectionStatus: Array<{ __typename?: 'SalesPotentialDatum', label: string, count: number, percentage: number }>, statusHistogram: Array<{ __typename?: 'WarrantyClaimStatusHistogramDatum', daysInPendingUntilApproved?: number, daysInApprovedUntilSent?: number, daysInPendingUntilRejected?: number, daysUntilReceived?: number, daysUntilInspected?: number, daysUntilSent?: number }> };

export type WarrantyClaimStatusHistogramDatumFragment = { __typename?: 'WarrantyClaimStatusHistogramDatum', daysInPendingUntilApproved?: number, daysInApprovedUntilSent?: number, daysInPendingUntilRejected?: number, daysUntilReceived?: number, daysUntilInspected?: number, daysUntilSent?: number };

export type WarrantyClaimsAnalyticsQueryVariables = Exact<{
  filters: AnalyticsFilters;
}>;


export type WarrantyClaimsAnalyticsQuery = { __typename?: 'Query', warrantyClaimsAnalytics?: { __typename?: 'WarrantyClaimsAnalyticsType', count: number, approvedCount: number, pendingCount: number, cancelledCount: number, rejectedCount: number, sentCount: number, byDate: Array<{ __typename?: 'DateSeriesDatum', date: string, count: number }>, productRanking: Array<{ __typename?: 'WarrantyProductRankingDatum', count: number, ranking: number, amount?: number, product: { __typename?: 'WarrantyProductType', name: string, subcategory: { __typename?: 'ProductSubcategoryType', name: string, category: { __typename?: 'ProductCategoryType', name: string } } } }>, byInspectionStatus: Array<{ __typename?: 'SalesPotentialDatum', label: string, count: number, percentage: number }>, statusHistogram: Array<{ __typename?: 'WarrantyClaimStatusHistogramDatum', daysInPendingUntilApproved?: number, daysInApprovedUntilSent?: number, daysInPendingUntilRejected?: number, daysUntilReceived?: number, daysUntilInspected?: number, daysUntilSent?: number }> } };

export type PermissionsFragment = { __typename?: 'UserPermissions', viewQuotes: boolean, viewSales: boolean, viewSupplyOrders: boolean, viewAccounts: boolean, viewContacts: boolean, viewOpportunities: boolean, viewWarrantyClaims: boolean, viewMachineStartUps: boolean, viewEcns: boolean, assignAccountOwner: boolean, requestSupplyOrderReview: boolean, submitSalesSupplyOrderReview: boolean, submitCreditsSupplyOrderReview: boolean, requestOemOrderReview: boolean, viewAnalytics: boolean, viewWarrantyClaimsAnalytics: boolean, manageShipments: boolean, manageQuotes: boolean, manageSales: boolean, manageSupplyOrders: boolean, manageWarrantyClaims: boolean, performTechnicalReview: boolean, manageMachineStartUps: boolean, manageOem: boolean, viewOemStock: boolean, manageEcns: boolean, manageAccounts: boolean, viewDatastudio: boolean, viewOems: boolean, viewSeeders: boolean, viewMaterialMaster: boolean, manageMaterialMaster: boolean, createMachineStartUps: boolean, viewOemOrderBankInvoices: boolean, viewStock: boolean, viewUnpublishedProducts: boolean, requestAccountRegistration: boolean, submitAccountRegistrationReview: boolean, receiveAccountRegistrationApprovedNotification: boolean };

export type ErrorFragment = { __typename?: 'ErrorType', field: string, messages: Array<string> };

export type UserFragment = { __typename?: 'UserType', id: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, canEditLockedEcnTasks: boolean, emailNotifications: boolean, inAppNotifications: boolean, organization?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }, role?: { __typename?: 'RoleType', id: string, name: string }, ecnRoles: Array<{ __typename?: 'EcnRoleType', id: string }>, permissions: { __typename?: 'UserPermissions', viewQuotes: boolean, viewSales: boolean, viewSupplyOrders: boolean, viewAccounts: boolean, viewContacts: boolean, viewOpportunities: boolean, viewWarrantyClaims: boolean, viewMachineStartUps: boolean, viewEcns: boolean, assignAccountOwner: boolean, requestSupplyOrderReview: boolean, submitSalesSupplyOrderReview: boolean, submitCreditsSupplyOrderReview: boolean, requestOemOrderReview: boolean, viewAnalytics: boolean, viewWarrantyClaimsAnalytics: boolean, manageShipments: boolean, manageQuotes: boolean, manageSales: boolean, manageSupplyOrders: boolean, manageWarrantyClaims: boolean, performTechnicalReview: boolean, manageMachineStartUps: boolean, manageOem: boolean, viewOemStock: boolean, manageEcns: boolean, manageAccounts: boolean, viewDatastudio: boolean, viewOems: boolean, viewSeeders: boolean, viewMaterialMaster: boolean, manageMaterialMaster: boolean, createMachineStartUps: boolean, viewOemOrderBankInvoices: boolean, viewStock: boolean, viewUnpublishedProducts: boolean, requestAccountRegistration: boolean, submitAccountRegistrationReview: boolean, receiveAccountRegistrationApprovedNotification: boolean } };

export type RoleFragment = { __typename?: 'RoleType', id: string, name: string };

export type MinimalUserFragment = { __typename?: 'UserType', id: string, displayName: string, email: string };

export type OrganizationFragment = { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } };

export type OrganizationGroupFragment = { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> };

export type LocationOptionFragment = { __typename?: 'LocationType', id: string, path?: string };

export type AccountRegionOptionFragment = { __typename?: 'AccountRegionType', id: string, name: string };

export type AccountRegistrationReviewFragment = { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } };

export type AccountFragment = { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } };

export type AccountDetailFragment = { __typename?: 'AccountType', extraLocation?: string, created: string, updated: string, id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, location?: { __typename?: 'LocationType', id: string, path?: string }, files: Array<{ __typename?: 'AccountFileType', id: string, file: string }>, registrationReviews: Array<{ __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, updatedBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, seeders: Array<{ __typename?: 'SeederType', id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } }>, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } };

export type AccountOptionFragment = { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } };

export type ContactTypeOptionFragment = { __typename?: 'ContactTypeType', id: string, name: string };

export type ContactFragment = { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } };

export type ContactOptionFragment = { __typename?: 'ContactType', id: string, displayName: string };

export type ContactDetailFragment = { __typename?: 'ContactType', created: string, updated: string, id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, updatedBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } };

export type OpportunityFragment = { __typename?: 'OpportunityType', id: string, displayName: string, date: string, notes: string, products: string, channel: { __typename?: 'OpportunityChannelType', id: string, name: string }, reason: { __typename?: 'OpportunityReasonType', id: string, name: string }, situation: { __typename?: 'OpportunitySituationType', id: string, name: string }, contact: { __typename?: 'ContactType', id: string, displayName: string, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } } };

export type OpportunityDetailFragment = { __typename?: 'OpportunityType', created: string, updated: string, id: string, displayName: string, date: string, notes: string, products: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, updatedBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, channel: { __typename?: 'OpportunityChannelType', id: string, name: string }, reason: { __typename?: 'OpportunityReasonType', id: string, name: string }, situation: { __typename?: 'OpportunitySituationType', id: string, name: string }, contact: { __typename?: 'ContactType', id: string, displayName: string, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } } };

export type OpportunityChannelOptionFragment = { __typename?: 'OpportunityChannelType', id: string, name: string };

export type OpportunityReasonOptionFragment = { __typename?: 'OpportunityReasonType', id: string, name: string };

export type OpportunitySituationOptionFragment = { __typename?: 'OpportunitySituationType', id: string, name: string };

export type BillingTypeOptionFragment = { __typename?: 'BillingTypeType', id: string, name: string };

export type BillingTypeFragment = { __typename?: 'BillingTypeType', id: string, name: string };

export type ProductCategoryOptionFragment = { __typename?: 'ProductCategoryType', id: string, name: string };

export type ProductCategoryFragment = { __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string };

export type ProductSubcategoryOptionFragment = { __typename?: 'ProductSubcategoryType', id: string, name: string };

export type ProductSubcategoryFragment = { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } };

export type ProductOriginOptionFragment = { __typename?: 'ProductOriginType', id: string, name: string };

export type ProductPriceModifierFragment = { __typename?: 'ProductPriceModifierType', id: string, enableDiscount: boolean, commissionMultiplier: number, billingType: ProductsProductPriceModifierBillingTypeChoices };

export type ProductOptionFragment = { __typename?: 'ProductType', id: string, name: string, displayName: string, externalId: string, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', name: string, id: string } } };

export type RuleGroupFragment = { __typename?: 'RuleGroupType', id: string, name: string };

export type ProductFragment = { __typename?: 'ProductType', id: string, externalId: string, name: string, displayName: string, price: number, type: ProductsProductTypeChoices, displayType: string, order: number, description: string, rowCount: number, published: boolean, mmStatus: ProductsProductMmStatusChoices, displayMmStatus: string, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> };

export type ProductImageFragment = { __typename?: 'ProductType', id: string, image?: string, externalId: string };

export type WarrantyClaimImageFragment = { __typename?: 'WarrantyClaimImageType', id: string, file: string, warrantyClaim: { __typename?: 'ProductWarrantyClaimType', id: string } };

export type WarrantyClaimVideoFragment = { __typename?: 'WarrantyClaimVideoType', id: string, file: string, warrantyClaim: { __typename?: 'ProductWarrantyClaimType', id: string } };

export type WarrantyProductFragment = { __typename?: 'WarrantyProductType', id: string, externalId: string, name: string, displayName: string, price: number, order: number, description: string, rowCount: number, originalProduct?: { __typename?: 'ProductType', id: string, image?: string }, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } } };

export type ProductWarrantyClaimListFragment = { __typename?: 'ProductWarrantyClaimType', id: string, deliveryDate: string, failureDate: string, serialNumber: string, created: string, quantity: number, description: string, finalClient: string, phone: string, externalId?: string, seederKilometers: number, displayId: number, product?: { __typename?: 'WarrantyProductType', id: string, externalId: string, name: string, displayName: string, price: number, order: number, description: string, rowCount: number, originalProduct?: { __typename?: 'ProductType', id: string, image?: string }, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } } }, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, seeder?: { __typename?: 'SeederType', id: string, displayName: string, rowCount: number }, lastReview?: { __typename?: 'ProductWarrantyClaimReviewType', id: string, created: string, notes: string, statusDisplay: string, status: ProductsProductWarrantyClaimReviewStatusChoices, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, inspectionReview?: { __typename?: 'WarrantyClaimInspectionReviewType', statusDisplay: string, status: ProductsWarrantyClaimInspectionReviewStatusChoices, inWarranty: boolean } };

export type ProductWarrantyClaimFragment = { __typename?: 'ProductWarrantyClaimType', id: string, deliveryDate: string, failureDate: string, serialNumber: string, created: string, quantity: number, description: string, finalClient: string, phone: string, externalId?: string, seederKilometers: number, displayId: number, inspectionReview?: { __typename?: 'WarrantyClaimInspectionReviewType', statusDisplay: string, status: ProductsWarrantyClaimInspectionReviewStatusChoices, inWarranty: boolean, id: string, created: string, updated: string, received: boolean, receivedDate?: string, inspected: boolean, inspectedDate?: string, failureDescription: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, updatedBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, warrantyClaim: { __typename?: 'ProductWarrantyClaimType', id: string }, files: Array<{ __typename?: 'WarrantyClaimInspectionFileType', id: string, file?: string }> }, seeder?: { __typename?: 'SeederType', id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } }, images?: Array<{ __typename?: 'WarrantyClaimImageType', id: string, file: string, warrantyClaim: { __typename?: 'ProductWarrantyClaimType', id: string } }>, videos: Array<{ __typename?: 'WarrantyClaimVideoType', id: string, file: string, warrantyClaim: { __typename?: 'ProductWarrantyClaimType', id: string } }>, reviews: Array<{ __typename?: 'ProductWarrantyClaimReviewType', id: string, created: string, notes: string, statusDisplay: string, status: ProductsProductWarrantyClaimReviewStatusChoices, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, inspectionReviewHistories: Array<{ __typename?: 'WarrantyClaimInspectionReviewHistoryType', id: string, created: string, inWarranty: boolean, inWarrantyDisplay: string, previousInWarranty?: boolean, previousInWarrantyDisplay?: string, failureDescription: string, previousFailureDescription: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, product?: { __typename?: 'WarrantyProductType', id: string, externalId: string, name: string, displayName: string, price: number, order: number, description: string, rowCount: number, originalProduct?: { __typename?: 'ProductType', id: string, image?: string }, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } } }, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, lastReview?: { __typename?: 'ProductWarrantyClaimReviewType', id: string, created: string, notes: string, statusDisplay: string, status: ProductsProductWarrantyClaimReviewStatusChoices, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } } };

export type ProductWarrantyClaimReviewFragment = { __typename?: 'ProductWarrantyClaimReviewType', id: string, created: string, notes: string, statusDisplay: string, status: ProductsProductWarrantyClaimReviewStatusChoices, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } };

export type PaymentMethodFragment = { __typename?: 'PaymentMethodType', id: string, name: string, order: number, multiplier: number, slug: string, paymentmethodcategorySet: Array<{ __typename?: 'PaymentMethodCategoryType', finnancied: boolean }> };

export type PaymentMethodOptionFragment = { __typename?: 'PaymentMethodType', id: string, name: string };

export type PaymentMethodCategoryFragment = { __typename?: 'PaymentMethodCategoryType', id: string, name: string, finnancied: boolean, paymentMethods: Array<{ __typename?: 'PaymentMethodType', id: string, name: string }> };

export type QuotePdfFragment = { __typename?: 'QuotePDFType', id: string, file?: string, type: QuotesQuotePdfTypeChoices, recipient: string, typeDisplay?: string, emailStatus?: string, created: string, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } };

export type MinimalQuotedPaymentMethodFragment = { __typename?: 'QuotedPaymentMethodType', name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean };

export type QuotedPaymentMethodFragment = { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } };

export type ShipmentProductFragment = { __typename?: 'ShipmentProductType', id: string, quantity: number, batch?: string, supplyOrder: { __typename?: 'SupplyOrderType', id: string }, shipment: { __typename?: 'ShipmentType', id: string }, orderedProduct: { __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } } };

export type ShipmentOemProductFragment = { __typename?: 'ShipmentOEMProductType', id: string, quantity: number, batch?: string, orderOem: { __typename?: 'OrderOEMType', id: string }, shipment: { __typename?: 'ShipmentOEMType', id: string }, orderedProduct: { __typename?: 'OrderedOEMProductType', name: string, externalId: string, productOemId?: string, description: string, price: number, rowCount: number, order: number, id: string, quantity: number, quantityLeft: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string } } };

export type MinimalQuotedProductFragment = { __typename?: 'QuotedProductType', price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, externalId: string };

export type QuotedProductFragment = { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> };

export type QuoteRuleFragment = { __typename?: 'QuoteRuleType', id: string, valueSource: QuotesQuoteRuleValueSourceChoices, image?: string, referenceSource: QuotesQuoteRuleReferenceSourceChoices, referenceMultiplier: number, operator: QuotesQuoteRuleOperatorChoices, description?: string, errorMessage?: string, useForValidation: boolean, useForInitialValue: boolean, prioritizeRule: boolean, product?: { __typename?: 'ProductType', id: string, externalId: string }, productCategory?: { __typename?: 'ProductCategoryType', id: string, name: string }, group?: { __typename?: 'RuleGroupType', id: string, name: string } };

export type MinimalQuoteFragment = { __typename?: 'QuoteType', id: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string };

export type QuoteFragment = { __typename?: 'QuoteType', additionalChargesValue?: number, additionalChargesDescription?: string, billingType: QuotesQuoteBillingTypeChoices, displayBillingType: string, rowCount?: number, notes?: string, oemOrder?: boolean, created: string, id: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: number }, seeder?: { __typename?: 'SeederType', id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } }, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> }>, pdfs: Array<{ __typename?: 'QuotePDFType', id: string, file?: string, type: QuotesQuotePdfTypeChoices, recipient: string, typeDisplay?: string, emailStatus?: string, created: string, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, sale?: { __typename?: 'SaleType', id: string, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteType', id: string } } };

export type QuoteListFragment = { __typename?: 'QuoteType', rowCount?: number, created: string, id: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string, seeder?: { __typename?: 'SeederType', displayName: string }, contact: { __typename?: 'ContactType', email?: string, account: { __typename?: 'AccountType', name: string, owner?: { __typename?: 'OrganizationType', name: string } } }, products: Array<{ __typename?: 'QuotedProductType', id: string, order: number, externalId: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: number }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteType', id: string } } };

export type QuoteKitMultiplierFragment = { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: number };

export type BankInvoicePdfDisclaimerFragment = { __typename?: 'BankInvoicePDFDisclaimerType', legalName: string, adress: string, taxId: string, taxpayerType: string, startOfActivities: string, disclaimer: string };

export type QuoteDetailFragment = { __typename?: 'QuoteType', billingType: QuotesQuoteBillingTypeChoices, created: string, updated: string, additionalChargesValue?: number, additionalChargesDescription?: string, displayBillingType: string, rowCount?: number, notes?: string, oemOrder?: boolean, id: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, sale?: { __typename?: 'SaleType', id: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, quote: { __typename?: 'QuoteType', additionalChargesValue?: number, additionalChargesDescription?: string, billingType: QuotesQuoteBillingTypeChoices, displayBillingType: string, rowCount?: number, notes?: string, oemOrder?: boolean, created: string, id: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: number }, seeder?: { __typename?: 'SeederType', id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } }, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> }>, pdfs: Array<{ __typename?: 'QuotePDFType', id: string, file?: string, type: QuotesQuotePdfTypeChoices, recipient: string, typeDisplay?: string, emailStatus?: string, created: string, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, sale?: { __typename?: 'SaleType', id: string, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteType', id: string } } }, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, supplyOrder?: { __typename?: 'SupplyOrderType', id: string, displayId: number, targetDate?: string, salesCanReview: boolean, status: SupplyOrdersSupplyOrderStatusChoices, statusDisplay: string, created: string, billingType?: SupplyOrdersSupplyOrderBillingTypeChoices, quote: { __typename?: 'QuoteType', additionalChargesValue?: number, additionalChargesDescription?: string, billingType: QuotesQuoteBillingTypeChoices, displayBillingType: string, rowCount?: number, notes?: string, oemOrder?: boolean, created: string, id: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: number }, seeder?: { __typename?: 'SeederType', id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } }, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> }>, pdfs: Array<{ __typename?: 'QuotePDFType', id: string, file?: string, type: QuotesQuotePdfTypeChoices, recipient: string, typeDisplay?: string, emailStatus?: string, created: string, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, sale?: { __typename?: 'SaleType', id: string, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteType', id: string } } }, orderedProducts: Array<{ __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } }>, productsWithoutShipment: Array<{ __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } }>, shipments: Array<{ __typename?: 'ShipmentType', id: string, externalId: string, exchangeRate: number, invoice?: string, created: string, status?: SupplyOrdersShipmentStatusChoices, statusDisplay: string, onHoldDescription?: string, supplyOrder: { __typename?: 'SupplyOrderType', id: string, displayName: string }, productsShipped: Array<{ __typename?: 'ShipmentProductType', id: string, quantity: number, batch?: string, supplyOrder: { __typename?: 'SupplyOrderType', id: string }, shipment: { __typename?: 'ShipmentType', id: string }, orderedProduct: { __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, originalQuote?: { __typename?: 'QuoteType', id: string, displayId: number }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, updatedBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: number }, seeder?: { __typename?: 'SeederType', id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } }, pdfs: Array<{ __typename?: 'QuotePDFType', id: string, file?: string, type: QuotesQuotePdfTypeChoices, recipient: string, typeDisplay?: string, emailStatus?: string, created: string, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteType', id: string } } };

export type OrderedOemProductFragment = { __typename?: 'OrderedOEMProductType', name: string, externalId: string, productOemId?: string, description: string, price: number, rowCount: number, order: number, id: string, quantity: number, quantityLeft: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string } };

export type OemOrganizationFragment = { __typename?: 'OEMOrganizationType', id: string, name: string, externalId: string, originalOrganization?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } };

export type OrderOemPaymentMethodFragment = { __typename?: 'OrderOEMPaymentMethodType', id: string, name: string, multiplier: number, slug: string, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string, name: string, order: number, multiplier: number, slug: string, paymentmethodcategorySet: Array<{ __typename?: 'PaymentMethodCategoryType', finnancied: boolean }> } };

export type OrderOemFragment = { __typename?: 'OrderOEMType', id: string, created: string, status?: OemsOrderOemStatusChoices, displayId: number, statusDisplay: string, reviewStart?: string, targetDate?: string, notes?: string, orderNumber?: string, reviews: Array<{ __typename?: 'OrderOEMReviewType', id: string, status: OemsOrderOemReviewStatusChoices, statusDisplay: string, notes: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, productsWithoutShipment: Array<{ __typename?: 'OrderedOEMProductType', name: string, externalId: string, productOemId?: string, description: string, price: number, rowCount: number, order: number, id: string, quantity: number, quantityLeft: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, organization?: { __typename?: 'OEMOrganizationType', id: string, name: string, externalId: string, originalOrganization?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } }, paymentMethod?: { __typename?: 'OrderOEMPaymentMethodType', id: string, name: string, multiplier: number, slug: string, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string, name: string, order: number, multiplier: number, slug: string, paymentmethodcategorySet: Array<{ __typename?: 'PaymentMethodCategoryType', finnancied: boolean }> } }, products: Array<{ __typename?: 'OrderedOEMProductType', name: string, externalId: string, productOemId?: string, description: string, price: number, rowCount: number, order: number, id: string, quantity: number, quantityLeft: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string } }>, shipments: Array<{ __typename?: 'ShipmentOEMType', id: string, externalId: string, invoice?: string, created: string, status?: OemsShipmentOemStatusChoices, statusDisplay: string, orderOem: { __typename?: 'OrderOEMType', id: string }, productsShipped: Array<{ __typename?: 'ShipmentOEMProductType', id: string, quantity: number, batch?: string, orderOem: { __typename?: 'OrderOEMType', id: string }, shipment: { __typename?: 'ShipmentOEMType', id: string }, orderedProduct: { __typename?: 'OrderedOEMProductType', name: string, externalId: string, productOemId?: string, description: string, price: number, rowCount: number, order: number, id: string, quantity: number, quantityLeft: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string } } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }> };

export type OrderOemReviewFragment = { __typename?: 'OrderOEMReviewType', id: string, status: OemsOrderOemReviewStatusChoices, statusDisplay: string, notes: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } };

export type SaleFragment = { __typename?: 'SaleType', id: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, quote: { __typename?: 'QuoteType', additionalChargesValue?: number, additionalChargesDescription?: string, billingType: QuotesQuoteBillingTypeChoices, displayBillingType: string, rowCount?: number, notes?: string, oemOrder?: boolean, created: string, id: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: number }, seeder?: { __typename?: 'SeederType', id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } }, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> }>, pdfs: Array<{ __typename?: 'QuotePDFType', id: string, file?: string, type: QuotesQuotePdfTypeChoices, recipient: string, typeDisplay?: string, emailStatus?: string, created: string, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, sale?: { __typename?: 'SaleType', id: string, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteType', id: string } } }, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } };

export type SaleListFragment = { __typename?: 'SaleType', id: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, quote: { __typename?: 'QuoteType', rowCount?: number, created: string, id: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string, seeder?: { __typename?: 'SeederType', displayName: string }, contact: { __typename?: 'ContactType', email?: string, account: { __typename?: 'AccountType', name: string, owner?: { __typename?: 'OrganizationType', name: string } } }, products: Array<{ __typename?: 'QuotedProductType', id: string, order: number, externalId: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: number }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteType', id: string } } }, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } };

export type MinimalSaleFragment = { __typename?: 'SaleType', id: string, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } };

export type SaleDetailFragment = { __typename?: 'SaleType', id: string, created: string, quote: { __typename?: 'QuoteType', billingType: QuotesQuoteBillingTypeChoices, created: string, updated: string, additionalChargesValue?: number, additionalChargesDescription?: string, displayBillingType: string, rowCount?: number, notes?: string, oemOrder?: boolean, id: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, sale?: { __typename?: 'SaleType', id: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, quote: { __typename?: 'QuoteType', additionalChargesValue?: number, additionalChargesDescription?: string, billingType: QuotesQuoteBillingTypeChoices, displayBillingType: string, rowCount?: number, notes?: string, oemOrder?: boolean, created: string, id: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: number }, seeder?: { __typename?: 'SeederType', id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } }, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> }>, pdfs: Array<{ __typename?: 'QuotePDFType', id: string, file?: string, type: QuotesQuotePdfTypeChoices, recipient: string, typeDisplay?: string, emailStatus?: string, created: string, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, sale?: { __typename?: 'SaleType', id: string, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteType', id: string } } }, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, supplyOrder?: { __typename?: 'SupplyOrderType', id: string, displayId: number, targetDate?: string, salesCanReview: boolean, status: SupplyOrdersSupplyOrderStatusChoices, statusDisplay: string, created: string, billingType?: SupplyOrdersSupplyOrderBillingTypeChoices, quote: { __typename?: 'QuoteType', additionalChargesValue?: number, additionalChargesDescription?: string, billingType: QuotesQuoteBillingTypeChoices, displayBillingType: string, rowCount?: number, notes?: string, oemOrder?: boolean, created: string, id: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: number }, seeder?: { __typename?: 'SeederType', id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } }, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> }>, pdfs: Array<{ __typename?: 'QuotePDFType', id: string, file?: string, type: QuotesQuotePdfTypeChoices, recipient: string, typeDisplay?: string, emailStatus?: string, created: string, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, sale?: { __typename?: 'SaleType', id: string, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteType', id: string } } }, orderedProducts: Array<{ __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } }>, productsWithoutShipment: Array<{ __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } }>, shipments: Array<{ __typename?: 'ShipmentType', id: string, externalId: string, exchangeRate: number, invoice?: string, created: string, status?: SupplyOrdersShipmentStatusChoices, statusDisplay: string, onHoldDescription?: string, supplyOrder: { __typename?: 'SupplyOrderType', id: string, displayName: string }, productsShipped: Array<{ __typename?: 'ShipmentProductType', id: string, quantity: number, batch?: string, supplyOrder: { __typename?: 'SupplyOrderType', id: string }, shipment: { __typename?: 'ShipmentType', id: string }, orderedProduct: { __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, originalQuote?: { __typename?: 'QuoteType', id: string, displayId: number }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, updatedBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: number }, seeder?: { __typename?: 'SeederType', id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } }, pdfs: Array<{ __typename?: 'QuotePDFType', id: string, file?: string, type: QuotesQuotePdfTypeChoices, recipient: string, typeDisplay?: string, emailStatus?: string, created: string, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteType', id: string } } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } };

export type SupplyOrderFragment = { __typename?: 'SupplyOrderType', id: string, displayId: number, targetDate?: string, salesCanReview: boolean, status: SupplyOrdersSupplyOrderStatusChoices, statusDisplay: string, created: string, billingType?: SupplyOrdersSupplyOrderBillingTypeChoices, quote: { __typename?: 'QuoteType', additionalChargesValue?: number, additionalChargesDescription?: string, billingType: QuotesQuoteBillingTypeChoices, displayBillingType: string, rowCount?: number, notes?: string, oemOrder?: boolean, created: string, id: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: number }, seeder?: { __typename?: 'SeederType', id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } }, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> }>, pdfs: Array<{ __typename?: 'QuotePDFType', id: string, file?: string, type: QuotesQuotePdfTypeChoices, recipient: string, typeDisplay?: string, emailStatus?: string, created: string, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, sale?: { __typename?: 'SaleType', id: string, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteType', id: string } } }, orderedProducts: Array<{ __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } }>, productsWithoutShipment: Array<{ __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } }>, shipments: Array<{ __typename?: 'ShipmentType', id: string, externalId: string, exchangeRate: number, invoice?: string, created: string, status?: SupplyOrdersShipmentStatusChoices, statusDisplay: string, onHoldDescription?: string, supplyOrder: { __typename?: 'SupplyOrderType', id: string, displayName: string }, productsShipped: Array<{ __typename?: 'ShipmentProductType', id: string, quantity: number, batch?: string, supplyOrder: { __typename?: 'SupplyOrderType', id: string }, shipment: { __typename?: 'ShipmentType', id: string }, orderedProduct: { __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } };

export type SupplyOrderListFragment = { __typename?: 'SupplyOrderType', id: string, displayId: number, statusDisplay: string, created: string, quote: { __typename?: 'QuoteType', oemOrder?: boolean, rowCount?: number, contact: { __typename?: 'ContactType', email?: string, account: { __typename?: 'AccountType', name: string, owner?: { __typename?: 'OrganizationType', name: string } } }, seeder?: { __typename?: 'SeederType', displayName: string }, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', multiplier: number }, sale?: { __typename?: 'SaleType', paymentMethod: { __typename?: 'QuotedPaymentMethodType', name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean } } }, orderedProducts: Array<{ __typename?: 'OrderedProductType', quantity: number, price: number, commissionMultiplier: number, enableDiscount: boolean }>, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean } };

export type SupplyOrderDetailFragment = { __typename?: 'SupplyOrderType', reviewStart?: string, updated: string, id: string, displayId: number, targetDate?: string, salesCanReview: boolean, status: SupplyOrdersSupplyOrderStatusChoices, statusDisplay: string, created: string, billingType?: SupplyOrdersSupplyOrderBillingTypeChoices, reviews: Array<{ __typename?: 'SupplyOrderReviewType', id: string, statusDisplay: string, typeDisplay: string, notes: string, created: string, automaticReviewRejectionRules: Array<{ __typename?: 'AutomaticReviewRejectionRuleType', message: string, description: string, supplyOrderReview?: { __typename?: 'SupplyOrderReviewType', id: string } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, updatedBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, quote: { __typename?: 'QuoteType', additionalChargesValue?: number, additionalChargesDescription?: string, billingType: QuotesQuoteBillingTypeChoices, displayBillingType: string, rowCount?: number, notes?: string, oemOrder?: boolean, created: string, id: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: number }, seeder?: { __typename?: 'SeederType', id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } }, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> }>, pdfs: Array<{ __typename?: 'QuotePDFType', id: string, file?: string, type: QuotesQuotePdfTypeChoices, recipient: string, typeDisplay?: string, emailStatus?: string, created: string, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, sale?: { __typename?: 'SaleType', id: string, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteType', id: string } } }, orderedProducts: Array<{ __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } }>, productsWithoutShipment: Array<{ __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } }>, shipments: Array<{ __typename?: 'ShipmentType', id: string, externalId: string, exchangeRate: number, invoice?: string, created: string, status?: SupplyOrdersShipmentStatusChoices, statusDisplay: string, onHoldDescription?: string, supplyOrder: { __typename?: 'SupplyOrderType', id: string, displayName: string }, productsShipped: Array<{ __typename?: 'ShipmentProductType', id: string, quantity: number, batch?: string, supplyOrder: { __typename?: 'SupplyOrderType', id: string }, shipment: { __typename?: 'ShipmentType', id: string }, orderedProduct: { __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } };

export type MinimalShipmentFragment = { __typename?: 'ShipmentType', id: string, externalId: string };

export type MinimalSupplyOrderFragment = { __typename?: 'SupplyOrderType', id: string, displayName: string };

export type ShipmentFragment = { __typename?: 'ShipmentType', id: string, externalId: string, exchangeRate: number, invoice?: string, created: string, status?: SupplyOrdersShipmentStatusChoices, statusDisplay: string, onHoldDescription?: string, supplyOrder: { __typename?: 'SupplyOrderType', id: string, displayName: string }, productsShipped: Array<{ __typename?: 'ShipmentProductType', id: string, quantity: number, batch?: string, supplyOrder: { __typename?: 'SupplyOrderType', id: string }, shipment: { __typename?: 'ShipmentType', id: string }, orderedProduct: { __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } };

export type ShipmentOemFragment = { __typename?: 'ShipmentOEMType', id: string, externalId: string, invoice?: string, created: string, status?: OemsShipmentOemStatusChoices, statusDisplay: string, orderOem: { __typename?: 'OrderOEMType', id: string }, productsShipped: Array<{ __typename?: 'ShipmentOEMProductType', id: string, quantity: number, batch?: string, orderOem: { __typename?: 'OrderOEMType', id: string }, shipment: { __typename?: 'ShipmentOEMType', id: string }, orderedProduct: { __typename?: 'OrderedOEMProductType', name: string, externalId: string, productOemId?: string, description: string, price: number, rowCount: number, order: number, id: string, quantity: number, quantityLeft: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string } } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } };

export type OrderedProductFragment = { __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } };

export type MinimalOrderedOemProductFragment = { __typename?: 'OrderedOEMProductType', id: string, quantity: number, quantityLeft: number };

export type AutomaticReviewRejectionRuleFragment = { __typename?: 'AutomaticReviewRejectionRuleType', message: string, description: string, supplyOrderReview?: { __typename?: 'SupplyOrderReviewType', id: string } };

export type SupplyOrderReviewFragment = { __typename?: 'SupplyOrderReviewType', id: string, statusDisplay: string, typeDisplay: string, notes: string, created: string, automaticReviewRejectionRules: Array<{ __typename?: 'AutomaticReviewRejectionRuleType', message: string, description: string, supplyOrderReview?: { __typename?: 'SupplyOrderReviewType', id: string } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } };

export type BankInvoicePdfFragment = { __typename?: 'BankInvoicePDFType', id: string, created: string, quote?: { __typename?: 'QuoteType', additionalChargesValue?: number, additionalChargesDescription?: string, billingType: QuotesQuoteBillingTypeChoices, displayBillingType: string, rowCount?: number, notes?: string, oemOrder?: boolean, created: string, id: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: number }, seeder?: { __typename?: 'SeederType', id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } }, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> }>, pdfs: Array<{ __typename?: 'QuotePDFType', id: string, file?: string, type: QuotesQuotePdfTypeChoices, recipient: string, typeDisplay?: string, emailStatus?: string, created: string, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, sale?: { __typename?: 'SaleType', id: string, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteType', id: string } } }, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } };

export type SeederFragment = { __typename?: 'SeederType', id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } };

export type SeederDetailFragment = { __typename?: 'SeederType', created: string, updated: string, id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, updatedBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } };

export type SeederModelFragment = { __typename?: 'SeederModelType', id: string, name: string };

export type SeederOptionFragment = { __typename?: 'SeederType', id: string, displayName: string, rowCount: number };

export type SeederBrandFragment = { __typename?: 'SeederBrandType', id: string, name: string };

export type GetFactoryControlOrganizationsQueryVariables = Exact<{
  organizationGroupId?: InputMaybe<Scalars['UUID']>;
}>;


export type GetFactoryControlOrganizationsQuery = { __typename?: 'Query', factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }> };

export type FactoryAssistantFragment = { __typename?: 'FactoryAssistantType', id: string, name: string, phone: string };

export type CustomerAssistantFragment = { __typename?: 'CustomerAssistantType', id: string, name: string, phone: string };

export type RuntimeSettingsFragment = { __typename?: 'RuntimeSettingsType', id: string, quotePdfDisclaimer: string, taxIdLabel: string, signaturesInDisclaimer: boolean, maxVideoSize: number, machineStartUpPercentage: number, machineStartUpInstallationPercentage: number, physicalPersonsDocumentation?: string, legalPersonsDocumentation?: string, templateOfAffidavit?: string, datastudioUrl?: string, tinymceUrl?: string, ordersOemTemplate?: string, datePaymentMethodCalculationV2: string, pricePerHour: number, pemProtocolTemplate?: string, pemTermsTemplate?: string, stockSpreadsheetUrl?: string };

export type GetUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserQuery = { __typename?: 'Query', user?: { __typename?: 'UserType', id: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, canEditLockedEcnTasks: boolean, emailNotifications: boolean, inAppNotifications: boolean, organization?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }, role?: { __typename?: 'RoleType', id: string, name: string }, ecnRoles: Array<{ __typename?: 'EcnRoleType', id: string }>, permissions: { __typename?: 'UserPermissions', viewQuotes: boolean, viewSales: boolean, viewSupplyOrders: boolean, viewAccounts: boolean, viewContacts: boolean, viewOpportunities: boolean, viewWarrantyClaims: boolean, viewMachineStartUps: boolean, viewEcns: boolean, assignAccountOwner: boolean, requestSupplyOrderReview: boolean, submitSalesSupplyOrderReview: boolean, submitCreditsSupplyOrderReview: boolean, requestOemOrderReview: boolean, viewAnalytics: boolean, viewWarrantyClaimsAnalytics: boolean, manageShipments: boolean, manageQuotes: boolean, manageSales: boolean, manageSupplyOrders: boolean, manageWarrantyClaims: boolean, performTechnicalReview: boolean, manageMachineStartUps: boolean, manageOem: boolean, viewOemStock: boolean, manageEcns: boolean, manageAccounts: boolean, viewDatastudio: boolean, viewOems: boolean, viewSeeders: boolean, viewMaterialMaster: boolean, manageMaterialMaster: boolean, createMachineStartUps: boolean, viewOemOrderBankInvoices: boolean, viewStock: boolean, viewUnpublishedProducts: boolean, requestAccountRegistration: boolean, submitAccountRegistrationReview: boolean, receiveAccountRegistrationApprovedNotification: boolean } } };

export type GetUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsersQuery = { __typename?: 'Query', users: Array<{ __typename?: 'UserType', id: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, canEditLockedEcnTasks: boolean, emailNotifications: boolean, inAppNotifications: boolean, organization?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }, role?: { __typename?: 'RoleType', id: string, name: string }, ecnRoles: Array<{ __typename?: 'EcnRoleType', id: string }>, permissions: { __typename?: 'UserPermissions', viewQuotes: boolean, viewSales: boolean, viewSupplyOrders: boolean, viewAccounts: boolean, viewContacts: boolean, viewOpportunities: boolean, viewWarrantyClaims: boolean, viewMachineStartUps: boolean, viewEcns: boolean, assignAccountOwner: boolean, requestSupplyOrderReview: boolean, submitSalesSupplyOrderReview: boolean, submitCreditsSupplyOrderReview: boolean, requestOemOrderReview: boolean, viewAnalytics: boolean, viewWarrantyClaimsAnalytics: boolean, manageShipments: boolean, manageQuotes: boolean, manageSales: boolean, manageSupplyOrders: boolean, manageWarrantyClaims: boolean, performTechnicalReview: boolean, manageMachineStartUps: boolean, manageOem: boolean, viewOemStock: boolean, manageEcns: boolean, manageAccounts: boolean, viewDatastudio: boolean, viewOems: boolean, viewSeeders: boolean, viewMaterialMaster: boolean, manageMaterialMaster: boolean, createMachineStartUps: boolean, viewOemOrderBankInvoices: boolean, viewStock: boolean, viewUnpublishedProducts: boolean, requestAccountRegistration: boolean, submitAccountRegistrationReview: boolean, receiveAccountRegistrationApprovedNotification: boolean } }> };

export type GetUsersListQueryVariables = Exact<{
  options?: InputMaybe<UserListOptionsInputType>;
}>;


export type GetUsersListQuery = { __typename?: 'Query', usersList: { __typename?: 'UserListType', count: number, items: Array<{ __typename?: 'UserType', id: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, canEditLockedEcnTasks: boolean, emailNotifications: boolean, inAppNotifications: boolean, organization?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }, role?: { __typename?: 'RoleType', id: string, name: string }, ecnRoles: Array<{ __typename?: 'EcnRoleType', id: string }>, permissions: { __typename?: 'UserPermissions', viewQuotes: boolean, viewSales: boolean, viewSupplyOrders: boolean, viewAccounts: boolean, viewContacts: boolean, viewOpportunities: boolean, viewWarrantyClaims: boolean, viewMachineStartUps: boolean, viewEcns: boolean, assignAccountOwner: boolean, requestSupplyOrderReview: boolean, submitSalesSupplyOrderReview: boolean, submitCreditsSupplyOrderReview: boolean, requestOemOrderReview: boolean, viewAnalytics: boolean, viewWarrantyClaimsAnalytics: boolean, manageShipments: boolean, manageQuotes: boolean, manageSales: boolean, manageSupplyOrders: boolean, manageWarrantyClaims: boolean, performTechnicalReview: boolean, manageMachineStartUps: boolean, manageOem: boolean, viewOemStock: boolean, manageEcns: boolean, manageAccounts: boolean, viewDatastudio: boolean, viewOems: boolean, viewSeeders: boolean, viewMaterialMaster: boolean, manageMaterialMaster: boolean, createMachineStartUps: boolean, viewOemOrderBankInvoices: boolean, viewStock: boolean, viewUnpublishedProducts: boolean, requestAccountRegistration: boolean, submitAccountRegistrationReview: boolean, receiveAccountRegistrationApprovedNotification: boolean } }> } };

export type GetOrganizationsQueryVariables = Exact<{
  options?: InputMaybe<OrganizationListOptionsInputType>;
}>;


export type GetOrganizationsQuery = { __typename?: 'Query', organizations: { __typename?: 'OrganizationListType', count: number, items: Array<{ __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }> } };

export type GetChildOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetChildOrganizationsQuery = { __typename?: 'Query', childOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }> };

export type GetChildUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetChildUsersQuery = { __typename?: 'Query', childUsers: Array<{ __typename?: 'UserType', id: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, canEditLockedEcnTasks: boolean, emailNotifications: boolean, inAppNotifications: boolean, organization?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }, role?: { __typename?: 'RoleType', id: string, name: string }, ecnRoles: Array<{ __typename?: 'EcnRoleType', id: string }>, permissions: { __typename?: 'UserPermissions', viewQuotes: boolean, viewSales: boolean, viewSupplyOrders: boolean, viewAccounts: boolean, viewContacts: boolean, viewOpportunities: boolean, viewWarrantyClaims: boolean, viewMachineStartUps: boolean, viewEcns: boolean, assignAccountOwner: boolean, requestSupplyOrderReview: boolean, submitSalesSupplyOrderReview: boolean, submitCreditsSupplyOrderReview: boolean, requestOemOrderReview: boolean, viewAnalytics: boolean, viewWarrantyClaimsAnalytics: boolean, manageShipments: boolean, manageQuotes: boolean, manageSales: boolean, manageSupplyOrders: boolean, manageWarrantyClaims: boolean, performTechnicalReview: boolean, manageMachineStartUps: boolean, manageOem: boolean, viewOemStock: boolean, manageEcns: boolean, manageAccounts: boolean, viewDatastudio: boolean, viewOems: boolean, viewSeeders: boolean, viewMaterialMaster: boolean, manageMaterialMaster: boolean, createMachineStartUps: boolean, viewOemOrderBankInvoices: boolean, viewStock: boolean, viewUnpublishedProducts: boolean, requestAccountRegistration: boolean, submitAccountRegistrationReview: boolean, receiveAccountRegistrationApprovedNotification: boolean } }> };

export type LoginMutationVariables = Exact<{
  input: LoginInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login?: { __typename?: 'LoginPayload', user?: { __typename?: 'UserType', id: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, canEditLockedEcnTasks: boolean, emailNotifications: boolean, inAppNotifications: boolean, organization?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }, role?: { __typename?: 'RoleType', id: string, name: string }, ecnRoles: Array<{ __typename?: 'EcnRoleType', id: string }>, permissions: { __typename?: 'UserPermissions', viewQuotes: boolean, viewSales: boolean, viewSupplyOrders: boolean, viewAccounts: boolean, viewContacts: boolean, viewOpportunities: boolean, viewWarrantyClaims: boolean, viewMachineStartUps: boolean, viewEcns: boolean, assignAccountOwner: boolean, requestSupplyOrderReview: boolean, submitSalesSupplyOrderReview: boolean, submitCreditsSupplyOrderReview: boolean, requestOemOrderReview: boolean, viewAnalytics: boolean, viewWarrantyClaimsAnalytics: boolean, manageShipments: boolean, manageQuotes: boolean, manageSales: boolean, manageSupplyOrders: boolean, manageWarrantyClaims: boolean, performTechnicalReview: boolean, manageMachineStartUps: boolean, manageOem: boolean, viewOemStock: boolean, manageEcns: boolean, manageAccounts: boolean, viewDatastudio: boolean, viewOems: boolean, viewSeeders: boolean, viewMaterialMaster: boolean, manageMaterialMaster: boolean, createMachineStartUps: boolean, viewOemOrderBankInvoices: boolean, viewStock: boolean, viewUnpublishedProducts: boolean, requestAccountRegistration: boolean, submitAccountRegistrationReview: boolean, receiveAccountRegistrationApprovedNotification: boolean } }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout?: { __typename?: 'Logout', success?: boolean } };

export type ResetPasswordMutationVariables = Exact<{
  input: ResetPasswordMutationInput;
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword?: { __typename?: 'ResetPasswordMutationPayload', errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type SetPasswordMutationVariables = Exact<{
  input: SetPasswordMutationInput;
}>;


export type SetPasswordMutation = { __typename?: 'Mutation', setPassword?: { __typename?: 'SetPasswordMutationPayload', errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type UpdatePasswordMutationVariables = Exact<{
  input: UpdatePasswordMutationInput;
}>;


export type UpdatePasswordMutation = { __typename?: 'Mutation', updatePassword?: { __typename?: 'UpdatePasswordMutationPayload', errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserMutationInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'UpdateUserMutationPayload', user?: { __typename?: 'UserType', id: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, canEditLockedEcnTasks: boolean, emailNotifications: boolean, inAppNotifications: boolean, organization?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }, role?: { __typename?: 'RoleType', id: string, name: string }, ecnRoles: Array<{ __typename?: 'EcnRoleType', id: string }>, permissions: { __typename?: 'UserPermissions', viewQuotes: boolean, viewSales: boolean, viewSupplyOrders: boolean, viewAccounts: boolean, viewContacts: boolean, viewOpportunities: boolean, viewWarrantyClaims: boolean, viewMachineStartUps: boolean, viewEcns: boolean, assignAccountOwner: boolean, requestSupplyOrderReview: boolean, submitSalesSupplyOrderReview: boolean, submitCreditsSupplyOrderReview: boolean, requestOemOrderReview: boolean, viewAnalytics: boolean, viewWarrantyClaimsAnalytics: boolean, manageShipments: boolean, manageQuotes: boolean, manageSales: boolean, manageSupplyOrders: boolean, manageWarrantyClaims: boolean, performTechnicalReview: boolean, manageMachineStartUps: boolean, manageOem: boolean, viewOemStock: boolean, manageEcns: boolean, manageAccounts: boolean, viewDatastudio: boolean, viewOems: boolean, viewSeeders: boolean, viewMaterialMaster: boolean, manageMaterialMaster: boolean, createMachineStartUps: boolean, viewOemOrderBankInvoices: boolean, viewStock: boolean, viewUnpublishedProducts: boolean, requestAccountRegistration: boolean, submitAccountRegistrationReview: boolean, receiveAccountRegistrationApprovedNotification: boolean } }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type GetAccountsQueryVariables = Exact<{
  options?: InputMaybe<AccountListOptionsInputType>;
  filterByUser?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetAccountsQuery = { __typename?: 'Query', accounts: { __typename?: 'AccountListType', count: number, items: Array<{ __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } }> } };

export type GetAccountOptionsQueryVariables = Exact<{
  options?: InputMaybe<AccountListOptionsInputType>;
  filterByUser?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetAccountOptionsQuery = { __typename?: 'Query', accounts: { __typename?: 'AccountListType', items: Array<{ __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } }> } };

export type GetAccountQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type GetAccountQuery = { __typename?: 'Query', account: { __typename?: 'AccountType', extraLocation?: string, created: string, updated: string, id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, location?: { __typename?: 'LocationType', id: string, path?: string }, files: Array<{ __typename?: 'AccountFileType', id: string, file: string }>, registrationReviews: Array<{ __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, updatedBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, seeders: Array<{ __typename?: 'SeederType', id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } }>, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } };

export type GetEditAccountQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type GetEditAccountQuery = { __typename?: 'Query', account: { __typename?: 'AccountType', id: string, name: string, externalId: string, taxId?: string, extraLocation?: string, location?: { __typename?: 'LocationType', id: string }, owner?: { __typename?: 'OrganizationType', id: string }, region?: { __typename?: 'AccountRegionType', id: string }, files: Array<{ __typename?: 'AccountFileType', id: string, file: string }> } };

export type GetAccountOptionQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type GetAccountOptionQuery = { __typename?: 'Query', account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } };

export type CreateAccountMutationVariables = Exact<{
  input: CreateAccountMutationInput;
}>;


export type CreateAccountMutation = { __typename?: 'Mutation', createAccount?: { __typename?: 'CreateAccountMutationPayload', account?: { __typename?: 'AccountType', extraLocation?: string, created: string, updated: string, id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, location?: { __typename?: 'LocationType', id: string, path?: string }, files: Array<{ __typename?: 'AccountFileType', id: string, file: string }>, registrationReviews: Array<{ __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, updatedBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, seeders: Array<{ __typename?: 'SeederType', id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } }>, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type UpdateAccountMutationVariables = Exact<{
  input: UpdateAccountMutationInput;
}>;


export type UpdateAccountMutation = { __typename?: 'Mutation', updateAccount?: { __typename?: 'UpdateAccountMutationPayload', account?: { __typename?: 'AccountType', extraLocation?: string, created: string, updated: string, id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, location?: { __typename?: 'LocationType', id: string, path?: string }, files: Array<{ __typename?: 'AccountFileType', id: string, file: string }>, registrationReviews: Array<{ __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, updatedBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, seeders: Array<{ __typename?: 'SeederType', id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } }>, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type DeleteAccountMutationVariables = Exact<{
  input: DeleteAccountMutationInput;
}>;


export type DeleteAccountMutation = { __typename?: 'Mutation', deleteAccount?: { __typename?: 'DeleteAccountMutationPayload', errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type UpdateAccountExternalIdMutationVariables = Exact<{
  input: UpdateAccountExternalIdMutationInput;
}>;


export type UpdateAccountExternalIdMutation = { __typename?: 'Mutation', updateAccountExternalId?: { __typename?: 'UpdateAccountExternalIdMutationPayload', errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type UpdateAccountFilesMutationVariables = Exact<{
  id: Scalars['UUID'];
  files: Array<InputMaybe<Scalars['Upload']>>;
}>;


export type UpdateAccountFilesMutation = { __typename?: 'Mutation', updateAccountFiles?: { __typename?: 'UpdateAccountFiles', errors?: { __typename?: 'ErrorType', field: string, messages: Array<string> } } };

export type StartAccountRegistrationMutationVariables = Exact<{
  input: StartAccountRegistrationMutationInput;
}>;


export type StartAccountRegistrationMutation = { __typename?: 'Mutation', startAccountRegistration?: { __typename?: 'StartAccountRegistrationMutationPayload', account?: { __typename?: 'AccountType', extraLocation?: string, created: string, updated: string, id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, location?: { __typename?: 'LocationType', id: string, path?: string }, files: Array<{ __typename?: 'AccountFileType', id: string, file: string }>, registrationReviews: Array<{ __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, updatedBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, seeders: Array<{ __typename?: 'SeederType', id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } }>, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type ReviewAccountRegistrationMutationVariables = Exact<{
  input: ReviewAccountRegistrationMutationInput;
}>;


export type ReviewAccountRegistrationMutation = { __typename?: 'Mutation', reviewAccountRegistration?: { __typename?: 'ReviewAccountRegistrationMutationPayload', accountRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type GetAccountRegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccountRegionsQuery = { __typename?: 'Query', accountRegions: Array<{ __typename?: 'AccountRegionType', id: string, name: string }> };

export type GetContactsQueryVariables = Exact<{
  options?: InputMaybe<ContactListOptionsInputType>;
  filterByUser?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetContactsQuery = { __typename?: 'Query', contacts: { __typename?: 'ContactListType', count: number, items: Array<{ __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }> } };

export type GetContactOptionsQueryVariables = Exact<{
  options?: InputMaybe<ContactListOptionsInputType>;
  filterByUser?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetContactOptionsQuery = { __typename?: 'Query', contacts: { __typename?: 'ContactListType', count: number, items: Array<{ __typename?: 'ContactType', id: string, displayName: string }> } };

export type GetContactAccountQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type GetContactAccountQuery = { __typename?: 'Query', contact: { __typename?: 'ContactType', account: { __typename?: 'AccountType', id: string } } };

export type GetContactQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type GetContactQuery = { __typename?: 'Query', contact: { __typename?: 'ContactType', created: string, updated: string, id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, updatedBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } } };

export type GetMachineStartupMinimalContactQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetMachineStartupMinimalContactQuery = { __typename?: 'Query', contact: { __typename?: 'ContactType', id: string, phone: string, mobilePhone: string } };

export type CreateContactMutationVariables = Exact<{
  input: CreateContactMutationInput;
}>;


export type CreateContactMutation = { __typename?: 'Mutation', createContact?: { __typename?: 'CreateContactMutationPayload', contact?: { __typename?: 'ContactType', created: string, updated: string, id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, updatedBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type UpdateContactMutationVariables = Exact<{
  input: UpdateContactMutationInput;
}>;


export type UpdateContactMutation = { __typename?: 'Mutation', updateContact?: { __typename?: 'UpdateContactMutationPayload', contact?: { __typename?: 'ContactType', created: string, updated: string, id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, updatedBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type DeleteContactMutationVariables = Exact<{
  input: DeleteContactMutationInput;
}>;


export type DeleteContactMutation = { __typename?: 'Mutation', deleteContact?: { __typename?: 'DeleteContactMutationPayload', errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type GetContactTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContactTypesQuery = { __typename?: 'Query', contactTypes: Array<{ __typename?: 'ContactTypeType', id: string, name: string }> };

export type GetOpportunitiesQueryVariables = Exact<{
  options?: InputMaybe<OpportunityListOptionsInputType>;
}>;


export type GetOpportunitiesQuery = { __typename?: 'Query', opportunities: { __typename?: 'OpportunityListType', count: number, items: Array<{ __typename?: 'OpportunityType', id: string, displayName: string, date: string, notes: string, products: string, channel: { __typename?: 'OpportunityChannelType', id: string, name: string }, reason: { __typename?: 'OpportunityReasonType', id: string, name: string }, situation: { __typename?: 'OpportunitySituationType', id: string, name: string }, contact: { __typename?: 'ContactType', id: string, displayName: string, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } } }> } };

export type GetOpportunityQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type GetOpportunityQuery = { __typename?: 'Query', opportunity: { __typename?: 'OpportunityType', created: string, updated: string, id: string, displayName: string, date: string, notes: string, products: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, updatedBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, channel: { __typename?: 'OpportunityChannelType', id: string, name: string }, reason: { __typename?: 'OpportunityReasonType', id: string, name: string }, situation: { __typename?: 'OpportunitySituationType', id: string, name: string }, contact: { __typename?: 'ContactType', id: string, displayName: string, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } } } };

export type CreateOpportunityMutationVariables = Exact<{
  input: CreateOpportunityMutationInput;
}>;


export type CreateOpportunityMutation = { __typename?: 'Mutation', createOpportunity?: { __typename?: 'CreateOpportunityMutationPayload', opportunity?: { __typename?: 'OpportunityType', created: string, updated: string, id: string, displayName: string, date: string, notes: string, products: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, updatedBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, channel: { __typename?: 'OpportunityChannelType', id: string, name: string }, reason: { __typename?: 'OpportunityReasonType', id: string, name: string }, situation: { __typename?: 'OpportunitySituationType', id: string, name: string }, contact: { __typename?: 'ContactType', id: string, displayName: string, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } } }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type UpdateOpportunityMutationVariables = Exact<{
  input: UpdateOpportunityMutationInput;
}>;


export type UpdateOpportunityMutation = { __typename?: 'Mutation', updateOpportunity?: { __typename?: 'UpdateOpportunityMutationPayload', opportunity?: { __typename?: 'OpportunityType', created: string, updated: string, id: string, displayName: string, date: string, notes: string, products: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, updatedBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, channel: { __typename?: 'OpportunityChannelType', id: string, name: string }, reason: { __typename?: 'OpportunityReasonType', id: string, name: string }, situation: { __typename?: 'OpportunitySituationType', id: string, name: string }, contact: { __typename?: 'ContactType', id: string, displayName: string, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } } }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type DeleteOpportunityMutationVariables = Exact<{
  input: DeleteOpportunityMutationInput;
}>;


export type DeleteOpportunityMutation = { __typename?: 'Mutation', deleteOpportunity?: { __typename?: 'DeleteOpportunityMutationPayload', errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type GetOpportunityChannelsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOpportunityChannelsQuery = { __typename?: 'Query', opportunityChannels: Array<{ __typename?: 'OpportunityChannelType', id: string, name: string }> };

export type GetOpportunityReasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOpportunityReasonsQuery = { __typename?: 'Query', opportunityReasons: Array<{ __typename?: 'OpportunityReasonType', id: string, name: string }> };

export type GetOpportunitySituationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOpportunitySituationsQuery = { __typename?: 'Query', opportunitySituations: Array<{ __typename?: 'OpportunitySituationType', id: string, name: string }> };

export type GetBillingTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBillingTypesQuery = { __typename?: 'Query', billingTypes: Array<{ __typename?: 'BillingTypeType', id: string, name: string }> };

export type GetProductCategoriesQueryVariables = Exact<{
  seederId?: InputMaybe<Scalars['UUID']>;
}>;


export type GetProductCategoriesQuery = { __typename?: 'Query', productCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }> };

export type GetProductCategoriesForAssistedQuoteQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProductCategoriesForAssistedQuoteQuery = { __typename?: 'Query', productCategoriesForAssistedQuote: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }> };

export type GetProductCategoriesEnabledForSeederQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProductCategoriesEnabledForSeederQuery = { __typename?: 'Query', productCategoriesEnabledForSeeder: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }> };

export type GetProductSubcategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProductSubcategoriesQuery = { __typename?: 'Query', productSubcategories: Array<{ __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }> };

export type GetProductsQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['UUID']>;
}>;


export type GetProductsQuery = { __typename?: 'Query', products: Array<{ __typename?: 'ProductType', id: string, externalId: string, name: string, displayName: string, price: number, type: ProductsProductTypeChoices, displayType: string, order: number, description: string, rowCount: number, published: boolean, mmStatus: ProductsProductMmStatusChoices, displayMmStatus: string, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> }> };

export type GetProductsV2QueryVariables = Exact<{
  options?: InputMaybe<ProductListTypeV2OptionsInputType2>;
}>;


export type GetProductsV2Query = { __typename?: 'Query', productsV2: { __typename?: 'ProductListTypeV2', count: number, items: Array<{ __typename?: 'ProductType', id: string, externalId: string, name: string, displayName: string, price: number, type: ProductsProductTypeChoices, displayType: string, order: number, description: string, rowCount: number, published: boolean, mmStatus: ProductsProductMmStatusChoices, displayMmStatus: string, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> }> } };

export type GetUnpublishedProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnpublishedProductsQuery = { __typename?: 'Query', unpublishedProducts: Array<{ __typename?: 'ProductType', id: string, externalId: string, name: string, displayName: string, price: number, type: ProductsProductTypeChoices, displayType: string, order: number, description: string, rowCount: number, published: boolean, mmStatus: ProductsProductMmStatusChoices, displayMmStatus: string, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> }> };

export type GetProductPriceModifiersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProductPriceModifiersQuery = { __typename?: 'Query', productPriceModifiers: Array<{ __typename?: 'ProductPriceModifierType', id: string, enableDiscount: boolean, commissionMultiplier: number, billingType: ProductsProductPriceModifierBillingTypeChoices }> };

export type GetProductQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type GetProductQuery = { __typename?: 'Query', product: { __typename?: 'ProductType', id: string, externalId: string, name: string, displayName: string, price: number, type: ProductsProductTypeChoices, displayType: string, order: number, description: string, rowCount: number, published: boolean, mmStatus: ProductsProductMmStatusChoices, displayMmStatus: string, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } };

export type GetProductsImagesQueryVariables = Exact<{
  req?: InputMaybe<ProductImageRequestType>;
}>;


export type GetProductsImagesQuery = { __typename?: 'Query', productsImages: Array<{ __typename?: 'ProductType', id: string, image?: string, externalId: string }> };

export type GetProductOptionsQueryVariables = Exact<{
  categoryId?: InputMaybe<Scalars['UUID']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
}>;


export type GetProductOptionsQuery = { __typename?: 'Query', products: Array<{ __typename?: 'ProductType', id: string, name: string, displayName: string, externalId: string, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', name: string, id: string } } }> };

export type GetProductCategoryQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type GetProductCategoryQuery = { __typename?: 'Query', product: { __typename?: 'ProductType', subcategory: { __typename?: 'ProductSubcategoryType', category: { __typename?: 'ProductCategoryType', id: string } } } };

export type GetProductSubcategoryQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type GetProductSubcategoryQuery = { __typename?: 'Query', product: { __typename?: 'ProductType', subcategory: { __typename?: 'ProductSubcategoryType', id: string } } };

export type GetProductWarrantyClaimQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type GetProductWarrantyClaimQuery = { __typename?: 'Query', productWarrantyClaim: { __typename?: 'ProductWarrantyClaimType', id: string, deliveryDate: string, failureDate: string, serialNumber: string, created: string, quantity: number, description: string, finalClient: string, phone: string, externalId?: string, seederKilometers: number, displayId: number, inspectionReview?: { __typename?: 'WarrantyClaimInspectionReviewType', statusDisplay: string, status: ProductsWarrantyClaimInspectionReviewStatusChoices, inWarranty: boolean, id: string, created: string, updated: string, received: boolean, receivedDate?: string, inspected: boolean, inspectedDate?: string, failureDescription: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, updatedBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, warrantyClaim: { __typename?: 'ProductWarrantyClaimType', id: string }, files: Array<{ __typename?: 'WarrantyClaimInspectionFileType', id: string, file?: string }> }, seeder?: { __typename?: 'SeederType', id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } }, images?: Array<{ __typename?: 'WarrantyClaimImageType', id: string, file: string, warrantyClaim: { __typename?: 'ProductWarrantyClaimType', id: string } }>, videos: Array<{ __typename?: 'WarrantyClaimVideoType', id: string, file: string, warrantyClaim: { __typename?: 'ProductWarrantyClaimType', id: string } }>, reviews: Array<{ __typename?: 'ProductWarrantyClaimReviewType', id: string, created: string, notes: string, statusDisplay: string, status: ProductsProductWarrantyClaimReviewStatusChoices, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, inspectionReviewHistories: Array<{ __typename?: 'WarrantyClaimInspectionReviewHistoryType', id: string, created: string, inWarranty: boolean, inWarrantyDisplay: string, previousInWarranty?: boolean, previousInWarrantyDisplay?: string, failureDescription: string, previousFailureDescription: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, product?: { __typename?: 'WarrantyProductType', id: string, externalId: string, name: string, displayName: string, price: number, order: number, description: string, rowCount: number, originalProduct?: { __typename?: 'ProductType', id: string, image?: string }, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } } }, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, lastReview?: { __typename?: 'ProductWarrantyClaimReviewType', id: string, created: string, notes: string, statusDisplay: string, status: ProductsProductWarrantyClaimReviewStatusChoices, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } } } };

export type GetProductWarrantyClaimsQueryVariables = Exact<{
  options?: InputMaybe<ProductWarrantyClaimListOptionsInputType>;
}>;


export type GetProductWarrantyClaimsQuery = { __typename?: 'Query', productWarrantyClaims: { __typename?: 'ProductWarrantyClaimListType', count: number, items: Array<{ __typename?: 'ProductWarrantyClaimType', id: string, deliveryDate: string, failureDate: string, serialNumber: string, created: string, quantity: number, description: string, finalClient: string, phone: string, externalId?: string, seederKilometers: number, displayId: number, product?: { __typename?: 'WarrantyProductType', id: string, externalId: string, name: string, displayName: string, price: number, order: number, description: string, rowCount: number, originalProduct?: { __typename?: 'ProductType', id: string, image?: string }, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } } }, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, seeder?: { __typename?: 'SeederType', id: string, displayName: string, rowCount: number }, lastReview?: { __typename?: 'ProductWarrantyClaimReviewType', id: string, created: string, notes: string, statusDisplay: string, status: ProductsProductWarrantyClaimReviewStatusChoices, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, inspectionReview?: { __typename?: 'WarrantyClaimInspectionReviewType', statusDisplay: string, status: ProductsWarrantyClaimInspectionReviewStatusChoices, inWarranty: boolean } }> } };

export type GetWarrantyClaimsIdsQueryVariables = Exact<{
  options?: InputMaybe<ProductWarrantyClaimListOptionsInputType>;
}>;


export type GetWarrantyClaimsIdsQuery = { __typename?: 'Query', productWarrantyClaims: { __typename?: 'ProductWarrantyClaimListType', items: Array<{ __typename?: 'ProductWarrantyClaimType', id: string, displayId: number }> } };

export type GetOrderOemQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type GetOrderOemQuery = { __typename?: 'Query', orderOem: { __typename?: 'OrderOEMType', id: string, created: string, status?: OemsOrderOemStatusChoices, displayId: number, statusDisplay: string, reviewStart?: string, targetDate?: string, notes?: string, orderNumber?: string, reviews: Array<{ __typename?: 'OrderOEMReviewType', id: string, status: OemsOrderOemReviewStatusChoices, statusDisplay: string, notes: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, productsWithoutShipment: Array<{ __typename?: 'OrderedOEMProductType', name: string, externalId: string, productOemId?: string, description: string, price: number, rowCount: number, order: number, id: string, quantity: number, quantityLeft: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, organization?: { __typename?: 'OEMOrganizationType', id: string, name: string, externalId: string, originalOrganization?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } }, paymentMethod?: { __typename?: 'OrderOEMPaymentMethodType', id: string, name: string, multiplier: number, slug: string, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string, name: string, order: number, multiplier: number, slug: string, paymentmethodcategorySet: Array<{ __typename?: 'PaymentMethodCategoryType', finnancied: boolean }> } }, products: Array<{ __typename?: 'OrderedOEMProductType', name: string, externalId: string, productOemId?: string, description: string, price: number, rowCount: number, order: number, id: string, quantity: number, quantityLeft: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string } }>, shipments: Array<{ __typename?: 'ShipmentOEMType', id: string, externalId: string, invoice?: string, created: string, status?: OemsShipmentOemStatusChoices, statusDisplay: string, orderOem: { __typename?: 'OrderOEMType', id: string }, productsShipped: Array<{ __typename?: 'ShipmentOEMProductType', id: string, quantity: number, batch?: string, orderOem: { __typename?: 'OrderOEMType', id: string }, shipment: { __typename?: 'ShipmentOEMType', id: string }, orderedProduct: { __typename?: 'OrderedOEMProductType', name: string, externalId: string, productOemId?: string, description: string, price: number, rowCount: number, order: number, id: string, quantity: number, quantityLeft: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string } } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }> } };

export type GetOrderOemBankInvoiceQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type GetOrderOemBankInvoiceQuery = { __typename?: 'Query', orderOem: { __typename?: 'OrderOEMType', id: string, created: string, status?: OemsOrderOemStatusChoices, displayId: number, statusDisplay: string, reviewStart?: string, targetDate?: string, notes?: string, orderNumber?: string, organization?: { __typename?: 'OEMOrganizationType', taxId: string, id: string, name: string, externalId: string, originalOrganization?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string, path?: string }, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } }, reviews: Array<{ __typename?: 'OrderOEMReviewType', id: string, status: OemsOrderOemReviewStatusChoices, statusDisplay: string, notes: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, productsWithoutShipment: Array<{ __typename?: 'OrderedOEMProductType', name: string, externalId: string, productOemId?: string, description: string, price: number, rowCount: number, order: number, id: string, quantity: number, quantityLeft: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, paymentMethod?: { __typename?: 'OrderOEMPaymentMethodType', id: string, name: string, multiplier: number, slug: string, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string, name: string, order: number, multiplier: number, slug: string, paymentmethodcategorySet: Array<{ __typename?: 'PaymentMethodCategoryType', finnancied: boolean }> } }, products: Array<{ __typename?: 'OrderedOEMProductType', name: string, externalId: string, productOemId?: string, description: string, price: number, rowCount: number, order: number, id: string, quantity: number, quantityLeft: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string } }>, shipments: Array<{ __typename?: 'ShipmentOEMType', id: string, externalId: string, invoice?: string, created: string, status?: OemsShipmentOemStatusChoices, statusDisplay: string, orderOem: { __typename?: 'OrderOEMType', id: string }, productsShipped: Array<{ __typename?: 'ShipmentOEMProductType', id: string, quantity: number, batch?: string, orderOem: { __typename?: 'OrderOEMType', id: string }, shipment: { __typename?: 'ShipmentOEMType', id: string }, orderedProduct: { __typename?: 'OrderedOEMProductType', name: string, externalId: string, productOemId?: string, description: string, price: number, rowCount: number, order: number, id: string, quantity: number, quantityLeft: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string } } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }> } };

export type OemOrderBankInvoicePdfExportMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type OemOrderBankInvoicePdfExportMutation = { __typename?: 'Mutation', oemOrderBankInvoicePdfExport?: { __typename?: 'OemOrderBankInvoicePdfExport', job: { __typename?: 'ExportJobType', id: string, status: JobStatus, result?: { __typename?: 'DownloadType', contentType: string, data: any, filename: string } } } };

export type CreateOemOrderPdfMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type CreateOemOrderPdfMutation = { __typename?: 'Mutation', createOemOrderPdf?: { __typename?: 'CreateOemOrderPDF', job?: { __typename?: 'ExportJobType', id: string, status: JobStatus, result?: { __typename?: 'DownloadType', contentType: string, data: any, filename: string } } } };

export type GetOrdersOemQueryVariables = Exact<{
  options?: InputMaybe<OrderOemListOptionsInputType>;
}>;


export type GetOrdersOemQuery = { __typename?: 'Query', ordersOem: { __typename?: 'OrderOEMListType', count: number, items: Array<{ __typename?: 'OrderOEMType', id: string, created: string, status?: OemsOrderOemStatusChoices, displayId: number, statusDisplay: string, reviewStart?: string, targetDate?: string, notes?: string, orderNumber?: string, reviews: Array<{ __typename?: 'OrderOEMReviewType', id: string, status: OemsOrderOemReviewStatusChoices, statusDisplay: string, notes: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, productsWithoutShipment: Array<{ __typename?: 'OrderedOEMProductType', name: string, externalId: string, productOemId?: string, description: string, price: number, rowCount: number, order: number, id: string, quantity: number, quantityLeft: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, organization?: { __typename?: 'OEMOrganizationType', id: string, name: string, externalId: string, originalOrganization?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } }, paymentMethod?: { __typename?: 'OrderOEMPaymentMethodType', id: string, name: string, multiplier: number, slug: string, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string, name: string, order: number, multiplier: number, slug: string, paymentmethodcategorySet: Array<{ __typename?: 'PaymentMethodCategoryType', finnancied: boolean }> } }, products: Array<{ __typename?: 'OrderedOEMProductType', name: string, externalId: string, productOemId?: string, description: string, price: number, rowCount: number, order: number, id: string, quantity: number, quantityLeft: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string } }>, shipments: Array<{ __typename?: 'ShipmentOEMType', id: string, externalId: string, invoice?: string, created: string, status?: OemsShipmentOemStatusChoices, statusDisplay: string, orderOem: { __typename?: 'OrderOEMType', id: string }, productsShipped: Array<{ __typename?: 'ShipmentOEMProductType', id: string, quantity: number, batch?: string, orderOem: { __typename?: 'OrderOEMType', id: string }, shipment: { __typename?: 'ShipmentOEMType', id: string }, orderedProduct: { __typename?: 'OrderedOEMProductType', name: string, externalId: string, productOemId?: string, description: string, price: number, rowCount: number, order: number, id: string, quantity: number, quantityLeft: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string } } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }> }> } };

export type GetPaymentMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPaymentMethodsQuery = { __typename?: 'Query', paymentMethods: Array<{ __typename?: 'PaymentMethodType', id: string, name: string, order: number, multiplier: number, slug: string, paymentmethodcategorySet: Array<{ __typename?: 'PaymentMethodCategoryType', finnancied: boolean }> }> };

export type GetPaymentMethodQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type GetPaymentMethodQuery = { __typename?: 'Query', paymentMethod: { __typename?: 'PaymentMethodType', id: string, name: string, order: number, multiplier: number, slug: string, paymentmethodcategorySet: Array<{ __typename?: 'PaymentMethodCategoryType', finnancied: boolean }> } };

export type GetPaymentMethodOptionsQueryVariables = Exact<{
  categoryId?: InputMaybe<Scalars['UUID']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
}>;


export type GetPaymentMethodOptionsQuery = { __typename?: 'Query', paymentMethods: Array<{ __typename?: 'PaymentMethodType', id: string, name: string }> };

export type GetPaymentMethodCategoryQueryVariables = Exact<{
  categoryId?: InputMaybe<Scalars['UUID']>;
}>;


export type GetPaymentMethodCategoryQuery = { __typename?: 'Query', paymentMethodCategories: Array<{ __typename?: 'PaymentMethodCategoryType', id: string, name: string, finnancied: boolean, paymentMethods: Array<{ __typename?: 'PaymentMethodType', id: string, name: string }> }> };

export type GetPaymentMethodCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPaymentMethodCategoriesQuery = { __typename?: 'Query', paymentMethodCategories: Array<{ __typename?: 'PaymentMethodCategoryType', id: string, name: string, finnancied: boolean }> };

export type GetQuoteRulesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQuoteRulesQuery = { __typename?: 'Query', quoteRules: Array<{ __typename?: 'QuoteRuleType', id: string, valueSource: QuotesQuoteRuleValueSourceChoices, image?: string, referenceSource: QuotesQuoteRuleReferenceSourceChoices, referenceMultiplier: number, operator: QuotesQuoteRuleOperatorChoices, description?: string, errorMessage?: string, useForValidation: boolean, useForInitialValue: boolean, prioritizeRule: boolean, product?: { __typename?: 'ProductType', id: string, externalId: string }, productCategory?: { __typename?: 'ProductCategoryType', id: string, name: string }, group?: { __typename?: 'RuleGroupType', id: string, name: string } }> };

export type GetQuotesQueryVariables = Exact<{
  options?: InputMaybe<QuoteListOptionsInputType>;
}>;


export type GetQuotesQuery = { __typename?: 'Query', quotes: { __typename?: 'QuoteListType', count: number, items: Array<{ __typename?: 'QuoteType', rowCount?: number, created: string, id: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string, seeder?: { __typename?: 'SeederType', displayName: string }, contact: { __typename?: 'ContactType', email?: string, account: { __typename?: 'AccountType', name: string, owner?: { __typename?: 'OrganizationType', name: string } } }, products: Array<{ __typename?: 'QuotedProductType', id: string, order: number, externalId: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: number }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteType', id: string } } }> } };

export type GetOemOrdersQueryVariables = Exact<{
  options?: InputMaybe<QuoteListOptionsInputType>;
}>;


export type GetOemOrdersQuery = { __typename?: 'Query', oemOrders: { __typename?: 'QuoteListType', count: number, items: Array<{ __typename?: 'QuoteType', additionalChargesValue?: number, additionalChargesDescription?: string, billingType: QuotesQuoteBillingTypeChoices, displayBillingType: string, rowCount?: number, notes?: string, oemOrder?: boolean, created: string, id: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: number }, seeder?: { __typename?: 'SeederType', id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } }, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> }>, pdfs: Array<{ __typename?: 'QuotePDFType', id: string, file?: string, type: QuotesQuotePdfTypeChoices, recipient: string, typeDisplay?: string, emailStatus?: string, created: string, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, sale?: { __typename?: 'SaleType', id: string, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteType', id: string } } }> } };

export type GetQuoteQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type GetQuoteQuery = { __typename?: 'Query', quote: { __typename?: 'QuoteType', billingType: QuotesQuoteBillingTypeChoices, created: string, updated: string, additionalChargesValue?: number, additionalChargesDescription?: string, displayBillingType: string, rowCount?: number, notes?: string, oemOrder?: boolean, id: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, sale?: { __typename?: 'SaleType', id: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, quote: { __typename?: 'QuoteType', additionalChargesValue?: number, additionalChargesDescription?: string, billingType: QuotesQuoteBillingTypeChoices, displayBillingType: string, rowCount?: number, notes?: string, oemOrder?: boolean, created: string, id: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: number }, seeder?: { __typename?: 'SeederType', id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } }, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> }>, pdfs: Array<{ __typename?: 'QuotePDFType', id: string, file?: string, type: QuotesQuotePdfTypeChoices, recipient: string, typeDisplay?: string, emailStatus?: string, created: string, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, sale?: { __typename?: 'SaleType', id: string, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteType', id: string } } }, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, supplyOrder?: { __typename?: 'SupplyOrderType', id: string, displayId: number, targetDate?: string, salesCanReview: boolean, status: SupplyOrdersSupplyOrderStatusChoices, statusDisplay: string, created: string, billingType?: SupplyOrdersSupplyOrderBillingTypeChoices, quote: { __typename?: 'QuoteType', additionalChargesValue?: number, additionalChargesDescription?: string, billingType: QuotesQuoteBillingTypeChoices, displayBillingType: string, rowCount?: number, notes?: string, oemOrder?: boolean, created: string, id: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: number }, seeder?: { __typename?: 'SeederType', id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } }, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> }>, pdfs: Array<{ __typename?: 'QuotePDFType', id: string, file?: string, type: QuotesQuotePdfTypeChoices, recipient: string, typeDisplay?: string, emailStatus?: string, created: string, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, sale?: { __typename?: 'SaleType', id: string, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteType', id: string } } }, orderedProducts: Array<{ __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } }>, productsWithoutShipment: Array<{ __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } }>, shipments: Array<{ __typename?: 'ShipmentType', id: string, externalId: string, exchangeRate: number, invoice?: string, created: string, status?: SupplyOrdersShipmentStatusChoices, statusDisplay: string, onHoldDescription?: string, supplyOrder: { __typename?: 'SupplyOrderType', id: string, displayName: string }, productsShipped: Array<{ __typename?: 'ShipmentProductType', id: string, quantity: number, batch?: string, supplyOrder: { __typename?: 'SupplyOrderType', id: string }, shipment: { __typename?: 'ShipmentType', id: string }, orderedProduct: { __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, originalQuote?: { __typename?: 'QuoteType', id: string, displayId: number }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, updatedBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: number }, seeder?: { __typename?: 'SeederType', id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } }, pdfs: Array<{ __typename?: 'QuotePDFType', id: string, file?: string, type: QuotesQuotePdfTypeChoices, recipient: string, typeDisplay?: string, emailStatus?: string, created: string, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteType', id: string } } } };

export type GetQuotedPaymentMethodQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type GetQuotedPaymentMethodQuery = { __typename?: 'Query', quotedPaymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } };

export type CreateQuoteMutationVariables = Exact<{
  input: CreateQuoteMutationInput;
}>;


export type CreateQuoteMutation = { __typename?: 'Mutation', createQuote?: { __typename?: 'CreateQuoteMutationPayload', quote?: { __typename?: 'QuoteType', billingType: QuotesQuoteBillingTypeChoices, created: string, updated: string, additionalChargesValue?: number, additionalChargesDescription?: string, displayBillingType: string, rowCount?: number, notes?: string, oemOrder?: boolean, id: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, sale?: { __typename?: 'SaleType', id: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, quote: { __typename?: 'QuoteType', additionalChargesValue?: number, additionalChargesDescription?: string, billingType: QuotesQuoteBillingTypeChoices, displayBillingType: string, rowCount?: number, notes?: string, oemOrder?: boolean, created: string, id: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: number }, seeder?: { __typename?: 'SeederType', id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } }, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> }>, pdfs: Array<{ __typename?: 'QuotePDFType', id: string, file?: string, type: QuotesQuotePdfTypeChoices, recipient: string, typeDisplay?: string, emailStatus?: string, created: string, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, sale?: { __typename?: 'SaleType', id: string, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteType', id: string } } }, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, supplyOrder?: { __typename?: 'SupplyOrderType', id: string, displayId: number, targetDate?: string, salesCanReview: boolean, status: SupplyOrdersSupplyOrderStatusChoices, statusDisplay: string, created: string, billingType?: SupplyOrdersSupplyOrderBillingTypeChoices, quote: { __typename?: 'QuoteType', additionalChargesValue?: number, additionalChargesDescription?: string, billingType: QuotesQuoteBillingTypeChoices, displayBillingType: string, rowCount?: number, notes?: string, oemOrder?: boolean, created: string, id: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: number }, seeder?: { __typename?: 'SeederType', id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } }, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> }>, pdfs: Array<{ __typename?: 'QuotePDFType', id: string, file?: string, type: QuotesQuotePdfTypeChoices, recipient: string, typeDisplay?: string, emailStatus?: string, created: string, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, sale?: { __typename?: 'SaleType', id: string, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteType', id: string } } }, orderedProducts: Array<{ __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } }>, productsWithoutShipment: Array<{ __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } }>, shipments: Array<{ __typename?: 'ShipmentType', id: string, externalId: string, exchangeRate: number, invoice?: string, created: string, status?: SupplyOrdersShipmentStatusChoices, statusDisplay: string, onHoldDescription?: string, supplyOrder: { __typename?: 'SupplyOrderType', id: string, displayName: string }, productsShipped: Array<{ __typename?: 'ShipmentProductType', id: string, quantity: number, batch?: string, supplyOrder: { __typename?: 'SupplyOrderType', id: string }, shipment: { __typename?: 'ShipmentType', id: string }, orderedProduct: { __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, originalQuote?: { __typename?: 'QuoteType', id: string, displayId: number }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, updatedBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: number }, seeder?: { __typename?: 'SeederType', id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } }, pdfs: Array<{ __typename?: 'QuotePDFType', id: string, file?: string, type: QuotesQuotePdfTypeChoices, recipient: string, typeDisplay?: string, emailStatus?: string, created: string, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteType', id: string } } }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type UpdateQuoteMutationVariables = Exact<{
  input: UpdateQuoteMutationInput;
}>;


export type UpdateQuoteMutation = { __typename?: 'Mutation', updateQuote?: { __typename?: 'UpdateQuoteMutationPayload', quote?: { __typename?: 'QuoteType', billingType: QuotesQuoteBillingTypeChoices, created: string, updated: string, additionalChargesValue?: number, additionalChargesDescription?: string, displayBillingType: string, rowCount?: number, notes?: string, oemOrder?: boolean, id: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, sale?: { __typename?: 'SaleType', id: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, quote: { __typename?: 'QuoteType', additionalChargesValue?: number, additionalChargesDescription?: string, billingType: QuotesQuoteBillingTypeChoices, displayBillingType: string, rowCount?: number, notes?: string, oemOrder?: boolean, created: string, id: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: number }, seeder?: { __typename?: 'SeederType', id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } }, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> }>, pdfs: Array<{ __typename?: 'QuotePDFType', id: string, file?: string, type: QuotesQuotePdfTypeChoices, recipient: string, typeDisplay?: string, emailStatus?: string, created: string, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, sale?: { __typename?: 'SaleType', id: string, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteType', id: string } } }, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, supplyOrder?: { __typename?: 'SupplyOrderType', id: string, displayId: number, targetDate?: string, salesCanReview: boolean, status: SupplyOrdersSupplyOrderStatusChoices, statusDisplay: string, created: string, billingType?: SupplyOrdersSupplyOrderBillingTypeChoices, quote: { __typename?: 'QuoteType', additionalChargesValue?: number, additionalChargesDescription?: string, billingType: QuotesQuoteBillingTypeChoices, displayBillingType: string, rowCount?: number, notes?: string, oemOrder?: boolean, created: string, id: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: number }, seeder?: { __typename?: 'SeederType', id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } }, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> }>, pdfs: Array<{ __typename?: 'QuotePDFType', id: string, file?: string, type: QuotesQuotePdfTypeChoices, recipient: string, typeDisplay?: string, emailStatus?: string, created: string, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, sale?: { __typename?: 'SaleType', id: string, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteType', id: string } } }, orderedProducts: Array<{ __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } }>, productsWithoutShipment: Array<{ __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } }>, shipments: Array<{ __typename?: 'ShipmentType', id: string, externalId: string, exchangeRate: number, invoice?: string, created: string, status?: SupplyOrdersShipmentStatusChoices, statusDisplay: string, onHoldDescription?: string, supplyOrder: { __typename?: 'SupplyOrderType', id: string, displayName: string }, productsShipped: Array<{ __typename?: 'ShipmentProductType', id: string, quantity: number, batch?: string, supplyOrder: { __typename?: 'SupplyOrderType', id: string }, shipment: { __typename?: 'ShipmentType', id: string }, orderedProduct: { __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, originalQuote?: { __typename?: 'QuoteType', id: string, displayId: number }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, updatedBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: number }, seeder?: { __typename?: 'SeederType', id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } }, pdfs: Array<{ __typename?: 'QuotePDFType', id: string, file?: string, type: QuotesQuotePdfTypeChoices, recipient: string, typeDisplay?: string, emailStatus?: string, created: string, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteType', id: string } } }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type UpdateQuotePricesMutationVariables = Exact<{
  input: UpdateQuotePricesMutationInput;
}>;


export type UpdateQuotePricesMutation = { __typename?: 'Mutation', updateQuotePrices?: { __typename?: 'UpdateQuotePricesMutationPayload', quote?: { __typename?: 'QuoteType', billingType: QuotesQuoteBillingTypeChoices, created: string, updated: string, additionalChargesValue?: number, additionalChargesDescription?: string, displayBillingType: string, rowCount?: number, notes?: string, oemOrder?: boolean, id: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, sale?: { __typename?: 'SaleType', id: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, quote: { __typename?: 'QuoteType', additionalChargesValue?: number, additionalChargesDescription?: string, billingType: QuotesQuoteBillingTypeChoices, displayBillingType: string, rowCount?: number, notes?: string, oemOrder?: boolean, created: string, id: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: number }, seeder?: { __typename?: 'SeederType', id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } }, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> }>, pdfs: Array<{ __typename?: 'QuotePDFType', id: string, file?: string, type: QuotesQuotePdfTypeChoices, recipient: string, typeDisplay?: string, emailStatus?: string, created: string, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, sale?: { __typename?: 'SaleType', id: string, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteType', id: string } } }, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, supplyOrder?: { __typename?: 'SupplyOrderType', id: string, displayId: number, targetDate?: string, salesCanReview: boolean, status: SupplyOrdersSupplyOrderStatusChoices, statusDisplay: string, created: string, billingType?: SupplyOrdersSupplyOrderBillingTypeChoices, quote: { __typename?: 'QuoteType', additionalChargesValue?: number, additionalChargesDescription?: string, billingType: QuotesQuoteBillingTypeChoices, displayBillingType: string, rowCount?: number, notes?: string, oemOrder?: boolean, created: string, id: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: number }, seeder?: { __typename?: 'SeederType', id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } }, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> }>, pdfs: Array<{ __typename?: 'QuotePDFType', id: string, file?: string, type: QuotesQuotePdfTypeChoices, recipient: string, typeDisplay?: string, emailStatus?: string, created: string, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, sale?: { __typename?: 'SaleType', id: string, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteType', id: string } } }, orderedProducts: Array<{ __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } }>, productsWithoutShipment: Array<{ __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } }>, shipments: Array<{ __typename?: 'ShipmentType', id: string, externalId: string, exchangeRate: number, invoice?: string, created: string, status?: SupplyOrdersShipmentStatusChoices, statusDisplay: string, onHoldDescription?: string, supplyOrder: { __typename?: 'SupplyOrderType', id: string, displayName: string }, productsShipped: Array<{ __typename?: 'ShipmentProductType', id: string, quantity: number, batch?: string, supplyOrder: { __typename?: 'SupplyOrderType', id: string }, shipment: { __typename?: 'ShipmentType', id: string }, orderedProduct: { __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, originalQuote?: { __typename?: 'QuoteType', id: string, displayId: number }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, updatedBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: number }, seeder?: { __typename?: 'SeederType', id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } }, pdfs: Array<{ __typename?: 'QuotePDFType', id: string, file?: string, type: QuotesQuotePdfTypeChoices, recipient: string, typeDisplay?: string, emailStatus?: string, created: string, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteType', id: string } } }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type DeleteQuoteMutationVariables = Exact<{
  input: DeleteQuoteMutationInput;
}>;


export type DeleteQuoteMutation = { __typename?: 'Mutation', deleteQuote?: { __typename?: 'DeleteQuoteMutationPayload', errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type CreateQuotePdfMutationVariables = Exact<{
  type?: InputMaybe<Scalars['String']>;
  recipient?: InputMaybe<Scalars['String']>;
  quoteId: Scalars['UUID'];
  productDisplay?: InputMaybe<Scalars['String']>;
  paymentMethodId?: InputMaybe<Scalars['String']>;
}>;


export type CreateQuotePdfMutation = { __typename?: 'Mutation', createQuotePdf?: { __typename?: 'CreateQuotePdf', job?: { __typename?: 'ExportJobType', id: string }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type CreateSupplyOrderPdfMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type CreateSupplyOrderPdfMutation = { __typename?: 'Mutation', createSupplyOrderPDF?: { __typename?: 'CreateSupplyOrderPDF', job?: { __typename?: 'ExportJobType', id: string }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type CreateBankInvoicePdfMutationVariables = Exact<{
  quoteId: Scalars['UUID'];
  paymentMethodId: Scalars['UUID'];
}>;


export type CreateBankInvoicePdfMutation = { __typename?: 'Mutation', createBankInvoicePdf?: { __typename?: 'CreateBankInvoicePdf', job?: { __typename?: 'ExportJobType', id: string }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type CreateOrderOemMutationVariables = Exact<{
  input: CreateOrderOemMutationInput;
}>;


export type CreateOrderOemMutation = { __typename?: 'Mutation', createOrderOem?: { __typename?: 'CreateOrderOEMMutationPayload', orderOEM?: { __typename?: 'OrderOEMType', id: string, created: string, status?: OemsOrderOemStatusChoices, displayId: number, statusDisplay: string, reviewStart?: string, targetDate?: string, notes?: string, orderNumber?: string, reviews: Array<{ __typename?: 'OrderOEMReviewType', id: string, status: OemsOrderOemReviewStatusChoices, statusDisplay: string, notes: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, productsWithoutShipment: Array<{ __typename?: 'OrderedOEMProductType', name: string, externalId: string, productOemId?: string, description: string, price: number, rowCount: number, order: number, id: string, quantity: number, quantityLeft: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, organization?: { __typename?: 'OEMOrganizationType', id: string, name: string, externalId: string, originalOrganization?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } }, paymentMethod?: { __typename?: 'OrderOEMPaymentMethodType', id: string, name: string, multiplier: number, slug: string, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string, name: string, order: number, multiplier: number, slug: string, paymentmethodcategorySet: Array<{ __typename?: 'PaymentMethodCategoryType', finnancied: boolean }> } }, products: Array<{ __typename?: 'OrderedOEMProductType', name: string, externalId: string, productOemId?: string, description: string, price: number, rowCount: number, order: number, id: string, quantity: number, quantityLeft: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string } }>, shipments: Array<{ __typename?: 'ShipmentOEMType', id: string, externalId: string, invoice?: string, created: string, status?: OemsShipmentOemStatusChoices, statusDisplay: string, orderOem: { __typename?: 'OrderOEMType', id: string }, productsShipped: Array<{ __typename?: 'ShipmentOEMProductType', id: string, quantity: number, batch?: string, orderOem: { __typename?: 'OrderOEMType', id: string }, shipment: { __typename?: 'ShipmentOEMType', id: string }, orderedProduct: { __typename?: 'OrderedOEMProductType', name: string, externalId: string, productOemId?: string, description: string, price: number, rowCount: number, order: number, id: string, quantity: number, quantityLeft: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string } } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }> }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type UpdateOrderOemMutationVariables = Exact<{
  input: UpdateOrderOemMutationInput;
}>;


export type UpdateOrderOemMutation = { __typename?: 'Mutation', updateOrderOem?: { __typename?: 'UpdateOrderOEMMutationPayload', orderOEM?: { __typename?: 'OrderOEMType', id: string, created: string, status?: OemsOrderOemStatusChoices, displayId: number, statusDisplay: string, reviewStart?: string, targetDate?: string, notes?: string, orderNumber?: string, reviews: Array<{ __typename?: 'OrderOEMReviewType', id: string, status: OemsOrderOemReviewStatusChoices, statusDisplay: string, notes: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, productsWithoutShipment: Array<{ __typename?: 'OrderedOEMProductType', name: string, externalId: string, productOemId?: string, description: string, price: number, rowCount: number, order: number, id: string, quantity: number, quantityLeft: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, organization?: { __typename?: 'OEMOrganizationType', id: string, name: string, externalId: string, originalOrganization?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } }, paymentMethod?: { __typename?: 'OrderOEMPaymentMethodType', id: string, name: string, multiplier: number, slug: string, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string, name: string, order: number, multiplier: number, slug: string, paymentmethodcategorySet: Array<{ __typename?: 'PaymentMethodCategoryType', finnancied: boolean }> } }, products: Array<{ __typename?: 'OrderedOEMProductType', name: string, externalId: string, productOemId?: string, description: string, price: number, rowCount: number, order: number, id: string, quantity: number, quantityLeft: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string } }>, shipments: Array<{ __typename?: 'ShipmentOEMType', id: string, externalId: string, invoice?: string, created: string, status?: OemsShipmentOemStatusChoices, statusDisplay: string, orderOem: { __typename?: 'OrderOEMType', id: string }, productsShipped: Array<{ __typename?: 'ShipmentOEMProductType', id: string, quantity: number, batch?: string, orderOem: { __typename?: 'OrderOEMType', id: string }, shipment: { __typename?: 'ShipmentOEMType', id: string }, orderedProduct: { __typename?: 'OrderedOEMProductType', name: string, externalId: string, productOemId?: string, description: string, price: number, rowCount: number, order: number, id: string, quantity: number, quantityLeft: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string } } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }> }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type DeleteOrderOemMutationVariables = Exact<{
  input: DeleteOrderOemMutationInput;
}>;


export type DeleteOrderOemMutation = { __typename?: 'Mutation', deleteOrderOem?: { __typename?: 'DeleteOrderOEMMutationPayload', errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type StartOemOrderReviewMutationVariables = Exact<{
  input: StartOemOrderReviewMutationInput;
}>;


export type StartOemOrderReviewMutation = { __typename?: 'Mutation', startOemOrderReview?: { __typename?: 'StartOemOrderReviewMutationPayload', orderOEM?: { __typename?: 'OrderOEMType', id: string, created: string, status?: OemsOrderOemStatusChoices, displayId: number, statusDisplay: string, reviewStart?: string, targetDate?: string, notes?: string, orderNumber?: string, reviews: Array<{ __typename?: 'OrderOEMReviewType', id: string, status: OemsOrderOemReviewStatusChoices, statusDisplay: string, notes: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, productsWithoutShipment: Array<{ __typename?: 'OrderedOEMProductType', name: string, externalId: string, productOemId?: string, description: string, price: number, rowCount: number, order: number, id: string, quantity: number, quantityLeft: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, organization?: { __typename?: 'OEMOrganizationType', id: string, name: string, externalId: string, originalOrganization?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } }, paymentMethod?: { __typename?: 'OrderOEMPaymentMethodType', id: string, name: string, multiplier: number, slug: string, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string, name: string, order: number, multiplier: number, slug: string, paymentmethodcategorySet: Array<{ __typename?: 'PaymentMethodCategoryType', finnancied: boolean }> } }, products: Array<{ __typename?: 'OrderedOEMProductType', name: string, externalId: string, productOemId?: string, description: string, price: number, rowCount: number, order: number, id: string, quantity: number, quantityLeft: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string } }>, shipments: Array<{ __typename?: 'ShipmentOEMType', id: string, externalId: string, invoice?: string, created: string, status?: OemsShipmentOemStatusChoices, statusDisplay: string, orderOem: { __typename?: 'OrderOEMType', id: string }, productsShipped: Array<{ __typename?: 'ShipmentOEMProductType', id: string, quantity: number, batch?: string, orderOem: { __typename?: 'OrderOEMType', id: string }, shipment: { __typename?: 'ShipmentOEMType', id: string }, orderedProduct: { __typename?: 'OrderedOEMProductType', name: string, externalId: string, productOemId?: string, description: string, price: number, rowCount: number, order: number, id: string, quantity: number, quantityLeft: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string } } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }> }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type ReviewOemOrderMutationVariables = Exact<{
  input: ReviewOemOrderMutationInput;
}>;


export type ReviewOemOrderMutation = { __typename?: 'Mutation', reviewOemOrder?: { __typename?: 'ReviewOemOrderMutationPayload', orderOEMReview?: { __typename?: 'OrderOEMReviewType', id: string, status: OemsOrderOemReviewStatusChoices, statusDisplay: string, notes: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } } } };

export type UpdateOrderOemPricesMutationVariables = Exact<{
  input: UpdateOrderOemPricesMutationInput;
}>;


export type UpdateOrderOemPricesMutation = { __typename?: 'Mutation', updateOrderOemPrices?: { __typename?: 'UpdateOrderOemPricesMutationPayload', orderOEM?: { __typename?: 'OrderOEMType', id: string, created: string, status?: OemsOrderOemStatusChoices, displayId: number, statusDisplay: string, reviewStart?: string, targetDate?: string, notes?: string, orderNumber?: string, reviews: Array<{ __typename?: 'OrderOEMReviewType', id: string, status: OemsOrderOemReviewStatusChoices, statusDisplay: string, notes: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, productsWithoutShipment: Array<{ __typename?: 'OrderedOEMProductType', name: string, externalId: string, productOemId?: string, description: string, price: number, rowCount: number, order: number, id: string, quantity: number, quantityLeft: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, organization?: { __typename?: 'OEMOrganizationType', id: string, name: string, externalId: string, originalOrganization?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } }, paymentMethod?: { __typename?: 'OrderOEMPaymentMethodType', id: string, name: string, multiplier: number, slug: string, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string, name: string, order: number, multiplier: number, slug: string, paymentmethodcategorySet: Array<{ __typename?: 'PaymentMethodCategoryType', finnancied: boolean }> } }, products: Array<{ __typename?: 'OrderedOEMProductType', name: string, externalId: string, productOemId?: string, description: string, price: number, rowCount: number, order: number, id: string, quantity: number, quantityLeft: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string } }>, shipments: Array<{ __typename?: 'ShipmentOEMType', id: string, externalId: string, invoice?: string, created: string, status?: OemsShipmentOemStatusChoices, statusDisplay: string, orderOem: { __typename?: 'OrderOEMType', id: string }, productsShipped: Array<{ __typename?: 'ShipmentOEMProductType', id: string, quantity: number, batch?: string, orderOem: { __typename?: 'OrderOEMType', id: string }, shipment: { __typename?: 'ShipmentOEMType', id: string }, orderedProduct: { __typename?: 'OrderedOEMProductType', name: string, externalId: string, productOemId?: string, description: string, price: number, rowCount: number, order: number, id: string, quantity: number, quantityLeft: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string } } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }> }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type ImportOrderOemMutationVariables = Exact<{
  rows?: InputMaybe<Array<RowInput>>;
  dryRun: Scalars['Boolean'];
}>;


export type ImportOrderOemMutation = { __typename?: 'Mutation', importOrderOem?: { __typename?: 'ImportOrderOem', ok?: boolean, errors?: Array<{ __typename?: 'ImportError', row?: number, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> }> } };

export type GetSalesQueryVariables = Exact<{
  options?: InputMaybe<SaleListOptionsInputType>;
}>;


export type GetSalesQuery = { __typename?: 'Query', sales: { __typename?: 'SaleListType', count: number, items: Array<{ __typename?: 'SaleType', id: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, quote: { __typename?: 'QuoteType', rowCount?: number, created: string, id: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string, seeder?: { __typename?: 'SeederType', displayName: string }, contact: { __typename?: 'ContactType', email?: string, account: { __typename?: 'AccountType', name: string, owner?: { __typename?: 'OrganizationType', name: string } } }, products: Array<{ __typename?: 'QuotedProductType', id: string, order: number, externalId: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: number }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteType', id: string } } }, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }> } };

export type GetSaleQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type GetSaleQuery = { __typename?: 'Query', sale: { __typename?: 'SaleType', id: string, created: string, quote: { __typename?: 'QuoteType', billingType: QuotesQuoteBillingTypeChoices, created: string, updated: string, additionalChargesValue?: number, additionalChargesDescription?: string, displayBillingType: string, rowCount?: number, notes?: string, oemOrder?: boolean, id: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, sale?: { __typename?: 'SaleType', id: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, quote: { __typename?: 'QuoteType', additionalChargesValue?: number, additionalChargesDescription?: string, billingType: QuotesQuoteBillingTypeChoices, displayBillingType: string, rowCount?: number, notes?: string, oemOrder?: boolean, created: string, id: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: number }, seeder?: { __typename?: 'SeederType', id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } }, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> }>, pdfs: Array<{ __typename?: 'QuotePDFType', id: string, file?: string, type: QuotesQuotePdfTypeChoices, recipient: string, typeDisplay?: string, emailStatus?: string, created: string, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, sale?: { __typename?: 'SaleType', id: string, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteType', id: string } } }, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, supplyOrder?: { __typename?: 'SupplyOrderType', id: string, displayId: number, targetDate?: string, salesCanReview: boolean, status: SupplyOrdersSupplyOrderStatusChoices, statusDisplay: string, created: string, billingType?: SupplyOrdersSupplyOrderBillingTypeChoices, quote: { __typename?: 'QuoteType', additionalChargesValue?: number, additionalChargesDescription?: string, billingType: QuotesQuoteBillingTypeChoices, displayBillingType: string, rowCount?: number, notes?: string, oemOrder?: boolean, created: string, id: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: number }, seeder?: { __typename?: 'SeederType', id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } }, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> }>, pdfs: Array<{ __typename?: 'QuotePDFType', id: string, file?: string, type: QuotesQuotePdfTypeChoices, recipient: string, typeDisplay?: string, emailStatus?: string, created: string, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, sale?: { __typename?: 'SaleType', id: string, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteType', id: string } } }, orderedProducts: Array<{ __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } }>, productsWithoutShipment: Array<{ __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } }>, shipments: Array<{ __typename?: 'ShipmentType', id: string, externalId: string, exchangeRate: number, invoice?: string, created: string, status?: SupplyOrdersShipmentStatusChoices, statusDisplay: string, onHoldDescription?: string, supplyOrder: { __typename?: 'SupplyOrderType', id: string, displayName: string }, productsShipped: Array<{ __typename?: 'ShipmentProductType', id: string, quantity: number, batch?: string, supplyOrder: { __typename?: 'SupplyOrderType', id: string }, shipment: { __typename?: 'ShipmentType', id: string }, orderedProduct: { __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, originalQuote?: { __typename?: 'QuoteType', id: string, displayId: number }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, updatedBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: number }, seeder?: { __typename?: 'SeederType', id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } }, pdfs: Array<{ __typename?: 'QuotePDFType', id: string, file?: string, type: QuotesQuotePdfTypeChoices, recipient: string, typeDisplay?: string, emailStatus?: string, created: string, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteType', id: string } } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } } };

export type CreateShipmentMutationVariables = Exact<{
  input: CreateShipmentMutationInput;
}>;


export type CreateShipmentMutation = { __typename?: 'Mutation', createShipment?: { __typename?: 'CreateShipmentMutationPayload', shipment?: { __typename?: 'ShipmentType', id: string, externalId: string, exchangeRate: number, invoice?: string, created: string, status?: SupplyOrdersShipmentStatusChoices, statusDisplay: string, onHoldDescription?: string, supplyOrder: { __typename?: 'SupplyOrderType', id: string, displayName: string }, productsShipped: Array<{ __typename?: 'ShipmentProductType', id: string, quantity: number, batch?: string, supplyOrder: { __typename?: 'SupplyOrderType', id: string }, shipment: { __typename?: 'ShipmentType', id: string }, orderedProduct: { __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type CreateShipmentOemMutationVariables = Exact<{
  input: CreateShipmentOemMutationInput;
}>;


export type CreateShipmentOemMutation = { __typename?: 'Mutation', createShipmentOem?: { __typename?: 'CreateShipmentOEMMutationPayload', shipmentOEM?: { __typename?: 'ShipmentOEMType', id: string, externalId: string, invoice?: string, created: string, status?: OemsShipmentOemStatusChoices, statusDisplay: string, orderOem: { __typename?: 'OrderOEMType', id: string }, productsShipped: Array<{ __typename?: 'ShipmentOEMProductType', id: string, quantity: number, batch?: string, orderOem: { __typename?: 'OrderOEMType', id: string }, shipment: { __typename?: 'ShipmentOEMType', id: string }, orderedProduct: { __typename?: 'OrderedOEMProductType', name: string, externalId: string, productOemId?: string, description: string, price: number, rowCount: number, order: number, id: string, quantity: number, quantityLeft: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string } } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type UpdateShipmentMutationVariables = Exact<{
  input: UpdateShipmentMutationInput;
}>;


export type UpdateShipmentMutation = { __typename?: 'Mutation', updateShipment?: { __typename?: 'UpdateShipmentMutationPayload', shipment?: { __typename?: 'ShipmentType', id: string, externalId: string, exchangeRate: number, invoice?: string, created: string, status?: SupplyOrdersShipmentStatusChoices, statusDisplay: string, onHoldDescription?: string, supplyOrder: { __typename?: 'SupplyOrderType', id: string, displayName: string }, productsShipped: Array<{ __typename?: 'ShipmentProductType', id: string, quantity: number, batch?: string, supplyOrder: { __typename?: 'SupplyOrderType', id: string }, shipment: { __typename?: 'ShipmentType', id: string }, orderedProduct: { __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type UpdateShipmentOemMutationVariables = Exact<{
  input: UpdateShipmentOemMutationInput;
}>;


export type UpdateShipmentOemMutation = { __typename?: 'Mutation', updateShipmentOem?: { __typename?: 'UpdateShipmentOEMMutationPayload', shipmentOEM?: { __typename?: 'ShipmentOEMType', id: string, externalId: string, invoice?: string, created: string, status?: OemsShipmentOemStatusChoices, statusDisplay: string, orderOem: { __typename?: 'OrderOEMType', id: string }, productsShipped: Array<{ __typename?: 'ShipmentOEMProductType', id: string, quantity: number, batch?: string, orderOem: { __typename?: 'OrderOEMType', id: string }, shipment: { __typename?: 'ShipmentOEMType', id: string }, orderedProduct: { __typename?: 'OrderedOEMProductType', name: string, externalId: string, productOemId?: string, description: string, price: number, rowCount: number, order: number, id: string, quantity: number, quantityLeft: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string } } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type DeleteShipmentMutationVariables = Exact<{
  input: DeleteShipmentMutationInput;
}>;


export type DeleteShipmentMutation = { __typename?: 'Mutation', deleteShipment?: { __typename?: 'DeleteShipmentMutationPayload', errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type DeleteShipmentProductMutationVariables = Exact<{
  input: DeleteShipmentProductMutationInput;
}>;


export type DeleteShipmentProductMutation = { __typename?: 'Mutation', deleteShipmentProduct?: { __typename?: 'DeleteShipmentProductMutationPayload', errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type DeleteShipmentOemMutationVariables = Exact<{
  input: DeleteShipmentOemMutationInput;
}>;


export type DeleteShipmentOemMutation = { __typename?: 'Mutation', deleteShipmentOem?: { __typename?: 'DeleteShipmentOEMMutationPayload', errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type CreateSaleMutationVariables = Exact<{
  input: CreateSaleMutationInput;
}>;


export type CreateSaleMutation = { __typename?: 'Mutation', createSale?: { __typename?: 'CreateSaleMutationPayload', sale?: { __typename?: 'SaleType', id: string, created: string, quote: { __typename?: 'QuoteType', billingType: QuotesQuoteBillingTypeChoices, created: string, updated: string, additionalChargesValue?: number, additionalChargesDescription?: string, displayBillingType: string, rowCount?: number, notes?: string, oemOrder?: boolean, id: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, sale?: { __typename?: 'SaleType', id: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, quote: { __typename?: 'QuoteType', additionalChargesValue?: number, additionalChargesDescription?: string, billingType: QuotesQuoteBillingTypeChoices, displayBillingType: string, rowCount?: number, notes?: string, oemOrder?: boolean, created: string, id: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: number }, seeder?: { __typename?: 'SeederType', id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } }, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> }>, pdfs: Array<{ __typename?: 'QuotePDFType', id: string, file?: string, type: QuotesQuotePdfTypeChoices, recipient: string, typeDisplay?: string, emailStatus?: string, created: string, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, sale?: { __typename?: 'SaleType', id: string, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteType', id: string } } }, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, supplyOrder?: { __typename?: 'SupplyOrderType', id: string, displayId: number, targetDate?: string, salesCanReview: boolean, status: SupplyOrdersSupplyOrderStatusChoices, statusDisplay: string, created: string, billingType?: SupplyOrdersSupplyOrderBillingTypeChoices, quote: { __typename?: 'QuoteType', additionalChargesValue?: number, additionalChargesDescription?: string, billingType: QuotesQuoteBillingTypeChoices, displayBillingType: string, rowCount?: number, notes?: string, oemOrder?: boolean, created: string, id: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: number }, seeder?: { __typename?: 'SeederType', id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } }, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> }>, pdfs: Array<{ __typename?: 'QuotePDFType', id: string, file?: string, type: QuotesQuotePdfTypeChoices, recipient: string, typeDisplay?: string, emailStatus?: string, created: string, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, sale?: { __typename?: 'SaleType', id: string, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteType', id: string } } }, orderedProducts: Array<{ __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } }>, productsWithoutShipment: Array<{ __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } }>, shipments: Array<{ __typename?: 'ShipmentType', id: string, externalId: string, exchangeRate: number, invoice?: string, created: string, status?: SupplyOrdersShipmentStatusChoices, statusDisplay: string, onHoldDescription?: string, supplyOrder: { __typename?: 'SupplyOrderType', id: string, displayName: string }, productsShipped: Array<{ __typename?: 'ShipmentProductType', id: string, quantity: number, batch?: string, supplyOrder: { __typename?: 'SupplyOrderType', id: string }, shipment: { __typename?: 'ShipmentType', id: string }, orderedProduct: { __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, originalQuote?: { __typename?: 'QuoteType', id: string, displayId: number }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, updatedBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: number }, seeder?: { __typename?: 'SeederType', id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } }, pdfs: Array<{ __typename?: 'QuotePDFType', id: string, file?: string, type: QuotesQuotePdfTypeChoices, recipient: string, typeDisplay?: string, emailStatus?: string, created: string, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteType', id: string } } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type UpdateSaleMutationVariables = Exact<{
  input: UpdateSaleMutationInput;
}>;


export type UpdateSaleMutation = { __typename?: 'Mutation', updateSale?: { __typename?: 'UpdateSaleMutationPayload', sale?: { __typename?: 'SaleType', id: string, created: string, quote: { __typename?: 'QuoteType', billingType: QuotesQuoteBillingTypeChoices, created: string, updated: string, additionalChargesValue?: number, additionalChargesDescription?: string, displayBillingType: string, rowCount?: number, notes?: string, oemOrder?: boolean, id: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, sale?: { __typename?: 'SaleType', id: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, quote: { __typename?: 'QuoteType', additionalChargesValue?: number, additionalChargesDescription?: string, billingType: QuotesQuoteBillingTypeChoices, displayBillingType: string, rowCount?: number, notes?: string, oemOrder?: boolean, created: string, id: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: number }, seeder?: { __typename?: 'SeederType', id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } }, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> }>, pdfs: Array<{ __typename?: 'QuotePDFType', id: string, file?: string, type: QuotesQuotePdfTypeChoices, recipient: string, typeDisplay?: string, emailStatus?: string, created: string, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, sale?: { __typename?: 'SaleType', id: string, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteType', id: string } } }, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, supplyOrder?: { __typename?: 'SupplyOrderType', id: string, displayId: number, targetDate?: string, salesCanReview: boolean, status: SupplyOrdersSupplyOrderStatusChoices, statusDisplay: string, created: string, billingType?: SupplyOrdersSupplyOrderBillingTypeChoices, quote: { __typename?: 'QuoteType', additionalChargesValue?: number, additionalChargesDescription?: string, billingType: QuotesQuoteBillingTypeChoices, displayBillingType: string, rowCount?: number, notes?: string, oemOrder?: boolean, created: string, id: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: number }, seeder?: { __typename?: 'SeederType', id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } }, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> }>, pdfs: Array<{ __typename?: 'QuotePDFType', id: string, file?: string, type: QuotesQuotePdfTypeChoices, recipient: string, typeDisplay?: string, emailStatus?: string, created: string, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, sale?: { __typename?: 'SaleType', id: string, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteType', id: string } } }, orderedProducts: Array<{ __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } }>, productsWithoutShipment: Array<{ __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } }>, shipments: Array<{ __typename?: 'ShipmentType', id: string, externalId: string, exchangeRate: number, invoice?: string, created: string, status?: SupplyOrdersShipmentStatusChoices, statusDisplay: string, onHoldDescription?: string, supplyOrder: { __typename?: 'SupplyOrderType', id: string, displayName: string }, productsShipped: Array<{ __typename?: 'ShipmentProductType', id: string, quantity: number, batch?: string, supplyOrder: { __typename?: 'SupplyOrderType', id: string }, shipment: { __typename?: 'ShipmentType', id: string }, orderedProduct: { __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, originalQuote?: { __typename?: 'QuoteType', id: string, displayId: number }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, updatedBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: number }, seeder?: { __typename?: 'SeederType', id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } }, pdfs: Array<{ __typename?: 'QuotePDFType', id: string, file?: string, type: QuotesQuotePdfTypeChoices, recipient: string, typeDisplay?: string, emailStatus?: string, created: string, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteType', id: string } } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type GetSupplyOrdersQueryVariables = Exact<{
  options?: InputMaybe<SupplyOrderListOptionsInputType>;
  user?: InputMaybe<Scalars['UUID']>;
}>;


export type GetSupplyOrdersQuery = { __typename?: 'Query', supplyOrders: { __typename?: 'SupplyOrderListType', count: number, items: Array<{ __typename?: 'SupplyOrderType', id: string, displayId: number, statusDisplay: string, created: string, quote: { __typename?: 'QuoteType', oemOrder?: boolean, rowCount?: number, contact: { __typename?: 'ContactType', email?: string, account: { __typename?: 'AccountType', name: string, owner?: { __typename?: 'OrganizationType', name: string } } }, seeder?: { __typename?: 'SeederType', displayName: string }, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', multiplier: number }, sale?: { __typename?: 'SaleType', paymentMethod: { __typename?: 'QuotedPaymentMethodType', name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean } } }, orderedProducts: Array<{ __typename?: 'OrderedProductType', quantity: number, price: number, commissionMultiplier: number, enableDiscount: boolean }>, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean } }> } };

export type GetSupplyOrdersIdsQueryVariables = Exact<{
  options?: InputMaybe<SupplyOrderListOptionsInputType>;
  user?: InputMaybe<Scalars['UUID']>;
}>;


export type GetSupplyOrdersIdsQuery = { __typename?: 'Query', supplyOrders: { __typename?: 'SupplyOrderListType', count: number, items: Array<{ __typename?: 'SupplyOrderType', id: string }> } };

export type GetSupplyOrderQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type GetSupplyOrderQuery = { __typename?: 'Query', supplyOrder: { __typename?: 'SupplyOrderType', reviewStart?: string, updated: string, id: string, displayId: number, targetDate?: string, salesCanReview: boolean, status: SupplyOrdersSupplyOrderStatusChoices, statusDisplay: string, created: string, billingType?: SupplyOrdersSupplyOrderBillingTypeChoices, reviews: Array<{ __typename?: 'SupplyOrderReviewType', id: string, statusDisplay: string, typeDisplay: string, notes: string, created: string, automaticReviewRejectionRules: Array<{ __typename?: 'AutomaticReviewRejectionRuleType', message: string, description: string, supplyOrderReview?: { __typename?: 'SupplyOrderReviewType', id: string } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, updatedBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, quote: { __typename?: 'QuoteType', additionalChargesValue?: number, additionalChargesDescription?: string, billingType: QuotesQuoteBillingTypeChoices, displayBillingType: string, rowCount?: number, notes?: string, oemOrder?: boolean, created: string, id: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: number }, seeder?: { __typename?: 'SeederType', id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } }, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> }>, pdfs: Array<{ __typename?: 'QuotePDFType', id: string, file?: string, type: QuotesQuotePdfTypeChoices, recipient: string, typeDisplay?: string, emailStatus?: string, created: string, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, sale?: { __typename?: 'SaleType', id: string, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteType', id: string } } }, orderedProducts: Array<{ __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } }>, productsWithoutShipment: Array<{ __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } }>, shipments: Array<{ __typename?: 'ShipmentType', id: string, externalId: string, exchangeRate: number, invoice?: string, created: string, status?: SupplyOrdersShipmentStatusChoices, statusDisplay: string, onHoldDescription?: string, supplyOrder: { __typename?: 'SupplyOrderType', id: string, displayName: string }, productsShipped: Array<{ __typename?: 'ShipmentProductType', id: string, quantity: number, batch?: string, supplyOrder: { __typename?: 'SupplyOrderType', id: string }, shipment: { __typename?: 'ShipmentType', id: string }, orderedProduct: { __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } } };

export type GetBankInvoicePdfQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type GetBankInvoicePdfQuery = { __typename?: 'Query', bankInvoicePdf: { __typename?: 'BankInvoicePDFType', id: string, created: string, quote?: { __typename?: 'QuoteType', additionalChargesValue?: number, additionalChargesDescription?: string, billingType: QuotesQuoteBillingTypeChoices, displayBillingType: string, rowCount?: number, notes?: string, oemOrder?: boolean, created: string, id: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: number }, seeder?: { __typename?: 'SeederType', id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } }, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> }>, pdfs: Array<{ __typename?: 'QuotePDFType', id: string, file?: string, type: QuotesQuotePdfTypeChoices, recipient: string, typeDisplay?: string, emailStatus?: string, created: string, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, sale?: { __typename?: 'SaleType', id: string, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteType', id: string } } }, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } } };

export type GetBankInvoicePdfDisclaimerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBankInvoicePdfDisclaimerQuery = { __typename?: 'Query', bankInvoicePdfDisclaimer: { __typename?: 'BankInvoicePDFDisclaimerType', legalName: string, adress: string, taxId: string, taxpayerType: string, startOfActivities: string, disclaimer: string } };

export type GetQuoteKitMultiplierQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type GetQuoteKitMultiplierQuery = { __typename?: 'Query', quoteKitMultiplier: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: number } };

export type GetQuoteKitMultipliersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQuoteKitMultipliersQuery = { __typename?: 'Query', quoteKitMultipliers: Array<{ __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: number }> };

export type GetOrderedProductQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type GetOrderedProductQuery = { __typename?: 'Query', orderedProduct: { __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } } };

export type GetShipmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetShipmentsQuery = { __typename?: 'Query', shipments: Array<{ __typename?: 'ShipmentType', id: string, externalId: string, exchangeRate: number, invoice?: string, created: string, status?: SupplyOrdersShipmentStatusChoices, statusDisplay: string, onHoldDescription?: string, supplyOrder: { __typename?: 'SupplyOrderType', id: string, displayName: string }, productsShipped: Array<{ __typename?: 'ShipmentProductType', id: string, quantity: number, batch?: string, supplyOrder: { __typename?: 'SupplyOrderType', id: string }, shipment: { __typename?: 'ShipmentType', id: string }, orderedProduct: { __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }> };

export type GetShipmentsOemQueryVariables = Exact<{ [key: string]: never; }>;


export type GetShipmentsOemQuery = { __typename?: 'Query', shipmentsOEM: Array<{ __typename?: 'ShipmentOEMType', id: string, externalId: string, invoice?: string, created: string, status?: OemsShipmentOemStatusChoices, statusDisplay: string, orderOem: { __typename?: 'OrderOEMType', id: string }, productsShipped: Array<{ __typename?: 'ShipmentOEMProductType', id: string, quantity: number, batch?: string, orderOem: { __typename?: 'OrderOEMType', id: string }, shipment: { __typename?: 'ShipmentOEMType', id: string }, orderedProduct: { __typename?: 'OrderedOEMProductType', name: string, externalId: string, productOemId?: string, description: string, price: number, rowCount: number, order: number, id: string, quantity: number, quantityLeft: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string } } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }> };

export type GetShipmentQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type GetShipmentQuery = { __typename?: 'Query', shipment: { __typename?: 'ShipmentType', id: string, externalId: string, exchangeRate: number, invoice?: string, created: string, status?: SupplyOrdersShipmentStatusChoices, statusDisplay: string, onHoldDescription?: string, supplyOrder: { __typename?: 'SupplyOrderType', id: string, displayName: string }, productsShipped: Array<{ __typename?: 'ShipmentProductType', id: string, quantity: number, batch?: string, supplyOrder: { __typename?: 'SupplyOrderType', id: string }, shipment: { __typename?: 'ShipmentType', id: string }, orderedProduct: { __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } } };

export type GetShipmentOemQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type GetShipmentOemQuery = { __typename?: 'Query', shipmentOEM: { __typename?: 'ShipmentOEMType', id: string, externalId: string, invoice?: string, created: string, status?: OemsShipmentOemStatusChoices, statusDisplay: string, orderOem: { __typename?: 'OrderOEMType', id: string }, productsShipped: Array<{ __typename?: 'ShipmentOEMProductType', id: string, quantity: number, batch?: string, orderOem: { __typename?: 'OrderOEMType', id: string }, shipment: { __typename?: 'ShipmentOEMType', id: string }, orderedProduct: { __typename?: 'OrderedOEMProductType', name: string, externalId: string, productOemId?: string, description: string, price: number, rowCount: number, order: number, id: string, quantity: number, quantityLeft: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string } } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } } };

export type CreateSupplyOrderMutationVariables = Exact<{
  input: CreateSupplyOrderMutationInput;
}>;


export type CreateSupplyOrderMutation = { __typename?: 'Mutation', createSupplyOrder?: { __typename?: 'CreateSupplyOrderMutationPayload', supplyOrder?: { __typename?: 'SupplyOrderType', reviewStart?: string, updated: string, id: string, displayId: number, targetDate?: string, salesCanReview: boolean, status: SupplyOrdersSupplyOrderStatusChoices, statusDisplay: string, created: string, billingType?: SupplyOrdersSupplyOrderBillingTypeChoices, reviews: Array<{ __typename?: 'SupplyOrderReviewType', id: string, statusDisplay: string, typeDisplay: string, notes: string, created: string, automaticReviewRejectionRules: Array<{ __typename?: 'AutomaticReviewRejectionRuleType', message: string, description: string, supplyOrderReview?: { __typename?: 'SupplyOrderReviewType', id: string } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, updatedBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, quote: { __typename?: 'QuoteType', additionalChargesValue?: number, additionalChargesDescription?: string, billingType: QuotesQuoteBillingTypeChoices, displayBillingType: string, rowCount?: number, notes?: string, oemOrder?: boolean, created: string, id: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: number }, seeder?: { __typename?: 'SeederType', id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } }, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> }>, pdfs: Array<{ __typename?: 'QuotePDFType', id: string, file?: string, type: QuotesQuotePdfTypeChoices, recipient: string, typeDisplay?: string, emailStatus?: string, created: string, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, sale?: { __typename?: 'SaleType', id: string, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteType', id: string } } }, orderedProducts: Array<{ __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } }>, productsWithoutShipment: Array<{ __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } }>, shipments: Array<{ __typename?: 'ShipmentType', id: string, externalId: string, exchangeRate: number, invoice?: string, created: string, status?: SupplyOrdersShipmentStatusChoices, statusDisplay: string, onHoldDescription?: string, supplyOrder: { __typename?: 'SupplyOrderType', id: string, displayName: string }, productsShipped: Array<{ __typename?: 'ShipmentProductType', id: string, quantity: number, batch?: string, supplyOrder: { __typename?: 'SupplyOrderType', id: string }, shipment: { __typename?: 'ShipmentType', id: string }, orderedProduct: { __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type UpdateSupplyOrderMutationVariables = Exact<{
  input: UpdateSupplyOrderMutationInput;
}>;


export type UpdateSupplyOrderMutation = { __typename?: 'Mutation', updateSupplyOrder?: { __typename?: 'UpdateSupplyOrderMutationPayload', supplyOrder?: { __typename?: 'SupplyOrderType', reviewStart?: string, updated: string, id: string, displayId: number, targetDate?: string, salesCanReview: boolean, status: SupplyOrdersSupplyOrderStatusChoices, statusDisplay: string, created: string, billingType?: SupplyOrdersSupplyOrderBillingTypeChoices, reviews: Array<{ __typename?: 'SupplyOrderReviewType', id: string, statusDisplay: string, typeDisplay: string, notes: string, created: string, automaticReviewRejectionRules: Array<{ __typename?: 'AutomaticReviewRejectionRuleType', message: string, description: string, supplyOrderReview?: { __typename?: 'SupplyOrderReviewType', id: string } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, updatedBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, quote: { __typename?: 'QuoteType', additionalChargesValue?: number, additionalChargesDescription?: string, billingType: QuotesQuoteBillingTypeChoices, displayBillingType: string, rowCount?: number, notes?: string, oemOrder?: boolean, created: string, id: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: number }, seeder?: { __typename?: 'SeederType', id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } }, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> }>, pdfs: Array<{ __typename?: 'QuotePDFType', id: string, file?: string, type: QuotesQuotePdfTypeChoices, recipient: string, typeDisplay?: string, emailStatus?: string, created: string, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, sale?: { __typename?: 'SaleType', id: string, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteType', id: string } } }, orderedProducts: Array<{ __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } }>, productsWithoutShipment: Array<{ __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } }>, shipments: Array<{ __typename?: 'ShipmentType', id: string, externalId: string, exchangeRate: number, invoice?: string, created: string, status?: SupplyOrdersShipmentStatusChoices, statusDisplay: string, onHoldDescription?: string, supplyOrder: { __typename?: 'SupplyOrderType', id: string, displayName: string }, productsShipped: Array<{ __typename?: 'ShipmentProductType', id: string, quantity: number, batch?: string, supplyOrder: { __typename?: 'SupplyOrderType', id: string }, shipment: { __typename?: 'ShipmentType', id: string }, orderedProduct: { __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type UpdateOrderedProductMutationVariables = Exact<{
  input: UpdateOrderedProductMutationInput;
}>;


export type UpdateOrderedProductMutation = { __typename?: 'Mutation', updateOrderedProduct?: { __typename?: 'UpdateOrderedProductMutationPayload', orderedProduct?: { __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type StartSupplyOrderReviewMutationVariables = Exact<{
  input: StartSupplyOrderReviewMutationInput;
}>;


export type StartSupplyOrderReviewMutation = { __typename?: 'Mutation', startSupplyOrderReview?: { __typename?: 'StartSupplyOrderReviewMutationPayload', supplyOrder?: { __typename?: 'SupplyOrderType', id: string, displayId: number, targetDate?: string, salesCanReview: boolean, status: SupplyOrdersSupplyOrderStatusChoices, statusDisplay: string, created: string, billingType?: SupplyOrdersSupplyOrderBillingTypeChoices, quote: { __typename?: 'QuoteType', additionalChargesValue?: number, additionalChargesDescription?: string, billingType: QuotesQuoteBillingTypeChoices, displayBillingType: string, rowCount?: number, notes?: string, oemOrder?: boolean, created: string, id: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: number }, seeder?: { __typename?: 'SeederType', id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } }, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> }>, pdfs: Array<{ __typename?: 'QuotePDFType', id: string, file?: string, type: QuotesQuotePdfTypeChoices, recipient: string, typeDisplay?: string, emailStatus?: string, created: string, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, sale?: { __typename?: 'SaleType', id: string, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteType', id: string } } }, orderedProducts: Array<{ __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } }>, productsWithoutShipment: Array<{ __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } }>, shipments: Array<{ __typename?: 'ShipmentType', id: string, externalId: string, exchangeRate: number, invoice?: string, created: string, status?: SupplyOrdersShipmentStatusChoices, statusDisplay: string, onHoldDescription?: string, supplyOrder: { __typename?: 'SupplyOrderType', id: string, displayName: string }, productsShipped: Array<{ __typename?: 'ShipmentProductType', id: string, quantity: number, batch?: string, supplyOrder: { __typename?: 'SupplyOrderType', id: string }, shipment: { __typename?: 'ShipmentType', id: string }, orderedProduct: { __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type ReviewSupplyOrderMutationVariables = Exact<{
  input: SupplyOrderReviewMutationInput;
}>;


export type ReviewSupplyOrderMutation = { __typename?: 'Mutation', reviewSupplyOrder?: { __typename?: 'SupplyOrderReviewMutationPayload', supplyOrderReview?: { __typename?: 'SupplyOrderReviewType', supplyOrder: { __typename?: 'SupplyOrderType', id: string, displayId: number, targetDate?: string, salesCanReview: boolean, status: SupplyOrdersSupplyOrderStatusChoices, statusDisplay: string, created: string, billingType?: SupplyOrdersSupplyOrderBillingTypeChoices, quote: { __typename?: 'QuoteType', additionalChargesValue?: number, additionalChargesDescription?: string, billingType: QuotesQuoteBillingTypeChoices, displayBillingType: string, rowCount?: number, notes?: string, oemOrder?: boolean, created: string, id: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: number }, seeder?: { __typename?: 'SeederType', id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } }, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> }>, pdfs: Array<{ __typename?: 'QuotePDFType', id: string, file?: string, type: QuotesQuotePdfTypeChoices, recipient: string, typeDisplay?: string, emailStatus?: string, created: string, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, sale?: { __typename?: 'SaleType', id: string, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteType', id: string } } }, orderedProducts: Array<{ __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } }>, productsWithoutShipment: Array<{ __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } }>, shipments: Array<{ __typename?: 'ShipmentType', id: string, externalId: string, exchangeRate: number, invoice?: string, created: string, status?: SupplyOrdersShipmentStatusChoices, statusDisplay: string, onHoldDescription?: string, supplyOrder: { __typename?: 'SupplyOrderType', id: string, displayName: string }, productsShipped: Array<{ __typename?: 'ShipmentProductType', id: string, quantity: number, batch?: string, supplyOrder: { __typename?: 'SupplyOrderType', id: string }, shipment: { __typename?: 'ShipmentType', id: string }, orderedProduct: { __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } } }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type CreateSupplyOrderExportMutationVariables = Exact<{
  filters?: InputMaybe<SupplyOrderListOptionsInputType>;
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type CreateSupplyOrderExportMutation = { __typename?: 'Mutation', createSupplyOrderExport?: { __typename?: 'CreateSupplyOrderExport', job?: { __typename?: 'ExportJobType', id: string }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type CreateAccountExportMutationVariables = Exact<{
  input: CreateAccountExportMutationInput;
}>;


export type CreateAccountExportMutation = { __typename?: 'Mutation', createAccountExport?: { __typename?: 'CreateAccountExportMutationPayload', accountExport?: { __typename?: 'AccountExportType', file?: string }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type CreateSaleExportMutationVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
  filters?: InputMaybe<SaleListOptionsInputType>;
}>;


export type CreateSaleExportMutation = { __typename?: 'Mutation', createSaleExport?: { __typename?: 'CreateSaleExport', job?: { __typename?: 'ExportJobType', id: string }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type QuoteExcelExportMutationVariables = Exact<{
  filters?: InputMaybe<QuoteListOptionsInputType>;
  id?: InputMaybe<Scalars['UUID']>;
  paymentMethod?: InputMaybe<Scalars['String']>;
}>;


export type QuoteExcelExportMutation = { __typename?: 'Mutation', quoteExcelExport?: { __typename?: 'QuoteExcelExport', job: { __typename?: 'ExportJobType', id: string } } };

export type CreateProductWarrantyClaimExportMutationVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
  filters?: InputMaybe<ProductWarrantyClaimListOptionsInputType>;
}>;


export type CreateProductWarrantyClaimExportMutation = { __typename?: 'Mutation', createProductWarrantyClaimExport?: { __typename?: 'CreateProductWarrantyClaimExport', job?: { __typename?: 'ExportJobType', id: string }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type CreateWarrantyClaimPdfMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type CreateWarrantyClaimPdfMutation = { __typename?: 'Mutation', createWarrantyClaimPdf?: { __typename?: 'CreateWarrantyClaimPDF', job?: { __typename?: 'ExportJobType', id: string }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type CreateSeederExportMutationVariables = Exact<{
  input: CreateSeederExportMutationInput;
}>;


export type CreateSeederExportMutation = { __typename?: 'Mutation', createSeederExport?: { __typename?: 'CreateSeederExportMutationPayload', seederExport?: { __typename?: 'SeederExportType', file?: string }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type GetSeederBrandsQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['UUID']>;
}>;


export type GetSeederBrandsQuery = { __typename?: 'Query', seederBrands: Array<{ __typename?: 'SeederBrandType', id: string, name: string }> };

export type GetSeederModelsQueryVariables = Exact<{
  seederBrandId?: InputMaybe<Scalars['UUID']>;
}>;


export type GetSeederModelsQuery = { __typename?: 'Query', seederModels: Array<{ __typename?: 'SeederModelType', id: string, name: string }> };

export type GetSeederQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type GetSeederQuery = { __typename?: 'Query', seeder: { __typename?: 'SeederType', created: string, updated: string, id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, updatedBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } } };

export type GetSeedersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSeedersQuery = { __typename?: 'Query', seeders: Array<{ __typename?: 'SeederType', id: string, displayName: string, rowCount: number }> };

export type GetSeederOptionsQueryVariables = Exact<{
  accountId?: InputMaybe<Scalars['UUID']>;
}>;


export type GetSeederOptionsQuery = { __typename?: 'Query', seeders: Array<{ __typename?: 'SeederType', id: string, displayName: string, rowCount: number }> };

export type CreateSeederMutationVariables = Exact<{
  input: CreateSeederMutationInput;
}>;


export type CreateSeederMutation = { __typename?: 'Mutation', createSeeder?: { __typename?: 'CreateSeederMutationPayload', seeder?: { __typename?: 'SeederType', created: string, updated: string, id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, updatedBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type UpdateSeederMutationVariables = Exact<{
  input: UpdateSeederMutationInput;
}>;


export type UpdateSeederMutation = { __typename?: 'Mutation', updateSeeder?: { __typename?: 'UpdateSeederMutationPayload', seeder?: { __typename?: 'SeederType', created: string, updated: string, id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, updatedBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type DeleteSeederMutationVariables = Exact<{
  input: DeleteSeederMutationInput;
}>;


export type DeleteSeederMutation = { __typename?: 'Mutation', deleteSeeder?: { __typename?: 'DeleteSeederMutationPayload', errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type GetRuntimeSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRuntimeSettingsQuery = { __typename?: 'Query', runtimeSettings: { __typename?: 'RuntimeSettingsType', id: string, quotePdfDisclaimer: string, taxIdLabel: string, signaturesInDisclaimer: boolean, maxVideoSize: number, machineStartUpPercentage: number, machineStartUpInstallationPercentage: number, physicalPersonsDocumentation?: string, legalPersonsDocumentation?: string, templateOfAffidavit?: string, datastudioUrl?: string, tinymceUrl?: string, ordersOemTemplate?: string, datePaymentMethodCalculationV2: string, pricePerHour: number, pemProtocolTemplate?: string, pemTermsTemplate?: string, stockSpreadsheetUrl?: string } };

export type GetLocationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetLocationQuery = { __typename?: 'Query', location?: { __typename?: 'LocationType', id: string, path?: string } };

export type GetLocationsQueryVariables = Exact<{
  level?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
}>;


export type GetLocationsQuery = { __typename?: 'Query', locations?: Array<{ __typename?: 'LocationType', id: string, path?: string }> };

export type RejectWarrantyClaimMutationVariables = Exact<{
  input: RejectWarrantyClaimRequestMutationInput;
}>;


export type RejectWarrantyClaimMutation = { __typename?: 'Mutation', rejectWarrantyClaim?: { __typename?: 'RejectWarrantyClaimRequestMutationPayload', productWarrantyClaimReview?: { __typename?: 'ProductWarrantyClaimReviewType', id: string, created: string, notes: string, statusDisplay: string, status: ProductsProductWarrantyClaimReviewStatusChoices, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type ApproveWarrantyClaimMutationVariables = Exact<{
  input: ApproveWarrantyClaimRequestMutationInput;
}>;


export type ApproveWarrantyClaimMutation = { __typename?: 'Mutation', approveWarrantyClaim?: { __typename?: 'ApproveWarrantyClaimRequestMutationPayload', productWarrantyClaimReview?: { __typename?: 'ProductWarrantyClaimReviewType', id: string, created: string, notes: string, statusDisplay: string, status: ProductsProductWarrantyClaimReviewStatusChoices, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type CreateShipmentProductWarrantyClaimMutationVariables = Exact<{
  input: CreateShipmentProductWarrantyClaimMutationInput;
}>;


export type CreateShipmentProductWarrantyClaimMutation = { __typename?: 'Mutation', createShipmentProductWarrantyClaim?: { __typename?: 'CreateShipmentProductWarrantyClaimMutationPayload', productWarrantyClaim?: { __typename?: 'ProductWarrantyClaimType', id: string, deliveryDate: string, failureDate: string, serialNumber: string, created: string, quantity: number, description: string, finalClient: string, phone: string, externalId?: string, seederKilometers: number, displayId: number, inspectionReview?: { __typename?: 'WarrantyClaimInspectionReviewType', statusDisplay: string, status: ProductsWarrantyClaimInspectionReviewStatusChoices, inWarranty: boolean, id: string, created: string, updated: string, received: boolean, receivedDate?: string, inspected: boolean, inspectedDate?: string, failureDescription: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, updatedBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, warrantyClaim: { __typename?: 'ProductWarrantyClaimType', id: string }, files: Array<{ __typename?: 'WarrantyClaimInspectionFileType', id: string, file?: string }> }, seeder?: { __typename?: 'SeederType', id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } }, images?: Array<{ __typename?: 'WarrantyClaimImageType', id: string, file: string, warrantyClaim: { __typename?: 'ProductWarrantyClaimType', id: string } }>, videos: Array<{ __typename?: 'WarrantyClaimVideoType', id: string, file: string, warrantyClaim: { __typename?: 'ProductWarrantyClaimType', id: string } }>, reviews: Array<{ __typename?: 'ProductWarrantyClaimReviewType', id: string, created: string, notes: string, statusDisplay: string, status: ProductsProductWarrantyClaimReviewStatusChoices, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, inspectionReviewHistories: Array<{ __typename?: 'WarrantyClaimInspectionReviewHistoryType', id: string, created: string, inWarranty: boolean, inWarrantyDisplay: string, previousInWarranty?: boolean, previousInWarrantyDisplay?: string, failureDescription: string, previousFailureDescription: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, product?: { __typename?: 'WarrantyProductType', id: string, externalId: string, name: string, displayName: string, price: number, order: number, description: string, rowCount: number, originalProduct?: { __typename?: 'ProductType', id: string, image?: string }, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } } }, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, lastReview?: { __typename?: 'ProductWarrantyClaimReviewType', id: string, created: string, notes: string, statusDisplay: string, status: ProductsProductWarrantyClaimReviewStatusChoices, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } } }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type CancelWarrantyClaimMutationVariables = Exact<{
  input: CancelWarrantyClaimRequestMutationInput;
}>;


export type CancelWarrantyClaimMutation = { __typename?: 'Mutation', cancelWarrantyClaim?: { __typename?: 'CancelWarrantyClaimRequestMutationPayload', productWarrantyClaimReview?: { __typename?: 'ProductWarrantyClaimReviewType', id: string, created: string, notes: string, statusDisplay: string, status: ProductsProductWarrantyClaimReviewStatusChoices, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type CloseReasonFragment = { __typename?: 'CloseReasonType', id: string, description: string };

export type QuoteCloseReasonFragment = { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteType', id: string } };

export type GetCloseReasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCloseReasonsQuery = { __typename?: 'Query', closeReasons: Array<{ __typename?: 'CloseReasonType', id: string, description: string }> };

export type CloseQuotesMutationVariables = Exact<{
  input: Array<InputMaybe<QuoteCloseReasonInputType>>;
}>;


export type CloseQuotesMutation = { __typename?: 'Mutation', closeQuotes?: { __typename?: 'CloseQuoteMutation', status: boolean } };

export type ExpiredQuoteFragment = { __typename?: 'QuoteType', id: string, displayId: number, created: string, status?: QuotesQuoteStatusChoices, statusDisplay: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteType', id: string } }, contact: { __typename?: 'ContactType', email?: string, account: { __typename?: 'AccountType', name: string, owner?: { __typename?: 'OrganizationType', name: string } } } };

export type GetExpiredQuotesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetExpiredQuotesQuery = { __typename?: 'Query', expiredQuotes: { __typename?: 'QuoteListType', count: number, items: Array<{ __typename?: 'QuoteType', id: string, displayId: number, created: string, status?: QuotesQuoteStatusChoices, statusDisplay: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteType', id: string } }, contact: { __typename?: 'ContactType', email?: string, account: { __typename?: 'AccountType', name: string, owner?: { __typename?: 'OrganizationType', name: string } } } }> } };

export type GetExpiredQuotesCountQueryVariables = Exact<{
  options?: InputMaybe<QuoteListOptionsInputType>;
}>;


export type GetExpiredQuotesCountQuery = { __typename?: 'Query', expiredQuotes: { __typename?: 'QuoteListType', count: number } };

export type GetClosedQuotesQueryVariables = Exact<{
  options?: InputMaybe<QuoteListOptionsInputType>;
}>;


export type GetClosedQuotesQuery = { __typename?: 'Query', closedQuotes: { __typename?: 'QuoteListType', count: number, items: Array<{ __typename?: 'QuoteType', rowCount?: number, created: string, id: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string, seeder?: { __typename?: 'SeederType', displayName: string }, contact: { __typename?: 'ContactType', email?: string, account: { __typename?: 'AccountType', name: string, owner?: { __typename?: 'OrganizationType', name: string } } }, products: Array<{ __typename?: 'QuotedProductType', id: string, order: number, externalId: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: number, name: string, multiplier: number, extraMultiplier: number, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: number }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteType', id: string } } }> } };

export type FailureFragment = { __typename?: 'FailureType', id: string, description: string, created: string, updated: string };

export type WarrantyClaimInspectionReviewFragment = { __typename?: 'WarrantyClaimInspectionReviewType', id: string, created: string, updated: string, received: boolean, receivedDate?: string, inspected: boolean, inspectedDate?: string, failureDescription: string, status: ProductsWarrantyClaimInspectionReviewStatusChoices, statusDisplay: string, inWarranty: boolean, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, updatedBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, warrantyClaim: { __typename?: 'ProductWarrantyClaimType', id: string }, files: Array<{ __typename?: 'WarrantyClaimInspectionFileType', id: string, file?: string }> };

export type WarrantyClaimInspectionReviewHistoryFragment = { __typename?: 'WarrantyClaimInspectionReviewHistoryType', id: string, created: string, inWarranty: boolean, inWarrantyDisplay: string, previousInWarranty?: boolean, previousInWarrantyDisplay?: string, failureDescription: string, previousFailureDescription: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } };

export type GetFailuresQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFailuresQuery = { __typename?: 'Query', failures: Array<{ __typename?: 'FailureType', id: string, description: string, created: string, updated: string }> };

export type CreateWarrantyClaimInspectionReviewMutationVariables = Exact<{
  input: CreateWarrantyClaimInspectionReviewMutationInput;
}>;


export type CreateWarrantyClaimInspectionReviewMutation = { __typename?: 'Mutation', createWarrantyClaimInspectionReview?: { __typename?: 'CreateWarrantyClaimInspectionReviewMutationPayload', warrantyClaimInspectionReview?: { __typename?: 'WarrantyClaimInspectionReviewType', id: string, created: string, updated: string, received: boolean, receivedDate?: string, inspected: boolean, inspectedDate?: string, failureDescription: string, status: ProductsWarrantyClaimInspectionReviewStatusChoices, statusDisplay: string, inWarranty: boolean, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, updatedBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, warrantyClaim: { __typename?: 'ProductWarrantyClaimType', id: string }, files: Array<{ __typename?: 'WarrantyClaimInspectionFileType', id: string, file?: string }> }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type NotificationFragment = { __typename?: 'NotificationType', id: string, message: string, path: string, isRead: boolean, created: string, updated: string, user: { __typename?: 'UserType', id: string } };

export type GetNotificationsQueryVariables = Exact<{
  options: NotificationListOptionsInputType;
}>;


export type GetNotificationsQuery = { __typename?: 'Query', notifications: { __typename?: 'NotificationsType', unreadCount: number, notifications: { __typename?: 'NotificationListType', count: number, page: number, items: Array<{ __typename?: 'NotificationType', id: string, message: string, path: string, isRead: boolean, created: string, updated: string, user: { __typename?: 'UserType', id: string } }> } } };

export type MarkNotificationAsReadMutationVariables = Exact<{
  input: MarkNotificationAsReadMutationInput;
}>;


export type MarkNotificationAsReadMutation = { __typename?: 'Mutation', markNotificationAsRead?: { __typename?: 'MarkNotificationAsReadMutationPayload', notification?: { __typename?: 'NotificationType', id: string, message: string, path: string, isRead: boolean, created: string, updated: string, user: { __typename?: 'UserType', id: string } }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type MarkAllNotificationsAsReadMutationVariables = Exact<{ [key: string]: never; }>;


export type MarkAllNotificationsAsReadMutation = { __typename?: 'Mutation', markAllNotificationsAsRead?: { __typename?: 'MarkAllNotificationsAsRead', status?: boolean } };

export type UploadInvoiceMutationVariables = Exact<{
  input: UploadInvoiceMutationInput;
}>;


export type UploadInvoiceMutation = { __typename?: 'Mutation', uploadInvoice?: { __typename?: 'UploadInvoiceMutationPayload', shipment?: { __typename?: 'ShipmentType', id: string, externalId: string, exchangeRate: number, invoice?: string, created: string, status?: SupplyOrdersShipmentStatusChoices, statusDisplay: string, onHoldDescription?: string, supplyOrder: { __typename?: 'SupplyOrderType', id: string, displayName: string }, productsShipped: Array<{ __typename?: 'ShipmentProductType', id: string, quantity: number, batch?: string, supplyOrder: { __typename?: 'SupplyOrderType', id: string }, shipment: { __typename?: 'ShipmentType', id: string }, orderedProduct: { __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type UploadInvoiceOemMutationVariables = Exact<{
  input: UploadInvoiceOemMutationInput;
}>;


export type UploadInvoiceOemMutation = { __typename?: 'Mutation', uploadInvoiceOem?: { __typename?: 'UploadInvoiceOemMutationPayload', shipmentOEM?: { __typename?: 'ShipmentOEMType', id: string, externalId: string, invoice?: string, created: string, status?: OemsShipmentOemStatusChoices, statusDisplay: string, orderOem: { __typename?: 'OrderOEMType', id: string }, productsShipped: Array<{ __typename?: 'ShipmentOEMProductType', id: string, quantity: number, batch?: string, orderOem: { __typename?: 'OrderOEMType', id: string }, shipment: { __typename?: 'ShipmentOEMType', id: string }, orderedProduct: { __typename?: 'OrderedOEMProductType', name: string, externalId: string, productOemId?: string, description: string, price: number, rowCount: number, order: number, id: string, quantity: number, quantityLeft: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string } } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type CreateWarrantyClaimMutationVariables = Exact<{
  input: CreateWarrantyClaimMutationInput;
}>;


export type CreateWarrantyClaimMutation = { __typename?: 'Mutation', createWarrantyClaim?: { __typename?: 'CreateWarrantyClaimMutationPayload', productWarrantyClaim?: { __typename?: 'ProductWarrantyClaimType', id: string, deliveryDate: string, failureDate: string, serialNumber: string, created: string, quantity: number, description: string, finalClient: string, phone: string, externalId?: string, seederKilometers: number, displayId: number, inspectionReview?: { __typename?: 'WarrantyClaimInspectionReviewType', statusDisplay: string, status: ProductsWarrantyClaimInspectionReviewStatusChoices, inWarranty: boolean, id: string, created: string, updated: string, received: boolean, receivedDate?: string, inspected: boolean, inspectedDate?: string, failureDescription: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, updatedBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, warrantyClaim: { __typename?: 'ProductWarrantyClaimType', id: string }, files: Array<{ __typename?: 'WarrantyClaimInspectionFileType', id: string, file?: string }> }, seeder?: { __typename?: 'SeederType', id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } }, images?: Array<{ __typename?: 'WarrantyClaimImageType', id: string, file: string, warrantyClaim: { __typename?: 'ProductWarrantyClaimType', id: string } }>, videos: Array<{ __typename?: 'WarrantyClaimVideoType', id: string, file: string, warrantyClaim: { __typename?: 'ProductWarrantyClaimType', id: string } }>, reviews: Array<{ __typename?: 'ProductWarrantyClaimReviewType', id: string, created: string, notes: string, statusDisplay: string, status: ProductsProductWarrantyClaimReviewStatusChoices, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, inspectionReviewHistories: Array<{ __typename?: 'WarrantyClaimInspectionReviewHistoryType', id: string, created: string, inWarranty: boolean, inWarrantyDisplay: string, previousInWarranty?: boolean, previousInWarrantyDisplay?: string, failureDescription: string, previousFailureDescription: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, product?: { __typename?: 'WarrantyProductType', id: string, externalId: string, name: string, displayName: string, price: number, order: number, description: string, rowCount: number, originalProduct?: { __typename?: 'ProductType', id: string, image?: string }, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } } }, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, lastReview?: { __typename?: 'ProductWarrantyClaimReviewType', id: string, created: string, notes: string, statusDisplay: string, status: ProductsProductWarrantyClaimReviewStatusChoices, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } } }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type UpdateWarrantyClaimMutationVariables = Exact<{
  input: UpdateWarrantyClaimMutationInput;
}>;


export type UpdateWarrantyClaimMutation = { __typename?: 'Mutation', updateWarrantyClaim?: { __typename?: 'UpdateWarrantyClaimMutationPayload', productWarrantyClaim?: { __typename?: 'ProductWarrantyClaimType', id: string, deliveryDate: string, failureDate: string, serialNumber: string, created: string, quantity: number, description: string, finalClient: string, phone: string, externalId?: string, seederKilometers: number, displayId: number, inspectionReview?: { __typename?: 'WarrantyClaimInspectionReviewType', statusDisplay: string, status: ProductsWarrantyClaimInspectionReviewStatusChoices, inWarranty: boolean, id: string, created: string, updated: string, received: boolean, receivedDate?: string, inspected: boolean, inspectedDate?: string, failureDescription: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, updatedBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, warrantyClaim: { __typename?: 'ProductWarrantyClaimType', id: string }, files: Array<{ __typename?: 'WarrantyClaimInspectionFileType', id: string, file?: string }> }, seeder?: { __typename?: 'SeederType', id: string, year: number, rowCount: number, displayName: string, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay?: string, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedProductCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string }>, brand: { __typename?: 'SeederBrandType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string } } }, images?: Array<{ __typename?: 'WarrantyClaimImageType', id: string, file: string, warrantyClaim: { __typename?: 'ProductWarrantyClaimType', id: string } }>, videos: Array<{ __typename?: 'WarrantyClaimVideoType', id: string, file: string, warrantyClaim: { __typename?: 'ProductWarrantyClaimType', id: string } }>, reviews: Array<{ __typename?: 'ProductWarrantyClaimReviewType', id: string, created: string, notes: string, statusDisplay: string, status: ProductsProductWarrantyClaimReviewStatusChoices, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, inspectionReviewHistories: Array<{ __typename?: 'WarrantyClaimInspectionReviewHistoryType', id: string, created: string, inWarranty: boolean, inWarrantyDisplay: string, previousInWarranty?: boolean, previousInWarrantyDisplay?: string, failureDescription: string, previousFailureDescription: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, product?: { __typename?: 'WarrantyProductType', id: string, externalId: string, name: string, displayName: string, price: number, order: number, description: string, rowCount: number, originalProduct?: { __typename?: 'ProductType', id: string, image?: string }, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } } }, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, lastReview?: { __typename?: 'ProductWarrantyClaimReviewType', id: string, created: string, notes: string, statusDisplay: string, status: ProductsProductWarrantyClaimReviewStatusChoices, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } } }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type DownloadFragment = { __typename?: 'DownloadType', contentType: string, data: any, filename: string };

export type GetAnalyticsPdfExportQueryVariables = Exact<{
  path: Scalars['String'];
  waitForSelector: Scalars['String'];
}>;


export type GetAnalyticsPdfExportQuery = { __typename?: 'Query', analyticsPdfExport: { __typename?: 'DownloadType', contentType: string, data: any, filename: string } };

export type CreateMultipleShipmentsMutationVariables = Exact<{
  shipments: Array<ShipmentFormInput>;
}>;


export type CreateMultipleShipmentsMutation = { __typename?: 'Mutation', createMultipleShipments?: { __typename?: 'CreateShipmentsMutation', shipments: Array<{ __typename?: 'ShipmentType', id: string, externalId: string, exchangeRate: number, invoice?: string, created: string, status?: SupplyOrdersShipmentStatusChoices, statusDisplay: string, onHoldDescription?: string, supplyOrder: { __typename?: 'SupplyOrderType', id: string, displayName: string }, productsShipped: Array<{ __typename?: 'ShipmentProductType', id: string, quantity: number, batch?: string, supplyOrder: { __typename?: 'SupplyOrderType', id: string }, shipment: { __typename?: 'ShipmentType', id: string }, orderedProduct: { __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, enableDiscount: boolean, commissionMultiplier: number, price: number, quotedProduct: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, price: number, quantity: number, enableDiscount: boolean, commissionMultiplier: number, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> } } }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type DownloadPdfFragment = { __typename?: 'DownloadType', filename: string, contentType: string, data: any };

export type AddOrderedProductMutationVariables = Exact<{
  input: OrderedProductSupplyOrderFormInput;
  orderedProducts: Array<OrderedProductOrderedProductFormInput>;
}>;


export type AddOrderedProductMutation = { __typename?: 'Mutation', addOrderedProductMutation?: { __typename?: 'AddOrderedProduct', errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type GefcoEventFragment = { __typename?: 'GefcoEvent', baseEvent: string, event: EventStatus, eventDisplay?: string, rejectReason?: string, date: string };

export type GefcoShipmentStatusFragment = { __typename?: 'GefcoShipmentStatus', deliverId: string, shipmentExternalId: string, documentId?: string, tmsStatus: TmsStatus, tmsStatusDisplay?: string, wmsStatus: WmsStatus, wmsStatusDisplay?: string, events: Array<{ __typename?: 'GefcoEvent', baseEvent: string, event: EventStatus, eventDisplay?: string, rejectReason?: string, date: string }> };

export type GetGefcoShipmentQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetGefcoShipmentQuery = { __typename?: 'Query', gefcoShipment: { __typename?: 'GefcoShipmentResponse', error?: string, shipments: Array<{ __typename?: 'GefcoShipmentStatus', deliverId: string, shipmentExternalId: string, documentId?: string, tmsStatus: TmsStatus, tmsStatusDisplay?: string, wmsStatus: WmsStatus, wmsStatusDisplay?: string, events: Array<{ __typename?: 'GefcoEvent', baseEvent: string, event: EventStatus, eventDisplay?: string, rejectReason?: string, date: string }> }> } };

export type GetOemProductsQueryVariables = Exact<{
  organizationId: Scalars['UUID'];
}>;


export type GetOemProductsQuery = { __typename?: 'Query', oemProducts: Array<{ __typename?: 'OrganizationGroupOemThroughType', id: string, price: number, displayName: string, externalId: string, product: { __typename?: 'ProductType', id: string, description: string, externalId: string, rowCount: number, order: number, name: string, ruleGroup?: { __typename?: 'RuleGroupType', id: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', id: string }>, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } } } }> };

export type GetOrganizationOemStockQueryVariables = Exact<{
  options?: InputMaybe<OrganizationGroupOemThroughListOptionsInputType>;
  organizationId: Scalars['UUID'];
}>;


export type GetOrganizationOemStockQuery = { __typename?: 'Query', organizationOemStock: { __typename?: 'OrganizationGroupOemThroughListType', count: number, items: Array<{ __typename?: 'OrganizationGroupOemThroughType', id: string, externalId: string, published: boolean, displayName: string, requestedQuantity: number, stock: number, organizationGroup: { __typename?: 'OrganizationGroupType', id: string }, product: { __typename?: 'ProductType', id: string, description: string, externalId: string, name: string, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } } } }> } };

export type AddStockToProductMutationVariables = Exact<{
  input: AddStockToProductMutationInput;
}>;


export type AddStockToProductMutation = { __typename?: 'Mutation', addStockToProduct?: { __typename?: 'AddStockToProductMutationPayload', organizationGroupOemThrough?: { __typename?: 'OrganizationGroupOemThroughType', id: string }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type AddProductsToOemOrganizationMutationVariables = Exact<{
  products: Array<AddStockToProductFormInput>;
}>;


export type AddProductsToOemOrganizationMutation = { __typename?: 'Mutation', addProductsToOemOrganization?: { __typename?: 'AddProductsToOemOrganization', ok?: boolean, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type JobFragment = { __typename?: 'JobType', id: string, status: JobStatus, result?: string };

export type GetJobQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetJobQuery = { __typename?: 'Query', job?: { __typename?: 'JobType', id: string, status: JobStatus, result?: string } };

export type GetExportFileJobQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetExportFileJobQuery = { __typename?: 'Query', exportFileJob?: { __typename?: 'ExportJobType', id: string, status: JobStatus, result?: { __typename?: 'DownloadType', contentType: string, data: any, filename: string } } };

export type ExportOemsMutationVariables = Exact<{
  options?: InputMaybe<OrderOemListOptionsInputType>;
  orderOemId?: InputMaybe<Scalars['UUID']>;
}>;


export type ExportOemsMutation = { __typename?: 'Mutation', exportOems?: { __typename?: 'ExportOems', job?: { __typename?: 'ExportJobType', id: string } } };

export type ExportJobFragment = { __typename?: 'ExportJobType', id: string, status: JobStatus, result?: { __typename?: 'DownloadType', contentType: string, data: any, filename: string } };

export type GetProductsStocksQueryVariables = Exact<{
  externalIds: Array<InputMaybe<Scalars['String']>>;
}>;


export type GetProductsStocksQuery = { __typename?: 'Query', productsStocks?: { __typename?: 'StockResponseType', stocks: Array<{ __typename?: 'StockType', externalId: string, availableQuantity: number, found: boolean }>, errors: Array<{ __typename?: 'StockErrorType', code?: string, message?: string }> } };

export type NotificationConfigFragment = { __typename?: 'NotificationConfigType', id: string, name: UsersNotificationConfigNameChoices, inAppEnabled: boolean, emailEnabled: boolean, displayName: string, user: { __typename?: 'UserType', id: string } };

export type NotificationConfigNameFragment = { __typename?: 'NotificationConfigNameType', value: NotificationConfigChoices, label: string };

export type GetUserNotificationConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserNotificationConfigQuery = { __typename?: 'Query', notificationsConfigNames: Array<{ __typename?: 'NotificationConfigNameType', value: NotificationConfigChoices, label: string }>, userNotificationsConfigs: Array<{ __typename?: 'NotificationConfigType', id: string, name: UsersNotificationConfigNameChoices, inAppEnabled: boolean, emailEnabled: boolean, displayName: string, user: { __typename?: 'UserType', id: string } }> };

export type ToggleNotificationConfigMutationVariables = Exact<{
  input: NotificationConfigMutationInput;
}>;


export type ToggleNotificationConfigMutation = { __typename?: 'Mutation', toggleNotificationConfig?: { __typename?: 'NotificationConfigMutationPayload', notificationConfig?: { __typename?: 'NotificationConfigType', id: string, name: UsersNotificationConfigNameChoices, inAppEnabled: boolean, emailEnabled: boolean, displayName: string, user: { __typename?: 'UserType', id: string } }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type MachineStartUpProductCategoryFragment = { __typename?: 'MachineStartUpProductCategoryType', id: string, name: string, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, engineQuantity: number, useInTotalPrice: boolean, payOnlyFieldReview: boolean };

export type MissingProductsListFragment = { __typename?: 'MissingProductType', externalId: string, name: string };

export type MachineStartUpListFragment = { __typename?: 'MachineStartUpType', id: string, displayId: number, seederRowCount: number, step: MachineStartUpsMachineStartUpStepChoices, stepDisplay: string, fieldStepDisplay?: string, fieldStep?: MachineStartUpsMachineStartUpFieldStepChoices, factoryStepDisplay?: string, factoryStep?: MachineStartUpsMachineStartUpFactoryStepChoices, created: string, expirationDate?: string, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, seederBrand: { __typename?: 'SeederBrandType', id: string, name: string }, seederModel: { __typename?: 'SeederModelType', id: string, name: string }, organizationFactory?: { __typename?: 'OrganizationType', id: string, name: string }, organizationField?: { __typename?: 'OrganizationType', id: string, name: string }, oemOrganization?: { __typename?: 'OrganizationType', id: string, name: string }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, missingProducts: Array<{ __typename?: 'MissingProductType', id: string, name: string, quantity: number }> };

export type MachineStartUpFragment = { __typename?: 'MachineStartUpType', id: string, displayId: number, isFieldStepPending: boolean, seederYear: number, seederRowCount: number, seederSerialNumber?: string, productionDateFrom?: string, productionDateTo?: string, estimatedDeliveryDate?: string, installationPrice: number, startUpPrice?: number, totalPriceMachine: number, factoryPlaqueImage?: string, factoryProtocolImage?: string, factoryTermsImage?: string, fieldPlaqueImage?: string, fieldProtocolImage?: string, fieldTermsImage?: string, dealerFactoryInvoice?: string, dealerFieldInvoice?: string, dealerFactoryNotes?: string, factoryWorkflowNumber?: string, fieldWorkflowNumber?: string, dealerFieldNotes?: string, racks: boolean, step: MachineStartUpsMachineStartUpStepChoices, stepDisplay: string, fieldStep?: MachineStartUpsMachineStartUpFieldStepChoices, fieldStepDisplay?: string, factoryStep?: MachineStartUpsMachineStartUpFactoryStepChoices, factoryStepDisplay?: string, created: string, expirationDate?: string, withPostFieldRevision: boolean, dealerStartUpPrice: number, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, seederBrand: { __typename?: 'SeederBrandType', id: string, name: string }, seederModel: { __typename?: 'SeederModelType', id: string, name: string }, organizationFactory?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }, organizationField?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }, oemOrganization?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }, productCategories: Array<{ __typename?: 'MachineStartUpProductCategoryType', id: string, name: string, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, engineQuantity: number, useInTotalPrice: boolean, payOnlyFieldReview: boolean }>, factoryAssistants: Array<{ __typename?: 'FactoryAssistantType', id: string, name: string, phone: string }>, customerAssistants: Array<{ __typename?: 'CustomerAssistantType', id: string, name: string, phone: string }>, createdBy?: { __typename?: 'UserType', id: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, canEditLockedEcnTasks: boolean, emailNotifications: boolean, inAppNotifications: boolean, organization?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }, role?: { __typename?: 'RoleType', id: string, name: string }, ecnRoles: Array<{ __typename?: 'EcnRoleType', id: string }>, permissions: { __typename?: 'UserPermissions', viewQuotes: boolean, viewSales: boolean, viewSupplyOrders: boolean, viewAccounts: boolean, viewContacts: boolean, viewOpportunities: boolean, viewWarrantyClaims: boolean, viewMachineStartUps: boolean, viewEcns: boolean, assignAccountOwner: boolean, requestSupplyOrderReview: boolean, submitSalesSupplyOrderReview: boolean, submitCreditsSupplyOrderReview: boolean, requestOemOrderReview: boolean, viewAnalytics: boolean, viewWarrantyClaimsAnalytics: boolean, manageShipments: boolean, manageQuotes: boolean, manageSales: boolean, manageSupplyOrders: boolean, manageWarrantyClaims: boolean, performTechnicalReview: boolean, manageMachineStartUps: boolean, manageOem: boolean, viewOemStock: boolean, manageEcns: boolean, manageAccounts: boolean, viewDatastudio: boolean, viewOems: boolean, viewSeeders: boolean, viewMaterialMaster: boolean, manageMaterialMaster: boolean, createMachineStartUps: boolean, viewOemOrderBankInvoices: boolean, viewStock: boolean, viewUnpublishedProducts: boolean, requestAccountRegistration: boolean, submitAccountRegistrationReview: boolean, receiveAccountRegistrationApprovedNotification: boolean } }, missingProducts: Array<{ __typename?: 'MissingProductType', id: string, name: string, externalId: string, price: number, quantity: number, description: string, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, machineStartUp: { __typename?: 'MachineStartUpType', id: string } }>, pemRule?: { __typename?: 'PemRuleType', id: string, name: string, subCategories: Array<{ __typename?: 'ProductSubcategoryType', name: string, id: string }>, fixed?: { __typename?: 'PemCalculationTypeFixedType', partialHours: number }, variable?: { __typename?: 'PemCalculationTypeVariableType', minutesPerRow: number }, visit?: { __typename?: 'PemCalculationTypeVisitType', name: string, partialHours: number } } };

export type MachineStartUpMissingProductFragment = { __typename?: 'MissingProductType', id: string, name: string, externalId: string, price: number, quantity: number, description: string, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, machineStartUp: { __typename?: 'MachineStartUpType', id: string } };

export type PemCalculationTypeFixedFragment = { __typename?: 'PemCalculationTypeFixedType', partialHours: number };

export type PemCalculationTypeVariableFragment = { __typename?: 'PemCalculationTypeVariableType', minutesPerRow: number };

export type PemRuleAdditionalFragment = { __typename?: 'PemCalculationTypeAdditionalType', partialHours: number, id: string, subCategories: Array<{ __typename?: 'ProductSubcategoryType', name: string, id: string }> };

export type PemCalculationTypeVisitFragment = { __typename?: 'PemCalculationTypeVisitType', name: string, partialHours: number };

export type PemRuleFragment = { __typename?: 'PemRuleType', id: string, name: string, subCategories: Array<{ __typename?: 'ProductSubcategoryType', name: string, id: string }>, fixed?: { __typename?: 'PemCalculationTypeFixedType', partialHours: number }, variable?: { __typename?: 'PemCalculationTypeVariableType', minutesPerRow: number }, visit?: { __typename?: 'PemCalculationTypeVisitType', name: string, partialHours: number } };

export type MachineStartUpsExcelExportMutationVariables = Exact<{
  options?: InputMaybe<MachineStartUpListOptionsInputType>;
}>;


export type MachineStartUpsExcelExportMutation = { __typename?: 'Mutation', machineStartUpsExcelExport?: { __typename?: 'MachineStartUpsExcelExport', job: { __typename?: 'ExportJobType', id: string } } };

export type MsuMissingProductExcelExportMutationVariables = Exact<{
  options?: InputMaybe<MachineStartUpListOptionsInputType>;
}>;


export type MsuMissingProductExcelExportMutation = { __typename?: 'Mutation', msuMissingProductExport?: { __typename?: 'MSUMissingProductsExcelExport', job: { __typename?: 'ExportJobType', id: string } } };

export type PemPdfExportMutationVariables = Exact<{
  id: Scalars['UUID'];
  dealerType: Scalars['String'];
}>;


export type PemPdfExportMutation = { __typename?: 'Mutation', pemPdfExport?: { __typename?: 'PemPdfExport', job: { __typename?: 'ExportJobType', id: string, status: JobStatus, result?: { __typename?: 'DownloadType', contentType: string, data: any, filename: string } } } };

export type GetMachineStartUpsQueryVariables = Exact<{
  options?: InputMaybe<MachineStartUpListOptionsInputType>;
}>;


export type GetMachineStartUpsQuery = { __typename?: 'Query', machineStartUps: { __typename?: 'MachineStartUpListType', count: number, items: Array<{ __typename?: 'MachineStartUpType', id: string, displayId: number, seederRowCount: number, step: MachineStartUpsMachineStartUpStepChoices, stepDisplay: string, fieldStepDisplay?: string, fieldStep?: MachineStartUpsMachineStartUpFieldStepChoices, factoryStepDisplay?: string, factoryStep?: MachineStartUpsMachineStartUpFactoryStepChoices, created: string, expirationDate?: string, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, seederBrand: { __typename?: 'SeederBrandType', id: string, name: string }, seederModel: { __typename?: 'SeederModelType', id: string, name: string }, organizationFactory?: { __typename?: 'OrganizationType', id: string, name: string }, organizationField?: { __typename?: 'OrganizationType', id: string, name: string }, oemOrganization?: { __typename?: 'OrganizationType', id: string, name: string }, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, missingProducts: Array<{ __typename?: 'MissingProductType', id: string, name: string, quantity: number }> }> } };

export type GetMissingProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMissingProductsQuery = { __typename?: 'Query', missingProducts: { __typename?: 'MissingProductTypeList', items: Array<{ __typename?: 'MissingProductType', externalId: string, name: string }> } };

export type GetMachineStartUpQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type GetMachineStartUpQuery = { __typename?: 'Query', machineStartUp: { __typename?: 'MachineStartUpType', id: string, displayId: number, isFieldStepPending: boolean, seederYear: number, seederRowCount: number, seederSerialNumber?: string, productionDateFrom?: string, productionDateTo?: string, estimatedDeliveryDate?: string, installationPrice: number, startUpPrice?: number, totalPriceMachine: number, factoryPlaqueImage?: string, factoryProtocolImage?: string, factoryTermsImage?: string, fieldPlaqueImage?: string, fieldProtocolImage?: string, fieldTermsImage?: string, dealerFactoryInvoice?: string, dealerFieldInvoice?: string, dealerFactoryNotes?: string, factoryWorkflowNumber?: string, fieldWorkflowNumber?: string, dealerFieldNotes?: string, racks: boolean, step: MachineStartUpsMachineStartUpStepChoices, stepDisplay: string, fieldStep?: MachineStartUpsMachineStartUpFieldStepChoices, fieldStepDisplay?: string, factoryStep?: MachineStartUpsMachineStartUpFactoryStepChoices, factoryStepDisplay?: string, created: string, expirationDate?: string, withPostFieldRevision: boolean, dealerStartUpPrice: number, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, seederBrand: { __typename?: 'SeederBrandType', id: string, name: string }, seederModel: { __typename?: 'SeederModelType', id: string, name: string }, organizationFactory?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }, organizationField?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }, oemOrganization?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }, productCategories: Array<{ __typename?: 'MachineStartUpProductCategoryType', id: string, name: string, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, engineQuantity: number, useInTotalPrice: boolean, payOnlyFieldReview: boolean }>, factoryAssistants: Array<{ __typename?: 'FactoryAssistantType', id: string, name: string, phone: string }>, customerAssistants: Array<{ __typename?: 'CustomerAssistantType', id: string, name: string, phone: string }>, createdBy?: { __typename?: 'UserType', id: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, canEditLockedEcnTasks: boolean, emailNotifications: boolean, inAppNotifications: boolean, organization?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }, role?: { __typename?: 'RoleType', id: string, name: string }, ecnRoles: Array<{ __typename?: 'EcnRoleType', id: string }>, permissions: { __typename?: 'UserPermissions', viewQuotes: boolean, viewSales: boolean, viewSupplyOrders: boolean, viewAccounts: boolean, viewContacts: boolean, viewOpportunities: boolean, viewWarrantyClaims: boolean, viewMachineStartUps: boolean, viewEcns: boolean, assignAccountOwner: boolean, requestSupplyOrderReview: boolean, submitSalesSupplyOrderReview: boolean, submitCreditsSupplyOrderReview: boolean, requestOemOrderReview: boolean, viewAnalytics: boolean, viewWarrantyClaimsAnalytics: boolean, manageShipments: boolean, manageQuotes: boolean, manageSales: boolean, manageSupplyOrders: boolean, manageWarrantyClaims: boolean, performTechnicalReview: boolean, manageMachineStartUps: boolean, manageOem: boolean, viewOemStock: boolean, manageEcns: boolean, manageAccounts: boolean, viewDatastudio: boolean, viewOems: boolean, viewSeeders: boolean, viewMaterialMaster: boolean, manageMaterialMaster: boolean, createMachineStartUps: boolean, viewOemOrderBankInvoices: boolean, viewStock: boolean, viewUnpublishedProducts: boolean, requestAccountRegistration: boolean, submitAccountRegistrationReview: boolean, receiveAccountRegistrationApprovedNotification: boolean } }, missingProducts: Array<{ __typename?: 'MissingProductType', id: string, name: string, externalId: string, price: number, quantity: number, description: string, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, machineStartUp: { __typename?: 'MachineStartUpType', id: string } }>, pemRule?: { __typename?: 'PemRuleType', id: string, name: string, subCategories: Array<{ __typename?: 'ProductSubcategoryType', name: string, id: string }>, fixed?: { __typename?: 'PemCalculationTypeFixedType', partialHours: number }, variable?: { __typename?: 'PemCalculationTypeVariableType', minutesPerRow: number }, visit?: { __typename?: 'PemCalculationTypeVisitType', name: string, partialHours: number } } } };

export type GetProductCategoriesEnabledForMachineStartUpQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProductCategoriesEnabledForMachineStartUpQuery = { __typename?: 'Query', productCategoriesEnabledForMachineStartUp: Array<{ __typename?: 'ProductCategoryType', enabledForAssistedQuote: boolean, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, id: string, name: string }> };

export type GetPemRulesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPemRulesQuery = { __typename?: 'Query', pemRules: Array<{ __typename?: 'PemRuleType', id: string, name: string, subCategories: Array<{ __typename?: 'ProductSubcategoryType', name: string, id: string }>, fixed?: { __typename?: 'PemCalculationTypeFixedType', partialHours: number }, variable?: { __typename?: 'PemCalculationTypeVariableType', minutesPerRow: number }, visit?: { __typename?: 'PemCalculationTypeVisitType', name: string, partialHours: number } }> };

export type GetPemRuleQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetPemRuleQuery = { __typename?: 'Query', pemRule?: { __typename?: 'PemRuleType', id: string, name: string, subCategories: Array<{ __typename?: 'ProductSubcategoryType', name: string, id: string }>, fixed?: { __typename?: 'PemCalculationTypeFixedType', partialHours: number }, variable?: { __typename?: 'PemCalculationTypeVariableType', minutesPerRow: number }, visit?: { __typename?: 'PemCalculationTypeVisitType', name: string, partialHours: number } } };

export type GetPemRuleAdditionalsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPemRuleAdditionalsQuery = { __typename?: 'Query', pemRuleAdditionals?: Array<{ __typename?: 'PemCalculationTypeAdditionalType', partialHours: number, id: string, subCategories: Array<{ __typename?: 'ProductSubcategoryType', name: string, id: string }> }> };

export type GetPemRuleAdditionalsByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetPemRuleAdditionalsByIdQuery = { __typename?: 'Query', pemRuleAdditionalsById?: Array<{ __typename?: 'PemCalculationTypeAdditionalType', partialHours: number, id: string, subCategories: Array<{ __typename?: 'ProductSubcategoryType', name: string, id: string }> }> };

export type PemCreateMutationVariables = Exact<{
  input: CreateMachineStartUpMutationInput;
}>;


export type PemCreateMutation = { __typename?: 'Mutation', pemCreate?: { __typename?: 'CreateMachineStartUpMutationPayload', machineStartUp?: { __typename?: 'MachineStartUpType', id: string, displayId: number, isFieldStepPending: boolean, seederYear: number, seederRowCount: number, seederSerialNumber?: string, productionDateFrom?: string, productionDateTo?: string, estimatedDeliveryDate?: string, installationPrice: number, startUpPrice?: number, totalPriceMachine: number, factoryPlaqueImage?: string, factoryProtocolImage?: string, factoryTermsImage?: string, fieldPlaqueImage?: string, fieldProtocolImage?: string, fieldTermsImage?: string, dealerFactoryInvoice?: string, dealerFieldInvoice?: string, dealerFactoryNotes?: string, factoryWorkflowNumber?: string, fieldWorkflowNumber?: string, dealerFieldNotes?: string, racks: boolean, step: MachineStartUpsMachineStartUpStepChoices, stepDisplay: string, fieldStep?: MachineStartUpsMachineStartUpFieldStepChoices, fieldStepDisplay?: string, factoryStep?: MachineStartUpsMachineStartUpFactoryStepChoices, factoryStepDisplay?: string, created: string, expirationDate?: string, withPostFieldRevision: boolean, dealerStartUpPrice: number, productCategories: Array<{ __typename?: 'MachineStartUpProductCategoryType', id: string, name: string, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, engineQuantity: number, useInTotalPrice: boolean, payOnlyFieldReview: boolean }>, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, seederBrand: { __typename?: 'SeederBrandType', id: string, name: string }, seederModel: { __typename?: 'SeederModelType', id: string, name: string }, organizationFactory?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }, organizationField?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }, oemOrganization?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }, factoryAssistants: Array<{ __typename?: 'FactoryAssistantType', id: string, name: string, phone: string }>, customerAssistants: Array<{ __typename?: 'CustomerAssistantType', id: string, name: string, phone: string }>, createdBy?: { __typename?: 'UserType', id: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, canEditLockedEcnTasks: boolean, emailNotifications: boolean, inAppNotifications: boolean, organization?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }, role?: { __typename?: 'RoleType', id: string, name: string }, ecnRoles: Array<{ __typename?: 'EcnRoleType', id: string }>, permissions: { __typename?: 'UserPermissions', viewQuotes: boolean, viewSales: boolean, viewSupplyOrders: boolean, viewAccounts: boolean, viewContacts: boolean, viewOpportunities: boolean, viewWarrantyClaims: boolean, viewMachineStartUps: boolean, viewEcns: boolean, assignAccountOwner: boolean, requestSupplyOrderReview: boolean, submitSalesSupplyOrderReview: boolean, submitCreditsSupplyOrderReview: boolean, requestOemOrderReview: boolean, viewAnalytics: boolean, viewWarrantyClaimsAnalytics: boolean, manageShipments: boolean, manageQuotes: boolean, manageSales: boolean, manageSupplyOrders: boolean, manageWarrantyClaims: boolean, performTechnicalReview: boolean, manageMachineStartUps: boolean, manageOem: boolean, viewOemStock: boolean, manageEcns: boolean, manageAccounts: boolean, viewDatastudio: boolean, viewOems: boolean, viewSeeders: boolean, viewMaterialMaster: boolean, manageMaterialMaster: boolean, createMachineStartUps: boolean, viewOemOrderBankInvoices: boolean, viewStock: boolean, viewUnpublishedProducts: boolean, requestAccountRegistration: boolean, submitAccountRegistrationReview: boolean, receiveAccountRegistrationApprovedNotification: boolean } }, missingProducts: Array<{ __typename?: 'MissingProductType', id: string, name: string, externalId: string, price: number, quantity: number, description: string, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, machineStartUp: { __typename?: 'MachineStartUpType', id: string } }>, pemRule?: { __typename?: 'PemRuleType', id: string, name: string, subCategories: Array<{ __typename?: 'ProductSubcategoryType', name: string, id: string }>, fixed?: { __typename?: 'PemCalculationTypeFixedType', partialHours: number }, variable?: { __typename?: 'PemCalculationTypeVariableType', minutesPerRow: number }, visit?: { __typename?: 'PemCalculationTypeVisitType', name: string, partialHours: number } } }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type PemAdministrativeRevisionMutationVariables = Exact<{
  input: PemAdministrativeRevisionMutationInput;
}>;


export type PemAdministrativeRevisionMutation = { __typename?: 'Mutation', pemAdministrativeRevision?: { __typename?: 'PemAdministrativeRevisionMutationPayload', errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }>, machineStartUp?: { __typename?: 'MachineStartUpType', id: string, displayId: number, isFieldStepPending: boolean, seederYear: number, seederRowCount: number, seederSerialNumber?: string, productionDateFrom?: string, productionDateTo?: string, estimatedDeliveryDate?: string, installationPrice: number, startUpPrice?: number, totalPriceMachine: number, factoryPlaqueImage?: string, factoryProtocolImage?: string, factoryTermsImage?: string, fieldPlaqueImage?: string, fieldProtocolImage?: string, fieldTermsImage?: string, dealerFactoryInvoice?: string, dealerFieldInvoice?: string, dealerFactoryNotes?: string, factoryWorkflowNumber?: string, fieldWorkflowNumber?: string, dealerFieldNotes?: string, racks: boolean, step: MachineStartUpsMachineStartUpStepChoices, stepDisplay: string, fieldStep?: MachineStartUpsMachineStartUpFieldStepChoices, fieldStepDisplay?: string, factoryStep?: MachineStartUpsMachineStartUpFactoryStepChoices, factoryStepDisplay?: string, created: string, expirationDate?: string, withPostFieldRevision: boolean, dealerStartUpPrice: number, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, seederBrand: { __typename?: 'SeederBrandType', id: string, name: string }, seederModel: { __typename?: 'SeederModelType', id: string, name: string }, organizationFactory?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }, organizationField?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }, oemOrganization?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }, productCategories: Array<{ __typename?: 'MachineStartUpProductCategoryType', id: string, name: string, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, engineQuantity: number, useInTotalPrice: boolean, payOnlyFieldReview: boolean }>, factoryAssistants: Array<{ __typename?: 'FactoryAssistantType', id: string, name: string, phone: string }>, customerAssistants: Array<{ __typename?: 'CustomerAssistantType', id: string, name: string, phone: string }>, createdBy?: { __typename?: 'UserType', id: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, canEditLockedEcnTasks: boolean, emailNotifications: boolean, inAppNotifications: boolean, organization?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }, role?: { __typename?: 'RoleType', id: string, name: string }, ecnRoles: Array<{ __typename?: 'EcnRoleType', id: string }>, permissions: { __typename?: 'UserPermissions', viewQuotes: boolean, viewSales: boolean, viewSupplyOrders: boolean, viewAccounts: boolean, viewContacts: boolean, viewOpportunities: boolean, viewWarrantyClaims: boolean, viewMachineStartUps: boolean, viewEcns: boolean, assignAccountOwner: boolean, requestSupplyOrderReview: boolean, submitSalesSupplyOrderReview: boolean, submitCreditsSupplyOrderReview: boolean, requestOemOrderReview: boolean, viewAnalytics: boolean, viewWarrantyClaimsAnalytics: boolean, manageShipments: boolean, manageQuotes: boolean, manageSales: boolean, manageSupplyOrders: boolean, manageWarrantyClaims: boolean, performTechnicalReview: boolean, manageMachineStartUps: boolean, manageOem: boolean, viewOemStock: boolean, manageEcns: boolean, manageAccounts: boolean, viewDatastudio: boolean, viewOems: boolean, viewSeeders: boolean, viewMaterialMaster: boolean, manageMaterialMaster: boolean, createMachineStartUps: boolean, viewOemOrderBankInvoices: boolean, viewStock: boolean, viewUnpublishedProducts: boolean, requestAccountRegistration: boolean, submitAccountRegistrationReview: boolean, receiveAccountRegistrationApprovedNotification: boolean } }, missingProducts: Array<{ __typename?: 'MissingProductType', id: string, name: string, externalId: string, price: number, quantity: number, description: string, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, machineStartUp: { __typename?: 'MachineStartUpType', id: string } }>, pemRule?: { __typename?: 'PemRuleType', id: string, name: string, subCategories: Array<{ __typename?: 'ProductSubcategoryType', name: string, id: string }>, fixed?: { __typename?: 'PemCalculationTypeFixedType', partialHours: number }, variable?: { __typename?: 'PemCalculationTypeVariableType', minutesPerRow: number }, visit?: { __typename?: 'PemCalculationTypeVisitType', name: string, partialHours: number } } } } };

export type PemAdministrativeRevisionUpdateMutationVariables = Exact<{
  input: PemAdministrativeRevisionUpdateMutationInput;
}>;


export type PemAdministrativeRevisionUpdateMutation = { __typename?: 'Mutation', pemAdministrativeRevisionUpdate?: { __typename?: 'PemAdministrativeRevisionUpdateMutationPayload', errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }>, machineStartUp?: { __typename?: 'MachineStartUpType', id: string, displayId: number, isFieldStepPending: boolean, seederYear: number, seederRowCount: number, seederSerialNumber?: string, productionDateFrom?: string, productionDateTo?: string, estimatedDeliveryDate?: string, installationPrice: number, startUpPrice?: number, totalPriceMachine: number, factoryPlaqueImage?: string, factoryProtocolImage?: string, factoryTermsImage?: string, fieldPlaqueImage?: string, fieldProtocolImage?: string, fieldTermsImage?: string, dealerFactoryInvoice?: string, dealerFieldInvoice?: string, dealerFactoryNotes?: string, factoryWorkflowNumber?: string, fieldWorkflowNumber?: string, dealerFieldNotes?: string, racks: boolean, step: MachineStartUpsMachineStartUpStepChoices, stepDisplay: string, fieldStep?: MachineStartUpsMachineStartUpFieldStepChoices, fieldStepDisplay?: string, factoryStep?: MachineStartUpsMachineStartUpFactoryStepChoices, factoryStepDisplay?: string, created: string, expirationDate?: string, withPostFieldRevision: boolean, dealerStartUpPrice: number, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, seederBrand: { __typename?: 'SeederBrandType', id: string, name: string }, seederModel: { __typename?: 'SeederModelType', id: string, name: string }, organizationFactory?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }, organizationField?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }, oemOrganization?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }, productCategories: Array<{ __typename?: 'MachineStartUpProductCategoryType', id: string, name: string, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, engineQuantity: number, useInTotalPrice: boolean, payOnlyFieldReview: boolean }>, factoryAssistants: Array<{ __typename?: 'FactoryAssistantType', id: string, name: string, phone: string }>, customerAssistants: Array<{ __typename?: 'CustomerAssistantType', id: string, name: string, phone: string }>, createdBy?: { __typename?: 'UserType', id: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, canEditLockedEcnTasks: boolean, emailNotifications: boolean, inAppNotifications: boolean, organization?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }, role?: { __typename?: 'RoleType', id: string, name: string }, ecnRoles: Array<{ __typename?: 'EcnRoleType', id: string }>, permissions: { __typename?: 'UserPermissions', viewQuotes: boolean, viewSales: boolean, viewSupplyOrders: boolean, viewAccounts: boolean, viewContacts: boolean, viewOpportunities: boolean, viewWarrantyClaims: boolean, viewMachineStartUps: boolean, viewEcns: boolean, assignAccountOwner: boolean, requestSupplyOrderReview: boolean, submitSalesSupplyOrderReview: boolean, submitCreditsSupplyOrderReview: boolean, requestOemOrderReview: boolean, viewAnalytics: boolean, viewWarrantyClaimsAnalytics: boolean, manageShipments: boolean, manageQuotes: boolean, manageSales: boolean, manageSupplyOrders: boolean, manageWarrantyClaims: boolean, performTechnicalReview: boolean, manageMachineStartUps: boolean, manageOem: boolean, viewOemStock: boolean, manageEcns: boolean, manageAccounts: boolean, viewDatastudio: boolean, viewOems: boolean, viewSeeders: boolean, viewMaterialMaster: boolean, manageMaterialMaster: boolean, createMachineStartUps: boolean, viewOemOrderBankInvoices: boolean, viewStock: boolean, viewUnpublishedProducts: boolean, requestAccountRegistration: boolean, submitAccountRegistrationReview: boolean, receiveAccountRegistrationApprovedNotification: boolean } }, missingProducts: Array<{ __typename?: 'MissingProductType', id: string, name: string, externalId: string, price: number, quantity: number, description: string, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, machineStartUp: { __typename?: 'MachineStartUpType', id: string } }>, pemRule?: { __typename?: 'PemRuleType', id: string, name: string, subCategories: Array<{ __typename?: 'ProductSubcategoryType', name: string, id: string }>, fixed?: { __typename?: 'PemCalculationTypeFixedType', partialHours: number }, variable?: { __typename?: 'PemCalculationTypeVariableType', minutesPerRow: number }, visit?: { __typename?: 'PemCalculationTypeVisitType', name: string, partialHours: number } } } } };

export type PemFactoryReviewMutationVariables = Exact<{
  input: PemFactoryReviewMutationInput;
}>;


export type PemFactoryReviewMutation = { __typename?: 'Mutation', pemFactoryReview?: { __typename?: 'PemFactoryReviewMutationPayload', errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }>, machineStartUp?: { __typename?: 'MachineStartUpType', id: string, displayId: number, isFieldStepPending: boolean, seederYear: number, seederRowCount: number, seederSerialNumber?: string, productionDateFrom?: string, productionDateTo?: string, estimatedDeliveryDate?: string, installationPrice: number, startUpPrice?: number, totalPriceMachine: number, factoryPlaqueImage?: string, factoryProtocolImage?: string, factoryTermsImage?: string, fieldPlaqueImage?: string, fieldProtocolImage?: string, fieldTermsImage?: string, dealerFactoryInvoice?: string, dealerFieldInvoice?: string, dealerFactoryNotes?: string, factoryWorkflowNumber?: string, fieldWorkflowNumber?: string, dealerFieldNotes?: string, racks: boolean, step: MachineStartUpsMachineStartUpStepChoices, stepDisplay: string, fieldStep?: MachineStartUpsMachineStartUpFieldStepChoices, fieldStepDisplay?: string, factoryStep?: MachineStartUpsMachineStartUpFactoryStepChoices, factoryStepDisplay?: string, created: string, expirationDate?: string, withPostFieldRevision: boolean, dealerStartUpPrice: number, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, seederBrand: { __typename?: 'SeederBrandType', id: string, name: string }, seederModel: { __typename?: 'SeederModelType', id: string, name: string }, organizationFactory?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }, organizationField?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }, oemOrganization?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }, productCategories: Array<{ __typename?: 'MachineStartUpProductCategoryType', id: string, name: string, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, engineQuantity: number, useInTotalPrice: boolean, payOnlyFieldReview: boolean }>, factoryAssistants: Array<{ __typename?: 'FactoryAssistantType', id: string, name: string, phone: string }>, customerAssistants: Array<{ __typename?: 'CustomerAssistantType', id: string, name: string, phone: string }>, createdBy?: { __typename?: 'UserType', id: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, canEditLockedEcnTasks: boolean, emailNotifications: boolean, inAppNotifications: boolean, organization?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }, role?: { __typename?: 'RoleType', id: string, name: string }, ecnRoles: Array<{ __typename?: 'EcnRoleType', id: string }>, permissions: { __typename?: 'UserPermissions', viewQuotes: boolean, viewSales: boolean, viewSupplyOrders: boolean, viewAccounts: boolean, viewContacts: boolean, viewOpportunities: boolean, viewWarrantyClaims: boolean, viewMachineStartUps: boolean, viewEcns: boolean, assignAccountOwner: boolean, requestSupplyOrderReview: boolean, submitSalesSupplyOrderReview: boolean, submitCreditsSupplyOrderReview: boolean, requestOemOrderReview: boolean, viewAnalytics: boolean, viewWarrantyClaimsAnalytics: boolean, manageShipments: boolean, manageQuotes: boolean, manageSales: boolean, manageSupplyOrders: boolean, manageWarrantyClaims: boolean, performTechnicalReview: boolean, manageMachineStartUps: boolean, manageOem: boolean, viewOemStock: boolean, manageEcns: boolean, manageAccounts: boolean, viewDatastudio: boolean, viewOems: boolean, viewSeeders: boolean, viewMaterialMaster: boolean, manageMaterialMaster: boolean, createMachineStartUps: boolean, viewOemOrderBankInvoices: boolean, viewStock: boolean, viewUnpublishedProducts: boolean, requestAccountRegistration: boolean, submitAccountRegistrationReview: boolean, receiveAccountRegistrationApprovedNotification: boolean } }, missingProducts: Array<{ __typename?: 'MissingProductType', id: string, name: string, externalId: string, price: number, quantity: number, description: string, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, machineStartUp: { __typename?: 'MachineStartUpType', id: string } }>, pemRule?: { __typename?: 'PemRuleType', id: string, name: string, subCategories: Array<{ __typename?: 'ProductSubcategoryType', name: string, id: string }>, fixed?: { __typename?: 'PemCalculationTypeFixedType', partialHours: number }, variable?: { __typename?: 'PemCalculationTypeVariableType', minutesPerRow: number }, visit?: { __typename?: 'PemCalculationTypeVisitType', name: string, partialHours: number } } } } };

export type PemFieldReviewMutationVariables = Exact<{
  input: PemFieldReviewMutationInput;
}>;


export type PemFieldReviewMutation = { __typename?: 'Mutation', pemFieldReview?: { __typename?: 'PemFieldReviewMutationPayload', errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }>, machineStartUp?: { __typename?: 'MachineStartUpType', id: string, displayId: number, isFieldStepPending: boolean, seederYear: number, seederRowCount: number, seederSerialNumber?: string, productionDateFrom?: string, productionDateTo?: string, estimatedDeliveryDate?: string, installationPrice: number, startUpPrice?: number, totalPriceMachine: number, factoryPlaqueImage?: string, factoryProtocolImage?: string, factoryTermsImage?: string, fieldPlaqueImage?: string, fieldProtocolImage?: string, fieldTermsImage?: string, dealerFactoryInvoice?: string, dealerFieldInvoice?: string, dealerFactoryNotes?: string, factoryWorkflowNumber?: string, fieldWorkflowNumber?: string, dealerFieldNotes?: string, racks: boolean, step: MachineStartUpsMachineStartUpStepChoices, stepDisplay: string, fieldStep?: MachineStartUpsMachineStartUpFieldStepChoices, fieldStepDisplay?: string, factoryStep?: MachineStartUpsMachineStartUpFactoryStepChoices, factoryStepDisplay?: string, created: string, expirationDate?: string, withPostFieldRevision: boolean, dealerStartUpPrice: number, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, seederBrand: { __typename?: 'SeederBrandType', id: string, name: string }, seederModel: { __typename?: 'SeederModelType', id: string, name: string }, organizationFactory?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }, organizationField?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }, oemOrganization?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }, productCategories: Array<{ __typename?: 'MachineStartUpProductCategoryType', id: string, name: string, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, engineQuantity: number, useInTotalPrice: boolean, payOnlyFieldReview: boolean }>, factoryAssistants: Array<{ __typename?: 'FactoryAssistantType', id: string, name: string, phone: string }>, customerAssistants: Array<{ __typename?: 'CustomerAssistantType', id: string, name: string, phone: string }>, createdBy?: { __typename?: 'UserType', id: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, canEditLockedEcnTasks: boolean, emailNotifications: boolean, inAppNotifications: boolean, organization?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }, role?: { __typename?: 'RoleType', id: string, name: string }, ecnRoles: Array<{ __typename?: 'EcnRoleType', id: string }>, permissions: { __typename?: 'UserPermissions', viewQuotes: boolean, viewSales: boolean, viewSupplyOrders: boolean, viewAccounts: boolean, viewContacts: boolean, viewOpportunities: boolean, viewWarrantyClaims: boolean, viewMachineStartUps: boolean, viewEcns: boolean, assignAccountOwner: boolean, requestSupplyOrderReview: boolean, submitSalesSupplyOrderReview: boolean, submitCreditsSupplyOrderReview: boolean, requestOemOrderReview: boolean, viewAnalytics: boolean, viewWarrantyClaimsAnalytics: boolean, manageShipments: boolean, manageQuotes: boolean, manageSales: boolean, manageSupplyOrders: boolean, manageWarrantyClaims: boolean, performTechnicalReview: boolean, manageMachineStartUps: boolean, manageOem: boolean, viewOemStock: boolean, manageEcns: boolean, manageAccounts: boolean, viewDatastudio: boolean, viewOems: boolean, viewSeeders: boolean, viewMaterialMaster: boolean, manageMaterialMaster: boolean, createMachineStartUps: boolean, viewOemOrderBankInvoices: boolean, viewStock: boolean, viewUnpublishedProducts: boolean, requestAccountRegistration: boolean, submitAccountRegistrationReview: boolean, receiveAccountRegistrationApprovedNotification: boolean } }, missingProducts: Array<{ __typename?: 'MissingProductType', id: string, name: string, externalId: string, price: number, quantity: number, description: string, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, machineStartUp: { __typename?: 'MachineStartUpType', id: string } }>, pemRule?: { __typename?: 'PemRuleType', id: string, name: string, subCategories: Array<{ __typename?: 'ProductSubcategoryType', name: string, id: string }>, fixed?: { __typename?: 'PemCalculationTypeFixedType', partialHours: number }, variable?: { __typename?: 'PemCalculationTypeVariableType', minutesPerRow: number }, visit?: { __typename?: 'PemCalculationTypeVisitType', name: string, partialHours: number } } } } };

export type PemInspectionRevisionMutationVariables = Exact<{
  input: PemInspectionRevisionMutationInput;
}>;


export type PemInspectionRevisionMutation = { __typename?: 'Mutation', pemInspectionRevision?: { __typename?: 'PemInspectionRevisionMutationPayload', errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }>, machineStartUp?: { __typename?: 'MachineStartUpType', id: string, displayId: number, isFieldStepPending: boolean, seederYear: number, seederRowCount: number, seederSerialNumber?: string, productionDateFrom?: string, productionDateTo?: string, estimatedDeliveryDate?: string, installationPrice: number, startUpPrice?: number, totalPriceMachine: number, factoryPlaqueImage?: string, factoryProtocolImage?: string, factoryTermsImage?: string, fieldPlaqueImage?: string, fieldProtocolImage?: string, fieldTermsImage?: string, dealerFactoryInvoice?: string, dealerFieldInvoice?: string, dealerFactoryNotes?: string, factoryWorkflowNumber?: string, fieldWorkflowNumber?: string, dealerFieldNotes?: string, racks: boolean, step: MachineStartUpsMachineStartUpStepChoices, stepDisplay: string, fieldStep?: MachineStartUpsMachineStartUpFieldStepChoices, fieldStepDisplay?: string, factoryStep?: MachineStartUpsMachineStartUpFactoryStepChoices, factoryStepDisplay?: string, created: string, expirationDate?: string, withPostFieldRevision: boolean, dealerStartUpPrice: number, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, seederBrand: { __typename?: 'SeederBrandType', id: string, name: string }, seederModel: { __typename?: 'SeederModelType', id: string, name: string }, organizationFactory?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }, organizationField?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }, oemOrganization?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }, productCategories: Array<{ __typename?: 'MachineStartUpProductCategoryType', id: string, name: string, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, engineQuantity: number, useInTotalPrice: boolean, payOnlyFieldReview: boolean }>, factoryAssistants: Array<{ __typename?: 'FactoryAssistantType', id: string, name: string, phone: string }>, customerAssistants: Array<{ __typename?: 'CustomerAssistantType', id: string, name: string, phone: string }>, createdBy?: { __typename?: 'UserType', id: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, canEditLockedEcnTasks: boolean, emailNotifications: boolean, inAppNotifications: boolean, organization?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }, role?: { __typename?: 'RoleType', id: string, name: string }, ecnRoles: Array<{ __typename?: 'EcnRoleType', id: string }>, permissions: { __typename?: 'UserPermissions', viewQuotes: boolean, viewSales: boolean, viewSupplyOrders: boolean, viewAccounts: boolean, viewContacts: boolean, viewOpportunities: boolean, viewWarrantyClaims: boolean, viewMachineStartUps: boolean, viewEcns: boolean, assignAccountOwner: boolean, requestSupplyOrderReview: boolean, submitSalesSupplyOrderReview: boolean, submitCreditsSupplyOrderReview: boolean, requestOemOrderReview: boolean, viewAnalytics: boolean, viewWarrantyClaimsAnalytics: boolean, manageShipments: boolean, manageQuotes: boolean, manageSales: boolean, manageSupplyOrders: boolean, manageWarrantyClaims: boolean, performTechnicalReview: boolean, manageMachineStartUps: boolean, manageOem: boolean, viewOemStock: boolean, manageEcns: boolean, manageAccounts: boolean, viewDatastudio: boolean, viewOems: boolean, viewSeeders: boolean, viewMaterialMaster: boolean, manageMaterialMaster: boolean, createMachineStartUps: boolean, viewOemOrderBankInvoices: boolean, viewStock: boolean, viewUnpublishedProducts: boolean, requestAccountRegistration: boolean, submitAccountRegistrationReview: boolean, receiveAccountRegistrationApprovedNotification: boolean } }, missingProducts: Array<{ __typename?: 'MissingProductType', id: string, name: string, externalId: string, price: number, quantity: number, description: string, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, machineStartUp: { __typename?: 'MachineStartUpType', id: string } }>, pemRule?: { __typename?: 'PemRuleType', id: string, name: string, subCategories: Array<{ __typename?: 'ProductSubcategoryType', name: string, id: string }>, fixed?: { __typename?: 'PemCalculationTypeFixedType', partialHours: number }, variable?: { __typename?: 'PemCalculationTypeVariableType', minutesPerRow: number }, visit?: { __typename?: 'PemCalculationTypeVisitType', name: string, partialHours: number } } } } };

export type PemWorkflowMutationVariables = Exact<{
  input: PemWorkflowMutationInput;
}>;


export type PemWorkflowMutation = { __typename?: 'Mutation', pemWorkflow?: { __typename?: 'PemWorkflowMutationPayload', errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }>, machineStartUp?: { __typename?: 'MachineStartUpType', id: string, displayId: number, isFieldStepPending: boolean, seederYear: number, seederRowCount: number, seederSerialNumber?: string, productionDateFrom?: string, productionDateTo?: string, estimatedDeliveryDate?: string, installationPrice: number, startUpPrice?: number, totalPriceMachine: number, factoryPlaqueImage?: string, factoryProtocolImage?: string, factoryTermsImage?: string, fieldPlaqueImage?: string, fieldProtocolImage?: string, fieldTermsImage?: string, dealerFactoryInvoice?: string, dealerFieldInvoice?: string, dealerFactoryNotes?: string, factoryWorkflowNumber?: string, fieldWorkflowNumber?: string, dealerFieldNotes?: string, racks: boolean, step: MachineStartUpsMachineStartUpStepChoices, stepDisplay: string, fieldStep?: MachineStartUpsMachineStartUpFieldStepChoices, fieldStepDisplay?: string, factoryStep?: MachineStartUpsMachineStartUpFactoryStepChoices, factoryStepDisplay?: string, created: string, expirationDate?: string, withPostFieldRevision: boolean, dealerStartUpPrice: number, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, seederBrand: { __typename?: 'SeederBrandType', id: string, name: string }, seederModel: { __typename?: 'SeederModelType', id: string, name: string }, organizationFactory?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }, organizationField?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }, oemOrganization?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }, productCategories: Array<{ __typename?: 'MachineStartUpProductCategoryType', id: string, name: string, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, engineQuantity: number, useInTotalPrice: boolean, payOnlyFieldReview: boolean }>, factoryAssistants: Array<{ __typename?: 'FactoryAssistantType', id: string, name: string, phone: string }>, customerAssistants: Array<{ __typename?: 'CustomerAssistantType', id: string, name: string, phone: string }>, createdBy?: { __typename?: 'UserType', id: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, canEditLockedEcnTasks: boolean, emailNotifications: boolean, inAppNotifications: boolean, organization?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }, role?: { __typename?: 'RoleType', id: string, name: string }, ecnRoles: Array<{ __typename?: 'EcnRoleType', id: string }>, permissions: { __typename?: 'UserPermissions', viewQuotes: boolean, viewSales: boolean, viewSupplyOrders: boolean, viewAccounts: boolean, viewContacts: boolean, viewOpportunities: boolean, viewWarrantyClaims: boolean, viewMachineStartUps: boolean, viewEcns: boolean, assignAccountOwner: boolean, requestSupplyOrderReview: boolean, submitSalesSupplyOrderReview: boolean, submitCreditsSupplyOrderReview: boolean, requestOemOrderReview: boolean, viewAnalytics: boolean, viewWarrantyClaimsAnalytics: boolean, manageShipments: boolean, manageQuotes: boolean, manageSales: boolean, manageSupplyOrders: boolean, manageWarrantyClaims: boolean, performTechnicalReview: boolean, manageMachineStartUps: boolean, manageOem: boolean, viewOemStock: boolean, manageEcns: boolean, manageAccounts: boolean, viewDatastudio: boolean, viewOems: boolean, viewSeeders: boolean, viewMaterialMaster: boolean, manageMaterialMaster: boolean, createMachineStartUps: boolean, viewOemOrderBankInvoices: boolean, viewStock: boolean, viewUnpublishedProducts: boolean, requestAccountRegistration: boolean, submitAccountRegistrationReview: boolean, receiveAccountRegistrationApprovedNotification: boolean } }, missingProducts: Array<{ __typename?: 'MissingProductType', id: string, name: string, externalId: string, price: number, quantity: number, description: string, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, machineStartUp: { __typename?: 'MachineStartUpType', id: string } }>, pemRule?: { __typename?: 'PemRuleType', id: string, name: string, subCategories: Array<{ __typename?: 'ProductSubcategoryType', name: string, id: string }>, fixed?: { __typename?: 'PemCalculationTypeFixedType', partialHours: number }, variable?: { __typename?: 'PemCalculationTypeVariableType', minutesPerRow: number }, visit?: { __typename?: 'PemCalculationTypeVisitType', name: string, partialHours: number } } } } };

export type PemFactoryImagesMutationVariables = Exact<{
  input: PemFactoryImagesMutationInput;
}>;


export type PemFactoryImagesMutation = { __typename?: 'Mutation', pemFactoryImages?: { __typename?: 'PemFactoryImagesMutationPayload', errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }>, machineStartUp?: { __typename?: 'MachineStartUpType', id: string, displayId: number, isFieldStepPending: boolean, seederYear: number, seederRowCount: number, seederSerialNumber?: string, productionDateFrom?: string, productionDateTo?: string, estimatedDeliveryDate?: string, installationPrice: number, startUpPrice?: number, totalPriceMachine: number, factoryPlaqueImage?: string, factoryProtocolImage?: string, factoryTermsImage?: string, fieldPlaqueImage?: string, fieldProtocolImage?: string, fieldTermsImage?: string, dealerFactoryInvoice?: string, dealerFieldInvoice?: string, dealerFactoryNotes?: string, factoryWorkflowNumber?: string, fieldWorkflowNumber?: string, dealerFieldNotes?: string, racks: boolean, step: MachineStartUpsMachineStartUpStepChoices, stepDisplay: string, fieldStep?: MachineStartUpsMachineStartUpFieldStepChoices, fieldStepDisplay?: string, factoryStep?: MachineStartUpsMachineStartUpFactoryStepChoices, factoryStepDisplay?: string, created: string, expirationDate?: string, withPostFieldRevision: boolean, dealerStartUpPrice: number, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, seederBrand: { __typename?: 'SeederBrandType', id: string, name: string }, seederModel: { __typename?: 'SeederModelType', id: string, name: string }, organizationFactory?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }, organizationField?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }, oemOrganization?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }, productCategories: Array<{ __typename?: 'MachineStartUpProductCategoryType', id: string, name: string, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, engineQuantity: number, useInTotalPrice: boolean, payOnlyFieldReview: boolean }>, factoryAssistants: Array<{ __typename?: 'FactoryAssistantType', id: string, name: string, phone: string }>, customerAssistants: Array<{ __typename?: 'CustomerAssistantType', id: string, name: string, phone: string }>, createdBy?: { __typename?: 'UserType', id: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, canEditLockedEcnTasks: boolean, emailNotifications: boolean, inAppNotifications: boolean, organization?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }, role?: { __typename?: 'RoleType', id: string, name: string }, ecnRoles: Array<{ __typename?: 'EcnRoleType', id: string }>, permissions: { __typename?: 'UserPermissions', viewQuotes: boolean, viewSales: boolean, viewSupplyOrders: boolean, viewAccounts: boolean, viewContacts: boolean, viewOpportunities: boolean, viewWarrantyClaims: boolean, viewMachineStartUps: boolean, viewEcns: boolean, assignAccountOwner: boolean, requestSupplyOrderReview: boolean, submitSalesSupplyOrderReview: boolean, submitCreditsSupplyOrderReview: boolean, requestOemOrderReview: boolean, viewAnalytics: boolean, viewWarrantyClaimsAnalytics: boolean, manageShipments: boolean, manageQuotes: boolean, manageSales: boolean, manageSupplyOrders: boolean, manageWarrantyClaims: boolean, performTechnicalReview: boolean, manageMachineStartUps: boolean, manageOem: boolean, viewOemStock: boolean, manageEcns: boolean, manageAccounts: boolean, viewDatastudio: boolean, viewOems: boolean, viewSeeders: boolean, viewMaterialMaster: boolean, manageMaterialMaster: boolean, createMachineStartUps: boolean, viewOemOrderBankInvoices: boolean, viewStock: boolean, viewUnpublishedProducts: boolean, requestAccountRegistration: boolean, submitAccountRegistrationReview: boolean, receiveAccountRegistrationApprovedNotification: boolean } }, missingProducts: Array<{ __typename?: 'MissingProductType', id: string, name: string, externalId: string, price: number, quantity: number, description: string, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, machineStartUp: { __typename?: 'MachineStartUpType', id: string } }>, pemRule?: { __typename?: 'PemRuleType', id: string, name: string, subCategories: Array<{ __typename?: 'ProductSubcategoryType', name: string, id: string }>, fixed?: { __typename?: 'PemCalculationTypeFixedType', partialHours: number }, variable?: { __typename?: 'PemCalculationTypeVariableType', minutesPerRow: number }, visit?: { __typename?: 'PemCalculationTypeVisitType', name: string, partialHours: number } } } } };

export type PemFieldImagesMutationVariables = Exact<{
  input: PemFieldImagesMutationInput;
}>;


export type PemFieldImagesMutation = { __typename?: 'Mutation', pemFieldImages?: { __typename?: 'PemFieldImagesMutationPayload', errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }>, machineStartUp?: { __typename?: 'MachineStartUpType', id: string, displayId: number, isFieldStepPending: boolean, seederYear: number, seederRowCount: number, seederSerialNumber?: string, productionDateFrom?: string, productionDateTo?: string, estimatedDeliveryDate?: string, installationPrice: number, startUpPrice?: number, totalPriceMachine: number, factoryPlaqueImage?: string, factoryProtocolImage?: string, factoryTermsImage?: string, fieldPlaqueImage?: string, fieldProtocolImage?: string, fieldTermsImage?: string, dealerFactoryInvoice?: string, dealerFieldInvoice?: string, dealerFactoryNotes?: string, factoryWorkflowNumber?: string, fieldWorkflowNumber?: string, dealerFieldNotes?: string, racks: boolean, step: MachineStartUpsMachineStartUpStepChoices, stepDisplay: string, fieldStep?: MachineStartUpsMachineStartUpFieldStepChoices, fieldStepDisplay?: string, factoryStep?: MachineStartUpsMachineStartUpFactoryStepChoices, factoryStepDisplay?: string, created: string, expirationDate?: string, withPostFieldRevision: boolean, dealerStartUpPrice: number, contact: { __typename?: 'ContactType', id: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, name: string, taxId?: string, externalId: string, registrationCanReview: boolean, lastRegistrationReview?: { __typename?: 'AccountRegistrationReviewType', id: string, status: AccountsAccountRegistrationReviewStatusChoices, statusDisplay: string, notes: string, externalId: string, created: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }, location?: { __typename?: 'LocationType', id: string, path?: string }, region?: { __typename?: 'AccountRegionType', id: string, name: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } } } }, seederBrand: { __typename?: 'SeederBrandType', id: string, name: string }, seederModel: { __typename?: 'SeederModelType', id: string, name: string }, organizationFactory?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }, organizationField?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }, oemOrganization?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }, productCategories: Array<{ __typename?: 'MachineStartUpProductCategoryType', id: string, name: string, estimatedAmount: number, multiplyByEngine: boolean, multiplyBySeederRows: boolean, engineQuantity: number, useInTotalPrice: boolean, payOnlyFieldReview: boolean }>, factoryAssistants: Array<{ __typename?: 'FactoryAssistantType', id: string, name: string, phone: string }>, customerAssistants: Array<{ __typename?: 'CustomerAssistantType', id: string, name: string, phone: string }>, createdBy?: { __typename?: 'UserType', id: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, canEditLockedEcnTasks: boolean, emailNotifications: boolean, inAppNotifications: boolean, organization?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: number, isOem: boolean, factoryControlOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> } }, role?: { __typename?: 'RoleType', id: string, name: string }, ecnRoles: Array<{ __typename?: 'EcnRoleType', id: string }>, permissions: { __typename?: 'UserPermissions', viewQuotes: boolean, viewSales: boolean, viewSupplyOrders: boolean, viewAccounts: boolean, viewContacts: boolean, viewOpportunities: boolean, viewWarrantyClaims: boolean, viewMachineStartUps: boolean, viewEcns: boolean, assignAccountOwner: boolean, requestSupplyOrderReview: boolean, submitSalesSupplyOrderReview: boolean, submitCreditsSupplyOrderReview: boolean, requestOemOrderReview: boolean, viewAnalytics: boolean, viewWarrantyClaimsAnalytics: boolean, manageShipments: boolean, manageQuotes: boolean, manageSales: boolean, manageSupplyOrders: boolean, manageWarrantyClaims: boolean, performTechnicalReview: boolean, manageMachineStartUps: boolean, manageOem: boolean, viewOemStock: boolean, manageEcns: boolean, manageAccounts: boolean, viewDatastudio: boolean, viewOems: boolean, viewSeeders: boolean, viewMaterialMaster: boolean, manageMaterialMaster: boolean, createMachineStartUps: boolean, viewOemOrderBankInvoices: boolean, viewStock: boolean, viewUnpublishedProducts: boolean, requestAccountRegistration: boolean, submitAccountRegistrationReview: boolean, receiveAccountRegistrationApprovedNotification: boolean } }, missingProducts: Array<{ __typename?: 'MissingProductType', id: string, name: string, externalId: string, price: number, quantity: number, description: string, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string } }, machineStartUp: { __typename?: 'MachineStartUpType', id: string } }>, pemRule?: { __typename?: 'PemRuleType', id: string, name: string, subCategories: Array<{ __typename?: 'ProductSubcategoryType', name: string, id: string }>, fixed?: { __typename?: 'PemCalculationTypeFixedType', partialHours: number }, variable?: { __typename?: 'PemCalculationTypeVariableType', minutesPerRow: number }, visit?: { __typename?: 'PemCalculationTypeVisitType', name: string, partialHours: number } } } } };

export type CategoryYearlyForecastFragment = { __typename?: 'CategoryYearlyForecastType', id: string, year: number, value?: number, category: { __typename?: 'ProductCategoryType', id: string } };

export type ProductYearlyFactorFragment = { __typename?: 'ProductYearlyFactorType', id: string, year: number, value?: number };

export type MaterialMasterProductFragment = { __typename?: 'ProductType', id: string, ecnId?: string, externalId: string, name: string, created: string, effectiveDate?: string, mmStatus: ProductsProductMmStatusChoices, displayMmStatus: string, published: boolean, untilStockRunsOut: boolean, description: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string, yearlyForecast: Array<{ __typename?: 'CategoryYearlyForecastType', id: string, year: number, value?: number, category: { __typename?: 'ProductCategoryType', id: string } }> } }, origin?: { __typename?: 'ProductOriginType', id: string, name: string }, yearlyFactors: Array<{ __typename?: 'ProductYearlyFactorType', id: string, year: number, value?: number }> };

export type MaterialMasterProductDetailFragment = { __typename?: 'ProductType', order: number, price: number, rowCount: number, type: ProductsProductTypeChoices, image?: string, id: string, ecnId?: string, externalId: string, name: string, created: string, effectiveDate?: string, mmStatus: ProductsProductMmStatusChoices, displayMmStatus: string, published: boolean, untilStockRunsOut: boolean, description: string, organizationGroup?: { __typename?: 'OrganizationGroupType', id: string }, ruleGroup?: { __typename?: 'RuleGroupType', id: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', id: string }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string, yearlyForecast: Array<{ __typename?: 'CategoryYearlyForecastType', id: string, year: number, value?: number, category: { __typename?: 'ProductCategoryType', id: string } }> } }, origin?: { __typename?: 'ProductOriginType', id: string, name: string }, yearlyFactors: Array<{ __typename?: 'ProductYearlyFactorType', id: string, year: number, value?: number }> };

export type MaterialMasterProductsQueryVariables = Exact<{
  options?: InputMaybe<ProductListOptionsInputType>;
}>;


export type MaterialMasterProductsQuery = { __typename?: 'Query', materialMasterProducts?: { __typename?: 'ProductListType', count: number, items: Array<{ __typename?: 'ProductType', id: string, ecnId?: string, externalId: string, name: string, created: string, effectiveDate?: string, mmStatus: ProductsProductMmStatusChoices, displayMmStatus: string, published: boolean, untilStockRunsOut: boolean, description: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string, yearlyForecast: Array<{ __typename?: 'CategoryYearlyForecastType', id: string, year: number, value?: number, category: { __typename?: 'ProductCategoryType', id: string } }> } }, origin?: { __typename?: 'ProductOriginType', id: string, name: string }, yearlyFactors: Array<{ __typename?: 'ProductYearlyFactorType', id: string, year: number, value?: number }> }> } };

export type ProductYearlyFactorMutationVariables = Exact<{
  input: ProductYearlyFactorMutationInput;
}>;


export type ProductYearlyFactorMutation = { __typename?: 'Mutation', productYearlyFactor?: { __typename?: 'ProductYearlyFactorMutationPayload', productYearlyFactor?: { __typename?: 'ProductYearlyFactorType', id: string, year: number, value?: number }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type ProductCategoriesWithYearlyForecastQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductCategoriesWithYearlyForecastQuery = { __typename?: 'Query', productCategories: Array<{ __typename?: 'ProductCategoryType', id: string, name: string, yearlyForecast: Array<{ __typename?: 'CategoryYearlyForecastType', id: string, year: number, value?: number, category: { __typename?: 'ProductCategoryType', id: string } }> }> };

export type CategoriesYearlyForecastsMutationVariables = Exact<{
  inputs: Array<ListCategoryYearlyForecastFormInput>;
}>;


export type CategoriesYearlyForecastsMutation = { __typename?: 'Mutation', categoriesYearlyForecasts?: { __typename?: 'CategoriesYearlyForecasts', categoriesYearlyForecasts: Array<{ __typename?: 'CategoryYearlyForecastType', id: string, year: number, value?: number, category: { __typename?: 'ProductCategoryType', id: string } }>, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type GetMaterialMasterProductQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetMaterialMasterProductQuery = { __typename?: 'Query', product: { __typename?: 'ProductType', order: number, price: number, rowCount: number, type: ProductsProductTypeChoices, image?: string, id: string, ecnId?: string, externalId: string, name: string, created: string, effectiveDate?: string, mmStatus: ProductsProductMmStatusChoices, displayMmStatus: string, published: boolean, untilStockRunsOut: boolean, description: string, organizationGroup?: { __typename?: 'OrganizationGroupType', id: string }, ruleGroup?: { __typename?: 'RuleGroupType', id: string }, ruleCategories: Array<{ __typename?: 'ProductCategoryType', id: string }>, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', id: string, name: string, yearlyForecast: Array<{ __typename?: 'CategoryYearlyForecastType', id: string, year: number, value?: number, category: { __typename?: 'ProductCategoryType', id: string } }> } }, origin?: { __typename?: 'ProductOriginType', id: string, name: string }, yearlyFactors: Array<{ __typename?: 'ProductYearlyFactorType', id: string, year: number, value?: number }> } };

export type UpdateProductMutationVariables = Exact<{
  input: UpdateProductMutationInput;
}>;


export type UpdateProductMutation = { __typename?: 'Mutation', updateProduct?: { __typename?: 'UpdateProductMutationPayload', product?: { __typename?: 'ProductType', id: string }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type UpdateProductPublishedMutationVariables = Exact<{
  id: Scalars['UUID'];
  published: Scalars['Boolean'];
}>;


export type UpdateProductPublishedMutation = { __typename?: 'Mutation', updateProductPublishedMutation?: { __typename?: 'UpdateProductPublished', errors?: Array<string>, product?: { __typename?: 'ProductType', id: string, published: boolean } } };

export type UpdateProductUntilStockRunsOutMutationVariables = Exact<{
  id: Scalars['UUID'];
  untilStockRunsOut: Scalars['Boolean'];
}>;


export type UpdateProductUntilStockRunsOutMutation = { __typename?: 'Mutation', updateProductUntilStockRunsOutMutation?: { __typename?: 'UpdateProductUntilStockRunsOut', product?: { __typename?: 'ProductType', id: string } } };

export type GetOrganizationsGroupsQueryVariables = Exact<{
  options?: InputMaybe<OrganizationGroupListOptionsInputType>;
}>;


export type GetOrganizationsGroupsQuery = { __typename?: 'Query', organizationsGroups: { __typename?: 'OrganizationGroupListType', count: number, items: Array<{ __typename?: 'OrganizationGroupType', name: string, id: string }> } };

export type GetRulesGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRulesGroupsQuery = { __typename?: 'Query', rulesGroups: Array<{ __typename?: 'RuleGroupType', id: string, name: string }> };

export type MaterialMasterExportMutationVariables = Exact<{
  options?: InputMaybe<ProductListOptionsInputType>;
}>;


export type MaterialMasterExportMutation = { __typename?: 'Mutation', materialMasterExport?: { __typename?: 'MaterialMasterExport', job?: { __typename?: 'ExportJobType', id: string } } };

export type GetExternalIdsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetExternalIdsQuery = { __typename?: 'Query', externalIds?: Array<string> };

export type ProductCommentFragment = { __typename?: 'ProductCommentType', id: string, created: string, content: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, product: { __typename?: 'ProductType', id: string } };

export type GetProductCommentsQueryVariables = Exact<{
  options?: InputMaybe<ProductCommentListOptionsInputType>;
}>;


export type GetProductCommentsQuery = { __typename?: 'Query', productComments: { __typename?: 'ProductCommentListType', count: number, items: Array<{ __typename?: 'ProductCommentType', id: string, created: string, content: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, product: { __typename?: 'ProductType', id: string } }> } };

export type GetProductCommentsCountQueryVariables = Exact<{
  options?: InputMaybe<ProductCommentListOptionsInputType>;
}>;


export type GetProductCommentsCountQuery = { __typename?: 'Query', productComments: { __typename?: 'ProductCommentListType', count: number } };

export type CreateProductcommentMutationVariables = Exact<{
  input: ProductCommentMutationInput;
}>;


export type CreateProductcommentMutation = { __typename?: 'Mutation', createProductComment?: { __typename?: 'ProductCommentMutationPayload', productComment?: { __typename?: 'ProductCommentType', id: string, created: string, content: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, product: { __typename?: 'ProductType', id: string } }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type ImportProductFactorsMutationVariables = Exact<{
  inputs: Array<ImportProductFactorsMutationInput>;
}>;


export type ImportProductFactorsMutation = { __typename?: 'Mutation', importProductFactors?: { __typename?: 'ImportProductFactors', errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type DraftBlueprintEcnFragment = { __typename?: 'DraftBlueprintEcnType', id: string, file?: string };

export type DraftEcnFragment = { __typename?: 'DraftEcnType', id: string, step: number, data?: any, created: string, updated: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, updatedBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, blueprints: Array<{ __typename?: 'DraftBlueprintEcnType', id: string, file?: string }> };

export type DraftEcnListFragment = { __typename?: 'DraftEcnType', ecnNumberDuplicated?: boolean, id: string, step: number, data?: any, created: string, updated: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, updatedBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, blueprints: Array<{ __typename?: 'DraftBlueprintEcnType', id: string, file?: string }> };

export type DefaultEcnTaskFragment = { __typename?: 'DefaultTaskType', id: string, name: EcnsDefaultTaskNameChoices, displayName: string, description?: string, ecnTypes?: Array<EcnsDefaultTaskEcnTypesChoices>, roles: Array<{ __typename?: 'EcnRoleType', id: string, name: string }> };

export type EcnTaskFragment = { __typename?: 'EcnTaskType', id: string, notes: string, name: EcnsEcnTaskNameChoices, displayName: string, done: boolean, ecnTypes?: Array<EcnsEcnTaskEcnTypesChoices>, originalTask?: { __typename?: 'DefaultTaskType', id: string }, roles: Array<{ __typename?: 'EcnRoleType', id: string, name: string }>, doneBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } };

export type EcnNewPartFragment = { __typename?: 'EcnNewPartType', id: string, name: string, externalId: string, type: EcnsEcnNewPartTypeChoices, displayType: string, pricing?: number, yearlyForecast?: number, betaQuantity?: number, buyingDate?: string, estimatedDateArrival?: string, buyingPrice?: number, supplier?: string, description: string, supportNotes?: string, supportLink?: string, tariffPosition?: boolean, tariffPositionNotes?: string, partsArrived: boolean, targetDate?: string, zpQuantity?: number, zpCheck?: boolean, forecastUpdated?: string, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string }, origin?: { __typename?: 'ProductOriginType', id: string, name: string } };

export type EcnCancelledPartFragment = { __typename?: 'EcnCancelledPartType', id: string, replace: EcnsEcnCancelledPartReplaceChoices, displayReplace: string, currentVersion?: string, targetVersion?: string, description: string, pricing?: number, yearlyForecast?: number, betaQuantity?: number, buyingDate?: string, estimatedDateArrival?: string, buyingPrice?: number, supplier?: string, supportNotes?: string, supportLink?: string, tariffPosition?: boolean, tariffPositionNotes?: string, partsArrived: boolean, targetDate?: string, zpQuantity?: number, zpCheck?: boolean, forecastUpdated?: string, part: { __typename?: 'ProductType', type: ProductsProductTypeChoices, displayType: string, id: string, name: string, displayName: string, externalId: string, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', name: string, id: string } } }, origin?: { __typename?: 'ProductOriginType', id: string, name: string } };

export type EcnPartFragment = { __typename?: 'EcnPartType', id: string, externalId?: string, type: EcnsEcnPartTypeChoices, displayType: string, newParts: Array<{ __typename?: 'EcnNewPartType', id: string, name: string, externalId: string, type: EcnsEcnNewPartTypeChoices, displayType: string, pricing?: number, yearlyForecast?: number, betaQuantity?: number, buyingDate?: string, estimatedDateArrival?: string, buyingPrice?: number, supplier?: string, description: string, supportNotes?: string, supportLink?: string, tariffPosition?: boolean, tariffPositionNotes?: string, partsArrived: boolean, targetDate?: string, zpQuantity?: number, zpCheck?: boolean, forecastUpdated?: string, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string }, origin?: { __typename?: 'ProductOriginType', id: string, name: string } }>, cancelledParts: Array<{ __typename?: 'EcnCancelledPartType', id: string, replace: EcnsEcnCancelledPartReplaceChoices, displayReplace: string, currentVersion?: string, targetVersion?: string, description: string, pricing?: number, yearlyForecast?: number, betaQuantity?: number, buyingDate?: string, estimatedDateArrival?: string, buyingPrice?: number, supplier?: string, supportNotes?: string, supportLink?: string, tariffPosition?: boolean, tariffPositionNotes?: string, partsArrived: boolean, targetDate?: string, zpQuantity?: number, zpCheck?: boolean, forecastUpdated?: string, part: { __typename?: 'ProductType', type: ProductsProductTypeChoices, displayType: string, id: string, name: string, displayName: string, externalId: string, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', name: string, id: string } } }, origin?: { __typename?: 'ProductOriginType', id: string, name: string } }> };

export type EcnFragment = { __typename?: 'EcnType', id: string, created: string, effectiveDate?: string, previousEcnId?: string, nextEcnId?: string, updated: string, status?: EcnsEcnStatusChoices, displayStatus: string, displayId: number, ecnNumber: string, notes: string, recipient?: EcnsEcnRecipientChoices, displayRecipient: string, viewed?: boolean, isFavorite: boolean, warrantyPriority: boolean, seasonPriority: EcnsEcnSeasonPriorityChoices, displaySeasonPriority: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, realesedBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, updatedBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, oems: Array<{ __typename?: 'OrganizationType', id: string, name: string }>, fyi: Array<{ __typename?: 'RoleType', id: string, name: string }>, informedUsers: Array<{ __typename?: 'UserType', id: string, email: string }>, blueprints: Array<{ __typename?: 'EcnBlueprintType', id: string, file: string }>, tasks: Array<{ __typename?: 'EcnTaskType', id: string, notes: string, name: EcnsEcnTaskNameChoices, displayName: string, done: boolean, ecnTypes?: Array<EcnsEcnTaskEcnTypesChoices>, originalTask?: { __typename?: 'DefaultTaskType', id: string }, roles: Array<{ __typename?: 'EcnRoleType', id: string, name: string }>, doneBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, parts: Array<{ __typename?: 'EcnPartType', id: string, externalId?: string, type: EcnsEcnPartTypeChoices, displayType: string, newParts: Array<{ __typename?: 'EcnNewPartType', id: string, name: string, externalId: string, type: EcnsEcnNewPartTypeChoices, displayType: string, pricing?: number, yearlyForecast?: number, betaQuantity?: number, buyingDate?: string, estimatedDateArrival?: string, buyingPrice?: number, supplier?: string, description: string, supportNotes?: string, supportLink?: string, tariffPosition?: boolean, tariffPositionNotes?: string, partsArrived: boolean, targetDate?: string, zpQuantity?: number, zpCheck?: boolean, forecastUpdated?: string, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string }, origin?: { __typename?: 'ProductOriginType', id: string, name: string } }>, cancelledParts: Array<{ __typename?: 'EcnCancelledPartType', id: string, replace: EcnsEcnCancelledPartReplaceChoices, displayReplace: string, currentVersion?: string, targetVersion?: string, description: string, pricing?: number, yearlyForecast?: number, betaQuantity?: number, buyingDate?: string, estimatedDateArrival?: string, buyingPrice?: number, supplier?: string, supportNotes?: string, supportLink?: string, tariffPosition?: boolean, tariffPositionNotes?: string, partsArrived: boolean, targetDate?: string, zpQuantity?: number, zpCheck?: boolean, forecastUpdated?: string, part: { __typename?: 'ProductType', type: ProductsProductTypeChoices, displayType: string, id: string, name: string, displayName: string, externalId: string, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', name: string, id: string } } }, origin?: { __typename?: 'ProductOriginType', id: string, name: string } }> }>, files: Array<{ __typename?: 'EcnFileType', id: string, created: string, file: string }> };

export type EcnListFragment = { __typename?: 'EcnType', id: string, displayId: number, created: string, effectiveDate?: string, status?: EcnsEcnStatusChoices, displayStatus: string, totalInformedUsers?: number, totalNotInformedUsers?: number, ecnNumber: string, viewed?: boolean, isFavorite: boolean, warrantyPriority: boolean, seasonPriority: EcnsEcnSeasonPriorityChoices, displaySeasonPriority: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, realesedBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, parts: Array<{ __typename?: 'EcnPartType', id: string, type: EcnsEcnPartTypeChoices, displayType: string, newParts: Array<{ __typename?: 'EcnNewPartType', id: string, name: string, externalId: string, type: EcnsEcnNewPartTypeChoices, displayType: string, pricing?: number, yearlyForecast?: number, betaQuantity?: number, buyingDate?: string, estimatedDateArrival?: string, buyingPrice?: number, supplier?: string, description: string, supportNotes?: string, supportLink?: string, tariffPosition?: boolean, tariffPositionNotes?: string, partsArrived: boolean, targetDate?: string, zpQuantity?: number, zpCheck?: boolean, forecastUpdated?: string, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string }, origin?: { __typename?: 'ProductOriginType', id: string, name: string } }>, cancelledParts: Array<{ __typename?: 'EcnCancelledPartType', id: string, replace: EcnsEcnCancelledPartReplaceChoices, displayReplace: string, currentVersion?: string, targetVersion?: string, description: string, pricing?: number, yearlyForecast?: number, betaQuantity?: number, buyingDate?: string, estimatedDateArrival?: string, buyingPrice?: number, supplier?: string, supportNotes?: string, supportLink?: string, tariffPosition?: boolean, tariffPositionNotes?: string, partsArrived: boolean, targetDate?: string, zpQuantity?: number, zpCheck?: boolean, forecastUpdated?: string, part: { __typename?: 'ProductType', type: ProductsProductTypeChoices, displayType: string, id: string, name: string, displayName: string, externalId: string, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', name: string, id: string } } }, origin?: { __typename?: 'ProductOriginType', id: string, name: string } }> }>, fyi: Array<{ __typename?: 'RoleType', id: string, name: string }>, tasks: Array<{ __typename?: 'EcnTaskType', id: string, done: boolean, name: EcnsEcnTaskNameChoices, displayName: string, users: Array<{ __typename?: 'UserType', id: string, displayName: string, email: string }> }> };

export type GetEcnsNumbersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEcnsNumbersQuery = { __typename?: 'Query', ecns: { __typename?: 'EcnListType2', items: Array<{ __typename?: 'EcnType', ecnNumber: string }> } };

export type GetEcnQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetEcnQuery = { __typename?: 'Query', ecn: { __typename?: 'EcnType', id: string, created: string, effectiveDate?: string, previousEcnId?: string, nextEcnId?: string, updated: string, status?: EcnsEcnStatusChoices, displayStatus: string, displayId: number, ecnNumber: string, notes: string, recipient?: EcnsEcnRecipientChoices, displayRecipient: string, viewed?: boolean, isFavorite: boolean, warrantyPriority: boolean, seasonPriority: EcnsEcnSeasonPriorityChoices, displaySeasonPriority: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, realesedBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, updatedBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, oems: Array<{ __typename?: 'OrganizationType', id: string, name: string }>, fyi: Array<{ __typename?: 'RoleType', id: string, name: string }>, informedUsers: Array<{ __typename?: 'UserType', id: string, email: string }>, blueprints: Array<{ __typename?: 'EcnBlueprintType', id: string, file: string }>, tasks: Array<{ __typename?: 'EcnTaskType', id: string, notes: string, name: EcnsEcnTaskNameChoices, displayName: string, done: boolean, ecnTypes?: Array<EcnsEcnTaskEcnTypesChoices>, originalTask?: { __typename?: 'DefaultTaskType', id: string }, roles: Array<{ __typename?: 'EcnRoleType', id: string, name: string }>, doneBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }>, parts: Array<{ __typename?: 'EcnPartType', id: string, externalId?: string, type: EcnsEcnPartTypeChoices, displayType: string, newParts: Array<{ __typename?: 'EcnNewPartType', id: string, name: string, externalId: string, type: EcnsEcnNewPartTypeChoices, displayType: string, pricing?: number, yearlyForecast?: number, betaQuantity?: number, buyingDate?: string, estimatedDateArrival?: string, buyingPrice?: number, supplier?: string, description: string, supportNotes?: string, supportLink?: string, tariffPosition?: boolean, tariffPositionNotes?: string, partsArrived: boolean, targetDate?: string, zpQuantity?: number, zpCheck?: boolean, forecastUpdated?: string, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string }, origin?: { __typename?: 'ProductOriginType', id: string, name: string } }>, cancelledParts: Array<{ __typename?: 'EcnCancelledPartType', id: string, replace: EcnsEcnCancelledPartReplaceChoices, displayReplace: string, currentVersion?: string, targetVersion?: string, description: string, pricing?: number, yearlyForecast?: number, betaQuantity?: number, buyingDate?: string, estimatedDateArrival?: string, buyingPrice?: number, supplier?: string, supportNotes?: string, supportLink?: string, tariffPosition?: boolean, tariffPositionNotes?: string, partsArrived: boolean, targetDate?: string, zpQuantity?: number, zpCheck?: boolean, forecastUpdated?: string, part: { __typename?: 'ProductType', type: ProductsProductTypeChoices, displayType: string, id: string, name: string, displayName: string, externalId: string, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', name: string, id: string } } }, origin?: { __typename?: 'ProductOriginType', id: string, name: string } }> }>, files: Array<{ __typename?: 'EcnFileType', id: string, created: string, file: string }> } };

export type GetDefaultTaskQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type GetDefaultTaskQuery = { __typename?: 'Query', defaultTask: { __typename?: 'DefaultTaskType', id: string, name: EcnsDefaultTaskNameChoices, displayName: string, description?: string, ecnTypes?: Array<EcnsDefaultTaskEcnTypesChoices>, roles: Array<{ __typename?: 'EcnRoleType', id: string, name: string }> } };

export type GetDefaultTasksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDefaultTasksQuery = { __typename?: 'Query', defaultTasks: Array<{ __typename?: 'DefaultTaskType', id: string, name: EcnsDefaultTaskNameChoices, displayName: string, description?: string, ecnTypes?: Array<EcnsDefaultTaskEcnTypesChoices>, roles: Array<{ __typename?: 'EcnRoleType', id: string, name: string }> }> };

export type GetRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRolesQuery = { __typename?: 'Query', roles: Array<{ __typename?: 'RoleType', id: string, name: string, userSet: Array<{ __typename?: 'UserType', id: string, displayName: string }> }> };

export type GetCurrentEcnNumberQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentEcnNumberQuery = { __typename?: 'Query', getCurrentEcnNumber: string };

export type GetDraftEcnQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetDraftEcnQuery = { __typename?: 'Query', draftEcn: { __typename?: 'DraftEcnType', id: string, step: number, data?: any, created: string, updated: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, updatedBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, blueprints: Array<{ __typename?: 'DraftBlueprintEcnType', id: string, file?: string }> } };

export type GetProductOriginsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProductOriginsQuery = { __typename?: 'Query', productOrigins: Array<{ __typename?: 'ProductOriginType', id: string, name: string }> };

export type GetDraftsEcnsQueryVariables = Exact<{
  options?: InputMaybe<DraftEcnListOptionsInputType>;
}>;


export type GetDraftsEcnsQuery = { __typename?: 'Query', draftsEcns: { __typename?: 'DraftEcnListType', count: number, page: number, items: Array<{ __typename?: 'DraftEcnType', ecnNumberDuplicated?: boolean, id: string, step: number, data?: any, created: string, updated: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, updatedBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, blueprints: Array<{ __typename?: 'DraftBlueprintEcnType', id: string, file?: string }> }> } };

export type GetPartsNumbersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPartsNumbersQuery = { __typename?: 'Query', partsNumbers: Array<{ __typename?: 'PartNumberType', displayName: string, externalId: string }> };

export type CreateEcnMutationVariables = Exact<{
  input: CreateEcnMutationInput;
}>;


export type CreateEcnMutation = { __typename?: 'Mutation', createEcn?: { __typename?: 'CreateEcnMutationPayload', ecn?: { __typename?: 'EcnType', id: string }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type UpdateEcnMutationVariables = Exact<{
  input: UpdateEcnMutationInput;
}>;


export type UpdateEcnMutation = { __typename?: 'Mutation', updateEcn?: { __typename?: 'UpdateEcnMutationPayload', ecn?: { __typename?: 'EcnType', id: string }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type EcnPricingTaskMutationVariables = Exact<{
  input: PricingTaskMutationInput;
}>;


export type EcnPricingTaskMutation = { __typename?: 'Mutation', ecnPricingTask?: { __typename?: 'PricingTaskMutationPayload', ecn?: { __typename?: 'EcnType', id: string }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type EcnForecastTaskMutationVariables = Exact<{
  input: ForecastTaskMutationInput;
}>;


export type EcnForecastTaskMutation = { __typename?: 'Mutation', ecnForecastTask?: { __typename?: 'ForecastTaskMutationPayload', ecn?: { __typename?: 'EcnType', id: string }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type NewModCancelledPartsPurchaseTaskMutationVariables = Exact<{
  input: NewModCancelledPartsPurchaseTaskMutationInput;
}>;


export type NewModCancelledPartsPurchaseTaskMutation = { __typename?: 'Mutation', newModCancelledPartsPurchaseTask?: { __typename?: 'NewModCancelledPartsPurchaseTaskMutationPayload', ecn?: { __typename?: 'EcnType', id: string }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type NewModCancelPartsTaskMutationVariables = Exact<{
  input: NewModCancelPartsTaskMutationInput;
}>;


export type NewModCancelPartsTaskMutation = { __typename?: 'Mutation', newModCancelPartsTask?: { __typename?: 'NewModCancelPartsTaskMutationPayload', ecn?: { __typename?: 'EcnType', id: string }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type ProductSupportTaskMutationVariables = Exact<{
  input: ProductSupportTaskMutationInput;
}>;


export type ProductSupportTaskMutation = { __typename?: 'Mutation', productSupportTask?: { __typename?: 'ProductSupportTaskMutationPayload', ecn?: { __typename?: 'EcnType', id: string }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type EcnMarkAsSeenMutationVariables = Exact<{
  input: EcnMarkAsSeenMutationInput;
}>;


export type EcnMarkAsSeenMutation = { __typename?: 'Mutation', ecnMarkAsSeen?: { __typename?: 'EcnMarkAsSeenMutationPayload', ecn?: { __typename?: 'EcnType', id: string }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type DraftEcnMutationVariables = Exact<{
  input: DraftEcnMutationInput;
}>;


export type DraftEcnMutation = { __typename?: 'Mutation', draftEcn?: { __typename?: 'DraftEcnMutationPayload', draftEcn?: { __typename?: 'DraftEcnType', id: string, data?: any, blueprints: Array<{ __typename?: 'DraftBlueprintEcnType', id: string, file?: string }> }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type DeleteDraftEcnMutationVariables = Exact<{
  input: DeleteDraftEcnMutationInput;
}>;


export type DeleteDraftEcnMutation = { __typename?: 'Mutation', deleteDraftEcn?: { __typename?: 'DeleteDraftEcnMutationPayload', errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type NotificateTasksForUserMutationVariables = Exact<{
  input: NotificateTasksForUserInput;
}>;


export type NotificateTasksForUserMutation = { __typename?: 'Mutation', notificateTasksForUser?: { __typename?: 'NotificateTasksForUserPayload', errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type UpdateEffectiveDateMutationVariables = Exact<{
  id: Scalars['UUID'];
  effectiveDate: Scalars['Date'];
}>;


export type UpdateEffectiveDateMutation = { __typename?: 'Mutation', updateEffectiveDate?: { __typename?: 'UpdateEcnEffectiveDateMutation', ecn?: { __typename?: 'EcnType', id: string } } };

export type HistoricalEcnFragment = { __typename?: 'HistoricalEcnType', created: string, updated: string, id: string, status: string, displayId: number, ecnNumber: string, notes: string, recipient: string, warrantyPriority: boolean, seasonPriority: string, effectiveDate?: string, historyId: string, historyDate: string, historyChangeReason?: string, historyTypeDisplay: string };

export type EcnTaskCommentFragment = { __typename?: 'EcnTaskCommentType', id: string, created: string, content: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, task: { __typename?: 'EcnTaskType', id: string } };

export type GetEcnTaskCommentsQueryVariables = Exact<{
  options?: InputMaybe<EcnTaskCommentListOptionsInputType>;
}>;


export type GetEcnTaskCommentsQuery = { __typename?: 'Query', taskComments: { __typename?: 'EcnTaskCommentListType', count: number, items: Array<{ __typename?: 'EcnTaskCommentType', id: string, created: string, content: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, task: { __typename?: 'EcnTaskType', id: string } }> } };

export type EcnTaskCommentMutationVariables = Exact<{
  input: EcnTaskCommentMutationInput;
}>;


export type EcnTaskCommentMutation = { __typename?: 'Mutation', ecnTaskComment?: { __typename?: 'EcnTaskCommentMutationPayload', ecnTaskComment?: { __typename?: 'EcnTaskCommentType', id: string, created: string, content: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, task: { __typename?: 'EcnTaskType', id: string } }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type PartsArrivalTaskMutationVariables = Exact<{
  input: PartsArrivalTaskMutationInput;
}>;


export type PartsArrivalTaskMutation = { __typename?: 'Mutation', partsArrivalTask?: { __typename?: 'PartsArrivalTaskMutationPayload', ecn?: { __typename?: 'EcnType', id: string }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type EcnFilesMutationVariables = Exact<{
  ecnId: Scalars['UUID'];
  files: Array<Scalars['Upload']>;
}>;


export type EcnFilesMutation = { __typename?: 'Mutation', ecnFiles?: { __typename?: 'EcnFiles', ecnFiles: Array<{ __typename?: 'EcnFileType', id: string, file: string }>, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type DeleteEcnFileMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteEcnFileMutation = { __typename?: 'Mutation', deleteEcnFile?: { __typename?: 'DeleteEcnFile', ok?: boolean, id: string } };

export type EcnAnalyticsQueryVariables = Exact<{
  filters: AnalyticsFilters;
}>;


export type EcnAnalyticsQuery = { __typename?: 'Query', ecnAnalytics?: { __typename?: 'EcnAnalyticsType', byStatus?: Array<{ __typename?: 'ByStatusDatum', label: string, count: number }>, accumulatedInProgressByEcn?: Array<{ __typename?: 'ByStatusDatum', label: string, count: number }>, accumulatedWithoutEffectiveDateByEcn?: Array<{ __typename?: 'ByStatusDatum', label: string, count: number }>, byEffectiveDate?: Array<{ __typename?: 'ByStatusDatum', label: string, count: number }>, byWarrantyPriorityInProgress?: Array<{ __typename?: 'ByStatusDatum', label: string, count: number }>, byWarrantyPriority?: Array<{ __typename?: 'ByStatusDatum', label: string, count: number }>, byEffectiveDateAndSeasonPriority?: Array<{ __typename?: 'PriotityDatum', label: string, lowCount: number, mediumCount: number, highCount: number }>, byPartType?: Array<{ __typename?: 'ByStatusDatum', label: string, count: number }>, accumulatedInProgress?: { __typename?: 'KpiDatum', min: number, max: number, avg: number }, accumulatedWithoutEffectiveDate?: { __typename?: 'KpiDatum', min: number, max: number, avg: number }, bySeasonPriority?: Array<{ __typename?: 'ByStatusDatum', label: string, count: number }> } };

export type CancelEcnMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type CancelEcnMutation = { __typename?: 'Mutation', cancelEcn?: { __typename?: 'CancelEcn', ok?: boolean } };

export type SetEcnFavoriteMutationVariables = Exact<{
  id: Scalars['UUID'];
  favorite: Scalars['Boolean'];
}>;


export type SetEcnFavoriteMutation = { __typename?: 'Mutation', setEcnFavorite?: { __typename?: 'SetEcnFavorite', ok?: boolean } };

export type MakeEcnEffectiveMutationVariables = Exact<{
  input: MakeEcnEffectiveMutationInput;
}>;


export type MakeEcnEffectiveMutation = { __typename?: 'Mutation', makeEcnEffective?: { __typename?: 'MakeEcnEffectiveMutationPayload', ecn?: { __typename?: 'EcnType', id: string }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type CreateEcnListExportMutationVariables = Exact<{
  filters?: InputMaybe<EcnListType2OptionsInputType2>;
}>;


export type CreateEcnListExportMutation = { __typename?: 'Mutation', createEcnListExport?: { __typename?: 'CreateEcnListExport', job: { __typename?: 'ExportJobType', id: string } } };

export type ValidExternalIdQueryVariables = Exact<{
  externalId: Scalars['String'];
  ignoreId?: InputMaybe<Scalars['UUID']>;
}>;


export type ValidExternalIdQuery = { __typename?: 'Query', validExternalId: boolean };

export type EcnHistoryQueryVariables = Exact<{
  id: Scalars['UUID'];
  options?: InputMaybe<HistoricalEcnListOptionsInputType>;
}>;


export type EcnHistoryQuery = { __typename?: 'Query', ecnHistory: { __typename?: 'HistoricalEcnListType', count: number, items: Array<{ __typename?: 'HistoricalEcnType', created: string, updated: string, id: string, status: string, displayId: number, ecnNumber: string, notes: string, recipient: string, warrantyPriority: boolean, seasonPriority: string, effectiveDate?: string, historyId: string, historyDate: string, historyChangeReason?: string, historyTypeDisplay: string }> } };

export type EcnHistoryDiffQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type EcnHistoryDiffQuery = { __typename?: 'Query', ecnHistoryDiff: Array<{ __typename?: 'ModelDeltaType', changedFields?: Array<string>, date: string, changes?: Array<{ __typename?: 'ModelChangeType', field: string, old?: string | number | undefined, new?: string | number | undefined, verboseField: string }>, updatedBy?: { __typename?: 'UserType', id: string, displayName: string, email: string } }> };

export type GetEcnsQueryVariables = Exact<{
  options?: InputMaybe<EcnListType2OptionsInputType2>;
}>;


export type GetEcnsQuery = { __typename?: 'Query', ecns: { __typename?: 'EcnListType2', count: number, page: number, items: Array<{ __typename?: 'EcnType', id: string, displayId: number, created: string, effectiveDate?: string, status?: EcnsEcnStatusChoices, displayStatus: string, totalInformedUsers?: number, totalNotInformedUsers?: number, ecnNumber: string, viewed?: boolean, isFavorite: boolean, warrantyPriority: boolean, seasonPriority: EcnsEcnSeasonPriorityChoices, displaySeasonPriority: string, createdBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, realesedBy?: { __typename?: 'UserType', id: string, displayName: string, email: string }, parts: Array<{ __typename?: 'EcnPartType', id: string, type: EcnsEcnPartTypeChoices, displayType: string, newParts: Array<{ __typename?: 'EcnNewPartType', id: string, name: string, externalId: string, type: EcnsEcnNewPartTypeChoices, displayType: string, pricing?: number, yearlyForecast?: number, betaQuantity?: number, buyingDate?: string, estimatedDateArrival?: string, buyingPrice?: number, supplier?: string, description: string, supportNotes?: string, supportLink?: string, tariffPosition?: boolean, tariffPositionNotes?: string, partsArrived: boolean, targetDate?: string, zpQuantity?: number, zpCheck?: boolean, forecastUpdated?: string, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string }, origin?: { __typename?: 'ProductOriginType', id: string, name: string } }>, cancelledParts: Array<{ __typename?: 'EcnCancelledPartType', id: string, replace: EcnsEcnCancelledPartReplaceChoices, displayReplace: string, currentVersion?: string, targetVersion?: string, description: string, pricing?: number, yearlyForecast?: number, betaQuantity?: number, buyingDate?: string, estimatedDateArrival?: string, buyingPrice?: number, supplier?: string, supportNotes?: string, supportLink?: string, tariffPosition?: boolean, tariffPositionNotes?: string, partsArrived: boolean, targetDate?: string, zpQuantity?: number, zpCheck?: boolean, forecastUpdated?: string, part: { __typename?: 'ProductType', type: ProductsProductTypeChoices, displayType: string, id: string, name: string, displayName: string, externalId: string, subcategory: { __typename?: 'ProductSubcategoryType', id: string, name: string, category: { __typename?: 'ProductCategoryType', name: string, id: string } } }, origin?: { __typename?: 'ProductOriginType', id: string, name: string } }> }>, fyi: Array<{ __typename?: 'RoleType', id: string, name: string }>, tasks: Array<{ __typename?: 'EcnTaskType', id: string, done: boolean, name: EcnsEcnTaskNameChoices, displayName: string, users: Array<{ __typename?: 'UserType', id: string, displayName: string, email: string }> }> }> } };

export const QuotesAnalyticsFragmentDoc = gql`
    fragment QuotesAnalytics on QuotesAnalyticsType {
  count
  amount
  bySeederBrand {
    label
    count
    percentage
    amount
  }
  bySeederModel {
    label
    count
    percentage
    amount
  }
  byPaymentMethod {
    label
    count
    percentage
    amount
    multiplier
  }
  byDate {
    date
    count
    amount
  }
  byBillingType {
    label
    count
    percentage
    amount
  }
  productRanking {
    product {
      name
      subcategory {
        name
        category {
          name
        }
      }
    }
    count
    ranking
  }
  byStatus {
    label
    count
    amount
  }
}
    `;
export const SalesPotentialAnalyticsFragmentDoc = gql`
    fragment SalesPotentialAnalytics on SalesPotentialAnalyticsType {
  rowsCount
  seedersCount
  bySeederBrand {
    label
    count
    percentage
  }
  byMeterType {
    label
    count
    percentage
  }
  byProductCategory {
    label
    count
    percentage
  }
}
    `;
export const SalesAnalyticsFragmentDoc = gql`
    fragment SalesAnalytics on SalesAnalyticsType {
  count
  amount
  byDate {
    date
    count
    amount
  }
  productRanking {
    product {
      name
      subcategory {
        name
        category {
          name
        }
      }
    }
    count
    ranking
  }
  byPaymentMethod {
    label
    count
    percentage
    amount
    multiplier
  }
  bySeederBrand {
    label
    count
    percentage
    amount
  }
  bySeederModel {
    label
    count
    percentage
    amount
  }
  byBillingType {
    label
    count
    percentage
    amount
  }
}
    `;
export const AmountDatumFragmentDoc = gql`
    fragment AmountDatum on AmountDatum {
  label
  count
  amount
  percentage
  multiplier
}
    `;
export const DateSeriesDatumFragmentDoc = gql`
    fragment DateSeriesDatum on DateSeriesDatum {
  date
  count
  amount
}
    `;
export const ProductRankingDatumFragmentDoc = gql`
    fragment ProductRankingDatum on ProductRankingDatum {
  product {
    name
    subcategory {
      name
      category {
        name
      }
    }
  }
  count
  amount
  ranking
}
    `;
export const SupplyOrdersAnalyticsFragmentDoc = gql`
    fragment SupplyOrdersAnalytics on SupplyOrdersAnalyticsType {
  count
  amount
  byStatus {
    ...AmountDatum
  }
  byDate {
    ...DateSeriesDatum
  }
  rankingByProduct {
    ...ProductRankingDatum
  }
  bySeederBrand {
    ...AmountDatum
  }
  bySeederModel {
    ...AmountDatum
  }
  byOrganization {
    ...AmountDatum
  }
  byPaymentMethod {
    ...AmountDatum
  }
}
    ${AmountDatumFragmentDoc}
${DateSeriesDatumFragmentDoc}
${ProductRankingDatumFragmentDoc}`;
export const GefcoShipmentHistogramFragmentDoc = gql`
    fragment GefcoShipmentHistogram on GefcoHistogramDatum {
  daysSinceShipmentUntilOrderReceipt
  daysSinceShipmentUntilPreparation
  daysSinceShipmentUntilRouting
  daysSinceShipmentUntilDispatch
  daysSinceShipmentUntilInterbaseDelivery
  daysSinceShipmentUntilPartialDelivery
  daysSinceShipmentUntilDelivered
  daysSinceShipmentUntilReturnedRejected
  daysSinceShipmentUntilRenderedToClient
}
    `;
export const GefcoSupplyOrderHistogramFragmentDoc = gql`
    fragment GefcoSupplyOrderHistogram on GefcoHistogramDatum {
  daysSinceSupplyOrderUntilOrderReceipt
  daysSinceSupplyOrderUntilPreparation
  daysSinceSupplyOrderUntilRouting
  daysSinceSupplyOrderUntilDispatch
  daysSinceSupplyOrderUntilInterbaseDelivery
  daysSinceSupplyOrderUntilPartialDelivery
  daysSinceSupplyOrderUntilDelivered
  daysSinceSupplyOrderUntilReturnedRejected
  daysSinceSupplyOrderUntilRenderedToClient
}
    `;
export const WarrantyClaimStatusHistogramDatumFragmentDoc = gql`
    fragment WarrantyClaimStatusHistogramDatum on WarrantyClaimStatusHistogramDatum {
  daysInPendingUntilApproved
  daysInApprovedUntilSent
  daysInPendingUntilRejected
  daysUntilReceived
  daysUntilInspected
  daysUntilSent
}
    `;
export const WarrantyClaimsAnalyticsFragmentDoc = gql`
    fragment warrantyClaimsAnalytics on WarrantyClaimsAnalyticsType {
  count
  byDate {
    date
    count
  }
  productRanking {
    product {
      name
      subcategory {
        name
        category {
          name
        }
      }
    }
    count
    ranking
    amount
  }
  approvedCount
  pendingCount
  cancelledCount
  rejectedCount
  sentCount
  byInspectionStatus {
    label
    count
    percentage
  }
  statusHistogram {
    ...WarrantyClaimStatusHistogramDatum
  }
}
    ${WarrantyClaimStatusHistogramDatumFragmentDoc}`;
export const ErrorFragmentDoc = gql`
    fragment Error on ErrorType {
  field
  messages
}
    `;
export const MinimalUserFragmentDoc = gql`
    fragment MinimalUser on UserType {
  id
  displayName
  email
}
    `;
export const AccountRegistrationReviewFragmentDoc = gql`
    fragment AccountRegistrationReview on AccountRegistrationReviewType {
  id
  status
  statusDisplay
  notes
  externalId
  created
  createdBy {
    ...MinimalUser
  }
}
    ${MinimalUserFragmentDoc}`;
export const LocationOptionFragmentDoc = gql`
    fragment LocationOption on LocationType {
  id
  path
}
    `;
export const AccountRegionOptionFragmentDoc = gql`
    fragment AccountRegionOption on AccountRegionType {
  id
  name
}
    `;
export const OrganizationGroupFragmentDoc = gql`
    fragment OrganizationGroup on OrganizationGroupType {
  id
  dealerCommission
  isOem
  factoryControlOrganizations {
    id
    name
  }
}
    `;
export const OrganizationFragmentDoc = gql`
    fragment Organization on OrganizationType {
  id
  name
  externalId
  group {
    ...OrganizationGroup
  }
}
    ${OrganizationGroupFragmentDoc}`;
export const AccountFragmentDoc = gql`
    fragment Account on AccountType {
  id
  name
  taxId
  externalId
  registrationCanReview
  lastRegistrationReview {
    ...AccountRegistrationReview
  }
  location {
    ...LocationOption
  }
  region {
    ...AccountRegionOption
  }
  owner {
    ...Organization
  }
}
    ${AccountRegistrationReviewFragmentDoc}
${LocationOptionFragmentDoc}
${AccountRegionOptionFragmentDoc}
${OrganizationFragmentDoc}`;
export const SeederModelFragmentDoc = gql`
    fragment SeederModel on SeederModelType {
  id
  name
}
    `;
export const ProductCategoryOptionFragmentDoc = gql`
    fragment ProductCategoryOption on ProductCategoryType {
  id
  name
}
    `;
export const SeederBrandFragmentDoc = gql`
    fragment SeederBrand on SeederBrandType {
  id
  name
}
    `;
export const AccountOptionFragmentDoc = gql`
    fragment AccountOption on AccountType {
  id
  name
  externalId
  location {
    id
  }
}
    `;
export const SeederFragmentDoc = gql`
    fragment Seeder on SeederType {
  id
  year
  rowCount
  displayName
  model {
    ...SeederModel
  }
  meterType
  meterTypeDisplay
  installedProductCategories {
    ...ProductCategoryOption
  }
  brand {
    ...SeederBrand
  }
  account {
    ...AccountOption
  }
}
    ${SeederModelFragmentDoc}
${ProductCategoryOptionFragmentDoc}
${SeederBrandFragmentDoc}
${AccountOptionFragmentDoc}`;
export const AccountDetailFragmentDoc = gql`
    fragment AccountDetail on AccountType {
  ...Account
  location {
    ...LocationOption
  }
  extraLocation
  files {
    id
    file
  }
  registrationReviews {
    ...AccountRegistrationReview
  }
  created
  createdBy {
    ...MinimalUser
  }
  updated
  updatedBy {
    ...MinimalUser
  }
  seeders {
    ...Seeder
  }
}
    ${AccountFragmentDoc}
${LocationOptionFragmentDoc}
${AccountRegistrationReviewFragmentDoc}
${MinimalUserFragmentDoc}
${SeederFragmentDoc}`;
export const ContactTypeOptionFragmentDoc = gql`
    fragment ContactTypeOption on ContactTypeType {
  id
  name
}
    `;
export const ContactFragmentDoc = gql`
    fragment Contact on ContactType {
  id
  externalId
  email
  firstName
  lastName
  displayName
  phone
  mobilePhone
  type {
    ...ContactTypeOption
  }
  account {
    ...Account
  }
}
    ${ContactTypeOptionFragmentDoc}
${AccountFragmentDoc}`;
export const ContactDetailFragmentDoc = gql`
    fragment ContactDetail on ContactType {
  ...Contact
  created
  createdBy {
    ...MinimalUser
  }
  updated
  updatedBy {
    ...MinimalUser
  }
}
    ${ContactFragmentDoc}
${MinimalUserFragmentDoc}`;
export const OpportunityChannelOptionFragmentDoc = gql`
    fragment OpportunityChannelOption on OpportunityChannelType {
  id
  name
}
    `;
export const OpportunityReasonOptionFragmentDoc = gql`
    fragment OpportunityReasonOption on OpportunityReasonType {
  id
  name
}
    `;
export const OpportunitySituationOptionFragmentDoc = gql`
    fragment OpportunitySituationOption on OpportunitySituationType {
  id
  name
}
    `;
export const ContactOptionFragmentDoc = gql`
    fragment ContactOption on ContactType {
  id
  displayName
}
    `;
export const OpportunityFragmentDoc = gql`
    fragment Opportunity on OpportunityType {
  id
  displayName
  date
  channel {
    ...OpportunityChannelOption
  }
  reason {
    ...OpportunityReasonOption
  }
  situation {
    ...OpportunitySituationOption
  }
  notes
  products
  contact {
    ...ContactOption
    account {
      ...Account
    }
  }
}
    ${OpportunityChannelOptionFragmentDoc}
${OpportunityReasonOptionFragmentDoc}
${OpportunitySituationOptionFragmentDoc}
${ContactOptionFragmentDoc}
${AccountFragmentDoc}`;
export const OpportunityDetailFragmentDoc = gql`
    fragment OpportunityDetail on OpportunityType {
  ...Opportunity
  created
  createdBy {
    ...MinimalUser
  }
  updated
  updatedBy {
    ...MinimalUser
  }
}
    ${OpportunityFragmentDoc}
${MinimalUserFragmentDoc}`;
export const BillingTypeOptionFragmentDoc = gql`
    fragment BillingTypeOption on BillingTypeType {
  id
  name
}
    `;
export const BillingTypeFragmentDoc = gql`
    fragment BillingType on BillingTypeType {
  ...BillingTypeOption
}
    ${BillingTypeOptionFragmentDoc}`;
export const ProductPriceModifierFragmentDoc = gql`
    fragment ProductPriceModifier on ProductPriceModifierType {
  id
  enableDiscount
  commissionMultiplier
  billingType
}
    `;
export const ProductSubcategoryOptionFragmentDoc = gql`
    fragment ProductSubcategoryOption on ProductSubcategoryType {
  id
  name
}
    `;
export const ProductSubcategoryFragmentDoc = gql`
    fragment ProductSubcategory on ProductSubcategoryType {
  ...ProductSubcategoryOption
  category {
    ...ProductCategoryOption
  }
}
    ${ProductSubcategoryOptionFragmentDoc}
${ProductCategoryOptionFragmentDoc}`;
export const RuleGroupFragmentDoc = gql`
    fragment RuleGroup on RuleGroupType {
  id
  name
}
    `;
export const ProductCategoryFragmentDoc = gql`
    fragment ProductCategory on ProductCategoryType {
  ...ProductCategoryOption
  enabledForAssistedQuote
  estimatedAmount
  multiplyByEngine
  multiplyBySeederRows
}
    ${ProductCategoryOptionFragmentDoc}`;
export const ProductFragmentDoc = gql`
    fragment Product on ProductType {
  id
  externalId
  name
  displayName
  price
  type
  displayType
  order
  description
  rowCount
  subcategory {
    ...ProductSubcategory
  }
  ruleGroup {
    ...RuleGroup
  }
  ruleCategories {
    ...ProductCategory
  }
  published
  mmStatus
  displayMmStatus
}
    ${ProductSubcategoryFragmentDoc}
${RuleGroupFragmentDoc}
${ProductCategoryFragmentDoc}`;
export const ProductImageFragmentDoc = gql`
    fragment ProductImage on ProductType {
  id
  image
  externalId
}
    `;
export const WarrantyProductFragmentDoc = gql`
    fragment WarrantyProduct on WarrantyProductType {
  originalProduct {
    id
    image
  }
  id
  externalId
  name
  displayName
  price
  order
  description
  rowCount
  subcategory {
    ...ProductSubcategory
  }
}
    ${ProductSubcategoryFragmentDoc}`;
export const SeederOptionFragmentDoc = gql`
    fragment SeederOption on SeederType {
  id
  displayName
  rowCount
}
    `;
export const ProductWarrantyClaimReviewFragmentDoc = gql`
    fragment ProductWarrantyClaimReview on ProductWarrantyClaimReviewType {
  id
  created
  createdBy {
    ...MinimalUser
  }
  notes
  statusDisplay
  status
}
    ${MinimalUserFragmentDoc}`;
export const ProductWarrantyClaimListFragmentDoc = gql`
    fragment ProductWarrantyClaimList on ProductWarrantyClaimType {
  id
  deliveryDate
  failureDate
  serialNumber
  created
  quantity
  description
  finalClient
  phone
  externalId
  seederKilometers
  displayId
  product {
    ...WarrantyProduct
  }
  contact {
    ...Contact
  }
  createdBy {
    ...MinimalUser
  }
  seeder {
    ...SeederOption
  }
  lastReview {
    ...ProductWarrantyClaimReview
  }
  inspectionReview {
    statusDisplay
    status
    inWarranty
  }
}
    ${WarrantyProductFragmentDoc}
${ContactFragmentDoc}
${MinimalUserFragmentDoc}
${SeederOptionFragmentDoc}
${ProductWarrantyClaimReviewFragmentDoc}`;
export const WarrantyClaimInspectionReviewFragmentDoc = gql`
    fragment WarrantyClaimInspectionReview on WarrantyClaimInspectionReviewType {
  id
  created
  createdBy {
    ...MinimalUser
  }
  updated
  updatedBy {
    ...MinimalUser
  }
  warrantyClaim {
    id
  }
  received
  receivedDate
  inspected
  inspectedDate
  failureDescription
  status
  statusDisplay
  inWarranty
  files {
    id
    file
  }
}
    ${MinimalUserFragmentDoc}`;
export const WarrantyClaimImageFragmentDoc = gql`
    fragment WarrantyClaimImage on WarrantyClaimImageType {
  id
  file
  warrantyClaim {
    id
  }
}
    `;
export const WarrantyClaimVideoFragmentDoc = gql`
    fragment WarrantyClaimVideo on WarrantyClaimVideoType {
  id
  file
  warrantyClaim {
    id
  }
}
    `;
export const WarrantyClaimInspectionReviewHistoryFragmentDoc = gql`
    fragment WarrantyClaimInspectionReviewHistory on WarrantyClaimInspectionReviewHistoryType {
  id
  created
  createdBy {
    ...MinimalUser
  }
  inWarranty
  inWarrantyDisplay
  previousInWarranty
  previousInWarrantyDisplay
  failureDescription
  previousFailureDescription
}
    ${MinimalUserFragmentDoc}`;
export const ProductWarrantyClaimFragmentDoc = gql`
    fragment ProductWarrantyClaim on ProductWarrantyClaimType {
  ...ProductWarrantyClaimList
  inspectionReview {
    ...WarrantyClaimInspectionReview
  }
  seeder {
    ...Seeder
  }
  images {
    ...WarrantyClaimImage
  }
  videos {
    ...WarrantyClaimVideo
  }
  reviews {
    ...ProductWarrantyClaimReview
  }
  inspectionReviewHistories {
    ...WarrantyClaimInspectionReviewHistory
  }
}
    ${ProductWarrantyClaimListFragmentDoc}
${WarrantyClaimInspectionReviewFragmentDoc}
${SeederFragmentDoc}
${WarrantyClaimImageFragmentDoc}
${WarrantyClaimVideoFragmentDoc}
${ProductWarrantyClaimReviewFragmentDoc}
${WarrantyClaimInspectionReviewHistoryFragmentDoc}`;
export const PaymentMethodOptionFragmentDoc = gql`
    fragment PaymentMethodOption on PaymentMethodType {
  id
  name
}
    `;
export const PaymentMethodCategoryFragmentDoc = gql`
    fragment PaymentMethodCategory on PaymentMethodCategoryType {
  id
  name
  finnancied
  paymentMethods {
    id
    name
  }
}
    `;
export const MinimalOrderedOemProductFragmentDoc = gql`
    fragment MinimalOrderedOEMProduct on OrderedOEMProductType {
  id
  quantity
  quantityLeft
}
    `;
export const OrderedOemProductFragmentDoc = gql`
    fragment OrderedOEMProduct on OrderedOEMProductType {
  ...MinimalOrderedOEMProduct
  name
  externalId
  productOemId
  description
  price
  subcategory {
    ...ProductSubcategoryOption
  }
  rowCount
  order
}
    ${MinimalOrderedOemProductFragmentDoc}
${ProductSubcategoryOptionFragmentDoc}`;
export const ShipmentOemProductFragmentDoc = gql`
    fragment ShipmentOEMProduct on ShipmentOEMProductType {
  id
  orderOem {
    id
  }
  shipment {
    id
  }
  quantity
  orderedProduct {
    ...OrderedOEMProduct
  }
  batch
}
    ${OrderedOemProductFragmentDoc}`;
export const QuoteRuleFragmentDoc = gql`
    fragment QuoteRule on QuoteRuleType {
  id
  product {
    id
    externalId
  }
  productCategory {
    id
    name
  }
  group {
    ...RuleGroup
  }
  valueSource
  image
  referenceSource
  referenceMultiplier
  operator
  description
  errorMessage
  useForValidation
  useForInitialValue
  prioritizeRule
}
    ${RuleGroupFragmentDoc}`;
export const BankInvoicePdfDisclaimerFragmentDoc = gql`
    fragment BankInvoicePDFDisclaimer on BankInvoicePDFDisclaimerType {
  legalName
  adress
  taxId
  taxpayerType
  startOfActivities
  disclaimer
}
    `;
export const OrderOemReviewFragmentDoc = gql`
    fragment OrderOEMReview on OrderOEMReviewType {
  id
  status
  statusDisplay
  notes
  created
  createdBy {
    ...MinimalUser
  }
}
    ${MinimalUserFragmentDoc}`;
export const OemOrganizationFragmentDoc = gql`
    fragment OEMOrganization on OEMOrganizationType {
  id
  name
  externalId
  originalOrganization {
    ...Organization
  }
}
    ${OrganizationFragmentDoc}`;
export const PaymentMethodFragmentDoc = gql`
    fragment PaymentMethod on PaymentMethodType {
  id
  name
  order
  multiplier
  slug
  paymentmethodcategorySet {
    finnancied
  }
}
    `;
export const OrderOemPaymentMethodFragmentDoc = gql`
    fragment OrderOEMPaymentMethod on OrderOEMPaymentMethodType {
  id
  name
  multiplier
  slug
  originalPaymentMethod {
    ...PaymentMethod
  }
}
    ${PaymentMethodFragmentDoc}`;
export const ShipmentOemFragmentDoc = gql`
    fragment ShipmentOEM on ShipmentOEMType {
  id
  externalId
  invoice
  orderOem {
    id
  }
  productsShipped {
    id
    orderOem {
      id
    }
    shipment {
      id
    }
    quantity
    orderedProduct {
      ...OrderedOEMProduct
    }
    batch
  }
  created
  createdBy {
    ...MinimalUser
  }
  status
  statusDisplay
}
    ${OrderedOemProductFragmentDoc}
${MinimalUserFragmentDoc}`;
export const OrderOemFragmentDoc = gql`
    fragment OrderOEM on OrderOEMType {
  id
  created
  status
  displayId
  statusDisplay
  reviewStart
  targetDate
  reviews {
    ...OrderOEMReview
  }
  productsWithoutShipment {
    ...OrderedOEMProduct
  }
  createdBy {
    ...MinimalUser
  }
  organization {
    ...OEMOrganization
  }
  paymentMethod {
    ...OrderOEMPaymentMethod
  }
  products {
    ...OrderedOEMProduct
  }
  shipments {
    ...ShipmentOEM
  }
  notes
  orderNumber
}
    ${OrderOemReviewFragmentDoc}
${OrderedOemProductFragmentDoc}
${MinimalUserFragmentDoc}
${OemOrganizationFragmentDoc}
${OrderOemPaymentMethodFragmentDoc}
${ShipmentOemFragmentDoc}`;
export const MinimalQuoteFragmentDoc = gql`
    fragment MinimalQuote on QuoteType {
  id
  displayName
  displayId
  status
  statusDisplay
}
    `;
export const MinimalQuotedProductFragmentDoc = gql`
    fragment MinimalQuotedProduct on QuotedProductType {
  price
  quantity
  enableDiscount
  commissionMultiplier
  externalId
}
    `;
export const MinimalQuotedPaymentMethodFragmentDoc = gql`
    fragment MinimalQuotedPaymentMethod on QuotedPaymentMethodType {
  name
  multiplier
  extraMultiplier
  slug
  finnancied
}
    `;
export const QuotedPaymentMethodFragmentDoc = gql`
    fragment QuotedPaymentMethod on QuotedPaymentMethodType {
  ...MinimalQuotedPaymentMethod
  id
  order
  isCustom
  dealerCommission
  originalPaymentMethod {
    id
  }
}
    ${MinimalQuotedPaymentMethodFragmentDoc}`;
export const QuoteKitMultiplierFragmentDoc = gql`
    fragment QuoteKitMultiplier on QuoteKitMultiplierType {
  id
  name
  multiplier
}
    `;
export const QuoteCloseReasonFragmentDoc = gql`
    fragment QuoteCloseReason on QuoteCloseReasonType {
  id
  description
  quote {
    id
  }
}
    `;
export const QuoteListFragmentDoc = gql`
    fragment QuoteList on QuoteType {
  ...MinimalQuote
  rowCount
  seeder {
    displayName
  }
  contact {
    email
    account {
      name
      owner {
        name
      }
    }
  }
  products {
    ...MinimalQuotedProduct
    id
    order
    externalId
  }
  paymentMethods {
    ...QuotedPaymentMethod
  }
  kitMultiplier {
    ...QuoteKitMultiplier
  }
  created
  createdBy {
    ...MinimalUser
  }
  closeReason {
    ...QuoteCloseReason
  }
}
    ${MinimalQuoteFragmentDoc}
${MinimalQuotedProductFragmentDoc}
${QuotedPaymentMethodFragmentDoc}
${QuoteKitMultiplierFragmentDoc}
${MinimalUserFragmentDoc}
${QuoteCloseReasonFragmentDoc}`;
export const SaleListFragmentDoc = gql`
    fragment SaleList on SaleType {
  id
  created
  createdBy {
    ...MinimalUser
  }
  quote {
    ...QuoteList
  }
  paymentMethod {
    ...QuotedPaymentMethod
  }
}
    ${MinimalUserFragmentDoc}
${QuoteListFragmentDoc}
${QuotedPaymentMethodFragmentDoc}`;
export const QuotedProductFragmentDoc = gql`
    fragment QuotedProduct on QuotedProductType {
  ...MinimalQuotedProduct
  id
  name
  order
  rowCount
  externalId
  description
  subcategory {
    ...ProductSubcategory
  }
  ruleGroup {
    ...RuleGroup
  }
  ruleCategories {
    ...ProductCategory
  }
}
    ${MinimalQuotedProductFragmentDoc}
${ProductSubcategoryFragmentDoc}
${RuleGroupFragmentDoc}
${ProductCategoryFragmentDoc}`;
export const QuotePdfFragmentDoc = gql`
    fragment QuotePDF on QuotePDFType {
  id
  file
  type
  paymentMethod {
    ...QuotedPaymentMethod
  }
  recipient
  typeDisplay
  emailStatus
  created
  createdBy {
    ...MinimalUser
  }
}
    ${QuotedPaymentMethodFragmentDoc}
${MinimalUserFragmentDoc}`;
export const MinimalSaleFragmentDoc = gql`
    fragment MinimalSale on SaleType {
  id
  paymentMethod {
    ...QuotedPaymentMethod
  }
}
    ${QuotedPaymentMethodFragmentDoc}`;
export const QuoteFragmentDoc = gql`
    fragment Quote on QuoteType {
  ...MinimalQuote
  additionalChargesValue
  additionalChargesDescription
  billingType
  displayBillingType
  rowCount
  notes
  oemOrder
  kitMultiplier {
    ...QuoteKitMultiplier
  }
  seeder {
    ...Seeder
  }
  products {
    ...QuotedProduct
  }
  pdfs {
    ...QuotePDF
  }
  paymentMethods {
    ...QuotedPaymentMethod
  }
  contact {
    ...Contact
  }
  sale {
    ...MinimalSale
  }
  created
  createdBy {
    ...MinimalUser
  }
  closeReason {
    ...QuoteCloseReason
  }
}
    ${MinimalQuoteFragmentDoc}
${QuoteKitMultiplierFragmentDoc}
${SeederFragmentDoc}
${QuotedProductFragmentDoc}
${QuotePdfFragmentDoc}
${QuotedPaymentMethodFragmentDoc}
${ContactFragmentDoc}
${MinimalSaleFragmentDoc}
${MinimalUserFragmentDoc}
${QuoteCloseReasonFragmentDoc}`;
export const SaleFragmentDoc = gql`
    fragment Sale on SaleType {
  id
  created
  createdBy {
    ...MinimalUser
  }
  quote {
    ...Quote
  }
  paymentMethod {
    ...QuotedPaymentMethod
  }
}
    ${MinimalUserFragmentDoc}
${QuoteFragmentDoc}
${QuotedPaymentMethodFragmentDoc}`;
export const OrderedProductFragmentDoc = gql`
    fragment OrderedProduct on OrderedProductType {
  id
  quantity
  quantityLeft
  enableDiscount
  commissionMultiplier
  price
  quotedProduct {
    ...QuotedProduct
  }
}
    ${QuotedProductFragmentDoc}`;
export const MinimalSupplyOrderFragmentDoc = gql`
    fragment MinimalSupplyOrder on SupplyOrderType {
  id
  displayName
}
    `;
export const ShipmentProductFragmentDoc = gql`
    fragment ShipmentProduct on ShipmentProductType {
  id
  supplyOrder {
    id
  }
  shipment {
    id
  }
  quantity
  orderedProduct {
    ...OrderedProduct
  }
  batch
}
    ${OrderedProductFragmentDoc}`;
export const ShipmentFragmentDoc = gql`
    fragment Shipment on ShipmentType {
  id
  externalId
  exchangeRate
  invoice
  supplyOrder {
    ...MinimalSupplyOrder
  }
  productsShipped {
    ...ShipmentProduct
  }
  created
  createdBy {
    ...MinimalUser
  }
  status
  statusDisplay
  onHoldDescription
}
    ${MinimalSupplyOrderFragmentDoc}
${ShipmentProductFragmentDoc}
${MinimalUserFragmentDoc}`;
export const SupplyOrderFragmentDoc = gql`
    fragment SupplyOrder on SupplyOrderType {
  id
  displayId
  targetDate
  quote {
    ...Quote
  }
  orderedProducts {
    ...OrderedProduct
  }
  productsWithoutShipment {
    ...OrderedProduct
  }
  shipments {
    ...Shipment
  }
  salesCanReview
  status
  statusDisplay
  created
  createdBy {
    ...MinimalUser
  }
  billingType
  paymentMethod {
    ...QuotedPaymentMethod
  }
}
    ${QuoteFragmentDoc}
${OrderedProductFragmentDoc}
${ShipmentFragmentDoc}
${MinimalUserFragmentDoc}
${QuotedPaymentMethodFragmentDoc}`;
export const QuoteDetailFragmentDoc = gql`
    fragment QuoteDetail on QuoteType {
  ...Quote
  billingType
  products {
    ...QuotedProduct
  }
  paymentMethods {
    ...QuotedPaymentMethod
  }
  sale {
    ...Sale
  }
  supplyOrder {
    ...SupplyOrder
  }
  originalQuote {
    id
    displayId
  }
  created
  createdBy {
    ...MinimalUser
  }
  updated
  updatedBy {
    ...MinimalUser
  }
}
    ${QuoteFragmentDoc}
${QuotedProductFragmentDoc}
${QuotedPaymentMethodFragmentDoc}
${SaleFragmentDoc}
${SupplyOrderFragmentDoc}
${MinimalUserFragmentDoc}`;
export const SaleDetailFragmentDoc = gql`
    fragment SaleDetail on SaleType {
  ...Sale
  quote {
    ...QuoteDetail
  }
}
    ${SaleFragmentDoc}
${QuoteDetailFragmentDoc}`;
export const SupplyOrderListFragmentDoc = gql`
    fragment SupplyOrderList on SupplyOrderType {
  id
  displayId
  quote {
    oemOrder
    contact {
      email
      account {
        name
        owner {
          name
        }
      }
    }
    seeder {
      displayName
    }
    rowCount
    kitMultiplier {
      multiplier
    }
    sale {
      paymentMethod {
        name
        multiplier
        extraMultiplier
        slug
        finnancied
      }
    }
  }
  statusDisplay
  orderedProducts {
    quantity
    price
    commissionMultiplier
    enableDiscount
  }
  paymentMethod {
    name
    multiplier
    extraMultiplier
    slug
    finnancied
  }
  created
}
    `;
export const AutomaticReviewRejectionRuleFragmentDoc = gql`
    fragment AutomaticReviewRejectionRule on AutomaticReviewRejectionRuleType {
  supplyOrderReview {
    id
  }
  message
  description
}
    `;
export const SupplyOrderReviewFragmentDoc = gql`
    fragment SupplyOrderReview on SupplyOrderReviewType {
  id
  statusDisplay
  typeDisplay
  notes
  created
  automaticReviewRejectionRules {
    ...AutomaticReviewRejectionRule
  }
  createdBy {
    ...MinimalUser
  }
}
    ${AutomaticReviewRejectionRuleFragmentDoc}
${MinimalUserFragmentDoc}`;
export const SupplyOrderDetailFragmentDoc = gql`
    fragment SupplyOrderDetail on SupplyOrderType {
  ...SupplyOrder
  reviewStart
  reviews {
    ...SupplyOrderReview
  }
  updated
  updatedBy {
    ...MinimalUser
  }
}
    ${SupplyOrderFragmentDoc}
${SupplyOrderReviewFragmentDoc}
${MinimalUserFragmentDoc}`;
export const MinimalShipmentFragmentDoc = gql`
    fragment MinimalShipment on ShipmentType {
  id
  externalId
}
    `;
export const BankInvoicePdfFragmentDoc = gql`
    fragment BankInvoicePDF on BankInvoicePDFType {
  id
  quote {
    ...Quote
  }
  paymentMethod {
    ...QuotedPaymentMethod
  }
  created
}
    ${QuoteFragmentDoc}
${QuotedPaymentMethodFragmentDoc}`;
export const SeederDetailFragmentDoc = gql`
    fragment SeederDetail on SeederType {
  ...Seeder
  created
  createdBy {
    ...MinimalUser
  }
  updated
  updatedBy {
    ...MinimalUser
  }
}
    ${SeederFragmentDoc}
${MinimalUserFragmentDoc}`;
export const RuntimeSettingsFragmentDoc = gql`
    fragment RuntimeSettings on RuntimeSettingsType {
  id
  quotePdfDisclaimer
  taxIdLabel
  signaturesInDisclaimer
  maxVideoSize
  machineStartUpPercentage
  machineStartUpInstallationPercentage
  physicalPersonsDocumentation
  legalPersonsDocumentation
  templateOfAffidavit
  datastudioUrl
  templateOfAffidavit
  physicalPersonsDocumentation
  legalPersonsDocumentation
  tinymceUrl
  ordersOemTemplate
  datePaymentMethodCalculationV2
  pricePerHour
  pemProtocolTemplate
  pemTermsTemplate
  stockSpreadsheetUrl
}
    `;
export const CloseReasonFragmentDoc = gql`
    fragment CloseReason on CloseReasonType {
  id
  description
}
    `;
export const ExpiredQuoteFragmentDoc = gql`
    fragment ExpiredQuote on QuoteType {
  id
  displayId
  created
  status
  statusDisplay
  createdBy {
    ...MinimalUser
  }
  closeReason {
    ...QuoteCloseReason
  }
  contact {
    email
    account {
      name
      owner {
        name
      }
    }
  }
}
    ${MinimalUserFragmentDoc}
${QuoteCloseReasonFragmentDoc}`;
export const FailureFragmentDoc = gql`
    fragment Failure on FailureType {
  id
  description
  created
  updated
}
    `;
export const NotificationFragmentDoc = gql`
    fragment Notification on NotificationType {
  id
  message
  path
  isRead
  created
  updated
  user {
    id
  }
}
    `;
export const DownloadPdfFragmentDoc = gql`
    fragment DownloadPdf on DownloadType {
  filename
  contentType
  data
}
    `;
export const GefcoEventFragmentDoc = gql`
    fragment GefcoEvent on GefcoEvent {
  baseEvent
  event
  eventDisplay
  rejectReason
  date
}
    `;
export const GefcoShipmentStatusFragmentDoc = gql`
    fragment GefcoShipmentStatus on GefcoShipmentStatus {
  deliverId
  shipmentExternalId
  documentId
  tmsStatus
  tmsStatusDisplay
  wmsStatus
  wmsStatusDisplay
  events {
    ...GefcoEvent
  }
}
    ${GefcoEventFragmentDoc}`;
export const JobFragmentDoc = gql`
    fragment Job on JobType {
  id
  status
  result
}
    `;
export const DownloadFragmentDoc = gql`
    fragment Download on DownloadType {
  contentType
  data
  filename
}
    `;
export const ExportJobFragmentDoc = gql`
    fragment ExportJob on ExportJobType {
  id
  status
  result {
    ...Download
  }
}
    ${DownloadFragmentDoc}`;
export const NotificationConfigFragmentDoc = gql`
    fragment NotificationConfig on NotificationConfigType {
  id
  user {
    id
  }
  name
  inAppEnabled
  emailEnabled
  displayName
}
    `;
export const NotificationConfigNameFragmentDoc = gql`
    fragment NotificationConfigName on NotificationConfigNameType {
  value
  label
}
    `;
export const MissingProductsListFragmentDoc = gql`
    fragment MissingProductsList on MissingProductType {
  externalId
  name
}
    `;
export const MachineStartUpListFragmentDoc = gql`
    fragment MachineStartUpList on MachineStartUpType {
  id
  displayId
  contact {
    ...Contact
  }
  seederBrand {
    ...SeederBrand
  }
  seederModel {
    ...SeederModel
  }
  seederRowCount
  step
  stepDisplay
  fieldStepDisplay
  fieldStep
  factoryStepDisplay
  factoryStep
  created
  expirationDate
  organizationFactory {
    id
    name
  }
  organizationField {
    id
    name
  }
  oemOrganization {
    id
    name
  }
  createdBy {
    ...MinimalUser
  }
  missingProducts {
    id
    name
    quantity
  }
}
    ${ContactFragmentDoc}
${SeederBrandFragmentDoc}
${SeederModelFragmentDoc}
${MinimalUserFragmentDoc}`;
export const MachineStartUpProductCategoryFragmentDoc = gql`
    fragment MachineStartUpProductCategory on MachineStartUpProductCategoryType {
  id
  name
  estimatedAmount
  multiplyByEngine
  multiplyBySeederRows
  engineQuantity
  useInTotalPrice
  payOnlyFieldReview
}
    `;
export const FactoryAssistantFragmentDoc = gql`
    fragment FactoryAssistant on FactoryAssistantType {
  id
  name
  phone
}
    `;
export const CustomerAssistantFragmentDoc = gql`
    fragment CustomerAssistant on CustomerAssistantType {
  id
  name
  phone
}
    `;
export const RoleFragmentDoc = gql`
    fragment Role on RoleType {
  id
  name
}
    `;
export const PermissionsFragmentDoc = gql`
    fragment Permissions on UserPermissions {
  viewQuotes
  viewSales
  viewSupplyOrders
  viewAccounts
  viewContacts
  viewOpportunities
  viewWarrantyClaims
  viewMachineStartUps
  viewEcns
  assignAccountOwner
  requestSupplyOrderReview
  submitSalesSupplyOrderReview
  submitCreditsSupplyOrderReview
  requestOemOrderReview
  viewAnalytics
  viewWarrantyClaimsAnalytics
  manageShipments
  manageQuotes
  manageSales
  manageSupplyOrders
  manageWarrantyClaims
  performTechnicalReview
  manageMachineStartUps
  manageOem
  viewOemStock
  manageEcns
  manageAccounts
  viewDatastudio
  viewOems
  viewSeeders
  viewMaterialMaster
  manageMaterialMaster
  createMachineStartUps
  viewOemOrderBankInvoices
  viewStock
  viewUnpublishedProducts
  requestAccountRegistration
  submitAccountRegistrationReview
  receiveAccountRegistrationApprovedNotification
}
    `;
export const UserFragmentDoc = gql`
    fragment User on UserType {
  id
  email
  firstName
  lastName
  displayName
  isActive
  isStaff
  dateJoined
  lastLogin
  language
  organization {
    ...Organization
  }
  role {
    ...Role
  }
  ecnRoles {
    id
  }
  canEditLockedEcnTasks
  permissions {
    ...Permissions
  }
  emailNotifications
  inAppNotifications
}
    ${OrganizationFragmentDoc}
${RoleFragmentDoc}
${PermissionsFragmentDoc}`;
export const MachineStartUpMissingProductFragmentDoc = gql`
    fragment MachineStartUpMissingProduct on MissingProductType {
  id
  name
  externalId
  price
  quantity
  description
  subcategory {
    id
    name
    category {
      id
      name
    }
  }
  machineStartUp {
    id
  }
}
    `;
export const PemCalculationTypeFixedFragmentDoc = gql`
    fragment PemCalculationTypeFixed on PemCalculationTypeFixedType {
  partialHours
}
    `;
export const PemCalculationTypeVariableFragmentDoc = gql`
    fragment PemCalculationTypeVariable on PemCalculationTypeVariableType {
  minutesPerRow
}
    `;
export const PemCalculationTypeVisitFragmentDoc = gql`
    fragment PemCalculationTypeVisit on PemCalculationTypeVisitType {
  name
  partialHours
}
    `;
export const PemRuleFragmentDoc = gql`
    fragment PemRule on PemRuleType {
  id
  name
  subCategories {
    name
    id
  }
  fixed {
    ...PemCalculationTypeFixed
  }
  variable {
    ...PemCalculationTypeVariable
  }
  visit {
    ...PemCalculationTypeVisit
  }
}
    ${PemCalculationTypeFixedFragmentDoc}
${PemCalculationTypeVariableFragmentDoc}
${PemCalculationTypeVisitFragmentDoc}`;
export const MachineStartUpFragmentDoc = gql`
    fragment MachineStartUp on MachineStartUpType {
  id
  displayId
  contact {
    ...Contact
  }
  seederBrand {
    ...SeederBrand
  }
  seederModel {
    ...SeederModel
  }
  organizationFactory {
    ...Organization
  }
  organizationField {
    ...Organization
  }
  oemOrganization {
    ...Organization
  }
  isFieldStepPending
  seederYear
  seederRowCount
  seederSerialNumber
  productionDateFrom
  productionDateTo
  estimatedDeliveryDate
  installationPrice
  startUpPrice
  totalPriceMachine
  factoryPlaqueImage
  factoryProtocolImage
  factoryTermsImage
  fieldPlaqueImage
  fieldProtocolImage
  fieldTermsImage
  dealerFactoryInvoice
  dealerFieldInvoice
  dealerFactoryNotes
  factoryWorkflowNumber
  fieldWorkflowNumber
  dealerFieldNotes
  racks
  productCategories {
    ...MachineStartUpProductCategory
  }
  factoryAssistants {
    ...FactoryAssistant
  }
  customerAssistants {
    ...CustomerAssistant
  }
  step
  stepDisplay
  fieldStep
  fieldStepDisplay
  factoryStep
  factoryStepDisplay
  created
  expirationDate
  createdBy {
    ...User
  }
  missingProducts {
    ...MachineStartUpMissingProduct
  }
  withPostFieldRevision
  dealerStartUpPrice
  pemRule {
    ...PemRule
  }
}
    ${ContactFragmentDoc}
${SeederBrandFragmentDoc}
${SeederModelFragmentDoc}
${OrganizationFragmentDoc}
${MachineStartUpProductCategoryFragmentDoc}
${FactoryAssistantFragmentDoc}
${CustomerAssistantFragmentDoc}
${UserFragmentDoc}
${MachineStartUpMissingProductFragmentDoc}
${PemRuleFragmentDoc}`;
export const PemRuleAdditionalFragmentDoc = gql`
    fragment PemRuleAdditional on PemCalculationTypeAdditionalType {
  partialHours
  id
  subCategories {
    name
    id
  }
}
    `;
export const CategoryYearlyForecastFragmentDoc = gql`
    fragment CategoryYearlyForecast on CategoryYearlyForecastType {
  id
  year
  value
  category {
    id
  }
}
    `;
export const ProductYearlyFactorFragmentDoc = gql`
    fragment ProductYearlyFactor on ProductYearlyFactorType {
  id
  year
  value
}
    `;
export const MaterialMasterProductFragmentDoc = gql`
    fragment MaterialMasterProduct on ProductType {
  id
  ecnId
  externalId
  name
  created
  effectiveDate
  mmStatus
  displayMmStatus
  createdBy {
    ...MinimalUser
  }
  subcategory {
    id
    name
    category {
      id
      name
      yearlyForecast {
        ...CategoryYearlyForecast
      }
    }
  }
  origin {
    id
    name
  }
  yearlyFactors {
    ...ProductYearlyFactor
  }
  published
  untilStockRunsOut
  description
}
    ${MinimalUserFragmentDoc}
${CategoryYearlyForecastFragmentDoc}
${ProductYearlyFactorFragmentDoc}`;
export const MaterialMasterProductDetailFragmentDoc = gql`
    fragment MaterialMasterProductDetail on ProductType {
  ...MaterialMasterProduct
  order
  price
  rowCount
  type
  image
  organizationGroup {
    id
  }
  ruleGroup {
    id
  }
  ruleCategories {
    id
  }
}
    ${MaterialMasterProductFragmentDoc}`;
export const ProductCommentFragmentDoc = gql`
    fragment ProductComment on ProductCommentType {
  id
  created
  createdBy {
    ...MinimalUser
  }
  product {
    id
  }
  content
}
    ${MinimalUserFragmentDoc}`;
export const DraftBlueprintEcnFragmentDoc = gql`
    fragment DraftBlueprintEcn on DraftBlueprintEcnType {
  id
  file
}
    `;
export const DraftEcnFragmentDoc = gql`
    fragment DraftEcn on DraftEcnType {
  id
  step
  data
  created
  createdBy {
    ...MinimalUser
  }
  updatedBy {
    ...MinimalUser
  }
  updated
  blueprints {
    ...DraftBlueprintEcn
  }
}
    ${MinimalUserFragmentDoc}
${DraftBlueprintEcnFragmentDoc}`;
export const DraftEcnListFragmentDoc = gql`
    fragment DraftEcnList on DraftEcnType {
  ...DraftEcn
  ecnNumberDuplicated
}
    ${DraftEcnFragmentDoc}`;
export const DefaultEcnTaskFragmentDoc = gql`
    fragment DefaultEcnTask on DefaultTaskType {
  id
  name
  displayName
  description
  roles {
    id
    name
  }
  ecnTypes
}
    `;
export const EcnTaskFragmentDoc = gql`
    fragment EcnTask on EcnTaskType {
  id
  originalTask {
    id
  }
  notes
  name
  displayName
  roles {
    id
    name
  }
  done
  doneBy {
    ...MinimalUser
  }
  ecnTypes
}
    ${MinimalUserFragmentDoc}`;
export const ProductOriginOptionFragmentDoc = gql`
    fragment ProductOriginOption on ProductOriginType {
  id
  name
}
    `;
export const EcnNewPartFragmentDoc = gql`
    fragment EcnNewPart on EcnNewPartType {
  id
  name
  externalId
  subcategory {
    ...ProductSubcategoryOption
  }
  type
  displayType
  pricing
  yearlyForecast
  betaQuantity
  buyingDate
  estimatedDateArrival
  buyingPrice
  supplier
  origin {
    ...ProductOriginOption
  }
  description
  supportNotes
  supportLink
  tariffPosition
  tariffPositionNotes
  partsArrived
  targetDate
  zpQuantity
  zpCheck
  forecastUpdated
}
    ${ProductSubcategoryOptionFragmentDoc}
${ProductOriginOptionFragmentDoc}`;
export const ProductOptionFragmentDoc = gql`
    fragment ProductOption on ProductType {
  id
  name
  displayName
  externalId
  subcategory {
    id
    name
    category {
      name
      id
    }
  }
}
    `;
export const EcnCancelledPartFragmentDoc = gql`
    fragment EcnCancelledPart on EcnCancelledPartType {
  id
  part {
    ...ProductOption
    type
    displayType
  }
  replace
  displayReplace
  currentVersion
  targetVersion
  description
  pricing
  yearlyForecast
  betaQuantity
  buyingDate
  estimatedDateArrival
  buyingPrice
  supplier
  origin {
    ...ProductOriginOption
  }
  supportNotes
  supportLink
  tariffPosition
  tariffPositionNotes
  partsArrived
  targetDate
  zpQuantity
  zpCheck
  forecastUpdated
}
    ${ProductOptionFragmentDoc}
${ProductOriginOptionFragmentDoc}`;
export const EcnPartFragmentDoc = gql`
    fragment EcnPart on EcnPartType {
  id
  externalId
  newParts {
    ...EcnNewPart
  }
  cancelledParts {
    ...EcnCancelledPart
  }
  type
  displayType
}
    ${EcnNewPartFragmentDoc}
${EcnCancelledPartFragmentDoc}`;
export const EcnFragmentDoc = gql`
    fragment Ecn on EcnType {
  id
  created
  effectiveDate
  previousEcnId
  nextEcnId
  createdBy {
    ...MinimalUser
  }
  realesedBy {
    ...MinimalUser
  }
  updated
  updatedBy {
    ...MinimalUser
  }
  status
  displayStatus
  displayId
  ecnNumber
  notes
  recipient
  displayRecipient
  oems {
    id
    name
  }
  fyi {
    id
    name
  }
  informedUsers {
    id
    email
  }
  blueprints {
    id
    file
  }
  tasks {
    ...EcnTask
  }
  parts {
    ...EcnPart
  }
  viewed
  isFavorite
  warrantyPriority
  seasonPriority
  displaySeasonPriority
  files {
    id
    created
    file
  }
}
    ${MinimalUserFragmentDoc}
${EcnTaskFragmentDoc}
${EcnPartFragmentDoc}`;
export const EcnListFragmentDoc = gql`
    fragment EcnList on EcnType {
  id
  displayId
  created
  effectiveDate
  createdBy {
    ...MinimalUser
  }
  realesedBy {
    ...MinimalUser
  }
  parts {
    id
    type
    displayType
    newParts {
      ...EcnNewPart
    }
    cancelledParts {
      ...EcnCancelledPart
    }
  }
  status
  displayStatus
  fyi {
    id
    name
  }
  tasks {
    id
    done
    name
    displayName
    users {
      ...MinimalUser
    }
  }
  totalInformedUsers
  totalNotInformedUsers
  ecnNumber
  viewed
  isFavorite
  warrantyPriority
  seasonPriority
  displaySeasonPriority
}
    ${MinimalUserFragmentDoc}
${EcnNewPartFragmentDoc}
${EcnCancelledPartFragmentDoc}`;
export const HistoricalEcnFragmentDoc = gql`
    fragment HistoricalEcn on HistoricalEcnType {
  created
  updated
  id
  status
  displayId
  ecnNumber
  notes
  recipient
  warrantyPriority
  seasonPriority
  effectiveDate
  historyId
  historyDate
  historyChangeReason
  historyTypeDisplay
}
    `;
export const EcnTaskCommentFragmentDoc = gql`
    fragment EcnTaskComment on EcnTaskCommentType {
  id
  created
  createdBy {
    ...MinimalUser
  }
  task {
    id
  }
  content
}
    ${MinimalUserFragmentDoc}`;
export const GetQuotesAnalyticsDocument = gql`
    query getQuotesAnalytics($filters: AnalyticsFilters!) {
  quotesAnalytics(filters: $filters) {
    ...QuotesAnalytics
  }
}
    ${QuotesAnalyticsFragmentDoc}`;

/**
 * __useGetQuotesAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetQuotesAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuotesAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuotesAnalyticsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetQuotesAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetQuotesAnalyticsQuery, GetQuotesAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuotesAnalyticsQuery, GetQuotesAnalyticsQueryVariables>(GetQuotesAnalyticsDocument, options);
      }
export function useGetQuotesAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuotesAnalyticsQuery, GetQuotesAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuotesAnalyticsQuery, GetQuotesAnalyticsQueryVariables>(GetQuotesAnalyticsDocument, options);
        }
export type GetQuotesAnalyticsQueryHookResult = ReturnType<typeof useGetQuotesAnalyticsQuery>;
export type GetQuotesAnalyticsLazyQueryHookResult = ReturnType<typeof useGetQuotesAnalyticsLazyQuery>;
export type GetQuotesAnalyticsQueryResult = Apollo.QueryResult<GetQuotesAnalyticsQuery, GetQuotesAnalyticsQueryVariables>;
export function refetchGetQuotesAnalyticsQuery(variables: GetQuotesAnalyticsQueryVariables) {
      return { query: GetQuotesAnalyticsDocument, variables: variables }
    }
export const GetSalesPotentialAnalyticsDocument = gql`
    query getSalesPotentialAnalytics($filters: AnalyticsFilters!) {
  salesPotentialAnalytics(filters: $filters) {
    ...SalesPotentialAnalytics
  }
}
    ${SalesPotentialAnalyticsFragmentDoc}`;

/**
 * __useGetSalesPotentialAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetSalesPotentialAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesPotentialAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesPotentialAnalyticsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetSalesPotentialAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetSalesPotentialAnalyticsQuery, GetSalesPotentialAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesPotentialAnalyticsQuery, GetSalesPotentialAnalyticsQueryVariables>(GetSalesPotentialAnalyticsDocument, options);
      }
export function useGetSalesPotentialAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesPotentialAnalyticsQuery, GetSalesPotentialAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesPotentialAnalyticsQuery, GetSalesPotentialAnalyticsQueryVariables>(GetSalesPotentialAnalyticsDocument, options);
        }
export type GetSalesPotentialAnalyticsQueryHookResult = ReturnType<typeof useGetSalesPotentialAnalyticsQuery>;
export type GetSalesPotentialAnalyticsLazyQueryHookResult = ReturnType<typeof useGetSalesPotentialAnalyticsLazyQuery>;
export type GetSalesPotentialAnalyticsQueryResult = Apollo.QueryResult<GetSalesPotentialAnalyticsQuery, GetSalesPotentialAnalyticsQueryVariables>;
export function refetchGetSalesPotentialAnalyticsQuery(variables: GetSalesPotentialAnalyticsQueryVariables) {
      return { query: GetSalesPotentialAnalyticsDocument, variables: variables }
    }
export const GetSalesAnalyticsDocument = gql`
    query getSalesAnalytics($filters: AnalyticsFilters!) {
  salesAnalytics(filters: $filters) {
    ...SalesAnalytics
  }
}
    ${SalesAnalyticsFragmentDoc}`;

/**
 * __useGetSalesAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetSalesAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesAnalyticsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetSalesAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetSalesAnalyticsQuery, GetSalesAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesAnalyticsQuery, GetSalesAnalyticsQueryVariables>(GetSalesAnalyticsDocument, options);
      }
export function useGetSalesAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesAnalyticsQuery, GetSalesAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesAnalyticsQuery, GetSalesAnalyticsQueryVariables>(GetSalesAnalyticsDocument, options);
        }
export type GetSalesAnalyticsQueryHookResult = ReturnType<typeof useGetSalesAnalyticsQuery>;
export type GetSalesAnalyticsLazyQueryHookResult = ReturnType<typeof useGetSalesAnalyticsLazyQuery>;
export type GetSalesAnalyticsQueryResult = Apollo.QueryResult<GetSalesAnalyticsQuery, GetSalesAnalyticsQueryVariables>;
export function refetchGetSalesAnalyticsQuery(variables: GetSalesAnalyticsQueryVariables) {
      return { query: GetSalesAnalyticsDocument, variables: variables }
    }
export const GetSupplyOrdersAnalyticsDocument = gql`
    query getSupplyOrdersAnalytics($filters: AnalyticsFilters!) {
  supplyOrdersAnalytics(filters: $filters) {
    ...SupplyOrdersAnalytics
  }
}
    ${SupplyOrdersAnalyticsFragmentDoc}`;

/**
 * __useGetSupplyOrdersAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetSupplyOrdersAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupplyOrdersAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupplyOrdersAnalyticsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetSupplyOrdersAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetSupplyOrdersAnalyticsQuery, GetSupplyOrdersAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSupplyOrdersAnalyticsQuery, GetSupplyOrdersAnalyticsQueryVariables>(GetSupplyOrdersAnalyticsDocument, options);
      }
export function useGetSupplyOrdersAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSupplyOrdersAnalyticsQuery, GetSupplyOrdersAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSupplyOrdersAnalyticsQuery, GetSupplyOrdersAnalyticsQueryVariables>(GetSupplyOrdersAnalyticsDocument, options);
        }
export type GetSupplyOrdersAnalyticsQueryHookResult = ReturnType<typeof useGetSupplyOrdersAnalyticsQuery>;
export type GetSupplyOrdersAnalyticsLazyQueryHookResult = ReturnType<typeof useGetSupplyOrdersAnalyticsLazyQuery>;
export type GetSupplyOrdersAnalyticsQueryResult = Apollo.QueryResult<GetSupplyOrdersAnalyticsQuery, GetSupplyOrdersAnalyticsQueryVariables>;
export function refetchGetSupplyOrdersAnalyticsQuery(variables: GetSupplyOrdersAnalyticsQueryVariables) {
      return { query: GetSupplyOrdersAnalyticsDocument, variables: variables }
    }
export const GetShipmentAnalyticsDocument = gql`
    query getShipmentAnalytics($filters: AnalyticsFilters!) {
  shipmentsAnalytics(filters: $filters) {
    gefcoHistogram {
      ...GefcoShipmentHistogram
      ...GefcoSupplyOrderHistogram
    }
  }
}
    ${GefcoShipmentHistogramFragmentDoc}
${GefcoSupplyOrderHistogramFragmentDoc}`;

/**
 * __useGetShipmentAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetShipmentAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShipmentAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShipmentAnalyticsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetShipmentAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetShipmentAnalyticsQuery, GetShipmentAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShipmentAnalyticsQuery, GetShipmentAnalyticsQueryVariables>(GetShipmentAnalyticsDocument, options);
      }
export function useGetShipmentAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShipmentAnalyticsQuery, GetShipmentAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShipmentAnalyticsQuery, GetShipmentAnalyticsQueryVariables>(GetShipmentAnalyticsDocument, options);
        }
export type GetShipmentAnalyticsQueryHookResult = ReturnType<typeof useGetShipmentAnalyticsQuery>;
export type GetShipmentAnalyticsLazyQueryHookResult = ReturnType<typeof useGetShipmentAnalyticsLazyQuery>;
export type GetShipmentAnalyticsQueryResult = Apollo.QueryResult<GetShipmentAnalyticsQuery, GetShipmentAnalyticsQueryVariables>;
export function refetchGetShipmentAnalyticsQuery(variables: GetShipmentAnalyticsQueryVariables) {
      return { query: GetShipmentAnalyticsDocument, variables: variables }
    }
export const WarrantyClaimsAnalyticsDocument = gql`
    query warrantyClaimsAnalytics($filters: AnalyticsFilters!) {
  warrantyClaimsAnalytics(filters: $filters) {
    ...warrantyClaimsAnalytics
  }
}
    ${WarrantyClaimsAnalyticsFragmentDoc}`;

/**
 * __useWarrantyClaimsAnalyticsQuery__
 *
 * To run a query within a React component, call `useWarrantyClaimsAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWarrantyClaimsAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWarrantyClaimsAnalyticsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useWarrantyClaimsAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<WarrantyClaimsAnalyticsQuery, WarrantyClaimsAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WarrantyClaimsAnalyticsQuery, WarrantyClaimsAnalyticsQueryVariables>(WarrantyClaimsAnalyticsDocument, options);
      }
export function useWarrantyClaimsAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WarrantyClaimsAnalyticsQuery, WarrantyClaimsAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WarrantyClaimsAnalyticsQuery, WarrantyClaimsAnalyticsQueryVariables>(WarrantyClaimsAnalyticsDocument, options);
        }
export type WarrantyClaimsAnalyticsQueryHookResult = ReturnType<typeof useWarrantyClaimsAnalyticsQuery>;
export type WarrantyClaimsAnalyticsLazyQueryHookResult = ReturnType<typeof useWarrantyClaimsAnalyticsLazyQuery>;
export type WarrantyClaimsAnalyticsQueryResult = Apollo.QueryResult<WarrantyClaimsAnalyticsQuery, WarrantyClaimsAnalyticsQueryVariables>;
export function refetchWarrantyClaimsAnalyticsQuery(variables: WarrantyClaimsAnalyticsQueryVariables) {
      return { query: WarrantyClaimsAnalyticsDocument, variables: variables }
    }
export const GetFactoryControlOrganizationsDocument = gql`
    query getFactoryControlOrganizations($organizationGroupId: UUID) {
  factoryControlOrganizations(organizationGroupId: $organizationGroupId) {
    ...Organization
  }
}
    ${OrganizationFragmentDoc}`;

/**
 * __useGetFactoryControlOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetFactoryControlOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFactoryControlOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFactoryControlOrganizationsQuery({
 *   variables: {
 *      organizationGroupId: // value for 'organizationGroupId'
 *   },
 * });
 */
export function useGetFactoryControlOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<GetFactoryControlOrganizationsQuery, GetFactoryControlOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFactoryControlOrganizationsQuery, GetFactoryControlOrganizationsQueryVariables>(GetFactoryControlOrganizationsDocument, options);
      }
export function useGetFactoryControlOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFactoryControlOrganizationsQuery, GetFactoryControlOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFactoryControlOrganizationsQuery, GetFactoryControlOrganizationsQueryVariables>(GetFactoryControlOrganizationsDocument, options);
        }
export type GetFactoryControlOrganizationsQueryHookResult = ReturnType<typeof useGetFactoryControlOrganizationsQuery>;
export type GetFactoryControlOrganizationsLazyQueryHookResult = ReturnType<typeof useGetFactoryControlOrganizationsLazyQuery>;
export type GetFactoryControlOrganizationsQueryResult = Apollo.QueryResult<GetFactoryControlOrganizationsQuery, GetFactoryControlOrganizationsQueryVariables>;
export function refetchGetFactoryControlOrganizationsQuery(variables?: GetFactoryControlOrganizationsQueryVariables) {
      return { query: GetFactoryControlOrganizationsDocument, variables: variables }
    }
export const GetUserDocument = gql`
    query getUser {
  user {
    ...User
  }
}
    ${UserFragmentDoc}`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserQuery(baseOptions?: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export function refetchGetUserQuery(variables?: GetUserQueryVariables) {
      return { query: GetUserDocument, variables: variables }
    }
export const GetUsersDocument = gql`
    query getUsers {
  users {
    ...User
  }
}
    ${UserFragmentDoc}`;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export function refetchGetUsersQuery(variables?: GetUsersQueryVariables) {
      return { query: GetUsersDocument, variables: variables }
    }
export const GetUsersListDocument = gql`
    query getUsersList($options: UserListOptionsInputType) {
  usersList(options: $options) {
    items {
      ...User
    }
    count
  }
}
    ${UserFragmentDoc}`;

/**
 * __useGetUsersListQuery__
 *
 * To run a query within a React component, call `useGetUsersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersListQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetUsersListQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersListQuery, GetUsersListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersListQuery, GetUsersListQueryVariables>(GetUsersListDocument, options);
      }
export function useGetUsersListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersListQuery, GetUsersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersListQuery, GetUsersListQueryVariables>(GetUsersListDocument, options);
        }
export type GetUsersListQueryHookResult = ReturnType<typeof useGetUsersListQuery>;
export type GetUsersListLazyQueryHookResult = ReturnType<typeof useGetUsersListLazyQuery>;
export type GetUsersListQueryResult = Apollo.QueryResult<GetUsersListQuery, GetUsersListQueryVariables>;
export function refetchGetUsersListQuery(variables?: GetUsersListQueryVariables) {
      return { query: GetUsersListDocument, variables: variables }
    }
export const GetOrganizationsDocument = gql`
    query getOrganizations($options: OrganizationListOptionsInputType) {
  organizations(options: $options) {
    items {
      ...Organization
    }
    count
  }
}
    ${OrganizationFragmentDoc}`;

/**
 * __useGetOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationsQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
      }
export function useGetOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
        }
export type GetOrganizationsQueryHookResult = ReturnType<typeof useGetOrganizationsQuery>;
export type GetOrganizationsLazyQueryHookResult = ReturnType<typeof useGetOrganizationsLazyQuery>;
export type GetOrganizationsQueryResult = Apollo.QueryResult<GetOrganizationsQuery, GetOrganizationsQueryVariables>;
export function refetchGetOrganizationsQuery(variables?: GetOrganizationsQueryVariables) {
      return { query: GetOrganizationsDocument, variables: variables }
    }
export const GetChildOrganizationsDocument = gql`
    query getChildOrganizations {
  childOrganizations {
    ...Organization
  }
}
    ${OrganizationFragmentDoc}`;

/**
 * __useGetChildOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetChildOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChildOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChildOrganizationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetChildOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<GetChildOrganizationsQuery, GetChildOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChildOrganizationsQuery, GetChildOrganizationsQueryVariables>(GetChildOrganizationsDocument, options);
      }
export function useGetChildOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChildOrganizationsQuery, GetChildOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChildOrganizationsQuery, GetChildOrganizationsQueryVariables>(GetChildOrganizationsDocument, options);
        }
export type GetChildOrganizationsQueryHookResult = ReturnType<typeof useGetChildOrganizationsQuery>;
export type GetChildOrganizationsLazyQueryHookResult = ReturnType<typeof useGetChildOrganizationsLazyQuery>;
export type GetChildOrganizationsQueryResult = Apollo.QueryResult<GetChildOrganizationsQuery, GetChildOrganizationsQueryVariables>;
export function refetchGetChildOrganizationsQuery(variables?: GetChildOrganizationsQueryVariables) {
      return { query: GetChildOrganizationsDocument, variables: variables }
    }
export const GetChildUsersDocument = gql`
    query getChildUsers {
  childUsers {
    ...User
  }
}
    ${UserFragmentDoc}`;

/**
 * __useGetChildUsersQuery__
 *
 * To run a query within a React component, call `useGetChildUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChildUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChildUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetChildUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetChildUsersQuery, GetChildUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChildUsersQuery, GetChildUsersQueryVariables>(GetChildUsersDocument, options);
      }
export function useGetChildUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChildUsersQuery, GetChildUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChildUsersQuery, GetChildUsersQueryVariables>(GetChildUsersDocument, options);
        }
export type GetChildUsersQueryHookResult = ReturnType<typeof useGetChildUsersQuery>;
export type GetChildUsersLazyQueryHookResult = ReturnType<typeof useGetChildUsersLazyQuery>;
export type GetChildUsersQueryResult = Apollo.QueryResult<GetChildUsersQuery, GetChildUsersQueryVariables>;
export function refetchGetChildUsersQuery(variables?: GetChildUsersQueryVariables) {
      return { query: GetChildUsersDocument, variables: variables }
    }
export const LoginDocument = gql`
    mutation login($input: LoginInput!) {
  login(input: $input) {
    user {
      ...User
    }
    errors {
      field
      messages
    }
  }
}
    ${UserFragmentDoc}`;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const LogoutDocument = gql`
    mutation logout {
  logout {
    success
  }
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation resetPassword($input: ResetPasswordMutationInput!) {
  resetPassword(input: $input) {
    errors {
      field
      messages
    }
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const SetPasswordDocument = gql`
    mutation setPassword($input: SetPasswordMutationInput!) {
  setPassword(input: $input) {
    errors {
      field
      messages
    }
  }
}
    `;
export type SetPasswordMutationFn = Apollo.MutationFunction<SetPasswordMutation, SetPasswordMutationVariables>;

/**
 * __useSetPasswordMutation__
 *
 * To run a mutation, you first call `useSetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPasswordMutation, { data, loading, error }] = useSetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<SetPasswordMutation, SetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPasswordMutation, SetPasswordMutationVariables>(SetPasswordDocument, options);
      }
export type SetPasswordMutationHookResult = ReturnType<typeof useSetPasswordMutation>;
export type SetPasswordMutationResult = Apollo.MutationResult<SetPasswordMutation>;
export type SetPasswordMutationOptions = Apollo.BaseMutationOptions<SetPasswordMutation, SetPasswordMutationVariables>;
export const UpdatePasswordDocument = gql`
    mutation updatePassword($input: UpdatePasswordMutationInput!) {
  updatePassword(input: $input) {
    errors {
      field
      messages
    }
  }
}
    `;
export type UpdatePasswordMutationFn = Apollo.MutationFunction<UpdatePasswordMutation, UpdatePasswordMutationVariables>;

/**
 * __useUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePasswordMutation, { data, loading, error }] = useUpdatePasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePasswordMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePasswordMutation, UpdatePasswordMutationVariables>(UpdatePasswordDocument, options);
      }
export type UpdatePasswordMutationHookResult = ReturnType<typeof useUpdatePasswordMutation>;
export type UpdatePasswordMutationResult = Apollo.MutationResult<UpdatePasswordMutation>;
export type UpdatePasswordMutationOptions = Apollo.BaseMutationOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($input: UpdateUserMutationInput!) {
  updateUser(input: $input) {
    user {
      ...User
    }
    errors {
      field
      messages
    }
  }
}
    ${UserFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const GetAccountsDocument = gql`
    query getAccounts($options: AccountListOptionsInputType, $filterByUser: Boolean) {
  accounts(options: $options, filterByUser: $filterByUser) {
    items {
      ...Account
    }
    count
  }
}
    ${AccountFragmentDoc}`;

/**
 * __useGetAccountsQuery__
 *
 * To run a query within a React component, call `useGetAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountsQuery({
 *   variables: {
 *      options: // value for 'options'
 *      filterByUser: // value for 'filterByUser'
 *   },
 * });
 */
export function useGetAccountsQuery(baseOptions?: Apollo.QueryHookOptions<GetAccountsQuery, GetAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountsQuery, GetAccountsQueryVariables>(GetAccountsDocument, options);
      }
export function useGetAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountsQuery, GetAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountsQuery, GetAccountsQueryVariables>(GetAccountsDocument, options);
        }
export type GetAccountsQueryHookResult = ReturnType<typeof useGetAccountsQuery>;
export type GetAccountsLazyQueryHookResult = ReturnType<typeof useGetAccountsLazyQuery>;
export type GetAccountsQueryResult = Apollo.QueryResult<GetAccountsQuery, GetAccountsQueryVariables>;
export function refetchGetAccountsQuery(variables?: GetAccountsQueryVariables) {
      return { query: GetAccountsDocument, variables: variables }
    }
export const GetAccountOptionsDocument = gql`
    query getAccountOptions($options: AccountListOptionsInputType, $filterByUser: Boolean) {
  accounts(options: $options, filterByUser: $filterByUser) {
    items {
      ...AccountOption
    }
  }
}
    ${AccountOptionFragmentDoc}`;

/**
 * __useGetAccountOptionsQuery__
 *
 * To run a query within a React component, call `useGetAccountOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountOptionsQuery({
 *   variables: {
 *      options: // value for 'options'
 *      filterByUser: // value for 'filterByUser'
 *   },
 * });
 */
export function useGetAccountOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetAccountOptionsQuery, GetAccountOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountOptionsQuery, GetAccountOptionsQueryVariables>(GetAccountOptionsDocument, options);
      }
export function useGetAccountOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountOptionsQuery, GetAccountOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountOptionsQuery, GetAccountOptionsQueryVariables>(GetAccountOptionsDocument, options);
        }
export type GetAccountOptionsQueryHookResult = ReturnType<typeof useGetAccountOptionsQuery>;
export type GetAccountOptionsLazyQueryHookResult = ReturnType<typeof useGetAccountOptionsLazyQuery>;
export type GetAccountOptionsQueryResult = Apollo.QueryResult<GetAccountOptionsQuery, GetAccountOptionsQueryVariables>;
export function refetchGetAccountOptionsQuery(variables?: GetAccountOptionsQueryVariables) {
      return { query: GetAccountOptionsDocument, variables: variables }
    }
export const GetAccountDocument = gql`
    query getAccount($id: UUID) {
  account(id: $id) {
    ...AccountDetail
  }
}
    ${AccountDetailFragmentDoc}`;

/**
 * __useGetAccountQuery__
 *
 * To run a query within a React component, call `useGetAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAccountQuery(baseOptions?: Apollo.QueryHookOptions<GetAccountQuery, GetAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
      }
export function useGetAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountQuery, GetAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
        }
export type GetAccountQueryHookResult = ReturnType<typeof useGetAccountQuery>;
export type GetAccountLazyQueryHookResult = ReturnType<typeof useGetAccountLazyQuery>;
export type GetAccountQueryResult = Apollo.QueryResult<GetAccountQuery, GetAccountQueryVariables>;
export function refetchGetAccountQuery(variables?: GetAccountQueryVariables) {
      return { query: GetAccountDocument, variables: variables }
    }
export const GetEditAccountDocument = gql`
    query getEditAccount($id: UUID) {
  account(id: $id) {
    id
    name
    externalId
    taxId
    location {
      id
    }
    extraLocation
    owner {
      id
    }
    region {
      id
    }
    files {
      id
      file
    }
  }
}
    `;

/**
 * __useGetEditAccountQuery__
 *
 * To run a query within a React component, call `useGetEditAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEditAccountQuery(baseOptions?: Apollo.QueryHookOptions<GetEditAccountQuery, GetEditAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditAccountQuery, GetEditAccountQueryVariables>(GetEditAccountDocument, options);
      }
export function useGetEditAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditAccountQuery, GetEditAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditAccountQuery, GetEditAccountQueryVariables>(GetEditAccountDocument, options);
        }
export type GetEditAccountQueryHookResult = ReturnType<typeof useGetEditAccountQuery>;
export type GetEditAccountLazyQueryHookResult = ReturnType<typeof useGetEditAccountLazyQuery>;
export type GetEditAccountQueryResult = Apollo.QueryResult<GetEditAccountQuery, GetEditAccountQueryVariables>;
export function refetchGetEditAccountQuery(variables?: GetEditAccountQueryVariables) {
      return { query: GetEditAccountDocument, variables: variables }
    }
export const GetAccountOptionDocument = gql`
    query getAccountOption($id: UUID) {
  account(id: $id) {
    ...AccountOption
  }
}
    ${AccountOptionFragmentDoc}`;

/**
 * __useGetAccountOptionQuery__
 *
 * To run a query within a React component, call `useGetAccountOptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountOptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountOptionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAccountOptionQuery(baseOptions?: Apollo.QueryHookOptions<GetAccountOptionQuery, GetAccountOptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountOptionQuery, GetAccountOptionQueryVariables>(GetAccountOptionDocument, options);
      }
export function useGetAccountOptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountOptionQuery, GetAccountOptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountOptionQuery, GetAccountOptionQueryVariables>(GetAccountOptionDocument, options);
        }
export type GetAccountOptionQueryHookResult = ReturnType<typeof useGetAccountOptionQuery>;
export type GetAccountOptionLazyQueryHookResult = ReturnType<typeof useGetAccountOptionLazyQuery>;
export type GetAccountOptionQueryResult = Apollo.QueryResult<GetAccountOptionQuery, GetAccountOptionQueryVariables>;
export function refetchGetAccountOptionQuery(variables?: GetAccountOptionQueryVariables) {
      return { query: GetAccountOptionDocument, variables: variables }
    }
export const CreateAccountDocument = gql`
    mutation createAccount($input: CreateAccountMutationInput!) {
  createAccount(input: $input) {
    account {
      ...AccountDetail
    }
    errors {
      field
      messages
    }
  }
}
    ${AccountDetailFragmentDoc}`;
export type CreateAccountMutationFn = Apollo.MutationFunction<CreateAccountMutation, CreateAccountMutationVariables>;

/**
 * __useCreateAccountMutation__
 *
 * To run a mutation, you first call `useCreateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountMutation, { data, loading, error }] = useCreateAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccountMutation, CreateAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccountMutation, CreateAccountMutationVariables>(CreateAccountDocument, options);
      }
export type CreateAccountMutationHookResult = ReturnType<typeof useCreateAccountMutation>;
export type CreateAccountMutationResult = Apollo.MutationResult<CreateAccountMutation>;
export type CreateAccountMutationOptions = Apollo.BaseMutationOptions<CreateAccountMutation, CreateAccountMutationVariables>;
export const UpdateAccountDocument = gql`
    mutation updateAccount($input: UpdateAccountMutationInput!) {
  updateAccount(input: $input) {
    account {
      ...AccountDetail
    }
    errors {
      field
      messages
    }
  }
}
    ${AccountDetailFragmentDoc}`;
export type UpdateAccountMutationFn = Apollo.MutationFunction<UpdateAccountMutation, UpdateAccountMutationVariables>;

/**
 * __useUpdateAccountMutation__
 *
 * To run a mutation, you first call `useUpdateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountMutation, { data, loading, error }] = useUpdateAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountMutation, UpdateAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountMutation, UpdateAccountMutationVariables>(UpdateAccountDocument, options);
      }
export type UpdateAccountMutationHookResult = ReturnType<typeof useUpdateAccountMutation>;
export type UpdateAccountMutationResult = Apollo.MutationResult<UpdateAccountMutation>;
export type UpdateAccountMutationOptions = Apollo.BaseMutationOptions<UpdateAccountMutation, UpdateAccountMutationVariables>;
export const DeleteAccountDocument = gql`
    mutation deleteAccount($input: DeleteAccountMutationInput!) {
  deleteAccount(input: $input) {
    errors {
      field
      messages
    }
  }
}
    `;
export type DeleteAccountMutationFn = Apollo.MutationFunction<DeleteAccountMutation, DeleteAccountMutationVariables>;

/**
 * __useDeleteAccountMutation__
 *
 * To run a mutation, you first call `useDeleteAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccountMutation, { data, loading, error }] = useDeleteAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAccountMutation, DeleteAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAccountMutation, DeleteAccountMutationVariables>(DeleteAccountDocument, options);
      }
export type DeleteAccountMutationHookResult = ReturnType<typeof useDeleteAccountMutation>;
export type DeleteAccountMutationResult = Apollo.MutationResult<DeleteAccountMutation>;
export type DeleteAccountMutationOptions = Apollo.BaseMutationOptions<DeleteAccountMutation, DeleteAccountMutationVariables>;
export const UpdateAccountExternalIdDocument = gql`
    mutation updateAccountExternalId($input: UpdateAccountExternalIdMutationInput!) {
  updateAccountExternalId(input: $input) {
    errors {
      field
      messages
    }
  }
}
    `;
export type UpdateAccountExternalIdMutationFn = Apollo.MutationFunction<UpdateAccountExternalIdMutation, UpdateAccountExternalIdMutationVariables>;

/**
 * __useUpdateAccountExternalIdMutation__
 *
 * To run a mutation, you first call `useUpdateAccountExternalIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountExternalIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountExternalIdMutation, { data, loading, error }] = useUpdateAccountExternalIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAccountExternalIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountExternalIdMutation, UpdateAccountExternalIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountExternalIdMutation, UpdateAccountExternalIdMutationVariables>(UpdateAccountExternalIdDocument, options);
      }
export type UpdateAccountExternalIdMutationHookResult = ReturnType<typeof useUpdateAccountExternalIdMutation>;
export type UpdateAccountExternalIdMutationResult = Apollo.MutationResult<UpdateAccountExternalIdMutation>;
export type UpdateAccountExternalIdMutationOptions = Apollo.BaseMutationOptions<UpdateAccountExternalIdMutation, UpdateAccountExternalIdMutationVariables>;
export const UpdateAccountFilesDocument = gql`
    mutation updateAccountFiles($id: UUID!, $files: [Upload]!) {
  updateAccountFiles(id: $id, files: $files) {
    errors {
      field
      messages
    }
  }
}
    `;
export type UpdateAccountFilesMutationFn = Apollo.MutationFunction<UpdateAccountFilesMutation, UpdateAccountFilesMutationVariables>;

/**
 * __useUpdateAccountFilesMutation__
 *
 * To run a mutation, you first call `useUpdateAccountFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountFilesMutation, { data, loading, error }] = useUpdateAccountFilesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      files: // value for 'files'
 *   },
 * });
 */
export function useUpdateAccountFilesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountFilesMutation, UpdateAccountFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountFilesMutation, UpdateAccountFilesMutationVariables>(UpdateAccountFilesDocument, options);
      }
export type UpdateAccountFilesMutationHookResult = ReturnType<typeof useUpdateAccountFilesMutation>;
export type UpdateAccountFilesMutationResult = Apollo.MutationResult<UpdateAccountFilesMutation>;
export type UpdateAccountFilesMutationOptions = Apollo.BaseMutationOptions<UpdateAccountFilesMutation, UpdateAccountFilesMutationVariables>;
export const StartAccountRegistrationDocument = gql`
    mutation startAccountRegistration($input: StartAccountRegistrationMutationInput!) {
  startAccountRegistration(input: $input) {
    account {
      ...AccountDetail
    }
    errors {
      field
      messages
    }
  }
}
    ${AccountDetailFragmentDoc}`;
export type StartAccountRegistrationMutationFn = Apollo.MutationFunction<StartAccountRegistrationMutation, StartAccountRegistrationMutationVariables>;

/**
 * __useStartAccountRegistrationMutation__
 *
 * To run a mutation, you first call `useStartAccountRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartAccountRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startAccountRegistrationMutation, { data, loading, error }] = useStartAccountRegistrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartAccountRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<StartAccountRegistrationMutation, StartAccountRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartAccountRegistrationMutation, StartAccountRegistrationMutationVariables>(StartAccountRegistrationDocument, options);
      }
export type StartAccountRegistrationMutationHookResult = ReturnType<typeof useStartAccountRegistrationMutation>;
export type StartAccountRegistrationMutationResult = Apollo.MutationResult<StartAccountRegistrationMutation>;
export type StartAccountRegistrationMutationOptions = Apollo.BaseMutationOptions<StartAccountRegistrationMutation, StartAccountRegistrationMutationVariables>;
export const ReviewAccountRegistrationDocument = gql`
    mutation reviewAccountRegistration($input: ReviewAccountRegistrationMutationInput!) {
  reviewAccountRegistration(input: $input) {
    accountRegistrationReview {
      ...AccountRegistrationReview
    }
    errors {
      field
      messages
    }
  }
}
    ${AccountRegistrationReviewFragmentDoc}`;
export type ReviewAccountRegistrationMutationFn = Apollo.MutationFunction<ReviewAccountRegistrationMutation, ReviewAccountRegistrationMutationVariables>;

/**
 * __useReviewAccountRegistrationMutation__
 *
 * To run a mutation, you first call `useReviewAccountRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewAccountRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewAccountRegistrationMutation, { data, loading, error }] = useReviewAccountRegistrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReviewAccountRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<ReviewAccountRegistrationMutation, ReviewAccountRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReviewAccountRegistrationMutation, ReviewAccountRegistrationMutationVariables>(ReviewAccountRegistrationDocument, options);
      }
export type ReviewAccountRegistrationMutationHookResult = ReturnType<typeof useReviewAccountRegistrationMutation>;
export type ReviewAccountRegistrationMutationResult = Apollo.MutationResult<ReviewAccountRegistrationMutation>;
export type ReviewAccountRegistrationMutationOptions = Apollo.BaseMutationOptions<ReviewAccountRegistrationMutation, ReviewAccountRegistrationMutationVariables>;
export const GetAccountRegionsDocument = gql`
    query getAccountRegions {
  accountRegions {
    ...AccountRegionOption
  }
}
    ${AccountRegionOptionFragmentDoc}`;

/**
 * __useGetAccountRegionsQuery__
 *
 * To run a query within a React component, call `useGetAccountRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountRegionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAccountRegionsQuery(baseOptions?: Apollo.QueryHookOptions<GetAccountRegionsQuery, GetAccountRegionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountRegionsQuery, GetAccountRegionsQueryVariables>(GetAccountRegionsDocument, options);
      }
export function useGetAccountRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountRegionsQuery, GetAccountRegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountRegionsQuery, GetAccountRegionsQueryVariables>(GetAccountRegionsDocument, options);
        }
export type GetAccountRegionsQueryHookResult = ReturnType<typeof useGetAccountRegionsQuery>;
export type GetAccountRegionsLazyQueryHookResult = ReturnType<typeof useGetAccountRegionsLazyQuery>;
export type GetAccountRegionsQueryResult = Apollo.QueryResult<GetAccountRegionsQuery, GetAccountRegionsQueryVariables>;
export function refetchGetAccountRegionsQuery(variables?: GetAccountRegionsQueryVariables) {
      return { query: GetAccountRegionsDocument, variables: variables }
    }
export const GetContactsDocument = gql`
    query getContacts($options: ContactListOptionsInputType, $filterByUser: Boolean) {
  contacts(options: $options, filterByUser: $filterByUser) {
    items {
      ...Contact
    }
    count
  }
}
    ${ContactFragmentDoc}`;

/**
 * __useGetContactsQuery__
 *
 * To run a query within a React component, call `useGetContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactsQuery({
 *   variables: {
 *      options: // value for 'options'
 *      filterByUser: // value for 'filterByUser'
 *   },
 * });
 */
export function useGetContactsQuery(baseOptions?: Apollo.QueryHookOptions<GetContactsQuery, GetContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactsQuery, GetContactsQueryVariables>(GetContactsDocument, options);
      }
export function useGetContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactsQuery, GetContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactsQuery, GetContactsQueryVariables>(GetContactsDocument, options);
        }
export type GetContactsQueryHookResult = ReturnType<typeof useGetContactsQuery>;
export type GetContactsLazyQueryHookResult = ReturnType<typeof useGetContactsLazyQuery>;
export type GetContactsQueryResult = Apollo.QueryResult<GetContactsQuery, GetContactsQueryVariables>;
export function refetchGetContactsQuery(variables?: GetContactsQueryVariables) {
      return { query: GetContactsDocument, variables: variables }
    }
export const GetContactOptionsDocument = gql`
    query getContactOptions($options: ContactListOptionsInputType, $filterByUser: Boolean) {
  contacts(options: $options, filterByUser: $filterByUser) {
    items {
      ...ContactOption
    }
    count
  }
}
    ${ContactOptionFragmentDoc}`;

/**
 * __useGetContactOptionsQuery__
 *
 * To run a query within a React component, call `useGetContactOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactOptionsQuery({
 *   variables: {
 *      options: // value for 'options'
 *      filterByUser: // value for 'filterByUser'
 *   },
 * });
 */
export function useGetContactOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetContactOptionsQuery, GetContactOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactOptionsQuery, GetContactOptionsQueryVariables>(GetContactOptionsDocument, options);
      }
export function useGetContactOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactOptionsQuery, GetContactOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactOptionsQuery, GetContactOptionsQueryVariables>(GetContactOptionsDocument, options);
        }
export type GetContactOptionsQueryHookResult = ReturnType<typeof useGetContactOptionsQuery>;
export type GetContactOptionsLazyQueryHookResult = ReturnType<typeof useGetContactOptionsLazyQuery>;
export type GetContactOptionsQueryResult = Apollo.QueryResult<GetContactOptionsQuery, GetContactOptionsQueryVariables>;
export function refetchGetContactOptionsQuery(variables?: GetContactOptionsQueryVariables) {
      return { query: GetContactOptionsDocument, variables: variables }
    }
export const GetContactAccountDocument = gql`
    query getContactAccount($id: UUID) {
  contact(id: $id) {
    account {
      id
    }
  }
}
    `;

/**
 * __useGetContactAccountQuery__
 *
 * To run a query within a React component, call `useGetContactAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetContactAccountQuery(baseOptions?: Apollo.QueryHookOptions<GetContactAccountQuery, GetContactAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactAccountQuery, GetContactAccountQueryVariables>(GetContactAccountDocument, options);
      }
export function useGetContactAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactAccountQuery, GetContactAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactAccountQuery, GetContactAccountQueryVariables>(GetContactAccountDocument, options);
        }
export type GetContactAccountQueryHookResult = ReturnType<typeof useGetContactAccountQuery>;
export type GetContactAccountLazyQueryHookResult = ReturnType<typeof useGetContactAccountLazyQuery>;
export type GetContactAccountQueryResult = Apollo.QueryResult<GetContactAccountQuery, GetContactAccountQueryVariables>;
export function refetchGetContactAccountQuery(variables?: GetContactAccountQueryVariables) {
      return { query: GetContactAccountDocument, variables: variables }
    }
export const GetContactDocument = gql`
    query getContact($id: UUID) {
  contact(id: $id) {
    ...ContactDetail
  }
}
    ${ContactDetailFragmentDoc}`;

/**
 * __useGetContactQuery__
 *
 * To run a query within a React component, call `useGetContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetContactQuery(baseOptions?: Apollo.QueryHookOptions<GetContactQuery, GetContactQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactQuery, GetContactQueryVariables>(GetContactDocument, options);
      }
export function useGetContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactQuery, GetContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactQuery, GetContactQueryVariables>(GetContactDocument, options);
        }
export type GetContactQueryHookResult = ReturnType<typeof useGetContactQuery>;
export type GetContactLazyQueryHookResult = ReturnType<typeof useGetContactLazyQuery>;
export type GetContactQueryResult = Apollo.QueryResult<GetContactQuery, GetContactQueryVariables>;
export function refetchGetContactQuery(variables?: GetContactQueryVariables) {
      return { query: GetContactDocument, variables: variables }
    }
export const GetMachineStartupMinimalContactDocument = gql`
    query getMachineStartupMinimalContact($id: UUID!) {
  contact(id: $id) {
    id
    phone
    mobilePhone
  }
}
    `;

/**
 * __useGetMachineStartupMinimalContactQuery__
 *
 * To run a query within a React component, call `useGetMachineStartupMinimalContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMachineStartupMinimalContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMachineStartupMinimalContactQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMachineStartupMinimalContactQuery(baseOptions: Apollo.QueryHookOptions<GetMachineStartupMinimalContactQuery, GetMachineStartupMinimalContactQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMachineStartupMinimalContactQuery, GetMachineStartupMinimalContactQueryVariables>(GetMachineStartupMinimalContactDocument, options);
      }
export function useGetMachineStartupMinimalContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMachineStartupMinimalContactQuery, GetMachineStartupMinimalContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMachineStartupMinimalContactQuery, GetMachineStartupMinimalContactQueryVariables>(GetMachineStartupMinimalContactDocument, options);
        }
export type GetMachineStartupMinimalContactQueryHookResult = ReturnType<typeof useGetMachineStartupMinimalContactQuery>;
export type GetMachineStartupMinimalContactLazyQueryHookResult = ReturnType<typeof useGetMachineStartupMinimalContactLazyQuery>;
export type GetMachineStartupMinimalContactQueryResult = Apollo.QueryResult<GetMachineStartupMinimalContactQuery, GetMachineStartupMinimalContactQueryVariables>;
export function refetchGetMachineStartupMinimalContactQuery(variables: GetMachineStartupMinimalContactQueryVariables) {
      return { query: GetMachineStartupMinimalContactDocument, variables: variables }
    }
export const CreateContactDocument = gql`
    mutation createContact($input: CreateContactMutationInput!) {
  createContact(input: $input) {
    contact {
      ...ContactDetail
    }
    errors {
      field
      messages
    }
  }
}
    ${ContactDetailFragmentDoc}`;
export type CreateContactMutationFn = Apollo.MutationFunction<CreateContactMutation, CreateContactMutationVariables>;

/**
 * __useCreateContactMutation__
 *
 * To run a mutation, you first call `useCreateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactMutation, { data, loading, error }] = useCreateContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContactMutation(baseOptions?: Apollo.MutationHookOptions<CreateContactMutation, CreateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContactMutation, CreateContactMutationVariables>(CreateContactDocument, options);
      }
export type CreateContactMutationHookResult = ReturnType<typeof useCreateContactMutation>;
export type CreateContactMutationResult = Apollo.MutationResult<CreateContactMutation>;
export type CreateContactMutationOptions = Apollo.BaseMutationOptions<CreateContactMutation, CreateContactMutationVariables>;
export const UpdateContactDocument = gql`
    mutation updateContact($input: UpdateContactMutationInput!) {
  updateContact(input: $input) {
    contact {
      ...ContactDetail
    }
    errors {
      field
      messages
    }
  }
}
    ${ContactDetailFragmentDoc}`;
export type UpdateContactMutationFn = Apollo.MutationFunction<UpdateContactMutation, UpdateContactMutationVariables>;

/**
 * __useUpdateContactMutation__
 *
 * To run a mutation, you first call `useUpdateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactMutation, { data, loading, error }] = useUpdateContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContactMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContactMutation, UpdateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContactMutation, UpdateContactMutationVariables>(UpdateContactDocument, options);
      }
export type UpdateContactMutationHookResult = ReturnType<typeof useUpdateContactMutation>;
export type UpdateContactMutationResult = Apollo.MutationResult<UpdateContactMutation>;
export type UpdateContactMutationOptions = Apollo.BaseMutationOptions<UpdateContactMutation, UpdateContactMutationVariables>;
export const DeleteContactDocument = gql`
    mutation deleteContact($input: DeleteContactMutationInput!) {
  deleteContact(input: $input) {
    errors {
      field
      messages
    }
  }
}
    `;
export type DeleteContactMutationFn = Apollo.MutationFunction<DeleteContactMutation, DeleteContactMutationVariables>;

/**
 * __useDeleteContactMutation__
 *
 * To run a mutation, you first call `useDeleteContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContactMutation, { data, loading, error }] = useDeleteContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteContactMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContactMutation, DeleteContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContactMutation, DeleteContactMutationVariables>(DeleteContactDocument, options);
      }
export type DeleteContactMutationHookResult = ReturnType<typeof useDeleteContactMutation>;
export type DeleteContactMutationResult = Apollo.MutationResult<DeleteContactMutation>;
export type DeleteContactMutationOptions = Apollo.BaseMutationOptions<DeleteContactMutation, DeleteContactMutationVariables>;
export const GetContactTypesDocument = gql`
    query getContactTypes {
  contactTypes {
    ...ContactTypeOption
  }
}
    ${ContactTypeOptionFragmentDoc}`;

/**
 * __useGetContactTypesQuery__
 *
 * To run a query within a React component, call `useGetContactTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContactTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetContactTypesQuery, GetContactTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactTypesQuery, GetContactTypesQueryVariables>(GetContactTypesDocument, options);
      }
export function useGetContactTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactTypesQuery, GetContactTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactTypesQuery, GetContactTypesQueryVariables>(GetContactTypesDocument, options);
        }
export type GetContactTypesQueryHookResult = ReturnType<typeof useGetContactTypesQuery>;
export type GetContactTypesLazyQueryHookResult = ReturnType<typeof useGetContactTypesLazyQuery>;
export type GetContactTypesQueryResult = Apollo.QueryResult<GetContactTypesQuery, GetContactTypesQueryVariables>;
export function refetchGetContactTypesQuery(variables?: GetContactTypesQueryVariables) {
      return { query: GetContactTypesDocument, variables: variables }
    }
export const GetOpportunitiesDocument = gql`
    query getOpportunities($options: OpportunityListOptionsInputType) {
  opportunities(options: $options) {
    items {
      ...Opportunity
    }
    count
  }
}
    ${OpportunityFragmentDoc}`;

/**
 * __useGetOpportunitiesQuery__
 *
 * To run a query within a React component, call `useGetOpportunitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpportunitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOpportunitiesQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetOpportunitiesQuery(baseOptions?: Apollo.QueryHookOptions<GetOpportunitiesQuery, GetOpportunitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOpportunitiesQuery, GetOpportunitiesQueryVariables>(GetOpportunitiesDocument, options);
      }
export function useGetOpportunitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOpportunitiesQuery, GetOpportunitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOpportunitiesQuery, GetOpportunitiesQueryVariables>(GetOpportunitiesDocument, options);
        }
export type GetOpportunitiesQueryHookResult = ReturnType<typeof useGetOpportunitiesQuery>;
export type GetOpportunitiesLazyQueryHookResult = ReturnType<typeof useGetOpportunitiesLazyQuery>;
export type GetOpportunitiesQueryResult = Apollo.QueryResult<GetOpportunitiesQuery, GetOpportunitiesQueryVariables>;
export function refetchGetOpportunitiesQuery(variables?: GetOpportunitiesQueryVariables) {
      return { query: GetOpportunitiesDocument, variables: variables }
    }
export const GetOpportunityDocument = gql`
    query getOpportunity($id: UUID) {
  opportunity(id: $id) {
    ...OpportunityDetail
  }
}
    ${OpportunityDetailFragmentDoc}`;

/**
 * __useGetOpportunityQuery__
 *
 * To run a query within a React component, call `useGetOpportunityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpportunityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOpportunityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOpportunityQuery(baseOptions?: Apollo.QueryHookOptions<GetOpportunityQuery, GetOpportunityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOpportunityQuery, GetOpportunityQueryVariables>(GetOpportunityDocument, options);
      }
export function useGetOpportunityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOpportunityQuery, GetOpportunityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOpportunityQuery, GetOpportunityQueryVariables>(GetOpportunityDocument, options);
        }
export type GetOpportunityQueryHookResult = ReturnType<typeof useGetOpportunityQuery>;
export type GetOpportunityLazyQueryHookResult = ReturnType<typeof useGetOpportunityLazyQuery>;
export type GetOpportunityQueryResult = Apollo.QueryResult<GetOpportunityQuery, GetOpportunityQueryVariables>;
export function refetchGetOpportunityQuery(variables?: GetOpportunityQueryVariables) {
      return { query: GetOpportunityDocument, variables: variables }
    }
export const CreateOpportunityDocument = gql`
    mutation createOpportunity($input: CreateOpportunityMutationInput!) {
  createOpportunity(input: $input) {
    opportunity {
      ...OpportunityDetail
    }
    errors {
      field
      messages
    }
  }
}
    ${OpportunityDetailFragmentDoc}`;
export type CreateOpportunityMutationFn = Apollo.MutationFunction<CreateOpportunityMutation, CreateOpportunityMutationVariables>;

/**
 * __useCreateOpportunityMutation__
 *
 * To run a mutation, you first call `useCreateOpportunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOpportunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOpportunityMutation, { data, loading, error }] = useCreateOpportunityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOpportunityMutation(baseOptions?: Apollo.MutationHookOptions<CreateOpportunityMutation, CreateOpportunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOpportunityMutation, CreateOpportunityMutationVariables>(CreateOpportunityDocument, options);
      }
export type CreateOpportunityMutationHookResult = ReturnType<typeof useCreateOpportunityMutation>;
export type CreateOpportunityMutationResult = Apollo.MutationResult<CreateOpportunityMutation>;
export type CreateOpportunityMutationOptions = Apollo.BaseMutationOptions<CreateOpportunityMutation, CreateOpportunityMutationVariables>;
export const UpdateOpportunityDocument = gql`
    mutation updateOpportunity($input: UpdateOpportunityMutationInput!) {
  updateOpportunity(input: $input) {
    opportunity {
      ...OpportunityDetail
    }
    errors {
      field
      messages
    }
  }
}
    ${OpportunityDetailFragmentDoc}`;
export type UpdateOpportunityMutationFn = Apollo.MutationFunction<UpdateOpportunityMutation, UpdateOpportunityMutationVariables>;

/**
 * __useUpdateOpportunityMutation__
 *
 * To run a mutation, you first call `useUpdateOpportunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOpportunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOpportunityMutation, { data, loading, error }] = useUpdateOpportunityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOpportunityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOpportunityMutation, UpdateOpportunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOpportunityMutation, UpdateOpportunityMutationVariables>(UpdateOpportunityDocument, options);
      }
export type UpdateOpportunityMutationHookResult = ReturnType<typeof useUpdateOpportunityMutation>;
export type UpdateOpportunityMutationResult = Apollo.MutationResult<UpdateOpportunityMutation>;
export type UpdateOpportunityMutationOptions = Apollo.BaseMutationOptions<UpdateOpportunityMutation, UpdateOpportunityMutationVariables>;
export const DeleteOpportunityDocument = gql`
    mutation deleteOpportunity($input: DeleteOpportunityMutationInput!) {
  deleteOpportunity(input: $input) {
    errors {
      field
      messages
    }
  }
}
    `;
export type DeleteOpportunityMutationFn = Apollo.MutationFunction<DeleteOpportunityMutation, DeleteOpportunityMutationVariables>;

/**
 * __useDeleteOpportunityMutation__
 *
 * To run a mutation, you first call `useDeleteOpportunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOpportunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOpportunityMutation, { data, loading, error }] = useDeleteOpportunityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteOpportunityMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOpportunityMutation, DeleteOpportunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOpportunityMutation, DeleteOpportunityMutationVariables>(DeleteOpportunityDocument, options);
      }
export type DeleteOpportunityMutationHookResult = ReturnType<typeof useDeleteOpportunityMutation>;
export type DeleteOpportunityMutationResult = Apollo.MutationResult<DeleteOpportunityMutation>;
export type DeleteOpportunityMutationOptions = Apollo.BaseMutationOptions<DeleteOpportunityMutation, DeleteOpportunityMutationVariables>;
export const GetOpportunityChannelsDocument = gql`
    query getOpportunityChannels {
  opportunityChannels {
    ...OpportunityChannelOption
  }
}
    ${OpportunityChannelOptionFragmentDoc}`;

/**
 * __useGetOpportunityChannelsQuery__
 *
 * To run a query within a React component, call `useGetOpportunityChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpportunityChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOpportunityChannelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOpportunityChannelsQuery(baseOptions?: Apollo.QueryHookOptions<GetOpportunityChannelsQuery, GetOpportunityChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOpportunityChannelsQuery, GetOpportunityChannelsQueryVariables>(GetOpportunityChannelsDocument, options);
      }
export function useGetOpportunityChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOpportunityChannelsQuery, GetOpportunityChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOpportunityChannelsQuery, GetOpportunityChannelsQueryVariables>(GetOpportunityChannelsDocument, options);
        }
export type GetOpportunityChannelsQueryHookResult = ReturnType<typeof useGetOpportunityChannelsQuery>;
export type GetOpportunityChannelsLazyQueryHookResult = ReturnType<typeof useGetOpportunityChannelsLazyQuery>;
export type GetOpportunityChannelsQueryResult = Apollo.QueryResult<GetOpportunityChannelsQuery, GetOpportunityChannelsQueryVariables>;
export function refetchGetOpportunityChannelsQuery(variables?: GetOpportunityChannelsQueryVariables) {
      return { query: GetOpportunityChannelsDocument, variables: variables }
    }
export const GetOpportunityReasonsDocument = gql`
    query getOpportunityReasons {
  opportunityReasons {
    ...OpportunityReasonOption
  }
}
    ${OpportunityReasonOptionFragmentDoc}`;

/**
 * __useGetOpportunityReasonsQuery__
 *
 * To run a query within a React component, call `useGetOpportunityReasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpportunityReasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOpportunityReasonsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOpportunityReasonsQuery(baseOptions?: Apollo.QueryHookOptions<GetOpportunityReasonsQuery, GetOpportunityReasonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOpportunityReasonsQuery, GetOpportunityReasonsQueryVariables>(GetOpportunityReasonsDocument, options);
      }
export function useGetOpportunityReasonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOpportunityReasonsQuery, GetOpportunityReasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOpportunityReasonsQuery, GetOpportunityReasonsQueryVariables>(GetOpportunityReasonsDocument, options);
        }
export type GetOpportunityReasonsQueryHookResult = ReturnType<typeof useGetOpportunityReasonsQuery>;
export type GetOpportunityReasonsLazyQueryHookResult = ReturnType<typeof useGetOpportunityReasonsLazyQuery>;
export type GetOpportunityReasonsQueryResult = Apollo.QueryResult<GetOpportunityReasonsQuery, GetOpportunityReasonsQueryVariables>;
export function refetchGetOpportunityReasonsQuery(variables?: GetOpportunityReasonsQueryVariables) {
      return { query: GetOpportunityReasonsDocument, variables: variables }
    }
export const GetOpportunitySituationsDocument = gql`
    query getOpportunitySituations {
  opportunitySituations {
    ...OpportunitySituationOption
  }
}
    ${OpportunitySituationOptionFragmentDoc}`;

/**
 * __useGetOpportunitySituationsQuery__
 *
 * To run a query within a React component, call `useGetOpportunitySituationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpportunitySituationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOpportunitySituationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOpportunitySituationsQuery(baseOptions?: Apollo.QueryHookOptions<GetOpportunitySituationsQuery, GetOpportunitySituationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOpportunitySituationsQuery, GetOpportunitySituationsQueryVariables>(GetOpportunitySituationsDocument, options);
      }
export function useGetOpportunitySituationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOpportunitySituationsQuery, GetOpportunitySituationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOpportunitySituationsQuery, GetOpportunitySituationsQueryVariables>(GetOpportunitySituationsDocument, options);
        }
export type GetOpportunitySituationsQueryHookResult = ReturnType<typeof useGetOpportunitySituationsQuery>;
export type GetOpportunitySituationsLazyQueryHookResult = ReturnType<typeof useGetOpportunitySituationsLazyQuery>;
export type GetOpportunitySituationsQueryResult = Apollo.QueryResult<GetOpportunitySituationsQuery, GetOpportunitySituationsQueryVariables>;
export function refetchGetOpportunitySituationsQuery(variables?: GetOpportunitySituationsQueryVariables) {
      return { query: GetOpportunitySituationsDocument, variables: variables }
    }
export const GetBillingTypesDocument = gql`
    query getBillingTypes {
  billingTypes {
    ...BillingTypeOption
  }
}
    ${BillingTypeOptionFragmentDoc}`;

/**
 * __useGetBillingTypesQuery__
 *
 * To run a query within a React component, call `useGetBillingTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillingTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBillingTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBillingTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetBillingTypesQuery, GetBillingTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBillingTypesQuery, GetBillingTypesQueryVariables>(GetBillingTypesDocument, options);
      }
export function useGetBillingTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBillingTypesQuery, GetBillingTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBillingTypesQuery, GetBillingTypesQueryVariables>(GetBillingTypesDocument, options);
        }
export type GetBillingTypesQueryHookResult = ReturnType<typeof useGetBillingTypesQuery>;
export type GetBillingTypesLazyQueryHookResult = ReturnType<typeof useGetBillingTypesLazyQuery>;
export type GetBillingTypesQueryResult = Apollo.QueryResult<GetBillingTypesQuery, GetBillingTypesQueryVariables>;
export function refetchGetBillingTypesQuery(variables?: GetBillingTypesQueryVariables) {
      return { query: GetBillingTypesDocument, variables: variables }
    }
export const GetProductCategoriesDocument = gql`
    query getProductCategories($seederId: UUID) {
  productCategories(seederId: $seederId) {
    ...ProductCategoryOption
  }
}
    ${ProductCategoryOptionFragmentDoc}`;

/**
 * __useGetProductCategoriesQuery__
 *
 * To run a query within a React component, call `useGetProductCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductCategoriesQuery({
 *   variables: {
 *      seederId: // value for 'seederId'
 *   },
 * });
 */
export function useGetProductCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetProductCategoriesQuery, GetProductCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductCategoriesQuery, GetProductCategoriesQueryVariables>(GetProductCategoriesDocument, options);
      }
export function useGetProductCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductCategoriesQuery, GetProductCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductCategoriesQuery, GetProductCategoriesQueryVariables>(GetProductCategoriesDocument, options);
        }
export type GetProductCategoriesQueryHookResult = ReturnType<typeof useGetProductCategoriesQuery>;
export type GetProductCategoriesLazyQueryHookResult = ReturnType<typeof useGetProductCategoriesLazyQuery>;
export type GetProductCategoriesQueryResult = Apollo.QueryResult<GetProductCategoriesQuery, GetProductCategoriesQueryVariables>;
export function refetchGetProductCategoriesQuery(variables?: GetProductCategoriesQueryVariables) {
      return { query: GetProductCategoriesDocument, variables: variables }
    }
export const GetProductCategoriesForAssistedQuoteDocument = gql`
    query getProductCategoriesForAssistedQuote {
  productCategoriesForAssistedQuote {
    ...ProductCategoryOption
  }
}
    ${ProductCategoryOptionFragmentDoc}`;

/**
 * __useGetProductCategoriesForAssistedQuoteQuery__
 *
 * To run a query within a React component, call `useGetProductCategoriesForAssistedQuoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductCategoriesForAssistedQuoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductCategoriesForAssistedQuoteQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProductCategoriesForAssistedQuoteQuery(baseOptions?: Apollo.QueryHookOptions<GetProductCategoriesForAssistedQuoteQuery, GetProductCategoriesForAssistedQuoteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductCategoriesForAssistedQuoteQuery, GetProductCategoriesForAssistedQuoteQueryVariables>(GetProductCategoriesForAssistedQuoteDocument, options);
      }
export function useGetProductCategoriesForAssistedQuoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductCategoriesForAssistedQuoteQuery, GetProductCategoriesForAssistedQuoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductCategoriesForAssistedQuoteQuery, GetProductCategoriesForAssistedQuoteQueryVariables>(GetProductCategoriesForAssistedQuoteDocument, options);
        }
export type GetProductCategoriesForAssistedQuoteQueryHookResult = ReturnType<typeof useGetProductCategoriesForAssistedQuoteQuery>;
export type GetProductCategoriesForAssistedQuoteLazyQueryHookResult = ReturnType<typeof useGetProductCategoriesForAssistedQuoteLazyQuery>;
export type GetProductCategoriesForAssistedQuoteQueryResult = Apollo.QueryResult<GetProductCategoriesForAssistedQuoteQuery, GetProductCategoriesForAssistedQuoteQueryVariables>;
export function refetchGetProductCategoriesForAssistedQuoteQuery(variables?: GetProductCategoriesForAssistedQuoteQueryVariables) {
      return { query: GetProductCategoriesForAssistedQuoteDocument, variables: variables }
    }
export const GetProductCategoriesEnabledForSeederDocument = gql`
    query getProductCategoriesEnabledForSeeder {
  productCategoriesEnabledForSeeder {
    ...ProductCategoryOption
  }
}
    ${ProductCategoryOptionFragmentDoc}`;

/**
 * __useGetProductCategoriesEnabledForSeederQuery__
 *
 * To run a query within a React component, call `useGetProductCategoriesEnabledForSeederQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductCategoriesEnabledForSeederQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductCategoriesEnabledForSeederQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProductCategoriesEnabledForSeederQuery(baseOptions?: Apollo.QueryHookOptions<GetProductCategoriesEnabledForSeederQuery, GetProductCategoriesEnabledForSeederQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductCategoriesEnabledForSeederQuery, GetProductCategoriesEnabledForSeederQueryVariables>(GetProductCategoriesEnabledForSeederDocument, options);
      }
export function useGetProductCategoriesEnabledForSeederLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductCategoriesEnabledForSeederQuery, GetProductCategoriesEnabledForSeederQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductCategoriesEnabledForSeederQuery, GetProductCategoriesEnabledForSeederQueryVariables>(GetProductCategoriesEnabledForSeederDocument, options);
        }
export type GetProductCategoriesEnabledForSeederQueryHookResult = ReturnType<typeof useGetProductCategoriesEnabledForSeederQuery>;
export type GetProductCategoriesEnabledForSeederLazyQueryHookResult = ReturnType<typeof useGetProductCategoriesEnabledForSeederLazyQuery>;
export type GetProductCategoriesEnabledForSeederQueryResult = Apollo.QueryResult<GetProductCategoriesEnabledForSeederQuery, GetProductCategoriesEnabledForSeederQueryVariables>;
export function refetchGetProductCategoriesEnabledForSeederQuery(variables?: GetProductCategoriesEnabledForSeederQueryVariables) {
      return { query: GetProductCategoriesEnabledForSeederDocument, variables: variables }
    }
export const GetProductSubcategoriesDocument = gql`
    query getProductSubcategories {
  productSubcategories {
    ...ProductSubcategory
  }
}
    ${ProductSubcategoryFragmentDoc}`;

/**
 * __useGetProductSubcategoriesQuery__
 *
 * To run a query within a React component, call `useGetProductSubcategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductSubcategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductSubcategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProductSubcategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetProductSubcategoriesQuery, GetProductSubcategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductSubcategoriesQuery, GetProductSubcategoriesQueryVariables>(GetProductSubcategoriesDocument, options);
      }
export function useGetProductSubcategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductSubcategoriesQuery, GetProductSubcategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductSubcategoriesQuery, GetProductSubcategoriesQueryVariables>(GetProductSubcategoriesDocument, options);
        }
export type GetProductSubcategoriesQueryHookResult = ReturnType<typeof useGetProductSubcategoriesQuery>;
export type GetProductSubcategoriesLazyQueryHookResult = ReturnType<typeof useGetProductSubcategoriesLazyQuery>;
export type GetProductSubcategoriesQueryResult = Apollo.QueryResult<GetProductSubcategoriesQuery, GetProductSubcategoriesQueryVariables>;
export function refetchGetProductSubcategoriesQuery(variables?: GetProductSubcategoriesQueryVariables) {
      return { query: GetProductSubcategoriesDocument, variables: variables }
    }
export const GetProductsDocument = gql`
    query getProducts($organizationId: UUID) {
  products(organizationId: $organizationId) {
    ...Product
  }
}
    ${ProductFragmentDoc}`;

/**
 * __useGetProductsQuery__
 *
 * To run a query within a React component, call `useGetProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetProductsQuery(baseOptions?: Apollo.QueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
      }
export function useGetProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
        }
export type GetProductsQueryHookResult = ReturnType<typeof useGetProductsQuery>;
export type GetProductsLazyQueryHookResult = ReturnType<typeof useGetProductsLazyQuery>;
export type GetProductsQueryResult = Apollo.QueryResult<GetProductsQuery, GetProductsQueryVariables>;
export function refetchGetProductsQuery(variables?: GetProductsQueryVariables) {
      return { query: GetProductsDocument, variables: variables }
    }
export const GetProductsV2Document = gql`
    query getProductsV2($options: ProductListTypeV2OptionsInputType2) {
  productsV2(options: $options) {
    items {
      ...Product
    }
    count
  }
}
    ${ProductFragmentDoc}`;

/**
 * __useGetProductsV2Query__
 *
 * To run a query within a React component, call `useGetProductsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsV2Query({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetProductsV2Query(baseOptions?: Apollo.QueryHookOptions<GetProductsV2Query, GetProductsV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsV2Query, GetProductsV2QueryVariables>(GetProductsV2Document, options);
      }
export function useGetProductsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsV2Query, GetProductsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsV2Query, GetProductsV2QueryVariables>(GetProductsV2Document, options);
        }
export type GetProductsV2QueryHookResult = ReturnType<typeof useGetProductsV2Query>;
export type GetProductsV2LazyQueryHookResult = ReturnType<typeof useGetProductsV2LazyQuery>;
export type GetProductsV2QueryResult = Apollo.QueryResult<GetProductsV2Query, GetProductsV2QueryVariables>;
export function refetchGetProductsV2Query(variables?: GetProductsV2QueryVariables) {
      return { query: GetProductsV2Document, variables: variables }
    }
export const GetUnpublishedProductsDocument = gql`
    query getUnpublishedProducts {
  unpublishedProducts {
    ...Product
  }
}
    ${ProductFragmentDoc}`;

/**
 * __useGetUnpublishedProductsQuery__
 *
 * To run a query within a React component, call `useGetUnpublishedProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnpublishedProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnpublishedProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnpublishedProductsQuery(baseOptions?: Apollo.QueryHookOptions<GetUnpublishedProductsQuery, GetUnpublishedProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnpublishedProductsQuery, GetUnpublishedProductsQueryVariables>(GetUnpublishedProductsDocument, options);
      }
export function useGetUnpublishedProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnpublishedProductsQuery, GetUnpublishedProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnpublishedProductsQuery, GetUnpublishedProductsQueryVariables>(GetUnpublishedProductsDocument, options);
        }
export type GetUnpublishedProductsQueryHookResult = ReturnType<typeof useGetUnpublishedProductsQuery>;
export type GetUnpublishedProductsLazyQueryHookResult = ReturnType<typeof useGetUnpublishedProductsLazyQuery>;
export type GetUnpublishedProductsQueryResult = Apollo.QueryResult<GetUnpublishedProductsQuery, GetUnpublishedProductsQueryVariables>;
export function refetchGetUnpublishedProductsQuery(variables?: GetUnpublishedProductsQueryVariables) {
      return { query: GetUnpublishedProductsDocument, variables: variables }
    }
export const GetProductPriceModifiersDocument = gql`
    query getProductPriceModifiers {
  productPriceModifiers {
    ...ProductPriceModifier
  }
}
    ${ProductPriceModifierFragmentDoc}`;

/**
 * __useGetProductPriceModifiersQuery__
 *
 * To run a query within a React component, call `useGetProductPriceModifiersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductPriceModifiersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductPriceModifiersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProductPriceModifiersQuery(baseOptions?: Apollo.QueryHookOptions<GetProductPriceModifiersQuery, GetProductPriceModifiersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductPriceModifiersQuery, GetProductPriceModifiersQueryVariables>(GetProductPriceModifiersDocument, options);
      }
export function useGetProductPriceModifiersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductPriceModifiersQuery, GetProductPriceModifiersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductPriceModifiersQuery, GetProductPriceModifiersQueryVariables>(GetProductPriceModifiersDocument, options);
        }
export type GetProductPriceModifiersQueryHookResult = ReturnType<typeof useGetProductPriceModifiersQuery>;
export type GetProductPriceModifiersLazyQueryHookResult = ReturnType<typeof useGetProductPriceModifiersLazyQuery>;
export type GetProductPriceModifiersQueryResult = Apollo.QueryResult<GetProductPriceModifiersQuery, GetProductPriceModifiersQueryVariables>;
export function refetchGetProductPriceModifiersQuery(variables?: GetProductPriceModifiersQueryVariables) {
      return { query: GetProductPriceModifiersDocument, variables: variables }
    }
export const GetProductDocument = gql`
    query getProduct($id: UUID) {
  product(id: $id) {
    ...Product
  }
}
    ${ProductFragmentDoc}`;

/**
 * __useGetProductQuery__
 *
 * To run a query within a React component, call `useGetProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProductQuery(baseOptions?: Apollo.QueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
      }
export function useGetProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
        }
export type GetProductQueryHookResult = ReturnType<typeof useGetProductQuery>;
export type GetProductLazyQueryHookResult = ReturnType<typeof useGetProductLazyQuery>;
export type GetProductQueryResult = Apollo.QueryResult<GetProductQuery, GetProductQueryVariables>;
export function refetchGetProductQuery(variables?: GetProductQueryVariables) {
      return { query: GetProductDocument, variables: variables }
    }
export const GetProductsImagesDocument = gql`
    query getProductsImages($req: ProductImageRequestType) {
  productsImages(req: $req) {
    ...ProductImage
  }
}
    ${ProductImageFragmentDoc}`;

/**
 * __useGetProductsImagesQuery__
 *
 * To run a query within a React component, call `useGetProductsImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsImagesQuery({
 *   variables: {
 *      req: // value for 'req'
 *   },
 * });
 */
export function useGetProductsImagesQuery(baseOptions?: Apollo.QueryHookOptions<GetProductsImagesQuery, GetProductsImagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsImagesQuery, GetProductsImagesQueryVariables>(GetProductsImagesDocument, options);
      }
export function useGetProductsImagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsImagesQuery, GetProductsImagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsImagesQuery, GetProductsImagesQueryVariables>(GetProductsImagesDocument, options);
        }
export type GetProductsImagesQueryHookResult = ReturnType<typeof useGetProductsImagesQuery>;
export type GetProductsImagesLazyQueryHookResult = ReturnType<typeof useGetProductsImagesLazyQuery>;
export type GetProductsImagesQueryResult = Apollo.QueryResult<GetProductsImagesQuery, GetProductsImagesQueryVariables>;
export function refetchGetProductsImagesQuery(variables?: GetProductsImagesQueryVariables) {
      return { query: GetProductsImagesDocument, variables: variables }
    }
export const GetProductOptionsDocument = gql`
    query getProductOptions($categoryId: UUID, $organizationId: UUID) {
  products(categoryId: $categoryId, organizationId: $organizationId) {
    ...ProductOption
  }
}
    ${ProductOptionFragmentDoc}`;

/**
 * __useGetProductOptionsQuery__
 *
 * To run a query within a React component, call `useGetProductOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductOptionsQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetProductOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetProductOptionsQuery, GetProductOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductOptionsQuery, GetProductOptionsQueryVariables>(GetProductOptionsDocument, options);
      }
export function useGetProductOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductOptionsQuery, GetProductOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductOptionsQuery, GetProductOptionsQueryVariables>(GetProductOptionsDocument, options);
        }
export type GetProductOptionsQueryHookResult = ReturnType<typeof useGetProductOptionsQuery>;
export type GetProductOptionsLazyQueryHookResult = ReturnType<typeof useGetProductOptionsLazyQuery>;
export type GetProductOptionsQueryResult = Apollo.QueryResult<GetProductOptionsQuery, GetProductOptionsQueryVariables>;
export function refetchGetProductOptionsQuery(variables?: GetProductOptionsQueryVariables) {
      return { query: GetProductOptionsDocument, variables: variables }
    }
export const GetProductCategoryDocument = gql`
    query getProductCategory($id: UUID) {
  product(id: $id) {
    subcategory {
      category {
        id
      }
    }
  }
}
    `;

/**
 * __useGetProductCategoryQuery__
 *
 * To run a query within a React component, call `useGetProductCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductCategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProductCategoryQuery(baseOptions?: Apollo.QueryHookOptions<GetProductCategoryQuery, GetProductCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductCategoryQuery, GetProductCategoryQueryVariables>(GetProductCategoryDocument, options);
      }
export function useGetProductCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductCategoryQuery, GetProductCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductCategoryQuery, GetProductCategoryQueryVariables>(GetProductCategoryDocument, options);
        }
export type GetProductCategoryQueryHookResult = ReturnType<typeof useGetProductCategoryQuery>;
export type GetProductCategoryLazyQueryHookResult = ReturnType<typeof useGetProductCategoryLazyQuery>;
export type GetProductCategoryQueryResult = Apollo.QueryResult<GetProductCategoryQuery, GetProductCategoryQueryVariables>;
export function refetchGetProductCategoryQuery(variables?: GetProductCategoryQueryVariables) {
      return { query: GetProductCategoryDocument, variables: variables }
    }
export const GetProductSubcategoryDocument = gql`
    query getProductSubcategory($id: UUID) {
  product(id: $id) {
    subcategory {
      id
    }
  }
}
    `;

/**
 * __useGetProductSubcategoryQuery__
 *
 * To run a query within a React component, call `useGetProductSubcategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductSubcategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductSubcategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProductSubcategoryQuery(baseOptions?: Apollo.QueryHookOptions<GetProductSubcategoryQuery, GetProductSubcategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductSubcategoryQuery, GetProductSubcategoryQueryVariables>(GetProductSubcategoryDocument, options);
      }
export function useGetProductSubcategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductSubcategoryQuery, GetProductSubcategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductSubcategoryQuery, GetProductSubcategoryQueryVariables>(GetProductSubcategoryDocument, options);
        }
export type GetProductSubcategoryQueryHookResult = ReturnType<typeof useGetProductSubcategoryQuery>;
export type GetProductSubcategoryLazyQueryHookResult = ReturnType<typeof useGetProductSubcategoryLazyQuery>;
export type GetProductSubcategoryQueryResult = Apollo.QueryResult<GetProductSubcategoryQuery, GetProductSubcategoryQueryVariables>;
export function refetchGetProductSubcategoryQuery(variables?: GetProductSubcategoryQueryVariables) {
      return { query: GetProductSubcategoryDocument, variables: variables }
    }
export const GetProductWarrantyClaimDocument = gql`
    query getProductWarrantyClaim($id: UUID) {
  productWarrantyClaim(id: $id) {
    ...ProductWarrantyClaim
  }
}
    ${ProductWarrantyClaimFragmentDoc}`;

/**
 * __useGetProductWarrantyClaimQuery__
 *
 * To run a query within a React component, call `useGetProductWarrantyClaimQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductWarrantyClaimQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductWarrantyClaimQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProductWarrantyClaimQuery(baseOptions?: Apollo.QueryHookOptions<GetProductWarrantyClaimQuery, GetProductWarrantyClaimQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductWarrantyClaimQuery, GetProductWarrantyClaimQueryVariables>(GetProductWarrantyClaimDocument, options);
      }
export function useGetProductWarrantyClaimLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductWarrantyClaimQuery, GetProductWarrantyClaimQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductWarrantyClaimQuery, GetProductWarrantyClaimQueryVariables>(GetProductWarrantyClaimDocument, options);
        }
export type GetProductWarrantyClaimQueryHookResult = ReturnType<typeof useGetProductWarrantyClaimQuery>;
export type GetProductWarrantyClaimLazyQueryHookResult = ReturnType<typeof useGetProductWarrantyClaimLazyQuery>;
export type GetProductWarrantyClaimQueryResult = Apollo.QueryResult<GetProductWarrantyClaimQuery, GetProductWarrantyClaimQueryVariables>;
export function refetchGetProductWarrantyClaimQuery(variables?: GetProductWarrantyClaimQueryVariables) {
      return { query: GetProductWarrantyClaimDocument, variables: variables }
    }
export const GetProductWarrantyClaimsDocument = gql`
    query getProductWarrantyClaims($options: ProductWarrantyClaimListOptionsInputType) {
  productWarrantyClaims(options: $options) {
    items {
      ...ProductWarrantyClaimList
    }
    count
  }
}
    ${ProductWarrantyClaimListFragmentDoc}`;

/**
 * __useGetProductWarrantyClaimsQuery__
 *
 * To run a query within a React component, call `useGetProductWarrantyClaimsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductWarrantyClaimsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductWarrantyClaimsQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetProductWarrantyClaimsQuery(baseOptions?: Apollo.QueryHookOptions<GetProductWarrantyClaimsQuery, GetProductWarrantyClaimsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductWarrantyClaimsQuery, GetProductWarrantyClaimsQueryVariables>(GetProductWarrantyClaimsDocument, options);
      }
export function useGetProductWarrantyClaimsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductWarrantyClaimsQuery, GetProductWarrantyClaimsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductWarrantyClaimsQuery, GetProductWarrantyClaimsQueryVariables>(GetProductWarrantyClaimsDocument, options);
        }
export type GetProductWarrantyClaimsQueryHookResult = ReturnType<typeof useGetProductWarrantyClaimsQuery>;
export type GetProductWarrantyClaimsLazyQueryHookResult = ReturnType<typeof useGetProductWarrantyClaimsLazyQuery>;
export type GetProductWarrantyClaimsQueryResult = Apollo.QueryResult<GetProductWarrantyClaimsQuery, GetProductWarrantyClaimsQueryVariables>;
export function refetchGetProductWarrantyClaimsQuery(variables?: GetProductWarrantyClaimsQueryVariables) {
      return { query: GetProductWarrantyClaimsDocument, variables: variables }
    }
export const GetWarrantyClaimsIdsDocument = gql`
    query getWarrantyClaimsIds($options: ProductWarrantyClaimListOptionsInputType) {
  productWarrantyClaims(options: $options) {
    items {
      id
      displayId
    }
  }
}
    `;

/**
 * __useGetWarrantyClaimsIdsQuery__
 *
 * To run a query within a React component, call `useGetWarrantyClaimsIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWarrantyClaimsIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWarrantyClaimsIdsQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetWarrantyClaimsIdsQuery(baseOptions?: Apollo.QueryHookOptions<GetWarrantyClaimsIdsQuery, GetWarrantyClaimsIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWarrantyClaimsIdsQuery, GetWarrantyClaimsIdsQueryVariables>(GetWarrantyClaimsIdsDocument, options);
      }
export function useGetWarrantyClaimsIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWarrantyClaimsIdsQuery, GetWarrantyClaimsIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWarrantyClaimsIdsQuery, GetWarrantyClaimsIdsQueryVariables>(GetWarrantyClaimsIdsDocument, options);
        }
export type GetWarrantyClaimsIdsQueryHookResult = ReturnType<typeof useGetWarrantyClaimsIdsQuery>;
export type GetWarrantyClaimsIdsLazyQueryHookResult = ReturnType<typeof useGetWarrantyClaimsIdsLazyQuery>;
export type GetWarrantyClaimsIdsQueryResult = Apollo.QueryResult<GetWarrantyClaimsIdsQuery, GetWarrantyClaimsIdsQueryVariables>;
export function refetchGetWarrantyClaimsIdsQuery(variables?: GetWarrantyClaimsIdsQueryVariables) {
      return { query: GetWarrantyClaimsIdsDocument, variables: variables }
    }
export const GetOrderOemDocument = gql`
    query getOrderOem($id: UUID) {
  orderOem(id: $id) {
    ...OrderOEM
  }
}
    ${OrderOemFragmentDoc}`;

/**
 * __useGetOrderOemQuery__
 *
 * To run a query within a React component, call `useGetOrderOemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderOemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderOemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrderOemQuery(baseOptions?: Apollo.QueryHookOptions<GetOrderOemQuery, GetOrderOemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderOemQuery, GetOrderOemQueryVariables>(GetOrderOemDocument, options);
      }
export function useGetOrderOemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderOemQuery, GetOrderOemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderOemQuery, GetOrderOemQueryVariables>(GetOrderOemDocument, options);
        }
export type GetOrderOemQueryHookResult = ReturnType<typeof useGetOrderOemQuery>;
export type GetOrderOemLazyQueryHookResult = ReturnType<typeof useGetOrderOemLazyQuery>;
export type GetOrderOemQueryResult = Apollo.QueryResult<GetOrderOemQuery, GetOrderOemQueryVariables>;
export function refetchGetOrderOemQuery(variables?: GetOrderOemQueryVariables) {
      return { query: GetOrderOemDocument, variables: variables }
    }
export const GetOrderOemBankInvoiceDocument = gql`
    query getOrderOemBankInvoice($id: UUID) {
  orderOem(id: $id) {
    ...OrderOEM
    organization {
      taxId
      originalOrganization {
        id
        location {
          id
          path
        }
      }
      ...OEMOrganization
    }
  }
}
    ${OrderOemFragmentDoc}
${OemOrganizationFragmentDoc}`;

/**
 * __useGetOrderOemBankInvoiceQuery__
 *
 * To run a query within a React component, call `useGetOrderOemBankInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderOemBankInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderOemBankInvoiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrderOemBankInvoiceQuery(baseOptions?: Apollo.QueryHookOptions<GetOrderOemBankInvoiceQuery, GetOrderOemBankInvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderOemBankInvoiceQuery, GetOrderOemBankInvoiceQueryVariables>(GetOrderOemBankInvoiceDocument, options);
      }
export function useGetOrderOemBankInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderOemBankInvoiceQuery, GetOrderOemBankInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderOemBankInvoiceQuery, GetOrderOemBankInvoiceQueryVariables>(GetOrderOemBankInvoiceDocument, options);
        }
export type GetOrderOemBankInvoiceQueryHookResult = ReturnType<typeof useGetOrderOemBankInvoiceQuery>;
export type GetOrderOemBankInvoiceLazyQueryHookResult = ReturnType<typeof useGetOrderOemBankInvoiceLazyQuery>;
export type GetOrderOemBankInvoiceQueryResult = Apollo.QueryResult<GetOrderOemBankInvoiceQuery, GetOrderOemBankInvoiceQueryVariables>;
export function refetchGetOrderOemBankInvoiceQuery(variables?: GetOrderOemBankInvoiceQueryVariables) {
      return { query: GetOrderOemBankInvoiceDocument, variables: variables }
    }
export const OemOrderBankInvoicePdfExportDocument = gql`
    mutation oemOrderBankInvoicePdfExport($id: UUID!) {
  oemOrderBankInvoicePdfExport(id: $id) {
    job {
      ...ExportJob
    }
  }
}
    ${ExportJobFragmentDoc}`;
export type OemOrderBankInvoicePdfExportMutationFn = Apollo.MutationFunction<OemOrderBankInvoicePdfExportMutation, OemOrderBankInvoicePdfExportMutationVariables>;

/**
 * __useOemOrderBankInvoicePdfExportMutation__
 *
 * To run a mutation, you first call `useOemOrderBankInvoicePdfExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOemOrderBankInvoicePdfExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [oemOrderBankInvoicePdfExportMutation, { data, loading, error }] = useOemOrderBankInvoicePdfExportMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOemOrderBankInvoicePdfExportMutation(baseOptions?: Apollo.MutationHookOptions<OemOrderBankInvoicePdfExportMutation, OemOrderBankInvoicePdfExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OemOrderBankInvoicePdfExportMutation, OemOrderBankInvoicePdfExportMutationVariables>(OemOrderBankInvoicePdfExportDocument, options);
      }
export type OemOrderBankInvoicePdfExportMutationHookResult = ReturnType<typeof useOemOrderBankInvoicePdfExportMutation>;
export type OemOrderBankInvoicePdfExportMutationResult = Apollo.MutationResult<OemOrderBankInvoicePdfExportMutation>;
export type OemOrderBankInvoicePdfExportMutationOptions = Apollo.BaseMutationOptions<OemOrderBankInvoicePdfExportMutation, OemOrderBankInvoicePdfExportMutationVariables>;
export const CreateOemOrderPdfDocument = gql`
    mutation createOemOrderPdf($id: UUID!) {
  createOemOrderPdf(id: $id) {
    job {
      ...ExportJob
    }
  }
}
    ${ExportJobFragmentDoc}`;
export type CreateOemOrderPdfMutationFn = Apollo.MutationFunction<CreateOemOrderPdfMutation, CreateOemOrderPdfMutationVariables>;

/**
 * __useCreateOemOrderPdfMutation__
 *
 * To run a mutation, you first call `useCreateOemOrderPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOemOrderPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOemOrderPdfMutation, { data, loading, error }] = useCreateOemOrderPdfMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCreateOemOrderPdfMutation(baseOptions?: Apollo.MutationHookOptions<CreateOemOrderPdfMutation, CreateOemOrderPdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOemOrderPdfMutation, CreateOemOrderPdfMutationVariables>(CreateOemOrderPdfDocument, options);
      }
export type CreateOemOrderPdfMutationHookResult = ReturnType<typeof useCreateOemOrderPdfMutation>;
export type CreateOemOrderPdfMutationResult = Apollo.MutationResult<CreateOemOrderPdfMutation>;
export type CreateOemOrderPdfMutationOptions = Apollo.BaseMutationOptions<CreateOemOrderPdfMutation, CreateOemOrderPdfMutationVariables>;
export const GetOrdersOemDocument = gql`
    query getOrdersOem($options: OrderOEMListOptionsInputType) {
  ordersOem(options: $options) {
    items {
      ...OrderOEM
    }
    count
  }
}
    ${OrderOemFragmentDoc}`;

/**
 * __useGetOrdersOemQuery__
 *
 * To run a query within a React component, call `useGetOrdersOemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdersOemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrdersOemQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetOrdersOemQuery(baseOptions?: Apollo.QueryHookOptions<GetOrdersOemQuery, GetOrdersOemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrdersOemQuery, GetOrdersOemQueryVariables>(GetOrdersOemDocument, options);
      }
export function useGetOrdersOemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrdersOemQuery, GetOrdersOemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrdersOemQuery, GetOrdersOemQueryVariables>(GetOrdersOemDocument, options);
        }
export type GetOrdersOemQueryHookResult = ReturnType<typeof useGetOrdersOemQuery>;
export type GetOrdersOemLazyQueryHookResult = ReturnType<typeof useGetOrdersOemLazyQuery>;
export type GetOrdersOemQueryResult = Apollo.QueryResult<GetOrdersOemQuery, GetOrdersOemQueryVariables>;
export function refetchGetOrdersOemQuery(variables?: GetOrdersOemQueryVariables) {
      return { query: GetOrdersOemDocument, variables: variables }
    }
export const GetPaymentMethodsDocument = gql`
    query getPaymentMethods {
  paymentMethods {
    ...PaymentMethod
  }
}
    ${PaymentMethodFragmentDoc}`;

/**
 * __useGetPaymentMethodsQuery__
 *
 * To run a query within a React component, call `useGetPaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentMethodsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPaymentMethodsQuery(baseOptions?: Apollo.QueryHookOptions<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>(GetPaymentMethodsDocument, options);
      }
export function useGetPaymentMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>(GetPaymentMethodsDocument, options);
        }
export type GetPaymentMethodsQueryHookResult = ReturnType<typeof useGetPaymentMethodsQuery>;
export type GetPaymentMethodsLazyQueryHookResult = ReturnType<typeof useGetPaymentMethodsLazyQuery>;
export type GetPaymentMethodsQueryResult = Apollo.QueryResult<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>;
export function refetchGetPaymentMethodsQuery(variables?: GetPaymentMethodsQueryVariables) {
      return { query: GetPaymentMethodsDocument, variables: variables }
    }
export const GetPaymentMethodDocument = gql`
    query getPaymentMethod($id: UUID) {
  paymentMethod(id: $id) {
    ...PaymentMethod
  }
}
    ${PaymentMethodFragmentDoc}`;

/**
 * __useGetPaymentMethodQuery__
 *
 * To run a query within a React component, call `useGetPaymentMethodQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentMethodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentMethodQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPaymentMethodQuery(baseOptions?: Apollo.QueryHookOptions<GetPaymentMethodQuery, GetPaymentMethodQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentMethodQuery, GetPaymentMethodQueryVariables>(GetPaymentMethodDocument, options);
      }
export function useGetPaymentMethodLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentMethodQuery, GetPaymentMethodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentMethodQuery, GetPaymentMethodQueryVariables>(GetPaymentMethodDocument, options);
        }
export type GetPaymentMethodQueryHookResult = ReturnType<typeof useGetPaymentMethodQuery>;
export type GetPaymentMethodLazyQueryHookResult = ReturnType<typeof useGetPaymentMethodLazyQuery>;
export type GetPaymentMethodQueryResult = Apollo.QueryResult<GetPaymentMethodQuery, GetPaymentMethodQueryVariables>;
export function refetchGetPaymentMethodQuery(variables?: GetPaymentMethodQueryVariables) {
      return { query: GetPaymentMethodDocument, variables: variables }
    }
export const GetPaymentMethodOptionsDocument = gql`
    query getPaymentMethodOptions($categoryId: UUID, $organizationId: UUID) {
  paymentMethods(categoryId: $categoryId, organizationId: $organizationId) {
    id
    name
  }
}
    `;

/**
 * __useGetPaymentMethodOptionsQuery__
 *
 * To run a query within a React component, call `useGetPaymentMethodOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentMethodOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentMethodOptionsQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetPaymentMethodOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetPaymentMethodOptionsQuery, GetPaymentMethodOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentMethodOptionsQuery, GetPaymentMethodOptionsQueryVariables>(GetPaymentMethodOptionsDocument, options);
      }
export function useGetPaymentMethodOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentMethodOptionsQuery, GetPaymentMethodOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentMethodOptionsQuery, GetPaymentMethodOptionsQueryVariables>(GetPaymentMethodOptionsDocument, options);
        }
export type GetPaymentMethodOptionsQueryHookResult = ReturnType<typeof useGetPaymentMethodOptionsQuery>;
export type GetPaymentMethodOptionsLazyQueryHookResult = ReturnType<typeof useGetPaymentMethodOptionsLazyQuery>;
export type GetPaymentMethodOptionsQueryResult = Apollo.QueryResult<GetPaymentMethodOptionsQuery, GetPaymentMethodOptionsQueryVariables>;
export function refetchGetPaymentMethodOptionsQuery(variables?: GetPaymentMethodOptionsQueryVariables) {
      return { query: GetPaymentMethodOptionsDocument, variables: variables }
    }
export const GetPaymentMethodCategoryDocument = gql`
    query getPaymentMethodCategory($categoryId: UUID) {
  paymentMethodCategories(categoryId: $categoryId) {
    ...PaymentMethodCategory
  }
}
    ${PaymentMethodCategoryFragmentDoc}`;

/**
 * __useGetPaymentMethodCategoryQuery__
 *
 * To run a query within a React component, call `useGetPaymentMethodCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentMethodCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentMethodCategoryQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useGetPaymentMethodCategoryQuery(baseOptions?: Apollo.QueryHookOptions<GetPaymentMethodCategoryQuery, GetPaymentMethodCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentMethodCategoryQuery, GetPaymentMethodCategoryQueryVariables>(GetPaymentMethodCategoryDocument, options);
      }
export function useGetPaymentMethodCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentMethodCategoryQuery, GetPaymentMethodCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentMethodCategoryQuery, GetPaymentMethodCategoryQueryVariables>(GetPaymentMethodCategoryDocument, options);
        }
export type GetPaymentMethodCategoryQueryHookResult = ReturnType<typeof useGetPaymentMethodCategoryQuery>;
export type GetPaymentMethodCategoryLazyQueryHookResult = ReturnType<typeof useGetPaymentMethodCategoryLazyQuery>;
export type GetPaymentMethodCategoryQueryResult = Apollo.QueryResult<GetPaymentMethodCategoryQuery, GetPaymentMethodCategoryQueryVariables>;
export function refetchGetPaymentMethodCategoryQuery(variables?: GetPaymentMethodCategoryQueryVariables) {
      return { query: GetPaymentMethodCategoryDocument, variables: variables }
    }
export const GetPaymentMethodCategoriesDocument = gql`
    query getPaymentMethodCategories {
  paymentMethodCategories {
    id
    name
    finnancied
  }
}
    `;

/**
 * __useGetPaymentMethodCategoriesQuery__
 *
 * To run a query within a React component, call `useGetPaymentMethodCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentMethodCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentMethodCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPaymentMethodCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetPaymentMethodCategoriesQuery, GetPaymentMethodCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentMethodCategoriesQuery, GetPaymentMethodCategoriesQueryVariables>(GetPaymentMethodCategoriesDocument, options);
      }
export function useGetPaymentMethodCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentMethodCategoriesQuery, GetPaymentMethodCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentMethodCategoriesQuery, GetPaymentMethodCategoriesQueryVariables>(GetPaymentMethodCategoriesDocument, options);
        }
export type GetPaymentMethodCategoriesQueryHookResult = ReturnType<typeof useGetPaymentMethodCategoriesQuery>;
export type GetPaymentMethodCategoriesLazyQueryHookResult = ReturnType<typeof useGetPaymentMethodCategoriesLazyQuery>;
export type GetPaymentMethodCategoriesQueryResult = Apollo.QueryResult<GetPaymentMethodCategoriesQuery, GetPaymentMethodCategoriesQueryVariables>;
export function refetchGetPaymentMethodCategoriesQuery(variables?: GetPaymentMethodCategoriesQueryVariables) {
      return { query: GetPaymentMethodCategoriesDocument, variables: variables }
    }
export const GetQuoteRulesDocument = gql`
    query getQuoteRules {
  quoteRules {
    ...QuoteRule
  }
}
    ${QuoteRuleFragmentDoc}`;

/**
 * __useGetQuoteRulesQuery__
 *
 * To run a query within a React component, call `useGetQuoteRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuoteRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuoteRulesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetQuoteRulesQuery(baseOptions?: Apollo.QueryHookOptions<GetQuoteRulesQuery, GetQuoteRulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuoteRulesQuery, GetQuoteRulesQueryVariables>(GetQuoteRulesDocument, options);
      }
export function useGetQuoteRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuoteRulesQuery, GetQuoteRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuoteRulesQuery, GetQuoteRulesQueryVariables>(GetQuoteRulesDocument, options);
        }
export type GetQuoteRulesQueryHookResult = ReturnType<typeof useGetQuoteRulesQuery>;
export type GetQuoteRulesLazyQueryHookResult = ReturnType<typeof useGetQuoteRulesLazyQuery>;
export type GetQuoteRulesQueryResult = Apollo.QueryResult<GetQuoteRulesQuery, GetQuoteRulesQueryVariables>;
export function refetchGetQuoteRulesQuery(variables?: GetQuoteRulesQueryVariables) {
      return { query: GetQuoteRulesDocument, variables: variables }
    }
export const GetQuotesDocument = gql`
    query getQuotes($options: QuoteListOptionsInputType) {
  quotes(options: $options) {
    items {
      ...QuoteList
    }
    count
  }
}
    ${QuoteListFragmentDoc}`;

/**
 * __useGetQuotesQuery__
 *
 * To run a query within a React component, call `useGetQuotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuotesQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetQuotesQuery(baseOptions?: Apollo.QueryHookOptions<GetQuotesQuery, GetQuotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuotesQuery, GetQuotesQueryVariables>(GetQuotesDocument, options);
      }
export function useGetQuotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuotesQuery, GetQuotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuotesQuery, GetQuotesQueryVariables>(GetQuotesDocument, options);
        }
export type GetQuotesQueryHookResult = ReturnType<typeof useGetQuotesQuery>;
export type GetQuotesLazyQueryHookResult = ReturnType<typeof useGetQuotesLazyQuery>;
export type GetQuotesQueryResult = Apollo.QueryResult<GetQuotesQuery, GetQuotesQueryVariables>;
export function refetchGetQuotesQuery(variables?: GetQuotesQueryVariables) {
      return { query: GetQuotesDocument, variables: variables }
    }
export const GetOemOrdersDocument = gql`
    query getOemOrders($options: QuoteListOptionsInputType) {
  oemOrders(options: $options) {
    items {
      ...Quote
    }
    count
  }
}
    ${QuoteFragmentDoc}`;

/**
 * __useGetOemOrdersQuery__
 *
 * To run a query within a React component, call `useGetOemOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOemOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOemOrdersQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetOemOrdersQuery(baseOptions?: Apollo.QueryHookOptions<GetOemOrdersQuery, GetOemOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOemOrdersQuery, GetOemOrdersQueryVariables>(GetOemOrdersDocument, options);
      }
export function useGetOemOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOemOrdersQuery, GetOemOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOemOrdersQuery, GetOemOrdersQueryVariables>(GetOemOrdersDocument, options);
        }
export type GetOemOrdersQueryHookResult = ReturnType<typeof useGetOemOrdersQuery>;
export type GetOemOrdersLazyQueryHookResult = ReturnType<typeof useGetOemOrdersLazyQuery>;
export type GetOemOrdersQueryResult = Apollo.QueryResult<GetOemOrdersQuery, GetOemOrdersQueryVariables>;
export function refetchGetOemOrdersQuery(variables?: GetOemOrdersQueryVariables) {
      return { query: GetOemOrdersDocument, variables: variables }
    }
export const GetQuoteDocument = gql`
    query getQuote($id: UUID) {
  quote(id: $id) {
    ...QuoteDetail
  }
}
    ${QuoteDetailFragmentDoc}`;

/**
 * __useGetQuoteQuery__
 *
 * To run a query within a React component, call `useGetQuoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuoteQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetQuoteQuery(baseOptions?: Apollo.QueryHookOptions<GetQuoteQuery, GetQuoteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuoteQuery, GetQuoteQueryVariables>(GetQuoteDocument, options);
      }
export function useGetQuoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuoteQuery, GetQuoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuoteQuery, GetQuoteQueryVariables>(GetQuoteDocument, options);
        }
export type GetQuoteQueryHookResult = ReturnType<typeof useGetQuoteQuery>;
export type GetQuoteLazyQueryHookResult = ReturnType<typeof useGetQuoteLazyQuery>;
export type GetQuoteQueryResult = Apollo.QueryResult<GetQuoteQuery, GetQuoteQueryVariables>;
export function refetchGetQuoteQuery(variables?: GetQuoteQueryVariables) {
      return { query: GetQuoteDocument, variables: variables }
    }
export const GetQuotedPaymentMethodDocument = gql`
    query getQuotedPaymentMethod($id: UUID) {
  quotedPaymentMethod(id: $id) {
    ...QuotedPaymentMethod
  }
}
    ${QuotedPaymentMethodFragmentDoc}`;

/**
 * __useGetQuotedPaymentMethodQuery__
 *
 * To run a query within a React component, call `useGetQuotedPaymentMethodQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuotedPaymentMethodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuotedPaymentMethodQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetQuotedPaymentMethodQuery(baseOptions?: Apollo.QueryHookOptions<GetQuotedPaymentMethodQuery, GetQuotedPaymentMethodQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuotedPaymentMethodQuery, GetQuotedPaymentMethodQueryVariables>(GetQuotedPaymentMethodDocument, options);
      }
export function useGetQuotedPaymentMethodLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuotedPaymentMethodQuery, GetQuotedPaymentMethodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuotedPaymentMethodQuery, GetQuotedPaymentMethodQueryVariables>(GetQuotedPaymentMethodDocument, options);
        }
export type GetQuotedPaymentMethodQueryHookResult = ReturnType<typeof useGetQuotedPaymentMethodQuery>;
export type GetQuotedPaymentMethodLazyQueryHookResult = ReturnType<typeof useGetQuotedPaymentMethodLazyQuery>;
export type GetQuotedPaymentMethodQueryResult = Apollo.QueryResult<GetQuotedPaymentMethodQuery, GetQuotedPaymentMethodQueryVariables>;
export function refetchGetQuotedPaymentMethodQuery(variables?: GetQuotedPaymentMethodQueryVariables) {
      return { query: GetQuotedPaymentMethodDocument, variables: variables }
    }
export const CreateQuoteDocument = gql`
    mutation createQuote($input: CreateQuoteMutationInput!) {
  createQuote(input: $input) {
    quote {
      ...QuoteDetail
    }
    errors {
      field
      messages
    }
  }
}
    ${QuoteDetailFragmentDoc}`;
export type CreateQuoteMutationFn = Apollo.MutationFunction<CreateQuoteMutation, CreateQuoteMutationVariables>;

/**
 * __useCreateQuoteMutation__
 *
 * To run a mutation, you first call `useCreateQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuoteMutation, { data, loading, error }] = useCreateQuoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateQuoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuoteMutation, CreateQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuoteMutation, CreateQuoteMutationVariables>(CreateQuoteDocument, options);
      }
export type CreateQuoteMutationHookResult = ReturnType<typeof useCreateQuoteMutation>;
export type CreateQuoteMutationResult = Apollo.MutationResult<CreateQuoteMutation>;
export type CreateQuoteMutationOptions = Apollo.BaseMutationOptions<CreateQuoteMutation, CreateQuoteMutationVariables>;
export const UpdateQuoteDocument = gql`
    mutation updateQuote($input: UpdateQuoteMutationInput!) {
  updateQuote(input: $input) {
    quote {
      ...QuoteDetail
    }
    errors {
      field
      messages
    }
  }
}
    ${QuoteDetailFragmentDoc}`;
export type UpdateQuoteMutationFn = Apollo.MutationFunction<UpdateQuoteMutation, UpdateQuoteMutationVariables>;

/**
 * __useUpdateQuoteMutation__
 *
 * To run a mutation, you first call `useUpdateQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuoteMutation, { data, loading, error }] = useUpdateQuoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuoteMutation, UpdateQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuoteMutation, UpdateQuoteMutationVariables>(UpdateQuoteDocument, options);
      }
export type UpdateQuoteMutationHookResult = ReturnType<typeof useUpdateQuoteMutation>;
export type UpdateQuoteMutationResult = Apollo.MutationResult<UpdateQuoteMutation>;
export type UpdateQuoteMutationOptions = Apollo.BaseMutationOptions<UpdateQuoteMutation, UpdateQuoteMutationVariables>;
export const UpdateQuotePricesDocument = gql`
    mutation updateQuotePrices($input: UpdateQuotePricesMutationInput!) {
  updateQuotePrices(input: $input) {
    quote {
      ...QuoteDetail
    }
    errors {
      field
      messages
    }
  }
}
    ${QuoteDetailFragmentDoc}`;
export type UpdateQuotePricesMutationFn = Apollo.MutationFunction<UpdateQuotePricesMutation, UpdateQuotePricesMutationVariables>;

/**
 * __useUpdateQuotePricesMutation__
 *
 * To run a mutation, you first call `useUpdateQuotePricesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuotePricesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuotePricesMutation, { data, loading, error }] = useUpdateQuotePricesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuotePricesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuotePricesMutation, UpdateQuotePricesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuotePricesMutation, UpdateQuotePricesMutationVariables>(UpdateQuotePricesDocument, options);
      }
export type UpdateQuotePricesMutationHookResult = ReturnType<typeof useUpdateQuotePricesMutation>;
export type UpdateQuotePricesMutationResult = Apollo.MutationResult<UpdateQuotePricesMutation>;
export type UpdateQuotePricesMutationOptions = Apollo.BaseMutationOptions<UpdateQuotePricesMutation, UpdateQuotePricesMutationVariables>;
export const DeleteQuoteDocument = gql`
    mutation deleteQuote($input: DeleteQuoteMutationInput!) {
  deleteQuote(input: $input) {
    errors {
      field
      messages
    }
  }
}
    `;
export type DeleteQuoteMutationFn = Apollo.MutationFunction<DeleteQuoteMutation, DeleteQuoteMutationVariables>;

/**
 * __useDeleteQuoteMutation__
 *
 * To run a mutation, you first call `useDeleteQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQuoteMutation, { data, loading, error }] = useDeleteQuoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteQuoteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteQuoteMutation, DeleteQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteQuoteMutation, DeleteQuoteMutationVariables>(DeleteQuoteDocument, options);
      }
export type DeleteQuoteMutationHookResult = ReturnType<typeof useDeleteQuoteMutation>;
export type DeleteQuoteMutationResult = Apollo.MutationResult<DeleteQuoteMutation>;
export type DeleteQuoteMutationOptions = Apollo.BaseMutationOptions<DeleteQuoteMutation, DeleteQuoteMutationVariables>;
export const CreateQuotePdfDocument = gql`
    mutation createQuotePDF($type: String, $recipient: String, $quoteId: UUID!, $productDisplay: String, $paymentMethodId: String) {
  createQuotePdf(
    type: $type
    recipient: $recipient
    quoteId: $quoteId
    productDisplay: $productDisplay
    paymentMethodId: $paymentMethodId
  ) {
    job {
      id
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type CreateQuotePdfMutationFn = Apollo.MutationFunction<CreateQuotePdfMutation, CreateQuotePdfMutationVariables>;

/**
 * __useCreateQuotePdfMutation__
 *
 * To run a mutation, you first call `useCreateQuotePdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuotePdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuotePdfMutation, { data, loading, error }] = useCreateQuotePdfMutation({
 *   variables: {
 *      type: // value for 'type'
 *      recipient: // value for 'recipient'
 *      quoteId: // value for 'quoteId'
 *      productDisplay: // value for 'productDisplay'
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useCreateQuotePdfMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuotePdfMutation, CreateQuotePdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuotePdfMutation, CreateQuotePdfMutationVariables>(CreateQuotePdfDocument, options);
      }
export type CreateQuotePdfMutationHookResult = ReturnType<typeof useCreateQuotePdfMutation>;
export type CreateQuotePdfMutationResult = Apollo.MutationResult<CreateQuotePdfMutation>;
export type CreateQuotePdfMutationOptions = Apollo.BaseMutationOptions<CreateQuotePdfMutation, CreateQuotePdfMutationVariables>;
export const CreateSupplyOrderPdfDocument = gql`
    mutation createSupplyOrderPDF($id: UUID!) {
  createSupplyOrderPDF(supplyOrderId: $id) {
    job {
      id
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type CreateSupplyOrderPdfMutationFn = Apollo.MutationFunction<CreateSupplyOrderPdfMutation, CreateSupplyOrderPdfMutationVariables>;

/**
 * __useCreateSupplyOrderPdfMutation__
 *
 * To run a mutation, you first call `useCreateSupplyOrderPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSupplyOrderPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSupplyOrderPdfMutation, { data, loading, error }] = useCreateSupplyOrderPdfMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCreateSupplyOrderPdfMutation(baseOptions?: Apollo.MutationHookOptions<CreateSupplyOrderPdfMutation, CreateSupplyOrderPdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSupplyOrderPdfMutation, CreateSupplyOrderPdfMutationVariables>(CreateSupplyOrderPdfDocument, options);
      }
export type CreateSupplyOrderPdfMutationHookResult = ReturnType<typeof useCreateSupplyOrderPdfMutation>;
export type CreateSupplyOrderPdfMutationResult = Apollo.MutationResult<CreateSupplyOrderPdfMutation>;
export type CreateSupplyOrderPdfMutationOptions = Apollo.BaseMutationOptions<CreateSupplyOrderPdfMutation, CreateSupplyOrderPdfMutationVariables>;
export const CreateBankInvoicePdfDocument = gql`
    mutation createBankInvoicePDF($quoteId: UUID!, $paymentMethodId: UUID!) {
  createBankInvoicePdf(quoteId: $quoteId, paymentMethodId: $paymentMethodId) {
    job {
      id
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type CreateBankInvoicePdfMutationFn = Apollo.MutationFunction<CreateBankInvoicePdfMutation, CreateBankInvoicePdfMutationVariables>;

/**
 * __useCreateBankInvoicePdfMutation__
 *
 * To run a mutation, you first call `useCreateBankInvoicePdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBankInvoicePdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBankInvoicePdfMutation, { data, loading, error }] = useCreateBankInvoicePdfMutation({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useCreateBankInvoicePdfMutation(baseOptions?: Apollo.MutationHookOptions<CreateBankInvoicePdfMutation, CreateBankInvoicePdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBankInvoicePdfMutation, CreateBankInvoicePdfMutationVariables>(CreateBankInvoicePdfDocument, options);
      }
export type CreateBankInvoicePdfMutationHookResult = ReturnType<typeof useCreateBankInvoicePdfMutation>;
export type CreateBankInvoicePdfMutationResult = Apollo.MutationResult<CreateBankInvoicePdfMutation>;
export type CreateBankInvoicePdfMutationOptions = Apollo.BaseMutationOptions<CreateBankInvoicePdfMutation, CreateBankInvoicePdfMutationVariables>;
export const CreateOrderOemDocument = gql`
    mutation createOrderOEM($input: CreateOrderOEMMutationInput!) {
  createOrderOem(input: $input) {
    orderOEM {
      ...OrderOEM
    }
    errors {
      field
      messages
    }
  }
}
    ${OrderOemFragmentDoc}`;
export type CreateOrderOemMutationFn = Apollo.MutationFunction<CreateOrderOemMutation, CreateOrderOemMutationVariables>;

/**
 * __useCreateOrderOemMutation__
 *
 * To run a mutation, you first call `useCreateOrderOemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderOemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderOemMutation, { data, loading, error }] = useCreateOrderOemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrderOemMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrderOemMutation, CreateOrderOemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrderOemMutation, CreateOrderOemMutationVariables>(CreateOrderOemDocument, options);
      }
export type CreateOrderOemMutationHookResult = ReturnType<typeof useCreateOrderOemMutation>;
export type CreateOrderOemMutationResult = Apollo.MutationResult<CreateOrderOemMutation>;
export type CreateOrderOemMutationOptions = Apollo.BaseMutationOptions<CreateOrderOemMutation, CreateOrderOemMutationVariables>;
export const UpdateOrderOemDocument = gql`
    mutation updateOrderOEM($input: UpdateOrderOEMMutationInput!) {
  updateOrderOem(input: $input) {
    orderOEM {
      ...OrderOEM
    }
    errors {
      field
      messages
    }
  }
}
    ${OrderOemFragmentDoc}`;
export type UpdateOrderOemMutationFn = Apollo.MutationFunction<UpdateOrderOemMutation, UpdateOrderOemMutationVariables>;

/**
 * __useUpdateOrderOemMutation__
 *
 * To run a mutation, you first call `useUpdateOrderOemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderOemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderOemMutation, { data, loading, error }] = useUpdateOrderOemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderOemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderOemMutation, UpdateOrderOemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderOemMutation, UpdateOrderOemMutationVariables>(UpdateOrderOemDocument, options);
      }
export type UpdateOrderOemMutationHookResult = ReturnType<typeof useUpdateOrderOemMutation>;
export type UpdateOrderOemMutationResult = Apollo.MutationResult<UpdateOrderOemMutation>;
export type UpdateOrderOemMutationOptions = Apollo.BaseMutationOptions<UpdateOrderOemMutation, UpdateOrderOemMutationVariables>;
export const DeleteOrderOemDocument = gql`
    mutation deleteOrderOEM($input: DeleteOrderOEMMutationInput!) {
  deleteOrderOem(input: $input) {
    errors {
      field
      messages
    }
  }
}
    `;
export type DeleteOrderOemMutationFn = Apollo.MutationFunction<DeleteOrderOemMutation, DeleteOrderOemMutationVariables>;

/**
 * __useDeleteOrderOemMutation__
 *
 * To run a mutation, you first call `useDeleteOrderOemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrderOemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrderOemMutation, { data, loading, error }] = useDeleteOrderOemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteOrderOemMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrderOemMutation, DeleteOrderOemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrderOemMutation, DeleteOrderOemMutationVariables>(DeleteOrderOemDocument, options);
      }
export type DeleteOrderOemMutationHookResult = ReturnType<typeof useDeleteOrderOemMutation>;
export type DeleteOrderOemMutationResult = Apollo.MutationResult<DeleteOrderOemMutation>;
export type DeleteOrderOemMutationOptions = Apollo.BaseMutationOptions<DeleteOrderOemMutation, DeleteOrderOemMutationVariables>;
export const StartOemOrderReviewDocument = gql`
    mutation startOemOrderReview($input: StartOemOrderReviewMutationInput!) {
  startOemOrderReview(input: $input) {
    orderOEM {
      ...OrderOEM
    }
    errors {
      field
      messages
    }
  }
}
    ${OrderOemFragmentDoc}`;
export type StartOemOrderReviewMutationFn = Apollo.MutationFunction<StartOemOrderReviewMutation, StartOemOrderReviewMutationVariables>;

/**
 * __useStartOemOrderReviewMutation__
 *
 * To run a mutation, you first call `useStartOemOrderReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartOemOrderReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startOemOrderReviewMutation, { data, loading, error }] = useStartOemOrderReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartOemOrderReviewMutation(baseOptions?: Apollo.MutationHookOptions<StartOemOrderReviewMutation, StartOemOrderReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartOemOrderReviewMutation, StartOemOrderReviewMutationVariables>(StartOemOrderReviewDocument, options);
      }
export type StartOemOrderReviewMutationHookResult = ReturnType<typeof useStartOemOrderReviewMutation>;
export type StartOemOrderReviewMutationResult = Apollo.MutationResult<StartOemOrderReviewMutation>;
export type StartOemOrderReviewMutationOptions = Apollo.BaseMutationOptions<StartOemOrderReviewMutation, StartOemOrderReviewMutationVariables>;
export const ReviewOemOrderDocument = gql`
    mutation reviewOemOrder($input: ReviewOemOrderMutationInput!) {
  reviewOemOrder(input: $input) {
    orderOEMReview {
      ...OrderOEMReview
    }
  }
}
    ${OrderOemReviewFragmentDoc}`;
export type ReviewOemOrderMutationFn = Apollo.MutationFunction<ReviewOemOrderMutation, ReviewOemOrderMutationVariables>;

/**
 * __useReviewOemOrderMutation__
 *
 * To run a mutation, you first call `useReviewOemOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewOemOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewOemOrderMutation, { data, loading, error }] = useReviewOemOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReviewOemOrderMutation(baseOptions?: Apollo.MutationHookOptions<ReviewOemOrderMutation, ReviewOemOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReviewOemOrderMutation, ReviewOemOrderMutationVariables>(ReviewOemOrderDocument, options);
      }
export type ReviewOemOrderMutationHookResult = ReturnType<typeof useReviewOemOrderMutation>;
export type ReviewOemOrderMutationResult = Apollo.MutationResult<ReviewOemOrderMutation>;
export type ReviewOemOrderMutationOptions = Apollo.BaseMutationOptions<ReviewOemOrderMutation, ReviewOemOrderMutationVariables>;
export const UpdateOrderOemPricesDocument = gql`
    mutation updateOrderOEMPrices($input: UpdateOrderOemPricesMutationInput!) {
  updateOrderOemPrices(input: $input) {
    orderOEM {
      ...OrderOEM
    }
    errors {
      field
      messages
    }
  }
}
    ${OrderOemFragmentDoc}`;
export type UpdateOrderOemPricesMutationFn = Apollo.MutationFunction<UpdateOrderOemPricesMutation, UpdateOrderOemPricesMutationVariables>;

/**
 * __useUpdateOrderOemPricesMutation__
 *
 * To run a mutation, you first call `useUpdateOrderOemPricesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderOemPricesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderOemPricesMutation, { data, loading, error }] = useUpdateOrderOemPricesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderOemPricesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderOemPricesMutation, UpdateOrderOemPricesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderOemPricesMutation, UpdateOrderOemPricesMutationVariables>(UpdateOrderOemPricesDocument, options);
      }
export type UpdateOrderOemPricesMutationHookResult = ReturnType<typeof useUpdateOrderOemPricesMutation>;
export type UpdateOrderOemPricesMutationResult = Apollo.MutationResult<UpdateOrderOemPricesMutation>;
export type UpdateOrderOemPricesMutationOptions = Apollo.BaseMutationOptions<UpdateOrderOemPricesMutation, UpdateOrderOemPricesMutationVariables>;
export const ImportOrderOemDocument = gql`
    mutation importOrderOem($rows: [RowInput!], $dryRun: Boolean!) {
  importOrderOem(rows: $rows, dryRun: $dryRun) {
    ok
    errors {
      row
      errors {
        ...Error
      }
    }
  }
}
    ${ErrorFragmentDoc}`;
export type ImportOrderOemMutationFn = Apollo.MutationFunction<ImportOrderOemMutation, ImportOrderOemMutationVariables>;

/**
 * __useImportOrderOemMutation__
 *
 * To run a mutation, you first call `useImportOrderOemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportOrderOemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importOrderOemMutation, { data, loading, error }] = useImportOrderOemMutation({
 *   variables: {
 *      rows: // value for 'rows'
 *      dryRun: // value for 'dryRun'
 *   },
 * });
 */
export function useImportOrderOemMutation(baseOptions?: Apollo.MutationHookOptions<ImportOrderOemMutation, ImportOrderOemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportOrderOemMutation, ImportOrderOemMutationVariables>(ImportOrderOemDocument, options);
      }
export type ImportOrderOemMutationHookResult = ReturnType<typeof useImportOrderOemMutation>;
export type ImportOrderOemMutationResult = Apollo.MutationResult<ImportOrderOemMutation>;
export type ImportOrderOemMutationOptions = Apollo.BaseMutationOptions<ImportOrderOemMutation, ImportOrderOemMutationVariables>;
export const GetSalesDocument = gql`
    query getSales($options: SaleListOptionsInputType) {
  sales(options: $options) {
    items {
      ...SaleList
    }
    count
  }
}
    ${SaleListFragmentDoc}`;

/**
 * __useGetSalesQuery__
 *
 * To run a query within a React component, call `useGetSalesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetSalesQuery(baseOptions?: Apollo.QueryHookOptions<GetSalesQuery, GetSalesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesQuery, GetSalesQueryVariables>(GetSalesDocument, options);
      }
export function useGetSalesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesQuery, GetSalesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesQuery, GetSalesQueryVariables>(GetSalesDocument, options);
        }
export type GetSalesQueryHookResult = ReturnType<typeof useGetSalesQuery>;
export type GetSalesLazyQueryHookResult = ReturnType<typeof useGetSalesLazyQuery>;
export type GetSalesQueryResult = Apollo.QueryResult<GetSalesQuery, GetSalesQueryVariables>;
export function refetchGetSalesQuery(variables?: GetSalesQueryVariables) {
      return { query: GetSalesDocument, variables: variables }
    }
export const GetSaleDocument = gql`
    query getSale($id: UUID) {
  sale(id: $id) {
    ...SaleDetail
  }
}
    ${SaleDetailFragmentDoc}`;

/**
 * __useGetSaleQuery__
 *
 * To run a query within a React component, call `useGetSaleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSaleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSaleQuery(baseOptions?: Apollo.QueryHookOptions<GetSaleQuery, GetSaleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSaleQuery, GetSaleQueryVariables>(GetSaleDocument, options);
      }
export function useGetSaleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSaleQuery, GetSaleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSaleQuery, GetSaleQueryVariables>(GetSaleDocument, options);
        }
export type GetSaleQueryHookResult = ReturnType<typeof useGetSaleQuery>;
export type GetSaleLazyQueryHookResult = ReturnType<typeof useGetSaleLazyQuery>;
export type GetSaleQueryResult = Apollo.QueryResult<GetSaleQuery, GetSaleQueryVariables>;
export function refetchGetSaleQuery(variables?: GetSaleQueryVariables) {
      return { query: GetSaleDocument, variables: variables }
    }
export const CreateShipmentDocument = gql`
    mutation createShipment($input: CreateShipmentMutationInput!) {
  createShipment(input: $input) {
    shipment {
      ...Shipment
    }
    errors {
      field
      messages
    }
  }
}
    ${ShipmentFragmentDoc}`;
export type CreateShipmentMutationFn = Apollo.MutationFunction<CreateShipmentMutation, CreateShipmentMutationVariables>;

/**
 * __useCreateShipmentMutation__
 *
 * To run a mutation, you first call `useCreateShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createShipmentMutation, { data, loading, error }] = useCreateShipmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateShipmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateShipmentMutation, CreateShipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateShipmentMutation, CreateShipmentMutationVariables>(CreateShipmentDocument, options);
      }
export type CreateShipmentMutationHookResult = ReturnType<typeof useCreateShipmentMutation>;
export type CreateShipmentMutationResult = Apollo.MutationResult<CreateShipmentMutation>;
export type CreateShipmentMutationOptions = Apollo.BaseMutationOptions<CreateShipmentMutation, CreateShipmentMutationVariables>;
export const CreateShipmentOemDocument = gql`
    mutation createShipmentOEM($input: CreateShipmentOEMMutationInput!) {
  createShipmentOem(input: $input) {
    shipmentOEM {
      ...ShipmentOEM
    }
    errors {
      field
      messages
    }
  }
}
    ${ShipmentOemFragmentDoc}`;
export type CreateShipmentOemMutationFn = Apollo.MutationFunction<CreateShipmentOemMutation, CreateShipmentOemMutationVariables>;

/**
 * __useCreateShipmentOemMutation__
 *
 * To run a mutation, you first call `useCreateShipmentOemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateShipmentOemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createShipmentOemMutation, { data, loading, error }] = useCreateShipmentOemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateShipmentOemMutation(baseOptions?: Apollo.MutationHookOptions<CreateShipmentOemMutation, CreateShipmentOemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateShipmentOemMutation, CreateShipmentOemMutationVariables>(CreateShipmentOemDocument, options);
      }
export type CreateShipmentOemMutationHookResult = ReturnType<typeof useCreateShipmentOemMutation>;
export type CreateShipmentOemMutationResult = Apollo.MutationResult<CreateShipmentOemMutation>;
export type CreateShipmentOemMutationOptions = Apollo.BaseMutationOptions<CreateShipmentOemMutation, CreateShipmentOemMutationVariables>;
export const UpdateShipmentDocument = gql`
    mutation updateShipment($input: UpdateShipmentMutationInput!) {
  updateShipment(input: $input) {
    shipment {
      ...Shipment
    }
    errors {
      field
      messages
    }
  }
}
    ${ShipmentFragmentDoc}`;
export type UpdateShipmentMutationFn = Apollo.MutationFunction<UpdateShipmentMutation, UpdateShipmentMutationVariables>;

/**
 * __useUpdateShipmentMutation__
 *
 * To run a mutation, you first call `useUpdateShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShipmentMutation, { data, loading, error }] = useUpdateShipmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateShipmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateShipmentMutation, UpdateShipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateShipmentMutation, UpdateShipmentMutationVariables>(UpdateShipmentDocument, options);
      }
export type UpdateShipmentMutationHookResult = ReturnType<typeof useUpdateShipmentMutation>;
export type UpdateShipmentMutationResult = Apollo.MutationResult<UpdateShipmentMutation>;
export type UpdateShipmentMutationOptions = Apollo.BaseMutationOptions<UpdateShipmentMutation, UpdateShipmentMutationVariables>;
export const UpdateShipmentOemDocument = gql`
    mutation updateShipmentOEM($input: UpdateShipmentOEMMutationInput!) {
  updateShipmentOem(input: $input) {
    shipmentOEM {
      ...ShipmentOEM
    }
    errors {
      field
      messages
    }
  }
}
    ${ShipmentOemFragmentDoc}`;
export type UpdateShipmentOemMutationFn = Apollo.MutationFunction<UpdateShipmentOemMutation, UpdateShipmentOemMutationVariables>;

/**
 * __useUpdateShipmentOemMutation__
 *
 * To run a mutation, you first call `useUpdateShipmentOemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShipmentOemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShipmentOemMutation, { data, loading, error }] = useUpdateShipmentOemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateShipmentOemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateShipmentOemMutation, UpdateShipmentOemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateShipmentOemMutation, UpdateShipmentOemMutationVariables>(UpdateShipmentOemDocument, options);
      }
export type UpdateShipmentOemMutationHookResult = ReturnType<typeof useUpdateShipmentOemMutation>;
export type UpdateShipmentOemMutationResult = Apollo.MutationResult<UpdateShipmentOemMutation>;
export type UpdateShipmentOemMutationOptions = Apollo.BaseMutationOptions<UpdateShipmentOemMutation, UpdateShipmentOemMutationVariables>;
export const DeleteShipmentDocument = gql`
    mutation deleteShipment($input: DeleteShipmentMutationInput!) {
  deleteShipment(input: $input) {
    errors {
      field
      messages
    }
  }
}
    `;
export type DeleteShipmentMutationFn = Apollo.MutationFunction<DeleteShipmentMutation, DeleteShipmentMutationVariables>;

/**
 * __useDeleteShipmentMutation__
 *
 * To run a mutation, you first call `useDeleteShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteShipmentMutation, { data, loading, error }] = useDeleteShipmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteShipmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteShipmentMutation, DeleteShipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteShipmentMutation, DeleteShipmentMutationVariables>(DeleteShipmentDocument, options);
      }
export type DeleteShipmentMutationHookResult = ReturnType<typeof useDeleteShipmentMutation>;
export type DeleteShipmentMutationResult = Apollo.MutationResult<DeleteShipmentMutation>;
export type DeleteShipmentMutationOptions = Apollo.BaseMutationOptions<DeleteShipmentMutation, DeleteShipmentMutationVariables>;
export const DeleteShipmentProductDocument = gql`
    mutation deleteShipmentProduct($input: DeleteShipmentProductMutationInput!) {
  deleteShipmentProduct(input: $input) {
    errors {
      field
      messages
    }
  }
}
    `;
export type DeleteShipmentProductMutationFn = Apollo.MutationFunction<DeleteShipmentProductMutation, DeleteShipmentProductMutationVariables>;

/**
 * __useDeleteShipmentProductMutation__
 *
 * To run a mutation, you first call `useDeleteShipmentProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteShipmentProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteShipmentProductMutation, { data, loading, error }] = useDeleteShipmentProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteShipmentProductMutation(baseOptions?: Apollo.MutationHookOptions<DeleteShipmentProductMutation, DeleteShipmentProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteShipmentProductMutation, DeleteShipmentProductMutationVariables>(DeleteShipmentProductDocument, options);
      }
export type DeleteShipmentProductMutationHookResult = ReturnType<typeof useDeleteShipmentProductMutation>;
export type DeleteShipmentProductMutationResult = Apollo.MutationResult<DeleteShipmentProductMutation>;
export type DeleteShipmentProductMutationOptions = Apollo.BaseMutationOptions<DeleteShipmentProductMutation, DeleteShipmentProductMutationVariables>;
export const DeleteShipmentOemDocument = gql`
    mutation deleteShipmentOEM($input: DeleteShipmentOEMMutationInput!) {
  deleteShipmentOem(input: $input) {
    errors {
      field
      messages
    }
  }
}
    `;
export type DeleteShipmentOemMutationFn = Apollo.MutationFunction<DeleteShipmentOemMutation, DeleteShipmentOemMutationVariables>;

/**
 * __useDeleteShipmentOemMutation__
 *
 * To run a mutation, you first call `useDeleteShipmentOemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteShipmentOemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteShipmentOemMutation, { data, loading, error }] = useDeleteShipmentOemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteShipmentOemMutation(baseOptions?: Apollo.MutationHookOptions<DeleteShipmentOemMutation, DeleteShipmentOemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteShipmentOemMutation, DeleteShipmentOemMutationVariables>(DeleteShipmentOemDocument, options);
      }
export type DeleteShipmentOemMutationHookResult = ReturnType<typeof useDeleteShipmentOemMutation>;
export type DeleteShipmentOemMutationResult = Apollo.MutationResult<DeleteShipmentOemMutation>;
export type DeleteShipmentOemMutationOptions = Apollo.BaseMutationOptions<DeleteShipmentOemMutation, DeleteShipmentOemMutationVariables>;
export const CreateSaleDocument = gql`
    mutation createSale($input: CreateSaleMutationInput!) {
  createSale(input: $input) {
    sale {
      ...SaleDetail
    }
    errors {
      field
      messages
    }
  }
}
    ${SaleDetailFragmentDoc}`;
export type CreateSaleMutationFn = Apollo.MutationFunction<CreateSaleMutation, CreateSaleMutationVariables>;

/**
 * __useCreateSaleMutation__
 *
 * To run a mutation, you first call `useCreateSaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSaleMutation, { data, loading, error }] = useCreateSaleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSaleMutation(baseOptions?: Apollo.MutationHookOptions<CreateSaleMutation, CreateSaleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSaleMutation, CreateSaleMutationVariables>(CreateSaleDocument, options);
      }
export type CreateSaleMutationHookResult = ReturnType<typeof useCreateSaleMutation>;
export type CreateSaleMutationResult = Apollo.MutationResult<CreateSaleMutation>;
export type CreateSaleMutationOptions = Apollo.BaseMutationOptions<CreateSaleMutation, CreateSaleMutationVariables>;
export const UpdateSaleDocument = gql`
    mutation updateSale($input: UpdateSaleMutationInput!) {
  updateSale(input: $input) {
    sale {
      ...SaleDetail
    }
    errors {
      field
      messages
    }
  }
}
    ${SaleDetailFragmentDoc}`;
export type UpdateSaleMutationFn = Apollo.MutationFunction<UpdateSaleMutation, UpdateSaleMutationVariables>;

/**
 * __useUpdateSaleMutation__
 *
 * To run a mutation, you first call `useUpdateSaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSaleMutation, { data, loading, error }] = useUpdateSaleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSaleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSaleMutation, UpdateSaleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSaleMutation, UpdateSaleMutationVariables>(UpdateSaleDocument, options);
      }
export type UpdateSaleMutationHookResult = ReturnType<typeof useUpdateSaleMutation>;
export type UpdateSaleMutationResult = Apollo.MutationResult<UpdateSaleMutation>;
export type UpdateSaleMutationOptions = Apollo.BaseMutationOptions<UpdateSaleMutation, UpdateSaleMutationVariables>;
export const GetSupplyOrdersDocument = gql`
    query getSupplyOrders($options: SupplyOrderListOptionsInputType, $user: UUID) {
  supplyOrders(options: $options, user: $user) {
    items {
      ...SupplyOrderList
    }
    count
  }
}
    ${SupplyOrderListFragmentDoc}`;

/**
 * __useGetSupplyOrdersQuery__
 *
 * To run a query within a React component, call `useGetSupplyOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupplyOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupplyOrdersQuery({
 *   variables: {
 *      options: // value for 'options'
 *      user: // value for 'user'
 *   },
 * });
 */
export function useGetSupplyOrdersQuery(baseOptions?: Apollo.QueryHookOptions<GetSupplyOrdersQuery, GetSupplyOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSupplyOrdersQuery, GetSupplyOrdersQueryVariables>(GetSupplyOrdersDocument, options);
      }
export function useGetSupplyOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSupplyOrdersQuery, GetSupplyOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSupplyOrdersQuery, GetSupplyOrdersQueryVariables>(GetSupplyOrdersDocument, options);
        }
export type GetSupplyOrdersQueryHookResult = ReturnType<typeof useGetSupplyOrdersQuery>;
export type GetSupplyOrdersLazyQueryHookResult = ReturnType<typeof useGetSupplyOrdersLazyQuery>;
export type GetSupplyOrdersQueryResult = Apollo.QueryResult<GetSupplyOrdersQuery, GetSupplyOrdersQueryVariables>;
export function refetchGetSupplyOrdersQuery(variables?: GetSupplyOrdersQueryVariables) {
      return { query: GetSupplyOrdersDocument, variables: variables }
    }
export const GetSupplyOrdersIdsDocument = gql`
    query getSupplyOrdersIds($options: SupplyOrderListOptionsInputType, $user: UUID) {
  supplyOrders(options: $options, user: $user) {
    items {
      id
    }
    count
  }
}
    `;

/**
 * __useGetSupplyOrdersIdsQuery__
 *
 * To run a query within a React component, call `useGetSupplyOrdersIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupplyOrdersIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupplyOrdersIdsQuery({
 *   variables: {
 *      options: // value for 'options'
 *      user: // value for 'user'
 *   },
 * });
 */
export function useGetSupplyOrdersIdsQuery(baseOptions?: Apollo.QueryHookOptions<GetSupplyOrdersIdsQuery, GetSupplyOrdersIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSupplyOrdersIdsQuery, GetSupplyOrdersIdsQueryVariables>(GetSupplyOrdersIdsDocument, options);
      }
export function useGetSupplyOrdersIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSupplyOrdersIdsQuery, GetSupplyOrdersIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSupplyOrdersIdsQuery, GetSupplyOrdersIdsQueryVariables>(GetSupplyOrdersIdsDocument, options);
        }
export type GetSupplyOrdersIdsQueryHookResult = ReturnType<typeof useGetSupplyOrdersIdsQuery>;
export type GetSupplyOrdersIdsLazyQueryHookResult = ReturnType<typeof useGetSupplyOrdersIdsLazyQuery>;
export type GetSupplyOrdersIdsQueryResult = Apollo.QueryResult<GetSupplyOrdersIdsQuery, GetSupplyOrdersIdsQueryVariables>;
export function refetchGetSupplyOrdersIdsQuery(variables?: GetSupplyOrdersIdsQueryVariables) {
      return { query: GetSupplyOrdersIdsDocument, variables: variables }
    }
export const GetSupplyOrderDocument = gql`
    query getSupplyOrder($id: UUID) {
  supplyOrder(id: $id) {
    ...SupplyOrderDetail
  }
}
    ${SupplyOrderDetailFragmentDoc}`;

/**
 * __useGetSupplyOrderQuery__
 *
 * To run a query within a React component, call `useGetSupplyOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupplyOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupplyOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSupplyOrderQuery(baseOptions?: Apollo.QueryHookOptions<GetSupplyOrderQuery, GetSupplyOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSupplyOrderQuery, GetSupplyOrderQueryVariables>(GetSupplyOrderDocument, options);
      }
export function useGetSupplyOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSupplyOrderQuery, GetSupplyOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSupplyOrderQuery, GetSupplyOrderQueryVariables>(GetSupplyOrderDocument, options);
        }
export type GetSupplyOrderQueryHookResult = ReturnType<typeof useGetSupplyOrderQuery>;
export type GetSupplyOrderLazyQueryHookResult = ReturnType<typeof useGetSupplyOrderLazyQuery>;
export type GetSupplyOrderQueryResult = Apollo.QueryResult<GetSupplyOrderQuery, GetSupplyOrderQueryVariables>;
export function refetchGetSupplyOrderQuery(variables?: GetSupplyOrderQueryVariables) {
      return { query: GetSupplyOrderDocument, variables: variables }
    }
export const GetBankInvoicePdfDocument = gql`
    query getBankInvoicePDF($id: UUID) {
  bankInvoicePdf(id: $id) {
    ...BankInvoicePDF
  }
}
    ${BankInvoicePdfFragmentDoc}`;

/**
 * __useGetBankInvoicePdfQuery__
 *
 * To run a query within a React component, call `useGetBankInvoicePdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBankInvoicePdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBankInvoicePdfQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBankInvoicePdfQuery(baseOptions?: Apollo.QueryHookOptions<GetBankInvoicePdfQuery, GetBankInvoicePdfQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBankInvoicePdfQuery, GetBankInvoicePdfQueryVariables>(GetBankInvoicePdfDocument, options);
      }
export function useGetBankInvoicePdfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBankInvoicePdfQuery, GetBankInvoicePdfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBankInvoicePdfQuery, GetBankInvoicePdfQueryVariables>(GetBankInvoicePdfDocument, options);
        }
export type GetBankInvoicePdfQueryHookResult = ReturnType<typeof useGetBankInvoicePdfQuery>;
export type GetBankInvoicePdfLazyQueryHookResult = ReturnType<typeof useGetBankInvoicePdfLazyQuery>;
export type GetBankInvoicePdfQueryResult = Apollo.QueryResult<GetBankInvoicePdfQuery, GetBankInvoicePdfQueryVariables>;
export function refetchGetBankInvoicePdfQuery(variables?: GetBankInvoicePdfQueryVariables) {
      return { query: GetBankInvoicePdfDocument, variables: variables }
    }
export const GetBankInvoicePdfDisclaimerDocument = gql`
    query getBankInvoicePDFDisclaimer {
  bankInvoicePdfDisclaimer {
    ...BankInvoicePDFDisclaimer
  }
}
    ${BankInvoicePdfDisclaimerFragmentDoc}`;

/**
 * __useGetBankInvoicePdfDisclaimerQuery__
 *
 * To run a query within a React component, call `useGetBankInvoicePdfDisclaimerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBankInvoicePdfDisclaimerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBankInvoicePdfDisclaimerQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBankInvoicePdfDisclaimerQuery(baseOptions?: Apollo.QueryHookOptions<GetBankInvoicePdfDisclaimerQuery, GetBankInvoicePdfDisclaimerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBankInvoicePdfDisclaimerQuery, GetBankInvoicePdfDisclaimerQueryVariables>(GetBankInvoicePdfDisclaimerDocument, options);
      }
export function useGetBankInvoicePdfDisclaimerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBankInvoicePdfDisclaimerQuery, GetBankInvoicePdfDisclaimerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBankInvoicePdfDisclaimerQuery, GetBankInvoicePdfDisclaimerQueryVariables>(GetBankInvoicePdfDisclaimerDocument, options);
        }
export type GetBankInvoicePdfDisclaimerQueryHookResult = ReturnType<typeof useGetBankInvoicePdfDisclaimerQuery>;
export type GetBankInvoicePdfDisclaimerLazyQueryHookResult = ReturnType<typeof useGetBankInvoicePdfDisclaimerLazyQuery>;
export type GetBankInvoicePdfDisclaimerQueryResult = Apollo.QueryResult<GetBankInvoicePdfDisclaimerQuery, GetBankInvoicePdfDisclaimerQueryVariables>;
export function refetchGetBankInvoicePdfDisclaimerQuery(variables?: GetBankInvoicePdfDisclaimerQueryVariables) {
      return { query: GetBankInvoicePdfDisclaimerDocument, variables: variables }
    }
export const GetQuoteKitMultiplierDocument = gql`
    query getQuoteKitMultiplier($id: UUID) {
  quoteKitMultiplier(id: $id) {
    ...QuoteKitMultiplier
  }
}
    ${QuoteKitMultiplierFragmentDoc}`;

/**
 * __useGetQuoteKitMultiplierQuery__
 *
 * To run a query within a React component, call `useGetQuoteKitMultiplierQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuoteKitMultiplierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuoteKitMultiplierQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetQuoteKitMultiplierQuery(baseOptions?: Apollo.QueryHookOptions<GetQuoteKitMultiplierQuery, GetQuoteKitMultiplierQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuoteKitMultiplierQuery, GetQuoteKitMultiplierQueryVariables>(GetQuoteKitMultiplierDocument, options);
      }
export function useGetQuoteKitMultiplierLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuoteKitMultiplierQuery, GetQuoteKitMultiplierQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuoteKitMultiplierQuery, GetQuoteKitMultiplierQueryVariables>(GetQuoteKitMultiplierDocument, options);
        }
export type GetQuoteKitMultiplierQueryHookResult = ReturnType<typeof useGetQuoteKitMultiplierQuery>;
export type GetQuoteKitMultiplierLazyQueryHookResult = ReturnType<typeof useGetQuoteKitMultiplierLazyQuery>;
export type GetQuoteKitMultiplierQueryResult = Apollo.QueryResult<GetQuoteKitMultiplierQuery, GetQuoteKitMultiplierQueryVariables>;
export function refetchGetQuoteKitMultiplierQuery(variables?: GetQuoteKitMultiplierQueryVariables) {
      return { query: GetQuoteKitMultiplierDocument, variables: variables }
    }
export const GetQuoteKitMultipliersDocument = gql`
    query getQuoteKitMultipliers {
  quoteKitMultipliers {
    ...QuoteKitMultiplier
  }
}
    ${QuoteKitMultiplierFragmentDoc}`;

/**
 * __useGetQuoteKitMultipliersQuery__
 *
 * To run a query within a React component, call `useGetQuoteKitMultipliersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuoteKitMultipliersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuoteKitMultipliersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetQuoteKitMultipliersQuery(baseOptions?: Apollo.QueryHookOptions<GetQuoteKitMultipliersQuery, GetQuoteKitMultipliersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuoteKitMultipliersQuery, GetQuoteKitMultipliersQueryVariables>(GetQuoteKitMultipliersDocument, options);
      }
export function useGetQuoteKitMultipliersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuoteKitMultipliersQuery, GetQuoteKitMultipliersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuoteKitMultipliersQuery, GetQuoteKitMultipliersQueryVariables>(GetQuoteKitMultipliersDocument, options);
        }
export type GetQuoteKitMultipliersQueryHookResult = ReturnType<typeof useGetQuoteKitMultipliersQuery>;
export type GetQuoteKitMultipliersLazyQueryHookResult = ReturnType<typeof useGetQuoteKitMultipliersLazyQuery>;
export type GetQuoteKitMultipliersQueryResult = Apollo.QueryResult<GetQuoteKitMultipliersQuery, GetQuoteKitMultipliersQueryVariables>;
export function refetchGetQuoteKitMultipliersQuery(variables?: GetQuoteKitMultipliersQueryVariables) {
      return { query: GetQuoteKitMultipliersDocument, variables: variables }
    }
export const GetOrderedProductDocument = gql`
    query getOrderedProduct($id: UUID) {
  orderedProduct(id: $id) {
    ...OrderedProduct
  }
}
    ${OrderedProductFragmentDoc}`;

/**
 * __useGetOrderedProductQuery__
 *
 * To run a query within a React component, call `useGetOrderedProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderedProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderedProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrderedProductQuery(baseOptions?: Apollo.QueryHookOptions<GetOrderedProductQuery, GetOrderedProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderedProductQuery, GetOrderedProductQueryVariables>(GetOrderedProductDocument, options);
      }
export function useGetOrderedProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderedProductQuery, GetOrderedProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderedProductQuery, GetOrderedProductQueryVariables>(GetOrderedProductDocument, options);
        }
export type GetOrderedProductQueryHookResult = ReturnType<typeof useGetOrderedProductQuery>;
export type GetOrderedProductLazyQueryHookResult = ReturnType<typeof useGetOrderedProductLazyQuery>;
export type GetOrderedProductQueryResult = Apollo.QueryResult<GetOrderedProductQuery, GetOrderedProductQueryVariables>;
export function refetchGetOrderedProductQuery(variables?: GetOrderedProductQueryVariables) {
      return { query: GetOrderedProductDocument, variables: variables }
    }
export const GetShipmentsDocument = gql`
    query getShipments {
  shipments {
    ...Shipment
  }
}
    ${ShipmentFragmentDoc}`;

/**
 * __useGetShipmentsQuery__
 *
 * To run a query within a React component, call `useGetShipmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShipmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShipmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetShipmentsQuery(baseOptions?: Apollo.QueryHookOptions<GetShipmentsQuery, GetShipmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShipmentsQuery, GetShipmentsQueryVariables>(GetShipmentsDocument, options);
      }
export function useGetShipmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShipmentsQuery, GetShipmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShipmentsQuery, GetShipmentsQueryVariables>(GetShipmentsDocument, options);
        }
export type GetShipmentsQueryHookResult = ReturnType<typeof useGetShipmentsQuery>;
export type GetShipmentsLazyQueryHookResult = ReturnType<typeof useGetShipmentsLazyQuery>;
export type GetShipmentsQueryResult = Apollo.QueryResult<GetShipmentsQuery, GetShipmentsQueryVariables>;
export function refetchGetShipmentsQuery(variables?: GetShipmentsQueryVariables) {
      return { query: GetShipmentsDocument, variables: variables }
    }
export const GetShipmentsOemDocument = gql`
    query getShipmentsOEM {
  shipmentsOEM {
    ...ShipmentOEM
  }
}
    ${ShipmentOemFragmentDoc}`;

/**
 * __useGetShipmentsOemQuery__
 *
 * To run a query within a React component, call `useGetShipmentsOemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShipmentsOemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShipmentsOemQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetShipmentsOemQuery(baseOptions?: Apollo.QueryHookOptions<GetShipmentsOemQuery, GetShipmentsOemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShipmentsOemQuery, GetShipmentsOemQueryVariables>(GetShipmentsOemDocument, options);
      }
export function useGetShipmentsOemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShipmentsOemQuery, GetShipmentsOemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShipmentsOemQuery, GetShipmentsOemQueryVariables>(GetShipmentsOemDocument, options);
        }
export type GetShipmentsOemQueryHookResult = ReturnType<typeof useGetShipmentsOemQuery>;
export type GetShipmentsOemLazyQueryHookResult = ReturnType<typeof useGetShipmentsOemLazyQuery>;
export type GetShipmentsOemQueryResult = Apollo.QueryResult<GetShipmentsOemQuery, GetShipmentsOemQueryVariables>;
export function refetchGetShipmentsOemQuery(variables?: GetShipmentsOemQueryVariables) {
      return { query: GetShipmentsOemDocument, variables: variables }
    }
export const GetShipmentDocument = gql`
    query getShipment($id: UUID) {
  shipment(id: $id) {
    ...Shipment
  }
}
    ${ShipmentFragmentDoc}`;

/**
 * __useGetShipmentQuery__
 *
 * To run a query within a React component, call `useGetShipmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShipmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShipmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetShipmentQuery(baseOptions?: Apollo.QueryHookOptions<GetShipmentQuery, GetShipmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShipmentQuery, GetShipmentQueryVariables>(GetShipmentDocument, options);
      }
export function useGetShipmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShipmentQuery, GetShipmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShipmentQuery, GetShipmentQueryVariables>(GetShipmentDocument, options);
        }
export type GetShipmentQueryHookResult = ReturnType<typeof useGetShipmentQuery>;
export type GetShipmentLazyQueryHookResult = ReturnType<typeof useGetShipmentLazyQuery>;
export type GetShipmentQueryResult = Apollo.QueryResult<GetShipmentQuery, GetShipmentQueryVariables>;
export function refetchGetShipmentQuery(variables?: GetShipmentQueryVariables) {
      return { query: GetShipmentDocument, variables: variables }
    }
export const GetShipmentOemDocument = gql`
    query getShipmentOEM($id: UUID) {
  shipmentOEM(id: $id) {
    ...ShipmentOEM
  }
}
    ${ShipmentOemFragmentDoc}`;

/**
 * __useGetShipmentOemQuery__
 *
 * To run a query within a React component, call `useGetShipmentOemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShipmentOemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShipmentOemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetShipmentOemQuery(baseOptions?: Apollo.QueryHookOptions<GetShipmentOemQuery, GetShipmentOemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShipmentOemQuery, GetShipmentOemQueryVariables>(GetShipmentOemDocument, options);
      }
export function useGetShipmentOemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShipmentOemQuery, GetShipmentOemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShipmentOemQuery, GetShipmentOemQueryVariables>(GetShipmentOemDocument, options);
        }
export type GetShipmentOemQueryHookResult = ReturnType<typeof useGetShipmentOemQuery>;
export type GetShipmentOemLazyQueryHookResult = ReturnType<typeof useGetShipmentOemLazyQuery>;
export type GetShipmentOemQueryResult = Apollo.QueryResult<GetShipmentOemQuery, GetShipmentOemQueryVariables>;
export function refetchGetShipmentOemQuery(variables?: GetShipmentOemQueryVariables) {
      return { query: GetShipmentOemDocument, variables: variables }
    }
export const CreateSupplyOrderDocument = gql`
    mutation createSupplyOrder($input: CreateSupplyOrderMutationInput!) {
  createSupplyOrder(input: $input) {
    supplyOrder {
      ...SupplyOrderDetail
    }
    errors {
      field
      messages
    }
  }
}
    ${SupplyOrderDetailFragmentDoc}`;
export type CreateSupplyOrderMutationFn = Apollo.MutationFunction<CreateSupplyOrderMutation, CreateSupplyOrderMutationVariables>;

/**
 * __useCreateSupplyOrderMutation__
 *
 * To run a mutation, you first call `useCreateSupplyOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSupplyOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSupplyOrderMutation, { data, loading, error }] = useCreateSupplyOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSupplyOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateSupplyOrderMutation, CreateSupplyOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSupplyOrderMutation, CreateSupplyOrderMutationVariables>(CreateSupplyOrderDocument, options);
      }
export type CreateSupplyOrderMutationHookResult = ReturnType<typeof useCreateSupplyOrderMutation>;
export type CreateSupplyOrderMutationResult = Apollo.MutationResult<CreateSupplyOrderMutation>;
export type CreateSupplyOrderMutationOptions = Apollo.BaseMutationOptions<CreateSupplyOrderMutation, CreateSupplyOrderMutationVariables>;
export const UpdateSupplyOrderDocument = gql`
    mutation updateSupplyOrder($input: UpdateSupplyOrderMutationInput!) {
  updateSupplyOrder(input: $input) {
    supplyOrder {
      ...SupplyOrderDetail
    }
    errors {
      field
      messages
    }
  }
}
    ${SupplyOrderDetailFragmentDoc}`;
export type UpdateSupplyOrderMutationFn = Apollo.MutationFunction<UpdateSupplyOrderMutation, UpdateSupplyOrderMutationVariables>;

/**
 * __useUpdateSupplyOrderMutation__
 *
 * To run a mutation, you first call `useUpdateSupplyOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSupplyOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSupplyOrderMutation, { data, loading, error }] = useUpdateSupplyOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSupplyOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSupplyOrderMutation, UpdateSupplyOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSupplyOrderMutation, UpdateSupplyOrderMutationVariables>(UpdateSupplyOrderDocument, options);
      }
export type UpdateSupplyOrderMutationHookResult = ReturnType<typeof useUpdateSupplyOrderMutation>;
export type UpdateSupplyOrderMutationResult = Apollo.MutationResult<UpdateSupplyOrderMutation>;
export type UpdateSupplyOrderMutationOptions = Apollo.BaseMutationOptions<UpdateSupplyOrderMutation, UpdateSupplyOrderMutationVariables>;
export const UpdateOrderedProductDocument = gql`
    mutation updateOrderedProduct($input: UpdateOrderedProductMutationInput!) {
  updateOrderedProduct(input: $input) {
    orderedProduct {
      ...OrderedProduct
    }
    errors {
      field
      messages
    }
  }
}
    ${OrderedProductFragmentDoc}`;
export type UpdateOrderedProductMutationFn = Apollo.MutationFunction<UpdateOrderedProductMutation, UpdateOrderedProductMutationVariables>;

/**
 * __useUpdateOrderedProductMutation__
 *
 * To run a mutation, you first call `useUpdateOrderedProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderedProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderedProductMutation, { data, loading, error }] = useUpdateOrderedProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderedProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderedProductMutation, UpdateOrderedProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderedProductMutation, UpdateOrderedProductMutationVariables>(UpdateOrderedProductDocument, options);
      }
export type UpdateOrderedProductMutationHookResult = ReturnType<typeof useUpdateOrderedProductMutation>;
export type UpdateOrderedProductMutationResult = Apollo.MutationResult<UpdateOrderedProductMutation>;
export type UpdateOrderedProductMutationOptions = Apollo.BaseMutationOptions<UpdateOrderedProductMutation, UpdateOrderedProductMutationVariables>;
export const StartSupplyOrderReviewDocument = gql`
    mutation startSupplyOrderReview($input: StartSupplyOrderReviewMutationInput!) {
  startSupplyOrderReview(input: $input) {
    supplyOrder {
      ...SupplyOrder
    }
    errors {
      field
      messages
    }
  }
}
    ${SupplyOrderFragmentDoc}`;
export type StartSupplyOrderReviewMutationFn = Apollo.MutationFunction<StartSupplyOrderReviewMutation, StartSupplyOrderReviewMutationVariables>;

/**
 * __useStartSupplyOrderReviewMutation__
 *
 * To run a mutation, you first call `useStartSupplyOrderReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartSupplyOrderReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startSupplyOrderReviewMutation, { data, loading, error }] = useStartSupplyOrderReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartSupplyOrderReviewMutation(baseOptions?: Apollo.MutationHookOptions<StartSupplyOrderReviewMutation, StartSupplyOrderReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartSupplyOrderReviewMutation, StartSupplyOrderReviewMutationVariables>(StartSupplyOrderReviewDocument, options);
      }
export type StartSupplyOrderReviewMutationHookResult = ReturnType<typeof useStartSupplyOrderReviewMutation>;
export type StartSupplyOrderReviewMutationResult = Apollo.MutationResult<StartSupplyOrderReviewMutation>;
export type StartSupplyOrderReviewMutationOptions = Apollo.BaseMutationOptions<StartSupplyOrderReviewMutation, StartSupplyOrderReviewMutationVariables>;
export const ReviewSupplyOrderDocument = gql`
    mutation reviewSupplyOrder($input: SupplyOrderReviewMutationInput!) {
  reviewSupplyOrder(input: $input) {
    supplyOrderReview {
      supplyOrder {
        ...SupplyOrder
      }
    }
    errors {
      field
      messages
    }
  }
}
    ${SupplyOrderFragmentDoc}`;
export type ReviewSupplyOrderMutationFn = Apollo.MutationFunction<ReviewSupplyOrderMutation, ReviewSupplyOrderMutationVariables>;

/**
 * __useReviewSupplyOrderMutation__
 *
 * To run a mutation, you first call `useReviewSupplyOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewSupplyOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewSupplyOrderMutation, { data, loading, error }] = useReviewSupplyOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReviewSupplyOrderMutation(baseOptions?: Apollo.MutationHookOptions<ReviewSupplyOrderMutation, ReviewSupplyOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReviewSupplyOrderMutation, ReviewSupplyOrderMutationVariables>(ReviewSupplyOrderDocument, options);
      }
export type ReviewSupplyOrderMutationHookResult = ReturnType<typeof useReviewSupplyOrderMutation>;
export type ReviewSupplyOrderMutationResult = Apollo.MutationResult<ReviewSupplyOrderMutation>;
export type ReviewSupplyOrderMutationOptions = Apollo.BaseMutationOptions<ReviewSupplyOrderMutation, ReviewSupplyOrderMutationVariables>;
export const CreateSupplyOrderExportDocument = gql`
    mutation createSupplyOrderExport($filters: SupplyOrderListOptionsInputType, $id: UUID) {
  createSupplyOrderExport(filters: $filters, supplyOrderId: $id) {
    job {
      id
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type CreateSupplyOrderExportMutationFn = Apollo.MutationFunction<CreateSupplyOrderExportMutation, CreateSupplyOrderExportMutationVariables>;

/**
 * __useCreateSupplyOrderExportMutation__
 *
 * To run a mutation, you first call `useCreateSupplyOrderExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSupplyOrderExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSupplyOrderExportMutation, { data, loading, error }] = useCreateSupplyOrderExportMutation({
 *   variables: {
 *      filters: // value for 'filters'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCreateSupplyOrderExportMutation(baseOptions?: Apollo.MutationHookOptions<CreateSupplyOrderExportMutation, CreateSupplyOrderExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSupplyOrderExportMutation, CreateSupplyOrderExportMutationVariables>(CreateSupplyOrderExportDocument, options);
      }
export type CreateSupplyOrderExportMutationHookResult = ReturnType<typeof useCreateSupplyOrderExportMutation>;
export type CreateSupplyOrderExportMutationResult = Apollo.MutationResult<CreateSupplyOrderExportMutation>;
export type CreateSupplyOrderExportMutationOptions = Apollo.BaseMutationOptions<CreateSupplyOrderExportMutation, CreateSupplyOrderExportMutationVariables>;
export const CreateAccountExportDocument = gql`
    mutation createAccountExport($input: CreateAccountExportMutationInput!) {
  createAccountExport(input: $input) {
    accountExport {
      file
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type CreateAccountExportMutationFn = Apollo.MutationFunction<CreateAccountExportMutation, CreateAccountExportMutationVariables>;

/**
 * __useCreateAccountExportMutation__
 *
 * To run a mutation, you first call `useCreateAccountExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountExportMutation, { data, loading, error }] = useCreateAccountExportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAccountExportMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccountExportMutation, CreateAccountExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccountExportMutation, CreateAccountExportMutationVariables>(CreateAccountExportDocument, options);
      }
export type CreateAccountExportMutationHookResult = ReturnType<typeof useCreateAccountExportMutation>;
export type CreateAccountExportMutationResult = Apollo.MutationResult<CreateAccountExportMutation>;
export type CreateAccountExportMutationOptions = Apollo.BaseMutationOptions<CreateAccountExportMutation, CreateAccountExportMutationVariables>;
export const CreateSaleExportDocument = gql`
    mutation createSaleExport($id: UUID, $filters: SaleListOptionsInputType) {
  createSaleExport(filters: $filters, saleId: $id) {
    job {
      id
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type CreateSaleExportMutationFn = Apollo.MutationFunction<CreateSaleExportMutation, CreateSaleExportMutationVariables>;

/**
 * __useCreateSaleExportMutation__
 *
 * To run a mutation, you first call `useCreateSaleExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSaleExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSaleExportMutation, { data, loading, error }] = useCreateSaleExportMutation({
 *   variables: {
 *      id: // value for 'id'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCreateSaleExportMutation(baseOptions?: Apollo.MutationHookOptions<CreateSaleExportMutation, CreateSaleExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSaleExportMutation, CreateSaleExportMutationVariables>(CreateSaleExportDocument, options);
      }
export type CreateSaleExportMutationHookResult = ReturnType<typeof useCreateSaleExportMutation>;
export type CreateSaleExportMutationResult = Apollo.MutationResult<CreateSaleExportMutation>;
export type CreateSaleExportMutationOptions = Apollo.BaseMutationOptions<CreateSaleExportMutation, CreateSaleExportMutationVariables>;
export const QuoteExcelExportDocument = gql`
    mutation quoteExcelExport($filters: QuoteListOptionsInputType, $id: UUID, $paymentMethod: String) {
  quoteExcelExport(filters: $filters, id: $id, paymentMethod: $paymentMethod) {
    job {
      id
    }
  }
}
    `;
export type QuoteExcelExportMutationFn = Apollo.MutationFunction<QuoteExcelExportMutation, QuoteExcelExportMutationVariables>;

/**
 * __useQuoteExcelExportMutation__
 *
 * To run a mutation, you first call `useQuoteExcelExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQuoteExcelExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [quoteExcelExportMutation, { data, loading, error }] = useQuoteExcelExportMutation({
 *   variables: {
 *      filters: // value for 'filters'
 *      id: // value for 'id'
 *      paymentMethod: // value for 'paymentMethod'
 *   },
 * });
 */
export function useQuoteExcelExportMutation(baseOptions?: Apollo.MutationHookOptions<QuoteExcelExportMutation, QuoteExcelExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<QuoteExcelExportMutation, QuoteExcelExportMutationVariables>(QuoteExcelExportDocument, options);
      }
export type QuoteExcelExportMutationHookResult = ReturnType<typeof useQuoteExcelExportMutation>;
export type QuoteExcelExportMutationResult = Apollo.MutationResult<QuoteExcelExportMutation>;
export type QuoteExcelExportMutationOptions = Apollo.BaseMutationOptions<QuoteExcelExportMutation, QuoteExcelExportMutationVariables>;
export const CreateProductWarrantyClaimExportDocument = gql`
    mutation createProductWarrantyClaimExport($id: UUID, $filters: ProductWarrantyClaimListOptionsInputType) {
  createProductWarrantyClaimExport(filters: $filters, id: $id) {
    job {
      id
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type CreateProductWarrantyClaimExportMutationFn = Apollo.MutationFunction<CreateProductWarrantyClaimExportMutation, CreateProductWarrantyClaimExportMutationVariables>;

/**
 * __useCreateProductWarrantyClaimExportMutation__
 *
 * To run a mutation, you first call `useCreateProductWarrantyClaimExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductWarrantyClaimExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductWarrantyClaimExportMutation, { data, loading, error }] = useCreateProductWarrantyClaimExportMutation({
 *   variables: {
 *      id: // value for 'id'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCreateProductWarrantyClaimExportMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductWarrantyClaimExportMutation, CreateProductWarrantyClaimExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductWarrantyClaimExportMutation, CreateProductWarrantyClaimExportMutationVariables>(CreateProductWarrantyClaimExportDocument, options);
      }
export type CreateProductWarrantyClaimExportMutationHookResult = ReturnType<typeof useCreateProductWarrantyClaimExportMutation>;
export type CreateProductWarrantyClaimExportMutationResult = Apollo.MutationResult<CreateProductWarrantyClaimExportMutation>;
export type CreateProductWarrantyClaimExportMutationOptions = Apollo.BaseMutationOptions<CreateProductWarrantyClaimExportMutation, CreateProductWarrantyClaimExportMutationVariables>;
export const CreateWarrantyClaimPdfDocument = gql`
    mutation createWarrantyClaimPDF($id: UUID!) {
  createWarrantyClaimPdf(warrantyClaimId: $id) {
    job {
      id
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type CreateWarrantyClaimPdfMutationFn = Apollo.MutationFunction<CreateWarrantyClaimPdfMutation, CreateWarrantyClaimPdfMutationVariables>;

/**
 * __useCreateWarrantyClaimPdfMutation__
 *
 * To run a mutation, you first call `useCreateWarrantyClaimPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWarrantyClaimPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWarrantyClaimPdfMutation, { data, loading, error }] = useCreateWarrantyClaimPdfMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCreateWarrantyClaimPdfMutation(baseOptions?: Apollo.MutationHookOptions<CreateWarrantyClaimPdfMutation, CreateWarrantyClaimPdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWarrantyClaimPdfMutation, CreateWarrantyClaimPdfMutationVariables>(CreateWarrantyClaimPdfDocument, options);
      }
export type CreateWarrantyClaimPdfMutationHookResult = ReturnType<typeof useCreateWarrantyClaimPdfMutation>;
export type CreateWarrantyClaimPdfMutationResult = Apollo.MutationResult<CreateWarrantyClaimPdfMutation>;
export type CreateWarrantyClaimPdfMutationOptions = Apollo.BaseMutationOptions<CreateWarrantyClaimPdfMutation, CreateWarrantyClaimPdfMutationVariables>;
export const CreateSeederExportDocument = gql`
    mutation createSeederExport($input: CreateSeederExportMutationInput!) {
  createSeederExport(input: $input) {
    seederExport {
      file
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type CreateSeederExportMutationFn = Apollo.MutationFunction<CreateSeederExportMutation, CreateSeederExportMutationVariables>;

/**
 * __useCreateSeederExportMutation__
 *
 * To run a mutation, you first call `useCreateSeederExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSeederExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSeederExportMutation, { data, loading, error }] = useCreateSeederExportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSeederExportMutation(baseOptions?: Apollo.MutationHookOptions<CreateSeederExportMutation, CreateSeederExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSeederExportMutation, CreateSeederExportMutationVariables>(CreateSeederExportDocument, options);
      }
export type CreateSeederExportMutationHookResult = ReturnType<typeof useCreateSeederExportMutation>;
export type CreateSeederExportMutationResult = Apollo.MutationResult<CreateSeederExportMutation>;
export type CreateSeederExportMutationOptions = Apollo.BaseMutationOptions<CreateSeederExportMutation, CreateSeederExportMutationVariables>;
export const GetSeederBrandsDocument = gql`
    query getSeederBrands($organizationId: UUID) {
  seederBrands(organizationId: $organizationId) {
    ...SeederBrand
  }
}
    ${SeederBrandFragmentDoc}`;

/**
 * __useGetSeederBrandsQuery__
 *
 * To run a query within a React component, call `useGetSeederBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeederBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeederBrandsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetSeederBrandsQuery(baseOptions?: Apollo.QueryHookOptions<GetSeederBrandsQuery, GetSeederBrandsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSeederBrandsQuery, GetSeederBrandsQueryVariables>(GetSeederBrandsDocument, options);
      }
export function useGetSeederBrandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSeederBrandsQuery, GetSeederBrandsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSeederBrandsQuery, GetSeederBrandsQueryVariables>(GetSeederBrandsDocument, options);
        }
export type GetSeederBrandsQueryHookResult = ReturnType<typeof useGetSeederBrandsQuery>;
export type GetSeederBrandsLazyQueryHookResult = ReturnType<typeof useGetSeederBrandsLazyQuery>;
export type GetSeederBrandsQueryResult = Apollo.QueryResult<GetSeederBrandsQuery, GetSeederBrandsQueryVariables>;
export function refetchGetSeederBrandsQuery(variables?: GetSeederBrandsQueryVariables) {
      return { query: GetSeederBrandsDocument, variables: variables }
    }
export const GetSeederModelsDocument = gql`
    query getSeederModels($seederBrandId: UUID) {
  seederModels(seederBrandId: $seederBrandId) {
    ...SeederModel
  }
}
    ${SeederModelFragmentDoc}`;

/**
 * __useGetSeederModelsQuery__
 *
 * To run a query within a React component, call `useGetSeederModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeederModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeederModelsQuery({
 *   variables: {
 *      seederBrandId: // value for 'seederBrandId'
 *   },
 * });
 */
export function useGetSeederModelsQuery(baseOptions?: Apollo.QueryHookOptions<GetSeederModelsQuery, GetSeederModelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSeederModelsQuery, GetSeederModelsQueryVariables>(GetSeederModelsDocument, options);
      }
export function useGetSeederModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSeederModelsQuery, GetSeederModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSeederModelsQuery, GetSeederModelsQueryVariables>(GetSeederModelsDocument, options);
        }
export type GetSeederModelsQueryHookResult = ReturnType<typeof useGetSeederModelsQuery>;
export type GetSeederModelsLazyQueryHookResult = ReturnType<typeof useGetSeederModelsLazyQuery>;
export type GetSeederModelsQueryResult = Apollo.QueryResult<GetSeederModelsQuery, GetSeederModelsQueryVariables>;
export function refetchGetSeederModelsQuery(variables?: GetSeederModelsQueryVariables) {
      return { query: GetSeederModelsDocument, variables: variables }
    }
export const GetSeederDocument = gql`
    query getSeeder($id: UUID) {
  seeder(id: $id) {
    ...SeederDetail
  }
}
    ${SeederDetailFragmentDoc}`;

/**
 * __useGetSeederQuery__
 *
 * To run a query within a React component, call `useGetSeederQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeederQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeederQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSeederQuery(baseOptions?: Apollo.QueryHookOptions<GetSeederQuery, GetSeederQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSeederQuery, GetSeederQueryVariables>(GetSeederDocument, options);
      }
export function useGetSeederLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSeederQuery, GetSeederQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSeederQuery, GetSeederQueryVariables>(GetSeederDocument, options);
        }
export type GetSeederQueryHookResult = ReturnType<typeof useGetSeederQuery>;
export type GetSeederLazyQueryHookResult = ReturnType<typeof useGetSeederLazyQuery>;
export type GetSeederQueryResult = Apollo.QueryResult<GetSeederQuery, GetSeederQueryVariables>;
export function refetchGetSeederQuery(variables?: GetSeederQueryVariables) {
      return { query: GetSeederDocument, variables: variables }
    }
export const GetSeedersDocument = gql`
    query getSeeders {
  seeders {
    ...SeederOption
  }
}
    ${SeederOptionFragmentDoc}`;

/**
 * __useGetSeedersQuery__
 *
 * To run a query within a React component, call `useGetSeedersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeedersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeedersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSeedersQuery(baseOptions?: Apollo.QueryHookOptions<GetSeedersQuery, GetSeedersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSeedersQuery, GetSeedersQueryVariables>(GetSeedersDocument, options);
      }
export function useGetSeedersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSeedersQuery, GetSeedersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSeedersQuery, GetSeedersQueryVariables>(GetSeedersDocument, options);
        }
export type GetSeedersQueryHookResult = ReturnType<typeof useGetSeedersQuery>;
export type GetSeedersLazyQueryHookResult = ReturnType<typeof useGetSeedersLazyQuery>;
export type GetSeedersQueryResult = Apollo.QueryResult<GetSeedersQuery, GetSeedersQueryVariables>;
export function refetchGetSeedersQuery(variables?: GetSeedersQueryVariables) {
      return { query: GetSeedersDocument, variables: variables }
    }
export const GetSeederOptionsDocument = gql`
    query getSeederOptions($accountId: UUID) {
  seeders(accountId: $accountId) {
    ...SeederOption
  }
}
    ${SeederOptionFragmentDoc}`;

/**
 * __useGetSeederOptionsQuery__
 *
 * To run a query within a React component, call `useGetSeederOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeederOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeederOptionsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetSeederOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetSeederOptionsQuery, GetSeederOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSeederOptionsQuery, GetSeederOptionsQueryVariables>(GetSeederOptionsDocument, options);
      }
export function useGetSeederOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSeederOptionsQuery, GetSeederOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSeederOptionsQuery, GetSeederOptionsQueryVariables>(GetSeederOptionsDocument, options);
        }
export type GetSeederOptionsQueryHookResult = ReturnType<typeof useGetSeederOptionsQuery>;
export type GetSeederOptionsLazyQueryHookResult = ReturnType<typeof useGetSeederOptionsLazyQuery>;
export type GetSeederOptionsQueryResult = Apollo.QueryResult<GetSeederOptionsQuery, GetSeederOptionsQueryVariables>;
export function refetchGetSeederOptionsQuery(variables?: GetSeederOptionsQueryVariables) {
      return { query: GetSeederOptionsDocument, variables: variables }
    }
export const CreateSeederDocument = gql`
    mutation createSeeder($input: CreateSeederMutationInput!) {
  createSeeder(input: $input) {
    seeder {
      ...SeederDetail
    }
    errors {
      field
      messages
    }
  }
}
    ${SeederDetailFragmentDoc}`;
export type CreateSeederMutationFn = Apollo.MutationFunction<CreateSeederMutation, CreateSeederMutationVariables>;

/**
 * __useCreateSeederMutation__
 *
 * To run a mutation, you first call `useCreateSeederMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSeederMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSeederMutation, { data, loading, error }] = useCreateSeederMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSeederMutation(baseOptions?: Apollo.MutationHookOptions<CreateSeederMutation, CreateSeederMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSeederMutation, CreateSeederMutationVariables>(CreateSeederDocument, options);
      }
export type CreateSeederMutationHookResult = ReturnType<typeof useCreateSeederMutation>;
export type CreateSeederMutationResult = Apollo.MutationResult<CreateSeederMutation>;
export type CreateSeederMutationOptions = Apollo.BaseMutationOptions<CreateSeederMutation, CreateSeederMutationVariables>;
export const UpdateSeederDocument = gql`
    mutation updateSeeder($input: UpdateSeederMutationInput!) {
  updateSeeder(input: $input) {
    seeder {
      ...SeederDetail
    }
    errors {
      field
      messages
    }
  }
}
    ${SeederDetailFragmentDoc}`;
export type UpdateSeederMutationFn = Apollo.MutationFunction<UpdateSeederMutation, UpdateSeederMutationVariables>;

/**
 * __useUpdateSeederMutation__
 *
 * To run a mutation, you first call `useUpdateSeederMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSeederMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSeederMutation, { data, loading, error }] = useUpdateSeederMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSeederMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSeederMutation, UpdateSeederMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSeederMutation, UpdateSeederMutationVariables>(UpdateSeederDocument, options);
      }
export type UpdateSeederMutationHookResult = ReturnType<typeof useUpdateSeederMutation>;
export type UpdateSeederMutationResult = Apollo.MutationResult<UpdateSeederMutation>;
export type UpdateSeederMutationOptions = Apollo.BaseMutationOptions<UpdateSeederMutation, UpdateSeederMutationVariables>;
export const DeleteSeederDocument = gql`
    mutation deleteSeeder($input: DeleteSeederMutationInput!) {
  deleteSeeder(input: $input) {
    errors {
      field
      messages
    }
  }
}
    `;
export type DeleteSeederMutationFn = Apollo.MutationFunction<DeleteSeederMutation, DeleteSeederMutationVariables>;

/**
 * __useDeleteSeederMutation__
 *
 * To run a mutation, you first call `useDeleteSeederMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSeederMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSeederMutation, { data, loading, error }] = useDeleteSeederMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSeederMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSeederMutation, DeleteSeederMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSeederMutation, DeleteSeederMutationVariables>(DeleteSeederDocument, options);
      }
export type DeleteSeederMutationHookResult = ReturnType<typeof useDeleteSeederMutation>;
export type DeleteSeederMutationResult = Apollo.MutationResult<DeleteSeederMutation>;
export type DeleteSeederMutationOptions = Apollo.BaseMutationOptions<DeleteSeederMutation, DeleteSeederMutationVariables>;
export const GetRuntimeSettingsDocument = gql`
    query getRuntimeSettings {
  runtimeSettings {
    ...RuntimeSettings
  }
}
    ${RuntimeSettingsFragmentDoc}`;

/**
 * __useGetRuntimeSettingsQuery__
 *
 * To run a query within a React component, call `useGetRuntimeSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRuntimeSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRuntimeSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRuntimeSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetRuntimeSettingsQuery, GetRuntimeSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRuntimeSettingsQuery, GetRuntimeSettingsQueryVariables>(GetRuntimeSettingsDocument, options);
      }
export function useGetRuntimeSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRuntimeSettingsQuery, GetRuntimeSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRuntimeSettingsQuery, GetRuntimeSettingsQueryVariables>(GetRuntimeSettingsDocument, options);
        }
export type GetRuntimeSettingsQueryHookResult = ReturnType<typeof useGetRuntimeSettingsQuery>;
export type GetRuntimeSettingsLazyQueryHookResult = ReturnType<typeof useGetRuntimeSettingsLazyQuery>;
export type GetRuntimeSettingsQueryResult = Apollo.QueryResult<GetRuntimeSettingsQuery, GetRuntimeSettingsQueryVariables>;
export function refetchGetRuntimeSettingsQuery(variables?: GetRuntimeSettingsQueryVariables) {
      return { query: GetRuntimeSettingsDocument, variables: variables }
    }
export const GetLocationDocument = gql`
    query getLocation($id: ID!) {
  location(id: $id) {
    ...LocationOption
  }
}
    ${LocationOptionFragmentDoc}`;

/**
 * __useGetLocationQuery__
 *
 * To run a query within a React component, call `useGetLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLocationQuery(baseOptions: Apollo.QueryHookOptions<GetLocationQuery, GetLocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationQuery, GetLocationQueryVariables>(GetLocationDocument, options);
      }
export function useGetLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationQuery, GetLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationQuery, GetLocationQueryVariables>(GetLocationDocument, options);
        }
export type GetLocationQueryHookResult = ReturnType<typeof useGetLocationQuery>;
export type GetLocationLazyQueryHookResult = ReturnType<typeof useGetLocationLazyQuery>;
export type GetLocationQueryResult = Apollo.QueryResult<GetLocationQuery, GetLocationQueryVariables>;
export function refetchGetLocationQuery(variables: GetLocationQueryVariables) {
      return { query: GetLocationDocument, variables: variables }
    }
export const GetLocationsDocument = gql`
    query getLocations($level: Int, $query: String, $limit: Int, $id: Int) {
  locations(level: $level, query: $query, limit: $limit, id: $id) {
    ...LocationOption
  }
}
    ${LocationOptionFragmentDoc}`;

/**
 * __useGetLocationsQuery__
 *
 * To run a query within a React component, call `useGetLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationsQuery({
 *   variables: {
 *      level: // value for 'level'
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLocationsQuery(baseOptions?: Apollo.QueryHookOptions<GetLocationsQuery, GetLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationsQuery, GetLocationsQueryVariables>(GetLocationsDocument, options);
      }
export function useGetLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationsQuery, GetLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationsQuery, GetLocationsQueryVariables>(GetLocationsDocument, options);
        }
export type GetLocationsQueryHookResult = ReturnType<typeof useGetLocationsQuery>;
export type GetLocationsLazyQueryHookResult = ReturnType<typeof useGetLocationsLazyQuery>;
export type GetLocationsQueryResult = Apollo.QueryResult<GetLocationsQuery, GetLocationsQueryVariables>;
export function refetchGetLocationsQuery(variables?: GetLocationsQueryVariables) {
      return { query: GetLocationsDocument, variables: variables }
    }
export const RejectWarrantyClaimDocument = gql`
    mutation rejectWarrantyClaim($input: RejectWarrantyClaimRequestMutationInput!) {
  rejectWarrantyClaim(input: $input) {
    productWarrantyClaimReview {
      ...ProductWarrantyClaimReview
    }
    errors {
      field
      messages
    }
  }
}
    ${ProductWarrantyClaimReviewFragmentDoc}`;
export type RejectWarrantyClaimMutationFn = Apollo.MutationFunction<RejectWarrantyClaimMutation, RejectWarrantyClaimMutationVariables>;

/**
 * __useRejectWarrantyClaimMutation__
 *
 * To run a mutation, you first call `useRejectWarrantyClaimMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectWarrantyClaimMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectWarrantyClaimMutation, { data, loading, error }] = useRejectWarrantyClaimMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRejectWarrantyClaimMutation(baseOptions?: Apollo.MutationHookOptions<RejectWarrantyClaimMutation, RejectWarrantyClaimMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectWarrantyClaimMutation, RejectWarrantyClaimMutationVariables>(RejectWarrantyClaimDocument, options);
      }
export type RejectWarrantyClaimMutationHookResult = ReturnType<typeof useRejectWarrantyClaimMutation>;
export type RejectWarrantyClaimMutationResult = Apollo.MutationResult<RejectWarrantyClaimMutation>;
export type RejectWarrantyClaimMutationOptions = Apollo.BaseMutationOptions<RejectWarrantyClaimMutation, RejectWarrantyClaimMutationVariables>;
export const ApproveWarrantyClaimDocument = gql`
    mutation approveWarrantyClaim($input: ApproveWarrantyClaimRequestMutationInput!) {
  approveWarrantyClaim(input: $input) {
    productWarrantyClaimReview {
      ...ProductWarrantyClaimReview
    }
    errors {
      field
      messages
    }
  }
}
    ${ProductWarrantyClaimReviewFragmentDoc}`;
export type ApproveWarrantyClaimMutationFn = Apollo.MutationFunction<ApproveWarrantyClaimMutation, ApproveWarrantyClaimMutationVariables>;

/**
 * __useApproveWarrantyClaimMutation__
 *
 * To run a mutation, you first call `useApproveWarrantyClaimMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveWarrantyClaimMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveWarrantyClaimMutation, { data, loading, error }] = useApproveWarrantyClaimMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApproveWarrantyClaimMutation(baseOptions?: Apollo.MutationHookOptions<ApproveWarrantyClaimMutation, ApproveWarrantyClaimMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveWarrantyClaimMutation, ApproveWarrantyClaimMutationVariables>(ApproveWarrantyClaimDocument, options);
      }
export type ApproveWarrantyClaimMutationHookResult = ReturnType<typeof useApproveWarrantyClaimMutation>;
export type ApproveWarrantyClaimMutationResult = Apollo.MutationResult<ApproveWarrantyClaimMutation>;
export type ApproveWarrantyClaimMutationOptions = Apollo.BaseMutationOptions<ApproveWarrantyClaimMutation, ApproveWarrantyClaimMutationVariables>;
export const CreateShipmentProductWarrantyClaimDocument = gql`
    mutation createShipmentProductWarrantyClaim($input: CreateShipmentProductWarrantyClaimMutationInput!) {
  createShipmentProductWarrantyClaim(input: $input) {
    productWarrantyClaim {
      ...ProductWarrantyClaim
    }
    errors {
      field
      messages
    }
  }
}
    ${ProductWarrantyClaimFragmentDoc}`;
export type CreateShipmentProductWarrantyClaimMutationFn = Apollo.MutationFunction<CreateShipmentProductWarrantyClaimMutation, CreateShipmentProductWarrantyClaimMutationVariables>;

/**
 * __useCreateShipmentProductWarrantyClaimMutation__
 *
 * To run a mutation, you first call `useCreateShipmentProductWarrantyClaimMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateShipmentProductWarrantyClaimMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createShipmentProductWarrantyClaimMutation, { data, loading, error }] = useCreateShipmentProductWarrantyClaimMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateShipmentProductWarrantyClaimMutation(baseOptions?: Apollo.MutationHookOptions<CreateShipmentProductWarrantyClaimMutation, CreateShipmentProductWarrantyClaimMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateShipmentProductWarrantyClaimMutation, CreateShipmentProductWarrantyClaimMutationVariables>(CreateShipmentProductWarrantyClaimDocument, options);
      }
export type CreateShipmentProductWarrantyClaimMutationHookResult = ReturnType<typeof useCreateShipmentProductWarrantyClaimMutation>;
export type CreateShipmentProductWarrantyClaimMutationResult = Apollo.MutationResult<CreateShipmentProductWarrantyClaimMutation>;
export type CreateShipmentProductWarrantyClaimMutationOptions = Apollo.BaseMutationOptions<CreateShipmentProductWarrantyClaimMutation, CreateShipmentProductWarrantyClaimMutationVariables>;
export const CancelWarrantyClaimDocument = gql`
    mutation cancelWarrantyClaim($input: CancelWarrantyClaimRequestMutationInput!) {
  cancelWarrantyClaim(input: $input) {
    productWarrantyClaimReview {
      ...ProductWarrantyClaimReview
    }
    errors {
      field
      messages
    }
  }
}
    ${ProductWarrantyClaimReviewFragmentDoc}`;
export type CancelWarrantyClaimMutationFn = Apollo.MutationFunction<CancelWarrantyClaimMutation, CancelWarrantyClaimMutationVariables>;

/**
 * __useCancelWarrantyClaimMutation__
 *
 * To run a mutation, you first call `useCancelWarrantyClaimMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelWarrantyClaimMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelWarrantyClaimMutation, { data, loading, error }] = useCancelWarrantyClaimMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelWarrantyClaimMutation(baseOptions?: Apollo.MutationHookOptions<CancelWarrantyClaimMutation, CancelWarrantyClaimMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelWarrantyClaimMutation, CancelWarrantyClaimMutationVariables>(CancelWarrantyClaimDocument, options);
      }
export type CancelWarrantyClaimMutationHookResult = ReturnType<typeof useCancelWarrantyClaimMutation>;
export type CancelWarrantyClaimMutationResult = Apollo.MutationResult<CancelWarrantyClaimMutation>;
export type CancelWarrantyClaimMutationOptions = Apollo.BaseMutationOptions<CancelWarrantyClaimMutation, CancelWarrantyClaimMutationVariables>;
export const GetCloseReasonsDocument = gql`
    query getCloseReasons {
  closeReasons {
    ...CloseReason
  }
}
    ${CloseReasonFragmentDoc}`;

/**
 * __useGetCloseReasonsQuery__
 *
 * To run a query within a React component, call `useGetCloseReasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCloseReasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCloseReasonsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCloseReasonsQuery(baseOptions?: Apollo.QueryHookOptions<GetCloseReasonsQuery, GetCloseReasonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCloseReasonsQuery, GetCloseReasonsQueryVariables>(GetCloseReasonsDocument, options);
      }
export function useGetCloseReasonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCloseReasonsQuery, GetCloseReasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCloseReasonsQuery, GetCloseReasonsQueryVariables>(GetCloseReasonsDocument, options);
        }
export type GetCloseReasonsQueryHookResult = ReturnType<typeof useGetCloseReasonsQuery>;
export type GetCloseReasonsLazyQueryHookResult = ReturnType<typeof useGetCloseReasonsLazyQuery>;
export type GetCloseReasonsQueryResult = Apollo.QueryResult<GetCloseReasonsQuery, GetCloseReasonsQueryVariables>;
export function refetchGetCloseReasonsQuery(variables?: GetCloseReasonsQueryVariables) {
      return { query: GetCloseReasonsDocument, variables: variables }
    }
export const CloseQuotesDocument = gql`
    mutation closeQuotes($input: [QuoteCloseReasonInputType]!) {
  closeQuotes(input: $input) {
    status
  }
}
    `;
export type CloseQuotesMutationFn = Apollo.MutationFunction<CloseQuotesMutation, CloseQuotesMutationVariables>;

/**
 * __useCloseQuotesMutation__
 *
 * To run a mutation, you first call `useCloseQuotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseQuotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeQuotesMutation, { data, loading, error }] = useCloseQuotesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCloseQuotesMutation(baseOptions?: Apollo.MutationHookOptions<CloseQuotesMutation, CloseQuotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloseQuotesMutation, CloseQuotesMutationVariables>(CloseQuotesDocument, options);
      }
export type CloseQuotesMutationHookResult = ReturnType<typeof useCloseQuotesMutation>;
export type CloseQuotesMutationResult = Apollo.MutationResult<CloseQuotesMutation>;
export type CloseQuotesMutationOptions = Apollo.BaseMutationOptions<CloseQuotesMutation, CloseQuotesMutationVariables>;
export const GetExpiredQuotesDocument = gql`
    query getExpiredQuotes {
  expiredQuotes {
    items {
      ...ExpiredQuote
    }
    count
  }
}
    ${ExpiredQuoteFragmentDoc}`;

/**
 * __useGetExpiredQuotesQuery__
 *
 * To run a query within a React component, call `useGetExpiredQuotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExpiredQuotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExpiredQuotesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetExpiredQuotesQuery(baseOptions?: Apollo.QueryHookOptions<GetExpiredQuotesQuery, GetExpiredQuotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExpiredQuotesQuery, GetExpiredQuotesQueryVariables>(GetExpiredQuotesDocument, options);
      }
export function useGetExpiredQuotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExpiredQuotesQuery, GetExpiredQuotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExpiredQuotesQuery, GetExpiredQuotesQueryVariables>(GetExpiredQuotesDocument, options);
        }
export type GetExpiredQuotesQueryHookResult = ReturnType<typeof useGetExpiredQuotesQuery>;
export type GetExpiredQuotesLazyQueryHookResult = ReturnType<typeof useGetExpiredQuotesLazyQuery>;
export type GetExpiredQuotesQueryResult = Apollo.QueryResult<GetExpiredQuotesQuery, GetExpiredQuotesQueryVariables>;
export function refetchGetExpiredQuotesQuery(variables?: GetExpiredQuotesQueryVariables) {
      return { query: GetExpiredQuotesDocument, variables: variables }
    }
export const GetExpiredQuotesCountDocument = gql`
    query getExpiredQuotesCount($options: QuoteListOptionsInputType) {
  expiredQuotes(options: $options) {
    count
  }
}
    `;

/**
 * __useGetExpiredQuotesCountQuery__
 *
 * To run a query within a React component, call `useGetExpiredQuotesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExpiredQuotesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExpiredQuotesCountQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetExpiredQuotesCountQuery(baseOptions?: Apollo.QueryHookOptions<GetExpiredQuotesCountQuery, GetExpiredQuotesCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExpiredQuotesCountQuery, GetExpiredQuotesCountQueryVariables>(GetExpiredQuotesCountDocument, options);
      }
export function useGetExpiredQuotesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExpiredQuotesCountQuery, GetExpiredQuotesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExpiredQuotesCountQuery, GetExpiredQuotesCountQueryVariables>(GetExpiredQuotesCountDocument, options);
        }
export type GetExpiredQuotesCountQueryHookResult = ReturnType<typeof useGetExpiredQuotesCountQuery>;
export type GetExpiredQuotesCountLazyQueryHookResult = ReturnType<typeof useGetExpiredQuotesCountLazyQuery>;
export type GetExpiredQuotesCountQueryResult = Apollo.QueryResult<GetExpiredQuotesCountQuery, GetExpiredQuotesCountQueryVariables>;
export function refetchGetExpiredQuotesCountQuery(variables?: GetExpiredQuotesCountQueryVariables) {
      return { query: GetExpiredQuotesCountDocument, variables: variables }
    }
export const GetClosedQuotesDocument = gql`
    query getClosedQuotes($options: QuoteListOptionsInputType) {
  closedQuotes(options: $options) {
    items {
      ...QuoteList
    }
    count
  }
}
    ${QuoteListFragmentDoc}`;

/**
 * __useGetClosedQuotesQuery__
 *
 * To run a query within a React component, call `useGetClosedQuotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClosedQuotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClosedQuotesQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetClosedQuotesQuery(baseOptions?: Apollo.QueryHookOptions<GetClosedQuotesQuery, GetClosedQuotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClosedQuotesQuery, GetClosedQuotesQueryVariables>(GetClosedQuotesDocument, options);
      }
export function useGetClosedQuotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClosedQuotesQuery, GetClosedQuotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClosedQuotesQuery, GetClosedQuotesQueryVariables>(GetClosedQuotesDocument, options);
        }
export type GetClosedQuotesQueryHookResult = ReturnType<typeof useGetClosedQuotesQuery>;
export type GetClosedQuotesLazyQueryHookResult = ReturnType<typeof useGetClosedQuotesLazyQuery>;
export type GetClosedQuotesQueryResult = Apollo.QueryResult<GetClosedQuotesQuery, GetClosedQuotesQueryVariables>;
export function refetchGetClosedQuotesQuery(variables?: GetClosedQuotesQueryVariables) {
      return { query: GetClosedQuotesDocument, variables: variables }
    }
export const GetFailuresDocument = gql`
    query getFailures {
  failures {
    ...Failure
  }
}
    ${FailureFragmentDoc}`;

/**
 * __useGetFailuresQuery__
 *
 * To run a query within a React component, call `useGetFailuresQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFailuresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFailuresQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFailuresQuery(baseOptions?: Apollo.QueryHookOptions<GetFailuresQuery, GetFailuresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFailuresQuery, GetFailuresQueryVariables>(GetFailuresDocument, options);
      }
export function useGetFailuresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFailuresQuery, GetFailuresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFailuresQuery, GetFailuresQueryVariables>(GetFailuresDocument, options);
        }
export type GetFailuresQueryHookResult = ReturnType<typeof useGetFailuresQuery>;
export type GetFailuresLazyQueryHookResult = ReturnType<typeof useGetFailuresLazyQuery>;
export type GetFailuresQueryResult = Apollo.QueryResult<GetFailuresQuery, GetFailuresQueryVariables>;
export function refetchGetFailuresQuery(variables?: GetFailuresQueryVariables) {
      return { query: GetFailuresDocument, variables: variables }
    }
export const CreateWarrantyClaimInspectionReviewDocument = gql`
    mutation createWarrantyClaimInspectionReview($input: CreateWarrantyClaimInspectionReviewMutationInput!) {
  createWarrantyClaimInspectionReview(input: $input) {
    warrantyClaimInspectionReview {
      ...WarrantyClaimInspectionReview
    }
    errors {
      field
      messages
    }
  }
}
    ${WarrantyClaimInspectionReviewFragmentDoc}`;
export type CreateWarrantyClaimInspectionReviewMutationFn = Apollo.MutationFunction<CreateWarrantyClaimInspectionReviewMutation, CreateWarrantyClaimInspectionReviewMutationVariables>;

/**
 * __useCreateWarrantyClaimInspectionReviewMutation__
 *
 * To run a mutation, you first call `useCreateWarrantyClaimInspectionReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWarrantyClaimInspectionReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWarrantyClaimInspectionReviewMutation, { data, loading, error }] = useCreateWarrantyClaimInspectionReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWarrantyClaimInspectionReviewMutation(baseOptions?: Apollo.MutationHookOptions<CreateWarrantyClaimInspectionReviewMutation, CreateWarrantyClaimInspectionReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWarrantyClaimInspectionReviewMutation, CreateWarrantyClaimInspectionReviewMutationVariables>(CreateWarrantyClaimInspectionReviewDocument, options);
      }
export type CreateWarrantyClaimInspectionReviewMutationHookResult = ReturnType<typeof useCreateWarrantyClaimInspectionReviewMutation>;
export type CreateWarrantyClaimInspectionReviewMutationResult = Apollo.MutationResult<CreateWarrantyClaimInspectionReviewMutation>;
export type CreateWarrantyClaimInspectionReviewMutationOptions = Apollo.BaseMutationOptions<CreateWarrantyClaimInspectionReviewMutation, CreateWarrantyClaimInspectionReviewMutationVariables>;
export const GetNotificationsDocument = gql`
    query getNotifications($options: NotificationListOptionsInputType!) {
  notifications {
    unreadCount
    notifications(options: $options) {
      items {
        ...Notification
      }
      count
      page
    }
  }
}
    ${NotificationFragmentDoc}`;

/**
 * __useGetNotificationsQuery__
 *
 * To run a query within a React component, call `useGetNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetNotificationsQuery(baseOptions: Apollo.QueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
      }
export function useGetNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
        }
export type GetNotificationsQueryHookResult = ReturnType<typeof useGetNotificationsQuery>;
export type GetNotificationsLazyQueryHookResult = ReturnType<typeof useGetNotificationsLazyQuery>;
export type GetNotificationsQueryResult = Apollo.QueryResult<GetNotificationsQuery, GetNotificationsQueryVariables>;
export function refetchGetNotificationsQuery(variables: GetNotificationsQueryVariables) {
      return { query: GetNotificationsDocument, variables: variables }
    }
export const MarkNotificationAsReadDocument = gql`
    mutation markNotificationAsRead($input: MarkNotificationAsReadMutationInput!) {
  markNotificationAsRead(input: $input) {
    notification {
      ...Notification
    }
    errors {
      field
      messages
    }
  }
}
    ${NotificationFragmentDoc}`;
export type MarkNotificationAsReadMutationFn = Apollo.MutationFunction<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>;

/**
 * __useMarkNotificationAsReadMutation__
 *
 * To run a mutation, you first call `useMarkNotificationAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationAsReadMutation, { data, loading, error }] = useMarkNotificationAsReadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkNotificationAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>(MarkNotificationAsReadDocument, options);
      }
export type MarkNotificationAsReadMutationHookResult = ReturnType<typeof useMarkNotificationAsReadMutation>;
export type MarkNotificationAsReadMutationResult = Apollo.MutationResult<MarkNotificationAsReadMutation>;
export type MarkNotificationAsReadMutationOptions = Apollo.BaseMutationOptions<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>;
export const MarkAllNotificationsAsReadDocument = gql`
    mutation markAllNotificationsAsRead {
  markAllNotificationsAsRead {
    status
  }
}
    `;
export type MarkAllNotificationsAsReadMutationFn = Apollo.MutationFunction<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>;

/**
 * __useMarkAllNotificationsAsReadMutation__
 *
 * To run a mutation, you first call `useMarkAllNotificationsAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllNotificationsAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAllNotificationsAsReadMutation, { data, loading, error }] = useMarkAllNotificationsAsReadMutation({
 *   variables: {
 *   },
 * });
 */
export function useMarkAllNotificationsAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>(MarkAllNotificationsAsReadDocument, options);
      }
export type MarkAllNotificationsAsReadMutationHookResult = ReturnType<typeof useMarkAllNotificationsAsReadMutation>;
export type MarkAllNotificationsAsReadMutationResult = Apollo.MutationResult<MarkAllNotificationsAsReadMutation>;
export type MarkAllNotificationsAsReadMutationOptions = Apollo.BaseMutationOptions<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>;
export const UploadInvoiceDocument = gql`
    mutation uploadInvoice($input: UploadInvoiceMutationInput!) {
  uploadInvoice(input: $input) {
    shipment {
      ...Shipment
    }
    errors {
      field
      messages
    }
  }
}
    ${ShipmentFragmentDoc}`;
export type UploadInvoiceMutationFn = Apollo.MutationFunction<UploadInvoiceMutation, UploadInvoiceMutationVariables>;

/**
 * __useUploadInvoiceMutation__
 *
 * To run a mutation, you first call `useUploadInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadInvoiceMutation, { data, loading, error }] = useUploadInvoiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<UploadInvoiceMutation, UploadInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadInvoiceMutation, UploadInvoiceMutationVariables>(UploadInvoiceDocument, options);
      }
export type UploadInvoiceMutationHookResult = ReturnType<typeof useUploadInvoiceMutation>;
export type UploadInvoiceMutationResult = Apollo.MutationResult<UploadInvoiceMutation>;
export type UploadInvoiceMutationOptions = Apollo.BaseMutationOptions<UploadInvoiceMutation, UploadInvoiceMutationVariables>;
export const UploadInvoiceOemDocument = gql`
    mutation uploadInvoiceOem($input: UploadInvoiceOemMutationInput!) {
  uploadInvoiceOem(input: $input) {
    shipmentOEM {
      ...ShipmentOEM
    }
    errors {
      field
      messages
    }
  }
}
    ${ShipmentOemFragmentDoc}`;
export type UploadInvoiceOemMutationFn = Apollo.MutationFunction<UploadInvoiceOemMutation, UploadInvoiceOemMutationVariables>;

/**
 * __useUploadInvoiceOemMutation__
 *
 * To run a mutation, you first call `useUploadInvoiceOemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadInvoiceOemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadInvoiceOemMutation, { data, loading, error }] = useUploadInvoiceOemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadInvoiceOemMutation(baseOptions?: Apollo.MutationHookOptions<UploadInvoiceOemMutation, UploadInvoiceOemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadInvoiceOemMutation, UploadInvoiceOemMutationVariables>(UploadInvoiceOemDocument, options);
      }
export type UploadInvoiceOemMutationHookResult = ReturnType<typeof useUploadInvoiceOemMutation>;
export type UploadInvoiceOemMutationResult = Apollo.MutationResult<UploadInvoiceOemMutation>;
export type UploadInvoiceOemMutationOptions = Apollo.BaseMutationOptions<UploadInvoiceOemMutation, UploadInvoiceOemMutationVariables>;
export const CreateWarrantyClaimDocument = gql`
    mutation createWarrantyClaim($input: CreateWarrantyClaimMutationInput!) {
  createWarrantyClaim(input: $input) {
    productWarrantyClaim {
      ...ProductWarrantyClaim
    }
    errors {
      field
      messages
    }
  }
}
    ${ProductWarrantyClaimFragmentDoc}`;
export type CreateWarrantyClaimMutationFn = Apollo.MutationFunction<CreateWarrantyClaimMutation, CreateWarrantyClaimMutationVariables>;

/**
 * __useCreateWarrantyClaimMutation__
 *
 * To run a mutation, you first call `useCreateWarrantyClaimMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWarrantyClaimMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWarrantyClaimMutation, { data, loading, error }] = useCreateWarrantyClaimMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWarrantyClaimMutation(baseOptions?: Apollo.MutationHookOptions<CreateWarrantyClaimMutation, CreateWarrantyClaimMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWarrantyClaimMutation, CreateWarrantyClaimMutationVariables>(CreateWarrantyClaimDocument, options);
      }
export type CreateWarrantyClaimMutationHookResult = ReturnType<typeof useCreateWarrantyClaimMutation>;
export type CreateWarrantyClaimMutationResult = Apollo.MutationResult<CreateWarrantyClaimMutation>;
export type CreateWarrantyClaimMutationOptions = Apollo.BaseMutationOptions<CreateWarrantyClaimMutation, CreateWarrantyClaimMutationVariables>;
export const UpdateWarrantyClaimDocument = gql`
    mutation updateWarrantyClaim($input: UpdateWarrantyClaimMutationInput!) {
  updateWarrantyClaim(input: $input) {
    productWarrantyClaim {
      ...ProductWarrantyClaim
    }
    errors {
      field
      messages
    }
  }
}
    ${ProductWarrantyClaimFragmentDoc}`;
export type UpdateWarrantyClaimMutationFn = Apollo.MutationFunction<UpdateWarrantyClaimMutation, UpdateWarrantyClaimMutationVariables>;

/**
 * __useUpdateWarrantyClaimMutation__
 *
 * To run a mutation, you first call `useUpdateWarrantyClaimMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWarrantyClaimMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWarrantyClaimMutation, { data, loading, error }] = useUpdateWarrantyClaimMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWarrantyClaimMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWarrantyClaimMutation, UpdateWarrantyClaimMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWarrantyClaimMutation, UpdateWarrantyClaimMutationVariables>(UpdateWarrantyClaimDocument, options);
      }
export type UpdateWarrantyClaimMutationHookResult = ReturnType<typeof useUpdateWarrantyClaimMutation>;
export type UpdateWarrantyClaimMutationResult = Apollo.MutationResult<UpdateWarrantyClaimMutation>;
export type UpdateWarrantyClaimMutationOptions = Apollo.BaseMutationOptions<UpdateWarrantyClaimMutation, UpdateWarrantyClaimMutationVariables>;
export const GetAnalyticsPdfExportDocument = gql`
    query getAnalyticsPdfExport($path: String!, $waitForSelector: String!) {
  analyticsPdfExport(path: $path, waitForSelector: $waitForSelector) {
    ...Download
  }
}
    ${DownloadFragmentDoc}`;

/**
 * __useGetAnalyticsPdfExportQuery__
 *
 * To run a query within a React component, call `useGetAnalyticsPdfExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyticsPdfExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalyticsPdfExportQuery({
 *   variables: {
 *      path: // value for 'path'
 *      waitForSelector: // value for 'waitForSelector'
 *   },
 * });
 */
export function useGetAnalyticsPdfExportQuery(baseOptions: Apollo.QueryHookOptions<GetAnalyticsPdfExportQuery, GetAnalyticsPdfExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnalyticsPdfExportQuery, GetAnalyticsPdfExportQueryVariables>(GetAnalyticsPdfExportDocument, options);
      }
export function useGetAnalyticsPdfExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnalyticsPdfExportQuery, GetAnalyticsPdfExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnalyticsPdfExportQuery, GetAnalyticsPdfExportQueryVariables>(GetAnalyticsPdfExportDocument, options);
        }
export type GetAnalyticsPdfExportQueryHookResult = ReturnType<typeof useGetAnalyticsPdfExportQuery>;
export type GetAnalyticsPdfExportLazyQueryHookResult = ReturnType<typeof useGetAnalyticsPdfExportLazyQuery>;
export type GetAnalyticsPdfExportQueryResult = Apollo.QueryResult<GetAnalyticsPdfExportQuery, GetAnalyticsPdfExportQueryVariables>;
export function refetchGetAnalyticsPdfExportQuery(variables: GetAnalyticsPdfExportQueryVariables) {
      return { query: GetAnalyticsPdfExportDocument, variables: variables }
    }
export const CreateMultipleShipmentsDocument = gql`
    mutation createMultipleShipments($shipments: [ShipmentFormInput!]!) {
  createMultipleShipments(shipments: $shipments) {
    shipments {
      ...Shipment
    }
    errors {
      field
      messages
    }
  }
}
    ${ShipmentFragmentDoc}`;
export type CreateMultipleShipmentsMutationFn = Apollo.MutationFunction<CreateMultipleShipmentsMutation, CreateMultipleShipmentsMutationVariables>;

/**
 * __useCreateMultipleShipmentsMutation__
 *
 * To run a mutation, you first call `useCreateMultipleShipmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMultipleShipmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMultipleShipmentsMutation, { data, loading, error }] = useCreateMultipleShipmentsMutation({
 *   variables: {
 *      shipments: // value for 'shipments'
 *   },
 * });
 */
export function useCreateMultipleShipmentsMutation(baseOptions?: Apollo.MutationHookOptions<CreateMultipleShipmentsMutation, CreateMultipleShipmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMultipleShipmentsMutation, CreateMultipleShipmentsMutationVariables>(CreateMultipleShipmentsDocument, options);
      }
export type CreateMultipleShipmentsMutationHookResult = ReturnType<typeof useCreateMultipleShipmentsMutation>;
export type CreateMultipleShipmentsMutationResult = Apollo.MutationResult<CreateMultipleShipmentsMutation>;
export type CreateMultipleShipmentsMutationOptions = Apollo.BaseMutationOptions<CreateMultipleShipmentsMutation, CreateMultipleShipmentsMutationVariables>;
export const AddOrderedProductDocument = gql`
    mutation addOrderedProduct($input: OrderedProductSupplyOrderFormInput!, $orderedProducts: [OrderedProductOrderedProductFormInput!]!) {
  addOrderedProductMutation(input: $input, orderedProducts: $orderedProducts) {
    errors {
      field
      messages
    }
  }
}
    `;
export type AddOrderedProductMutationFn = Apollo.MutationFunction<AddOrderedProductMutation, AddOrderedProductMutationVariables>;

/**
 * __useAddOrderedProductMutation__
 *
 * To run a mutation, you first call `useAddOrderedProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrderedProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrderedProductMutation, { data, loading, error }] = useAddOrderedProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *      orderedProducts: // value for 'orderedProducts'
 *   },
 * });
 */
export function useAddOrderedProductMutation(baseOptions?: Apollo.MutationHookOptions<AddOrderedProductMutation, AddOrderedProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddOrderedProductMutation, AddOrderedProductMutationVariables>(AddOrderedProductDocument, options);
      }
export type AddOrderedProductMutationHookResult = ReturnType<typeof useAddOrderedProductMutation>;
export type AddOrderedProductMutationResult = Apollo.MutationResult<AddOrderedProductMutation>;
export type AddOrderedProductMutationOptions = Apollo.BaseMutationOptions<AddOrderedProductMutation, AddOrderedProductMutationVariables>;
export const GetGefcoShipmentDocument = gql`
    query getGefcoShipment($id: String!) {
  gefcoShipment(id: $id, disableCache: false) {
    shipments {
      ...GefcoShipmentStatus
    }
    error
  }
}
    ${GefcoShipmentStatusFragmentDoc}`;

/**
 * __useGetGefcoShipmentQuery__
 *
 * To run a query within a React component, call `useGetGefcoShipmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGefcoShipmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGefcoShipmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetGefcoShipmentQuery(baseOptions: Apollo.QueryHookOptions<GetGefcoShipmentQuery, GetGefcoShipmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGefcoShipmentQuery, GetGefcoShipmentQueryVariables>(GetGefcoShipmentDocument, options);
      }
export function useGetGefcoShipmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGefcoShipmentQuery, GetGefcoShipmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGefcoShipmentQuery, GetGefcoShipmentQueryVariables>(GetGefcoShipmentDocument, options);
        }
export type GetGefcoShipmentQueryHookResult = ReturnType<typeof useGetGefcoShipmentQuery>;
export type GetGefcoShipmentLazyQueryHookResult = ReturnType<typeof useGetGefcoShipmentLazyQuery>;
export type GetGefcoShipmentQueryResult = Apollo.QueryResult<GetGefcoShipmentQuery, GetGefcoShipmentQueryVariables>;
export function refetchGetGefcoShipmentQuery(variables: GetGefcoShipmentQueryVariables) {
      return { query: GetGefcoShipmentDocument, variables: variables }
    }
export const GetOemProductsDocument = gql`
    query getOemProducts($organizationId: UUID!) {
  oemProducts(organizationId: $organizationId) {
    id
    price
    displayName
    externalId
    product {
      id
      description
      externalId
      rowCount
      order
      name
      ruleGroup {
        id
      }
      ruleCategories {
        id
      }
      subcategory {
        ...ProductSubcategory
      }
    }
  }
}
    ${ProductSubcategoryFragmentDoc}`;

/**
 * __useGetOemProductsQuery__
 *
 * To run a query within a React component, call `useGetOemProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOemProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOemProductsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOemProductsQuery(baseOptions: Apollo.QueryHookOptions<GetOemProductsQuery, GetOemProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOemProductsQuery, GetOemProductsQueryVariables>(GetOemProductsDocument, options);
      }
export function useGetOemProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOemProductsQuery, GetOemProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOemProductsQuery, GetOemProductsQueryVariables>(GetOemProductsDocument, options);
        }
export type GetOemProductsQueryHookResult = ReturnType<typeof useGetOemProductsQuery>;
export type GetOemProductsLazyQueryHookResult = ReturnType<typeof useGetOemProductsLazyQuery>;
export type GetOemProductsQueryResult = Apollo.QueryResult<GetOemProductsQuery, GetOemProductsQueryVariables>;
export function refetchGetOemProductsQuery(variables: GetOemProductsQueryVariables) {
      return { query: GetOemProductsDocument, variables: variables }
    }
export const GetOrganizationOemStockDocument = gql`
    query getOrganizationOemStock($options: OrganizationGroupOemThroughListOptionsInputType, $organizationId: UUID!) {
  organizationOemStock(options: $options) {
    count
    items {
      id
      externalId
      published
      displayName
      organizationGroup {
        id
      }
      requestedQuantity(organizationId: $organizationId)
      stock
      product {
        id
        description
        externalId
        name
        subcategory {
          ...ProductSubcategory
        }
      }
    }
  }
}
    ${ProductSubcategoryFragmentDoc}`;

/**
 * __useGetOrganizationOemStockQuery__
 *
 * To run a query within a React component, call `useGetOrganizationOemStockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationOemStockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationOemStockQuery({
 *   variables: {
 *      options: // value for 'options'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationOemStockQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationOemStockQuery, GetOrganizationOemStockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationOemStockQuery, GetOrganizationOemStockQueryVariables>(GetOrganizationOemStockDocument, options);
      }
export function useGetOrganizationOemStockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationOemStockQuery, GetOrganizationOemStockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationOemStockQuery, GetOrganizationOemStockQueryVariables>(GetOrganizationOemStockDocument, options);
        }
export type GetOrganizationOemStockQueryHookResult = ReturnType<typeof useGetOrganizationOemStockQuery>;
export type GetOrganizationOemStockLazyQueryHookResult = ReturnType<typeof useGetOrganizationOemStockLazyQuery>;
export type GetOrganizationOemStockQueryResult = Apollo.QueryResult<GetOrganizationOemStockQuery, GetOrganizationOemStockQueryVariables>;
export function refetchGetOrganizationOemStockQuery(variables: GetOrganizationOemStockQueryVariables) {
      return { query: GetOrganizationOemStockDocument, variables: variables }
    }
export const AddStockToProductDocument = gql`
    mutation addStockToProduct($input: AddStockToProductMutationInput!) {
  addStockToProduct(input: $input) {
    organizationGroupOemThrough {
      id
    }
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type AddStockToProductMutationFn = Apollo.MutationFunction<AddStockToProductMutation, AddStockToProductMutationVariables>;

/**
 * __useAddStockToProductMutation__
 *
 * To run a mutation, you first call `useAddStockToProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddStockToProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addStockToProductMutation, { data, loading, error }] = useAddStockToProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddStockToProductMutation(baseOptions?: Apollo.MutationHookOptions<AddStockToProductMutation, AddStockToProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddStockToProductMutation, AddStockToProductMutationVariables>(AddStockToProductDocument, options);
      }
export type AddStockToProductMutationHookResult = ReturnType<typeof useAddStockToProductMutation>;
export type AddStockToProductMutationResult = Apollo.MutationResult<AddStockToProductMutation>;
export type AddStockToProductMutationOptions = Apollo.BaseMutationOptions<AddStockToProductMutation, AddStockToProductMutationVariables>;
export const AddProductsToOemOrganizationDocument = gql`
    mutation addProductsToOemOrganization($products: [AddStockToProductFormInput!]!) {
  addProductsToOemOrganization(products: $products) {
    ok
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type AddProductsToOemOrganizationMutationFn = Apollo.MutationFunction<AddProductsToOemOrganizationMutation, AddProductsToOemOrganizationMutationVariables>;

/**
 * __useAddProductsToOemOrganizationMutation__
 *
 * To run a mutation, you first call `useAddProductsToOemOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProductsToOemOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductsToOemOrganizationMutation, { data, loading, error }] = useAddProductsToOemOrganizationMutation({
 *   variables: {
 *      products: // value for 'products'
 *   },
 * });
 */
export function useAddProductsToOemOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<AddProductsToOemOrganizationMutation, AddProductsToOemOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProductsToOemOrganizationMutation, AddProductsToOemOrganizationMutationVariables>(AddProductsToOemOrganizationDocument, options);
      }
export type AddProductsToOemOrganizationMutationHookResult = ReturnType<typeof useAddProductsToOemOrganizationMutation>;
export type AddProductsToOemOrganizationMutationResult = Apollo.MutationResult<AddProductsToOemOrganizationMutation>;
export type AddProductsToOemOrganizationMutationOptions = Apollo.BaseMutationOptions<AddProductsToOemOrganizationMutation, AddProductsToOemOrganizationMutationVariables>;
export const GetJobDocument = gql`
    query getJob($id: String!) {
  job(id: $id) {
    ...Job
  }
}
    ${JobFragmentDoc}`;

/**
 * __useGetJobQuery__
 *
 * To run a query within a React component, call `useGetJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetJobQuery(baseOptions: Apollo.QueryHookOptions<GetJobQuery, GetJobQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobQuery, GetJobQueryVariables>(GetJobDocument, options);
      }
export function useGetJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobQuery, GetJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobQuery, GetJobQueryVariables>(GetJobDocument, options);
        }
export type GetJobQueryHookResult = ReturnType<typeof useGetJobQuery>;
export type GetJobLazyQueryHookResult = ReturnType<typeof useGetJobLazyQuery>;
export type GetJobQueryResult = Apollo.QueryResult<GetJobQuery, GetJobQueryVariables>;
export function refetchGetJobQuery(variables: GetJobQueryVariables) {
      return { query: GetJobDocument, variables: variables }
    }
export const GetExportFileJobDocument = gql`
    query getExportFileJob($id: String!) {
  exportFileJob(id: $id) {
    id
    status
    result {
      ...Download
    }
  }
}
    ${DownloadFragmentDoc}`;

/**
 * __useGetExportFileJobQuery__
 *
 * To run a query within a React component, call `useGetExportFileJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExportFileJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExportFileJobQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetExportFileJobQuery(baseOptions: Apollo.QueryHookOptions<GetExportFileJobQuery, GetExportFileJobQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExportFileJobQuery, GetExportFileJobQueryVariables>(GetExportFileJobDocument, options);
      }
export function useGetExportFileJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExportFileJobQuery, GetExportFileJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExportFileJobQuery, GetExportFileJobQueryVariables>(GetExportFileJobDocument, options);
        }
export type GetExportFileJobQueryHookResult = ReturnType<typeof useGetExportFileJobQuery>;
export type GetExportFileJobLazyQueryHookResult = ReturnType<typeof useGetExportFileJobLazyQuery>;
export type GetExportFileJobQueryResult = Apollo.QueryResult<GetExportFileJobQuery, GetExportFileJobQueryVariables>;
export function refetchGetExportFileJobQuery(variables: GetExportFileJobQueryVariables) {
      return { query: GetExportFileJobDocument, variables: variables }
    }
export const ExportOemsDocument = gql`
    mutation exportOems($options: OrderOEMListOptionsInputType, $orderOemId: UUID) {
  exportOems(filters: $options, orderOemId: $orderOemId) {
    job {
      id
    }
  }
}
    `;
export type ExportOemsMutationFn = Apollo.MutationFunction<ExportOemsMutation, ExportOemsMutationVariables>;

/**
 * __useExportOemsMutation__
 *
 * To run a mutation, you first call `useExportOemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportOemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportOemsMutation, { data, loading, error }] = useExportOemsMutation({
 *   variables: {
 *      options: // value for 'options'
 *      orderOemId: // value for 'orderOemId'
 *   },
 * });
 */
export function useExportOemsMutation(baseOptions?: Apollo.MutationHookOptions<ExportOemsMutation, ExportOemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportOemsMutation, ExportOemsMutationVariables>(ExportOemsDocument, options);
      }
export type ExportOemsMutationHookResult = ReturnType<typeof useExportOemsMutation>;
export type ExportOemsMutationResult = Apollo.MutationResult<ExportOemsMutation>;
export type ExportOemsMutationOptions = Apollo.BaseMutationOptions<ExportOemsMutation, ExportOemsMutationVariables>;
export const GetProductsStocksDocument = gql`
    query getProductsStocks($externalIds: [String]!) {
  productsStocks(externalIds: $externalIds) {
    stocks {
      externalId
      availableQuantity
      found
    }
    errors {
      code
      message
    }
  }
}
    `;

/**
 * __useGetProductsStocksQuery__
 *
 * To run a query within a React component, call `useGetProductsStocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsStocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsStocksQuery({
 *   variables: {
 *      externalIds: // value for 'externalIds'
 *   },
 * });
 */
export function useGetProductsStocksQuery(baseOptions: Apollo.QueryHookOptions<GetProductsStocksQuery, GetProductsStocksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsStocksQuery, GetProductsStocksQueryVariables>(GetProductsStocksDocument, options);
      }
export function useGetProductsStocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsStocksQuery, GetProductsStocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsStocksQuery, GetProductsStocksQueryVariables>(GetProductsStocksDocument, options);
        }
export type GetProductsStocksQueryHookResult = ReturnType<typeof useGetProductsStocksQuery>;
export type GetProductsStocksLazyQueryHookResult = ReturnType<typeof useGetProductsStocksLazyQuery>;
export type GetProductsStocksQueryResult = Apollo.QueryResult<GetProductsStocksQuery, GetProductsStocksQueryVariables>;
export function refetchGetProductsStocksQuery(variables: GetProductsStocksQueryVariables) {
      return { query: GetProductsStocksDocument, variables: variables }
    }
export const GetUserNotificationConfigDocument = gql`
    query getUserNotificationConfig {
  notificationsConfigNames {
    ...NotificationConfigName
  }
  userNotificationsConfigs {
    ...NotificationConfig
  }
}
    ${NotificationConfigNameFragmentDoc}
${NotificationConfigFragmentDoc}`;

/**
 * __useGetUserNotificationConfigQuery__
 *
 * To run a query within a React component, call `useGetUserNotificationConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserNotificationConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserNotificationConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserNotificationConfigQuery(baseOptions?: Apollo.QueryHookOptions<GetUserNotificationConfigQuery, GetUserNotificationConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserNotificationConfigQuery, GetUserNotificationConfigQueryVariables>(GetUserNotificationConfigDocument, options);
      }
export function useGetUserNotificationConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserNotificationConfigQuery, GetUserNotificationConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserNotificationConfigQuery, GetUserNotificationConfigQueryVariables>(GetUserNotificationConfigDocument, options);
        }
export type GetUserNotificationConfigQueryHookResult = ReturnType<typeof useGetUserNotificationConfigQuery>;
export type GetUserNotificationConfigLazyQueryHookResult = ReturnType<typeof useGetUserNotificationConfigLazyQuery>;
export type GetUserNotificationConfigQueryResult = Apollo.QueryResult<GetUserNotificationConfigQuery, GetUserNotificationConfigQueryVariables>;
export function refetchGetUserNotificationConfigQuery(variables?: GetUserNotificationConfigQueryVariables) {
      return { query: GetUserNotificationConfigDocument, variables: variables }
    }
export const ToggleNotificationConfigDocument = gql`
    mutation toggleNotificationConfig($input: NotificationConfigMutationInput!) {
  toggleNotificationConfig(input: $input) {
    notificationConfig {
      ...NotificationConfig
    }
    errors {
      ...Error
    }
  }
}
    ${NotificationConfigFragmentDoc}
${ErrorFragmentDoc}`;
export type ToggleNotificationConfigMutationFn = Apollo.MutationFunction<ToggleNotificationConfigMutation, ToggleNotificationConfigMutationVariables>;

/**
 * __useToggleNotificationConfigMutation__
 *
 * To run a mutation, you first call `useToggleNotificationConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleNotificationConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleNotificationConfigMutation, { data, loading, error }] = useToggleNotificationConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToggleNotificationConfigMutation(baseOptions?: Apollo.MutationHookOptions<ToggleNotificationConfigMutation, ToggleNotificationConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleNotificationConfigMutation, ToggleNotificationConfigMutationVariables>(ToggleNotificationConfigDocument, options);
      }
export type ToggleNotificationConfigMutationHookResult = ReturnType<typeof useToggleNotificationConfigMutation>;
export type ToggleNotificationConfigMutationResult = Apollo.MutationResult<ToggleNotificationConfigMutation>;
export type ToggleNotificationConfigMutationOptions = Apollo.BaseMutationOptions<ToggleNotificationConfigMutation, ToggleNotificationConfigMutationVariables>;
export const MachineStartUpsExcelExportDocument = gql`
    mutation machineStartUpsExcelExport($options: MachineStartUpListOptionsInputType) {
  machineStartUpsExcelExport(options: $options) {
    job {
      id
    }
  }
}
    `;
export type MachineStartUpsExcelExportMutationFn = Apollo.MutationFunction<MachineStartUpsExcelExportMutation, MachineStartUpsExcelExportMutationVariables>;

/**
 * __useMachineStartUpsExcelExportMutation__
 *
 * To run a mutation, you first call `useMachineStartUpsExcelExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMachineStartUpsExcelExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [machineStartUpsExcelExportMutation, { data, loading, error }] = useMachineStartUpsExcelExportMutation({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useMachineStartUpsExcelExportMutation(baseOptions?: Apollo.MutationHookOptions<MachineStartUpsExcelExportMutation, MachineStartUpsExcelExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MachineStartUpsExcelExportMutation, MachineStartUpsExcelExportMutationVariables>(MachineStartUpsExcelExportDocument, options);
      }
export type MachineStartUpsExcelExportMutationHookResult = ReturnType<typeof useMachineStartUpsExcelExportMutation>;
export type MachineStartUpsExcelExportMutationResult = Apollo.MutationResult<MachineStartUpsExcelExportMutation>;
export type MachineStartUpsExcelExportMutationOptions = Apollo.BaseMutationOptions<MachineStartUpsExcelExportMutation, MachineStartUpsExcelExportMutationVariables>;
export const MsuMissingProductExcelExportDocument = gql`
    mutation msuMissingProductExcelExport($options: MachineStartUpListOptionsInputType) {
  msuMissingProductExport(options: $options) {
    job {
      id
    }
  }
}
    `;
export type MsuMissingProductExcelExportMutationFn = Apollo.MutationFunction<MsuMissingProductExcelExportMutation, MsuMissingProductExcelExportMutationVariables>;

/**
 * __useMsuMissingProductExcelExportMutation__
 *
 * To run a mutation, you first call `useMsuMissingProductExcelExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMsuMissingProductExcelExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [msuMissingProductExcelExportMutation, { data, loading, error }] = useMsuMissingProductExcelExportMutation({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useMsuMissingProductExcelExportMutation(baseOptions?: Apollo.MutationHookOptions<MsuMissingProductExcelExportMutation, MsuMissingProductExcelExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MsuMissingProductExcelExportMutation, MsuMissingProductExcelExportMutationVariables>(MsuMissingProductExcelExportDocument, options);
      }
export type MsuMissingProductExcelExportMutationHookResult = ReturnType<typeof useMsuMissingProductExcelExportMutation>;
export type MsuMissingProductExcelExportMutationResult = Apollo.MutationResult<MsuMissingProductExcelExportMutation>;
export type MsuMissingProductExcelExportMutationOptions = Apollo.BaseMutationOptions<MsuMissingProductExcelExportMutation, MsuMissingProductExcelExportMutationVariables>;
export const PemPdfExportDocument = gql`
    mutation pemPdfExport($id: UUID!, $dealerType: String!) {
  pemPdfExport(id: $id, dealerType: $dealerType) {
    job {
      ...ExportJob
    }
  }
}
    ${ExportJobFragmentDoc}`;
export type PemPdfExportMutationFn = Apollo.MutationFunction<PemPdfExportMutation, PemPdfExportMutationVariables>;

/**
 * __usePemPdfExportMutation__
 *
 * To run a mutation, you first call `usePemPdfExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePemPdfExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pemPdfExportMutation, { data, loading, error }] = usePemPdfExportMutation({
 *   variables: {
 *      id: // value for 'id'
 *      dealerType: // value for 'dealerType'
 *   },
 * });
 */
export function usePemPdfExportMutation(baseOptions?: Apollo.MutationHookOptions<PemPdfExportMutation, PemPdfExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PemPdfExportMutation, PemPdfExportMutationVariables>(PemPdfExportDocument, options);
      }
export type PemPdfExportMutationHookResult = ReturnType<typeof usePemPdfExportMutation>;
export type PemPdfExportMutationResult = Apollo.MutationResult<PemPdfExportMutation>;
export type PemPdfExportMutationOptions = Apollo.BaseMutationOptions<PemPdfExportMutation, PemPdfExportMutationVariables>;
export const GetMachineStartUpsDocument = gql`
    query getMachineStartUps($options: MachineStartUpListOptionsInputType) {
  machineStartUps(options: $options) {
    items {
      ...MachineStartUpList
    }
    count
  }
}
    ${MachineStartUpListFragmentDoc}`;

/**
 * __useGetMachineStartUpsQuery__
 *
 * To run a query within a React component, call `useGetMachineStartUpsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMachineStartUpsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMachineStartUpsQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetMachineStartUpsQuery(baseOptions?: Apollo.QueryHookOptions<GetMachineStartUpsQuery, GetMachineStartUpsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMachineStartUpsQuery, GetMachineStartUpsQueryVariables>(GetMachineStartUpsDocument, options);
      }
export function useGetMachineStartUpsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMachineStartUpsQuery, GetMachineStartUpsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMachineStartUpsQuery, GetMachineStartUpsQueryVariables>(GetMachineStartUpsDocument, options);
        }
export type GetMachineStartUpsQueryHookResult = ReturnType<typeof useGetMachineStartUpsQuery>;
export type GetMachineStartUpsLazyQueryHookResult = ReturnType<typeof useGetMachineStartUpsLazyQuery>;
export type GetMachineStartUpsQueryResult = Apollo.QueryResult<GetMachineStartUpsQuery, GetMachineStartUpsQueryVariables>;
export function refetchGetMachineStartUpsQuery(variables?: GetMachineStartUpsQueryVariables) {
      return { query: GetMachineStartUpsDocument, variables: variables }
    }
export const GetMissingProductsDocument = gql`
    query getMissingProducts {
  missingProducts {
    items {
      ...MissingProductsList
    }
  }
}
    ${MissingProductsListFragmentDoc}`;

/**
 * __useGetMissingProductsQuery__
 *
 * To run a query within a React component, call `useGetMissingProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMissingProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMissingProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMissingProductsQuery(baseOptions?: Apollo.QueryHookOptions<GetMissingProductsQuery, GetMissingProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMissingProductsQuery, GetMissingProductsQueryVariables>(GetMissingProductsDocument, options);
      }
export function useGetMissingProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMissingProductsQuery, GetMissingProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMissingProductsQuery, GetMissingProductsQueryVariables>(GetMissingProductsDocument, options);
        }
export type GetMissingProductsQueryHookResult = ReturnType<typeof useGetMissingProductsQuery>;
export type GetMissingProductsLazyQueryHookResult = ReturnType<typeof useGetMissingProductsLazyQuery>;
export type GetMissingProductsQueryResult = Apollo.QueryResult<GetMissingProductsQuery, GetMissingProductsQueryVariables>;
export function refetchGetMissingProductsQuery(variables?: GetMissingProductsQueryVariables) {
      return { query: GetMissingProductsDocument, variables: variables }
    }
export const GetMachineStartUpDocument = gql`
    query getMachineStartUp($id: UUID) {
  machineStartUp(id: $id) {
    ...MachineStartUp
  }
}
    ${MachineStartUpFragmentDoc}`;

/**
 * __useGetMachineStartUpQuery__
 *
 * To run a query within a React component, call `useGetMachineStartUpQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMachineStartUpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMachineStartUpQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMachineStartUpQuery(baseOptions?: Apollo.QueryHookOptions<GetMachineStartUpQuery, GetMachineStartUpQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMachineStartUpQuery, GetMachineStartUpQueryVariables>(GetMachineStartUpDocument, options);
      }
export function useGetMachineStartUpLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMachineStartUpQuery, GetMachineStartUpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMachineStartUpQuery, GetMachineStartUpQueryVariables>(GetMachineStartUpDocument, options);
        }
export type GetMachineStartUpQueryHookResult = ReturnType<typeof useGetMachineStartUpQuery>;
export type GetMachineStartUpLazyQueryHookResult = ReturnType<typeof useGetMachineStartUpLazyQuery>;
export type GetMachineStartUpQueryResult = Apollo.QueryResult<GetMachineStartUpQuery, GetMachineStartUpQueryVariables>;
export function refetchGetMachineStartUpQuery(variables?: GetMachineStartUpQueryVariables) {
      return { query: GetMachineStartUpDocument, variables: variables }
    }
export const GetProductCategoriesEnabledForMachineStartUpDocument = gql`
    query getProductCategoriesEnabledForMachineStartUp {
  productCategoriesEnabledForMachineStartUp {
    ...ProductCategory
  }
}
    ${ProductCategoryFragmentDoc}`;

/**
 * __useGetProductCategoriesEnabledForMachineStartUpQuery__
 *
 * To run a query within a React component, call `useGetProductCategoriesEnabledForMachineStartUpQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductCategoriesEnabledForMachineStartUpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductCategoriesEnabledForMachineStartUpQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProductCategoriesEnabledForMachineStartUpQuery(baseOptions?: Apollo.QueryHookOptions<GetProductCategoriesEnabledForMachineStartUpQuery, GetProductCategoriesEnabledForMachineStartUpQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductCategoriesEnabledForMachineStartUpQuery, GetProductCategoriesEnabledForMachineStartUpQueryVariables>(GetProductCategoriesEnabledForMachineStartUpDocument, options);
      }
export function useGetProductCategoriesEnabledForMachineStartUpLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductCategoriesEnabledForMachineStartUpQuery, GetProductCategoriesEnabledForMachineStartUpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductCategoriesEnabledForMachineStartUpQuery, GetProductCategoriesEnabledForMachineStartUpQueryVariables>(GetProductCategoriesEnabledForMachineStartUpDocument, options);
        }
export type GetProductCategoriesEnabledForMachineStartUpQueryHookResult = ReturnType<typeof useGetProductCategoriesEnabledForMachineStartUpQuery>;
export type GetProductCategoriesEnabledForMachineStartUpLazyQueryHookResult = ReturnType<typeof useGetProductCategoriesEnabledForMachineStartUpLazyQuery>;
export type GetProductCategoriesEnabledForMachineStartUpQueryResult = Apollo.QueryResult<GetProductCategoriesEnabledForMachineStartUpQuery, GetProductCategoriesEnabledForMachineStartUpQueryVariables>;
export function refetchGetProductCategoriesEnabledForMachineStartUpQuery(variables?: GetProductCategoriesEnabledForMachineStartUpQueryVariables) {
      return { query: GetProductCategoriesEnabledForMachineStartUpDocument, variables: variables }
    }
export const GetPemRulesDocument = gql`
    query getPemRules {
  pemRules {
    ...PemRule
  }
}
    ${PemRuleFragmentDoc}`;

/**
 * __useGetPemRulesQuery__
 *
 * To run a query within a React component, call `useGetPemRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPemRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPemRulesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPemRulesQuery(baseOptions?: Apollo.QueryHookOptions<GetPemRulesQuery, GetPemRulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPemRulesQuery, GetPemRulesQueryVariables>(GetPemRulesDocument, options);
      }
export function useGetPemRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPemRulesQuery, GetPemRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPemRulesQuery, GetPemRulesQueryVariables>(GetPemRulesDocument, options);
        }
export type GetPemRulesQueryHookResult = ReturnType<typeof useGetPemRulesQuery>;
export type GetPemRulesLazyQueryHookResult = ReturnType<typeof useGetPemRulesLazyQuery>;
export type GetPemRulesQueryResult = Apollo.QueryResult<GetPemRulesQuery, GetPemRulesQueryVariables>;
export function refetchGetPemRulesQuery(variables?: GetPemRulesQueryVariables) {
      return { query: GetPemRulesDocument, variables: variables }
    }
export const GetPemRuleDocument = gql`
    query getPemRule($id: UUID!) {
  pemRule(id: $id) {
    ...PemRule
  }
}
    ${PemRuleFragmentDoc}`;

/**
 * __useGetPemRuleQuery__
 *
 * To run a query within a React component, call `useGetPemRuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPemRuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPemRuleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPemRuleQuery(baseOptions: Apollo.QueryHookOptions<GetPemRuleQuery, GetPemRuleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPemRuleQuery, GetPemRuleQueryVariables>(GetPemRuleDocument, options);
      }
export function useGetPemRuleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPemRuleQuery, GetPemRuleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPemRuleQuery, GetPemRuleQueryVariables>(GetPemRuleDocument, options);
        }
export type GetPemRuleQueryHookResult = ReturnType<typeof useGetPemRuleQuery>;
export type GetPemRuleLazyQueryHookResult = ReturnType<typeof useGetPemRuleLazyQuery>;
export type GetPemRuleQueryResult = Apollo.QueryResult<GetPemRuleQuery, GetPemRuleQueryVariables>;
export function refetchGetPemRuleQuery(variables: GetPemRuleQueryVariables) {
      return { query: GetPemRuleDocument, variables: variables }
    }
export const GetPemRuleAdditionalsDocument = gql`
    query getPemRuleAdditionals {
  pemRuleAdditionals {
    ...PemRuleAdditional
  }
}
    ${PemRuleAdditionalFragmentDoc}`;

/**
 * __useGetPemRuleAdditionalsQuery__
 *
 * To run a query within a React component, call `useGetPemRuleAdditionalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPemRuleAdditionalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPemRuleAdditionalsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPemRuleAdditionalsQuery(baseOptions?: Apollo.QueryHookOptions<GetPemRuleAdditionalsQuery, GetPemRuleAdditionalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPemRuleAdditionalsQuery, GetPemRuleAdditionalsQueryVariables>(GetPemRuleAdditionalsDocument, options);
      }
export function useGetPemRuleAdditionalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPemRuleAdditionalsQuery, GetPemRuleAdditionalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPemRuleAdditionalsQuery, GetPemRuleAdditionalsQueryVariables>(GetPemRuleAdditionalsDocument, options);
        }
export type GetPemRuleAdditionalsQueryHookResult = ReturnType<typeof useGetPemRuleAdditionalsQuery>;
export type GetPemRuleAdditionalsLazyQueryHookResult = ReturnType<typeof useGetPemRuleAdditionalsLazyQuery>;
export type GetPemRuleAdditionalsQueryResult = Apollo.QueryResult<GetPemRuleAdditionalsQuery, GetPemRuleAdditionalsQueryVariables>;
export function refetchGetPemRuleAdditionalsQuery(variables?: GetPemRuleAdditionalsQueryVariables) {
      return { query: GetPemRuleAdditionalsDocument, variables: variables }
    }
export const GetPemRuleAdditionalsByIdDocument = gql`
    query getPemRuleAdditionalsById($id: UUID!) {
  pemRuleAdditionalsById(id: $id) {
    ...PemRuleAdditional
  }
}
    ${PemRuleAdditionalFragmentDoc}`;

/**
 * __useGetPemRuleAdditionalsByIdQuery__
 *
 * To run a query within a React component, call `useGetPemRuleAdditionalsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPemRuleAdditionalsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPemRuleAdditionalsByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPemRuleAdditionalsByIdQuery(baseOptions: Apollo.QueryHookOptions<GetPemRuleAdditionalsByIdQuery, GetPemRuleAdditionalsByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPemRuleAdditionalsByIdQuery, GetPemRuleAdditionalsByIdQueryVariables>(GetPemRuleAdditionalsByIdDocument, options);
      }
export function useGetPemRuleAdditionalsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPemRuleAdditionalsByIdQuery, GetPemRuleAdditionalsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPemRuleAdditionalsByIdQuery, GetPemRuleAdditionalsByIdQueryVariables>(GetPemRuleAdditionalsByIdDocument, options);
        }
export type GetPemRuleAdditionalsByIdQueryHookResult = ReturnType<typeof useGetPemRuleAdditionalsByIdQuery>;
export type GetPemRuleAdditionalsByIdLazyQueryHookResult = ReturnType<typeof useGetPemRuleAdditionalsByIdLazyQuery>;
export type GetPemRuleAdditionalsByIdQueryResult = Apollo.QueryResult<GetPemRuleAdditionalsByIdQuery, GetPemRuleAdditionalsByIdQueryVariables>;
export function refetchGetPemRuleAdditionalsByIdQuery(variables: GetPemRuleAdditionalsByIdQueryVariables) {
      return { query: GetPemRuleAdditionalsByIdDocument, variables: variables }
    }
export const PemCreateDocument = gql`
    mutation pemCreate($input: CreateMachineStartUpMutationInput!) {
  pemCreate(input: $input) {
    machineStartUp {
      ...MachineStartUp
      productCategories {
        ...MachineStartUpProductCategory
      }
    }
    errors {
      ...Error
    }
  }
}
    ${MachineStartUpFragmentDoc}
${MachineStartUpProductCategoryFragmentDoc}
${ErrorFragmentDoc}`;
export type PemCreateMutationFn = Apollo.MutationFunction<PemCreateMutation, PemCreateMutationVariables>;

/**
 * __usePemCreateMutation__
 *
 * To run a mutation, you first call `usePemCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePemCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pemCreateMutation, { data, loading, error }] = usePemCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePemCreateMutation(baseOptions?: Apollo.MutationHookOptions<PemCreateMutation, PemCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PemCreateMutation, PemCreateMutationVariables>(PemCreateDocument, options);
      }
export type PemCreateMutationHookResult = ReturnType<typeof usePemCreateMutation>;
export type PemCreateMutationResult = Apollo.MutationResult<PemCreateMutation>;
export type PemCreateMutationOptions = Apollo.BaseMutationOptions<PemCreateMutation, PemCreateMutationVariables>;
export const PemAdministrativeRevisionDocument = gql`
    mutation pemAdministrativeRevision($input: PemAdministrativeRevisionMutationInput!) {
  pemAdministrativeRevision(input: $input) {
    errors {
      ...Error
    }
    machineStartUp {
      ...MachineStartUp
    }
  }
}
    ${ErrorFragmentDoc}
${MachineStartUpFragmentDoc}`;
export type PemAdministrativeRevisionMutationFn = Apollo.MutationFunction<PemAdministrativeRevisionMutation, PemAdministrativeRevisionMutationVariables>;

/**
 * __usePemAdministrativeRevisionMutation__
 *
 * To run a mutation, you first call `usePemAdministrativeRevisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePemAdministrativeRevisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pemAdministrativeRevisionMutation, { data, loading, error }] = usePemAdministrativeRevisionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePemAdministrativeRevisionMutation(baseOptions?: Apollo.MutationHookOptions<PemAdministrativeRevisionMutation, PemAdministrativeRevisionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PemAdministrativeRevisionMutation, PemAdministrativeRevisionMutationVariables>(PemAdministrativeRevisionDocument, options);
      }
export type PemAdministrativeRevisionMutationHookResult = ReturnType<typeof usePemAdministrativeRevisionMutation>;
export type PemAdministrativeRevisionMutationResult = Apollo.MutationResult<PemAdministrativeRevisionMutation>;
export type PemAdministrativeRevisionMutationOptions = Apollo.BaseMutationOptions<PemAdministrativeRevisionMutation, PemAdministrativeRevisionMutationVariables>;
export const PemAdministrativeRevisionUpdateDocument = gql`
    mutation pemAdministrativeRevisionUpdate($input: PemAdministrativeRevisionUpdateMutationInput!) {
  pemAdministrativeRevisionUpdate(input: $input) {
    errors {
      ...Error
    }
    machineStartUp {
      ...MachineStartUp
    }
  }
}
    ${ErrorFragmentDoc}
${MachineStartUpFragmentDoc}`;
export type PemAdministrativeRevisionUpdateMutationFn = Apollo.MutationFunction<PemAdministrativeRevisionUpdateMutation, PemAdministrativeRevisionUpdateMutationVariables>;

/**
 * __usePemAdministrativeRevisionUpdateMutation__
 *
 * To run a mutation, you first call `usePemAdministrativeRevisionUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePemAdministrativeRevisionUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pemAdministrativeRevisionUpdateMutation, { data, loading, error }] = usePemAdministrativeRevisionUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePemAdministrativeRevisionUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PemAdministrativeRevisionUpdateMutation, PemAdministrativeRevisionUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PemAdministrativeRevisionUpdateMutation, PemAdministrativeRevisionUpdateMutationVariables>(PemAdministrativeRevisionUpdateDocument, options);
      }
export type PemAdministrativeRevisionUpdateMutationHookResult = ReturnType<typeof usePemAdministrativeRevisionUpdateMutation>;
export type PemAdministrativeRevisionUpdateMutationResult = Apollo.MutationResult<PemAdministrativeRevisionUpdateMutation>;
export type PemAdministrativeRevisionUpdateMutationOptions = Apollo.BaseMutationOptions<PemAdministrativeRevisionUpdateMutation, PemAdministrativeRevisionUpdateMutationVariables>;
export const PemFactoryReviewDocument = gql`
    mutation pemFactoryReview($input: PemFactoryReviewMutationInput!) {
  pemFactoryReview(input: $input) {
    errors {
      ...Error
    }
    machineStartUp {
      ...MachineStartUp
    }
  }
}
    ${ErrorFragmentDoc}
${MachineStartUpFragmentDoc}`;
export type PemFactoryReviewMutationFn = Apollo.MutationFunction<PemFactoryReviewMutation, PemFactoryReviewMutationVariables>;

/**
 * __usePemFactoryReviewMutation__
 *
 * To run a mutation, you first call `usePemFactoryReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePemFactoryReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pemFactoryReviewMutation, { data, loading, error }] = usePemFactoryReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePemFactoryReviewMutation(baseOptions?: Apollo.MutationHookOptions<PemFactoryReviewMutation, PemFactoryReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PemFactoryReviewMutation, PemFactoryReviewMutationVariables>(PemFactoryReviewDocument, options);
      }
export type PemFactoryReviewMutationHookResult = ReturnType<typeof usePemFactoryReviewMutation>;
export type PemFactoryReviewMutationResult = Apollo.MutationResult<PemFactoryReviewMutation>;
export type PemFactoryReviewMutationOptions = Apollo.BaseMutationOptions<PemFactoryReviewMutation, PemFactoryReviewMutationVariables>;
export const PemFieldReviewDocument = gql`
    mutation pemFieldReview($input: PemFieldReviewMutationInput!) {
  pemFieldReview(input: $input) {
    errors {
      ...Error
    }
    machineStartUp {
      ...MachineStartUp
    }
  }
}
    ${ErrorFragmentDoc}
${MachineStartUpFragmentDoc}`;
export type PemFieldReviewMutationFn = Apollo.MutationFunction<PemFieldReviewMutation, PemFieldReviewMutationVariables>;

/**
 * __usePemFieldReviewMutation__
 *
 * To run a mutation, you first call `usePemFieldReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePemFieldReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pemFieldReviewMutation, { data, loading, error }] = usePemFieldReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePemFieldReviewMutation(baseOptions?: Apollo.MutationHookOptions<PemFieldReviewMutation, PemFieldReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PemFieldReviewMutation, PemFieldReviewMutationVariables>(PemFieldReviewDocument, options);
      }
export type PemFieldReviewMutationHookResult = ReturnType<typeof usePemFieldReviewMutation>;
export type PemFieldReviewMutationResult = Apollo.MutationResult<PemFieldReviewMutation>;
export type PemFieldReviewMutationOptions = Apollo.BaseMutationOptions<PemFieldReviewMutation, PemFieldReviewMutationVariables>;
export const PemInspectionRevisionDocument = gql`
    mutation pemInspectionRevision($input: PemInspectionRevisionMutationInput!) {
  pemInspectionRevision(input: $input) {
    errors {
      ...Error
    }
    machineStartUp {
      ...MachineStartUp
    }
  }
}
    ${ErrorFragmentDoc}
${MachineStartUpFragmentDoc}`;
export type PemInspectionRevisionMutationFn = Apollo.MutationFunction<PemInspectionRevisionMutation, PemInspectionRevisionMutationVariables>;

/**
 * __usePemInspectionRevisionMutation__
 *
 * To run a mutation, you first call `usePemInspectionRevisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePemInspectionRevisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pemInspectionRevisionMutation, { data, loading, error }] = usePemInspectionRevisionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePemInspectionRevisionMutation(baseOptions?: Apollo.MutationHookOptions<PemInspectionRevisionMutation, PemInspectionRevisionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PemInspectionRevisionMutation, PemInspectionRevisionMutationVariables>(PemInspectionRevisionDocument, options);
      }
export type PemInspectionRevisionMutationHookResult = ReturnType<typeof usePemInspectionRevisionMutation>;
export type PemInspectionRevisionMutationResult = Apollo.MutationResult<PemInspectionRevisionMutation>;
export type PemInspectionRevisionMutationOptions = Apollo.BaseMutationOptions<PemInspectionRevisionMutation, PemInspectionRevisionMutationVariables>;
export const PemWorkflowDocument = gql`
    mutation pemWorkflow($input: PemWorkflowMutationInput!) {
  pemWorkflow(input: $input) {
    errors {
      ...Error
    }
    machineStartUp {
      ...MachineStartUp
    }
  }
}
    ${ErrorFragmentDoc}
${MachineStartUpFragmentDoc}`;
export type PemWorkflowMutationFn = Apollo.MutationFunction<PemWorkflowMutation, PemWorkflowMutationVariables>;

/**
 * __usePemWorkflowMutation__
 *
 * To run a mutation, you first call `usePemWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePemWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pemWorkflowMutation, { data, loading, error }] = usePemWorkflowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePemWorkflowMutation(baseOptions?: Apollo.MutationHookOptions<PemWorkflowMutation, PemWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PemWorkflowMutation, PemWorkflowMutationVariables>(PemWorkflowDocument, options);
      }
export type PemWorkflowMutationHookResult = ReturnType<typeof usePemWorkflowMutation>;
export type PemWorkflowMutationResult = Apollo.MutationResult<PemWorkflowMutation>;
export type PemWorkflowMutationOptions = Apollo.BaseMutationOptions<PemWorkflowMutation, PemWorkflowMutationVariables>;
export const PemFactoryImagesDocument = gql`
    mutation pemFactoryImages($input: PemFactoryImagesMutationInput!) {
  pemFactoryImages(input: $input) {
    errors {
      ...Error
    }
    machineStartUp {
      ...MachineStartUp
    }
  }
}
    ${ErrorFragmentDoc}
${MachineStartUpFragmentDoc}`;
export type PemFactoryImagesMutationFn = Apollo.MutationFunction<PemFactoryImagesMutation, PemFactoryImagesMutationVariables>;

/**
 * __usePemFactoryImagesMutation__
 *
 * To run a mutation, you first call `usePemFactoryImagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePemFactoryImagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pemFactoryImagesMutation, { data, loading, error }] = usePemFactoryImagesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePemFactoryImagesMutation(baseOptions?: Apollo.MutationHookOptions<PemFactoryImagesMutation, PemFactoryImagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PemFactoryImagesMutation, PemFactoryImagesMutationVariables>(PemFactoryImagesDocument, options);
      }
export type PemFactoryImagesMutationHookResult = ReturnType<typeof usePemFactoryImagesMutation>;
export type PemFactoryImagesMutationResult = Apollo.MutationResult<PemFactoryImagesMutation>;
export type PemFactoryImagesMutationOptions = Apollo.BaseMutationOptions<PemFactoryImagesMutation, PemFactoryImagesMutationVariables>;
export const PemFieldImagesDocument = gql`
    mutation pemFieldImages($input: PemFieldImagesMutationInput!) {
  pemFieldImages(input: $input) {
    errors {
      ...Error
    }
    machineStartUp {
      ...MachineStartUp
    }
  }
}
    ${ErrorFragmentDoc}
${MachineStartUpFragmentDoc}`;
export type PemFieldImagesMutationFn = Apollo.MutationFunction<PemFieldImagesMutation, PemFieldImagesMutationVariables>;

/**
 * __usePemFieldImagesMutation__
 *
 * To run a mutation, you first call `usePemFieldImagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePemFieldImagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pemFieldImagesMutation, { data, loading, error }] = usePemFieldImagesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePemFieldImagesMutation(baseOptions?: Apollo.MutationHookOptions<PemFieldImagesMutation, PemFieldImagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PemFieldImagesMutation, PemFieldImagesMutationVariables>(PemFieldImagesDocument, options);
      }
export type PemFieldImagesMutationHookResult = ReturnType<typeof usePemFieldImagesMutation>;
export type PemFieldImagesMutationResult = Apollo.MutationResult<PemFieldImagesMutation>;
export type PemFieldImagesMutationOptions = Apollo.BaseMutationOptions<PemFieldImagesMutation, PemFieldImagesMutationVariables>;
export const MaterialMasterProductsDocument = gql`
    query materialMasterProducts($options: ProductListOptionsInputType) {
  materialMasterProducts(options: $options) {
    items {
      ...MaterialMasterProduct
    }
    count
  }
}
    ${MaterialMasterProductFragmentDoc}`;

/**
 * __useMaterialMasterProductsQuery__
 *
 * To run a query within a React component, call `useMaterialMasterProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaterialMasterProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaterialMasterProductsQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useMaterialMasterProductsQuery(baseOptions?: Apollo.QueryHookOptions<MaterialMasterProductsQuery, MaterialMasterProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MaterialMasterProductsQuery, MaterialMasterProductsQueryVariables>(MaterialMasterProductsDocument, options);
      }
export function useMaterialMasterProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MaterialMasterProductsQuery, MaterialMasterProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MaterialMasterProductsQuery, MaterialMasterProductsQueryVariables>(MaterialMasterProductsDocument, options);
        }
export type MaterialMasterProductsQueryHookResult = ReturnType<typeof useMaterialMasterProductsQuery>;
export type MaterialMasterProductsLazyQueryHookResult = ReturnType<typeof useMaterialMasterProductsLazyQuery>;
export type MaterialMasterProductsQueryResult = Apollo.QueryResult<MaterialMasterProductsQuery, MaterialMasterProductsQueryVariables>;
export function refetchMaterialMasterProductsQuery(variables?: MaterialMasterProductsQueryVariables) {
      return { query: MaterialMasterProductsDocument, variables: variables }
    }
export const ProductYearlyFactorDocument = gql`
    mutation productYearlyFactor($input: ProductYearlyFactorMutationInput!) {
  productYearlyFactor(input: $input) {
    productYearlyFactor {
      ...ProductYearlyFactor
    }
    errors {
      ...Error
    }
  }
}
    ${ProductYearlyFactorFragmentDoc}
${ErrorFragmentDoc}`;
export type ProductYearlyFactorMutationFn = Apollo.MutationFunction<ProductYearlyFactorMutation, ProductYearlyFactorMutationVariables>;

/**
 * __useProductYearlyFactorMutation__
 *
 * To run a mutation, you first call `useProductYearlyFactorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductYearlyFactorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productYearlyFactorMutation, { data, loading, error }] = useProductYearlyFactorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProductYearlyFactorMutation(baseOptions?: Apollo.MutationHookOptions<ProductYearlyFactorMutation, ProductYearlyFactorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProductYearlyFactorMutation, ProductYearlyFactorMutationVariables>(ProductYearlyFactorDocument, options);
      }
export type ProductYearlyFactorMutationHookResult = ReturnType<typeof useProductYearlyFactorMutation>;
export type ProductYearlyFactorMutationResult = Apollo.MutationResult<ProductYearlyFactorMutation>;
export type ProductYearlyFactorMutationOptions = Apollo.BaseMutationOptions<ProductYearlyFactorMutation, ProductYearlyFactorMutationVariables>;
export const ProductCategoriesWithYearlyForecastDocument = gql`
    query productCategoriesWithYearlyForecast {
  productCategories {
    id
    name
    yearlyForecast {
      ...CategoryYearlyForecast
    }
  }
}
    ${CategoryYearlyForecastFragmentDoc}`;

/**
 * __useProductCategoriesWithYearlyForecastQuery__
 *
 * To run a query within a React component, call `useProductCategoriesWithYearlyForecastQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductCategoriesWithYearlyForecastQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductCategoriesWithYearlyForecastQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductCategoriesWithYearlyForecastQuery(baseOptions?: Apollo.QueryHookOptions<ProductCategoriesWithYearlyForecastQuery, ProductCategoriesWithYearlyForecastQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductCategoriesWithYearlyForecastQuery, ProductCategoriesWithYearlyForecastQueryVariables>(ProductCategoriesWithYearlyForecastDocument, options);
      }
export function useProductCategoriesWithYearlyForecastLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductCategoriesWithYearlyForecastQuery, ProductCategoriesWithYearlyForecastQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductCategoriesWithYearlyForecastQuery, ProductCategoriesWithYearlyForecastQueryVariables>(ProductCategoriesWithYearlyForecastDocument, options);
        }
export type ProductCategoriesWithYearlyForecastQueryHookResult = ReturnType<typeof useProductCategoriesWithYearlyForecastQuery>;
export type ProductCategoriesWithYearlyForecastLazyQueryHookResult = ReturnType<typeof useProductCategoriesWithYearlyForecastLazyQuery>;
export type ProductCategoriesWithYearlyForecastQueryResult = Apollo.QueryResult<ProductCategoriesWithYearlyForecastQuery, ProductCategoriesWithYearlyForecastQueryVariables>;
export function refetchProductCategoriesWithYearlyForecastQuery(variables?: ProductCategoriesWithYearlyForecastQueryVariables) {
      return { query: ProductCategoriesWithYearlyForecastDocument, variables: variables }
    }
export const CategoriesYearlyForecastsDocument = gql`
    mutation categoriesYearlyForecasts($inputs: [ListCategoryYearlyForecastFormInput!]!) {
  categoriesYearlyForecasts(inputs: $inputs) {
    categoriesYearlyForecasts {
      ...CategoryYearlyForecast
    }
    errors {
      ...Error
    }
  }
}
    ${CategoryYearlyForecastFragmentDoc}
${ErrorFragmentDoc}`;
export type CategoriesYearlyForecastsMutationFn = Apollo.MutationFunction<CategoriesYearlyForecastsMutation, CategoriesYearlyForecastsMutationVariables>;

/**
 * __useCategoriesYearlyForecastsMutation__
 *
 * To run a mutation, you first call `useCategoriesYearlyForecastsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCategoriesYearlyForecastsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [categoriesYearlyForecastsMutation, { data, loading, error }] = useCategoriesYearlyForecastsMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCategoriesYearlyForecastsMutation(baseOptions?: Apollo.MutationHookOptions<CategoriesYearlyForecastsMutation, CategoriesYearlyForecastsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CategoriesYearlyForecastsMutation, CategoriesYearlyForecastsMutationVariables>(CategoriesYearlyForecastsDocument, options);
      }
export type CategoriesYearlyForecastsMutationHookResult = ReturnType<typeof useCategoriesYearlyForecastsMutation>;
export type CategoriesYearlyForecastsMutationResult = Apollo.MutationResult<CategoriesYearlyForecastsMutation>;
export type CategoriesYearlyForecastsMutationOptions = Apollo.BaseMutationOptions<CategoriesYearlyForecastsMutation, CategoriesYearlyForecastsMutationVariables>;
export const GetMaterialMasterProductDocument = gql`
    query getMaterialMasterProduct($id: UUID!) {
  product(id: $id) {
    ...MaterialMasterProductDetail
  }
}
    ${MaterialMasterProductDetailFragmentDoc}`;

/**
 * __useGetMaterialMasterProductQuery__
 *
 * To run a query within a React component, call `useGetMaterialMasterProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaterialMasterProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaterialMasterProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMaterialMasterProductQuery(baseOptions: Apollo.QueryHookOptions<GetMaterialMasterProductQuery, GetMaterialMasterProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMaterialMasterProductQuery, GetMaterialMasterProductQueryVariables>(GetMaterialMasterProductDocument, options);
      }
export function useGetMaterialMasterProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMaterialMasterProductQuery, GetMaterialMasterProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMaterialMasterProductQuery, GetMaterialMasterProductQueryVariables>(GetMaterialMasterProductDocument, options);
        }
export type GetMaterialMasterProductQueryHookResult = ReturnType<typeof useGetMaterialMasterProductQuery>;
export type GetMaterialMasterProductLazyQueryHookResult = ReturnType<typeof useGetMaterialMasterProductLazyQuery>;
export type GetMaterialMasterProductQueryResult = Apollo.QueryResult<GetMaterialMasterProductQuery, GetMaterialMasterProductQueryVariables>;
export function refetchGetMaterialMasterProductQuery(variables: GetMaterialMasterProductQueryVariables) {
      return { query: GetMaterialMasterProductDocument, variables: variables }
    }
export const UpdateProductDocument = gql`
    mutation updateProduct($input: UpdateProductMutationInput!) {
  updateProduct(input: $input) {
    product {
      id
    }
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type UpdateProductMutationFn = Apollo.MutationFunction<UpdateProductMutation, UpdateProductMutationVariables>;

/**
 * __useUpdateProductMutation__
 *
 * To run a mutation, you first call `useUpdateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductMutation, { data, loading, error }] = useUpdateProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductMutation, UpdateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductMutation, UpdateProductMutationVariables>(UpdateProductDocument, options);
      }
export type UpdateProductMutationHookResult = ReturnType<typeof useUpdateProductMutation>;
export type UpdateProductMutationResult = Apollo.MutationResult<UpdateProductMutation>;
export type UpdateProductMutationOptions = Apollo.BaseMutationOptions<UpdateProductMutation, UpdateProductMutationVariables>;
export const UpdateProductPublishedDocument = gql`
    mutation updateProductPublished($id: UUID!, $published: Boolean!) {
  updateProductPublishedMutation(id: $id, published: $published) {
    product {
      id
      published
    }
    errors
  }
}
    `;
export type UpdateProductPublishedMutationFn = Apollo.MutationFunction<UpdateProductPublishedMutation, UpdateProductPublishedMutationVariables>;

/**
 * __useUpdateProductPublishedMutation__
 *
 * To run a mutation, you first call `useUpdateProductPublishedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductPublishedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductPublishedMutation, { data, loading, error }] = useUpdateProductPublishedMutation({
 *   variables: {
 *      id: // value for 'id'
 *      published: // value for 'published'
 *   },
 * });
 */
export function useUpdateProductPublishedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductPublishedMutation, UpdateProductPublishedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductPublishedMutation, UpdateProductPublishedMutationVariables>(UpdateProductPublishedDocument, options);
      }
export type UpdateProductPublishedMutationHookResult = ReturnType<typeof useUpdateProductPublishedMutation>;
export type UpdateProductPublishedMutationResult = Apollo.MutationResult<UpdateProductPublishedMutation>;
export type UpdateProductPublishedMutationOptions = Apollo.BaseMutationOptions<UpdateProductPublishedMutation, UpdateProductPublishedMutationVariables>;
export const UpdateProductUntilStockRunsOutDocument = gql`
    mutation updateProductUntilStockRunsOut($id: UUID!, $untilStockRunsOut: Boolean!) {
  updateProductUntilStockRunsOutMutation(
    id: $id
    untilStockRunsOut: $untilStockRunsOut
  ) {
    product {
      id
    }
  }
}
    `;
export type UpdateProductUntilStockRunsOutMutationFn = Apollo.MutationFunction<UpdateProductUntilStockRunsOutMutation, UpdateProductUntilStockRunsOutMutationVariables>;

/**
 * __useUpdateProductUntilStockRunsOutMutation__
 *
 * To run a mutation, you first call `useUpdateProductUntilStockRunsOutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductUntilStockRunsOutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductUntilStockRunsOutMutation, { data, loading, error }] = useUpdateProductUntilStockRunsOutMutation({
 *   variables: {
 *      id: // value for 'id'
 *      untilStockRunsOut: // value for 'untilStockRunsOut'
 *   },
 * });
 */
export function useUpdateProductUntilStockRunsOutMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductUntilStockRunsOutMutation, UpdateProductUntilStockRunsOutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductUntilStockRunsOutMutation, UpdateProductUntilStockRunsOutMutationVariables>(UpdateProductUntilStockRunsOutDocument, options);
      }
export type UpdateProductUntilStockRunsOutMutationHookResult = ReturnType<typeof useUpdateProductUntilStockRunsOutMutation>;
export type UpdateProductUntilStockRunsOutMutationResult = Apollo.MutationResult<UpdateProductUntilStockRunsOutMutation>;
export type UpdateProductUntilStockRunsOutMutationOptions = Apollo.BaseMutationOptions<UpdateProductUntilStockRunsOutMutation, UpdateProductUntilStockRunsOutMutationVariables>;
export const GetOrganizationsGroupsDocument = gql`
    query getOrganizationsGroups($options: OrganizationGroupListOptionsInputType) {
  organizationsGroups(options: $options) {
    items {
      name
      id
    }
    count
  }
}
    `;

/**
 * __useGetOrganizationsGroupsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationsGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationsGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationsGroupsQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetOrganizationsGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationsGroupsQuery, GetOrganizationsGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationsGroupsQuery, GetOrganizationsGroupsQueryVariables>(GetOrganizationsGroupsDocument, options);
      }
export function useGetOrganizationsGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationsGroupsQuery, GetOrganizationsGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationsGroupsQuery, GetOrganizationsGroupsQueryVariables>(GetOrganizationsGroupsDocument, options);
        }
export type GetOrganizationsGroupsQueryHookResult = ReturnType<typeof useGetOrganizationsGroupsQuery>;
export type GetOrganizationsGroupsLazyQueryHookResult = ReturnType<typeof useGetOrganizationsGroupsLazyQuery>;
export type GetOrganizationsGroupsQueryResult = Apollo.QueryResult<GetOrganizationsGroupsQuery, GetOrganizationsGroupsQueryVariables>;
export function refetchGetOrganizationsGroupsQuery(variables?: GetOrganizationsGroupsQueryVariables) {
      return { query: GetOrganizationsGroupsDocument, variables: variables }
    }
export const GetRulesGroupsDocument = gql`
    query getRulesGroups {
  rulesGroups {
    id
    name
  }
}
    `;

/**
 * __useGetRulesGroupsQuery__
 *
 * To run a query within a React component, call `useGetRulesGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRulesGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRulesGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRulesGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GetRulesGroupsQuery, GetRulesGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRulesGroupsQuery, GetRulesGroupsQueryVariables>(GetRulesGroupsDocument, options);
      }
export function useGetRulesGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRulesGroupsQuery, GetRulesGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRulesGroupsQuery, GetRulesGroupsQueryVariables>(GetRulesGroupsDocument, options);
        }
export type GetRulesGroupsQueryHookResult = ReturnType<typeof useGetRulesGroupsQuery>;
export type GetRulesGroupsLazyQueryHookResult = ReturnType<typeof useGetRulesGroupsLazyQuery>;
export type GetRulesGroupsQueryResult = Apollo.QueryResult<GetRulesGroupsQuery, GetRulesGroupsQueryVariables>;
export function refetchGetRulesGroupsQuery(variables?: GetRulesGroupsQueryVariables) {
      return { query: GetRulesGroupsDocument, variables: variables }
    }
export const MaterialMasterExportDocument = gql`
    mutation materialMasterExport($options: ProductListOptionsInputType) {
  materialMasterExport(options: $options) {
    job {
      id
    }
  }
}
    `;
export type MaterialMasterExportMutationFn = Apollo.MutationFunction<MaterialMasterExportMutation, MaterialMasterExportMutationVariables>;

/**
 * __useMaterialMasterExportMutation__
 *
 * To run a mutation, you first call `useMaterialMasterExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMaterialMasterExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [materialMasterExportMutation, { data, loading, error }] = useMaterialMasterExportMutation({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useMaterialMasterExportMutation(baseOptions?: Apollo.MutationHookOptions<MaterialMasterExportMutation, MaterialMasterExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MaterialMasterExportMutation, MaterialMasterExportMutationVariables>(MaterialMasterExportDocument, options);
      }
export type MaterialMasterExportMutationHookResult = ReturnType<typeof useMaterialMasterExportMutation>;
export type MaterialMasterExportMutationResult = Apollo.MutationResult<MaterialMasterExportMutation>;
export type MaterialMasterExportMutationOptions = Apollo.BaseMutationOptions<MaterialMasterExportMutation, MaterialMasterExportMutationVariables>;
export const GetExternalIdsDocument = gql`
    query getExternalIds {
  externalIds
}
    `;

/**
 * __useGetExternalIdsQuery__
 *
 * To run a query within a React component, call `useGetExternalIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExternalIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExternalIdsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetExternalIdsQuery(baseOptions?: Apollo.QueryHookOptions<GetExternalIdsQuery, GetExternalIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExternalIdsQuery, GetExternalIdsQueryVariables>(GetExternalIdsDocument, options);
      }
export function useGetExternalIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExternalIdsQuery, GetExternalIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExternalIdsQuery, GetExternalIdsQueryVariables>(GetExternalIdsDocument, options);
        }
export type GetExternalIdsQueryHookResult = ReturnType<typeof useGetExternalIdsQuery>;
export type GetExternalIdsLazyQueryHookResult = ReturnType<typeof useGetExternalIdsLazyQuery>;
export type GetExternalIdsQueryResult = Apollo.QueryResult<GetExternalIdsQuery, GetExternalIdsQueryVariables>;
export function refetchGetExternalIdsQuery(variables?: GetExternalIdsQueryVariables) {
      return { query: GetExternalIdsDocument, variables: variables }
    }
export const GetProductCommentsDocument = gql`
    query getProductComments($options: ProductCommentListOptionsInputType) {
  productComments(options: $options) {
    items {
      ...ProductComment
    }
    count
  }
}
    ${ProductCommentFragmentDoc}`;

/**
 * __useGetProductCommentsQuery__
 *
 * To run a query within a React component, call `useGetProductCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductCommentsQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetProductCommentsQuery(baseOptions?: Apollo.QueryHookOptions<GetProductCommentsQuery, GetProductCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductCommentsQuery, GetProductCommentsQueryVariables>(GetProductCommentsDocument, options);
      }
export function useGetProductCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductCommentsQuery, GetProductCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductCommentsQuery, GetProductCommentsQueryVariables>(GetProductCommentsDocument, options);
        }
export type GetProductCommentsQueryHookResult = ReturnType<typeof useGetProductCommentsQuery>;
export type GetProductCommentsLazyQueryHookResult = ReturnType<typeof useGetProductCommentsLazyQuery>;
export type GetProductCommentsQueryResult = Apollo.QueryResult<GetProductCommentsQuery, GetProductCommentsQueryVariables>;
export function refetchGetProductCommentsQuery(variables?: GetProductCommentsQueryVariables) {
      return { query: GetProductCommentsDocument, variables: variables }
    }
export const GetProductCommentsCountDocument = gql`
    query getProductCommentsCount($options: ProductCommentListOptionsInputType) {
  productComments(options: $options) {
    count
  }
}
    `;

/**
 * __useGetProductCommentsCountQuery__
 *
 * To run a query within a React component, call `useGetProductCommentsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductCommentsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductCommentsCountQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetProductCommentsCountQuery(baseOptions?: Apollo.QueryHookOptions<GetProductCommentsCountQuery, GetProductCommentsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductCommentsCountQuery, GetProductCommentsCountQueryVariables>(GetProductCommentsCountDocument, options);
      }
export function useGetProductCommentsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductCommentsCountQuery, GetProductCommentsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductCommentsCountQuery, GetProductCommentsCountQueryVariables>(GetProductCommentsCountDocument, options);
        }
export type GetProductCommentsCountQueryHookResult = ReturnType<typeof useGetProductCommentsCountQuery>;
export type GetProductCommentsCountLazyQueryHookResult = ReturnType<typeof useGetProductCommentsCountLazyQuery>;
export type GetProductCommentsCountQueryResult = Apollo.QueryResult<GetProductCommentsCountQuery, GetProductCommentsCountQueryVariables>;
export function refetchGetProductCommentsCountQuery(variables?: GetProductCommentsCountQueryVariables) {
      return { query: GetProductCommentsCountDocument, variables: variables }
    }
export const CreateProductcommentDocument = gql`
    mutation createProductcomment($input: ProductCommentMutationInput!) {
  createProductComment(input: $input) {
    productComment {
      ...ProductComment
    }
    errors {
      ...Error
    }
  }
}
    ${ProductCommentFragmentDoc}
${ErrorFragmentDoc}`;
export type CreateProductcommentMutationFn = Apollo.MutationFunction<CreateProductcommentMutation, CreateProductcommentMutationVariables>;

/**
 * __useCreateProductcommentMutation__
 *
 * To run a mutation, you first call `useCreateProductcommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductcommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductcommentMutation, { data, loading, error }] = useCreateProductcommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductcommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductcommentMutation, CreateProductcommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductcommentMutation, CreateProductcommentMutationVariables>(CreateProductcommentDocument, options);
      }
export type CreateProductcommentMutationHookResult = ReturnType<typeof useCreateProductcommentMutation>;
export type CreateProductcommentMutationResult = Apollo.MutationResult<CreateProductcommentMutation>;
export type CreateProductcommentMutationOptions = Apollo.BaseMutationOptions<CreateProductcommentMutation, CreateProductcommentMutationVariables>;
export const ImportProductFactorsDocument = gql`
    mutation importProductFactors($inputs: [ImportProductFactorsMutationInput!]!) {
  importProductFactors(inputs: $inputs) {
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type ImportProductFactorsMutationFn = Apollo.MutationFunction<ImportProductFactorsMutation, ImportProductFactorsMutationVariables>;

/**
 * __useImportProductFactorsMutation__
 *
 * To run a mutation, you first call `useImportProductFactorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportProductFactorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importProductFactorsMutation, { data, loading, error }] = useImportProductFactorsMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useImportProductFactorsMutation(baseOptions?: Apollo.MutationHookOptions<ImportProductFactorsMutation, ImportProductFactorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportProductFactorsMutation, ImportProductFactorsMutationVariables>(ImportProductFactorsDocument, options);
      }
export type ImportProductFactorsMutationHookResult = ReturnType<typeof useImportProductFactorsMutation>;
export type ImportProductFactorsMutationResult = Apollo.MutationResult<ImportProductFactorsMutation>;
export type ImportProductFactorsMutationOptions = Apollo.BaseMutationOptions<ImportProductFactorsMutation, ImportProductFactorsMutationVariables>;
export const GetEcnsNumbersDocument = gql`
    query getEcnsNumbers {
  ecns(options: {}) {
    items {
      ecnNumber
    }
  }
}
    `;

/**
 * __useGetEcnsNumbersQuery__
 *
 * To run a query within a React component, call `useGetEcnsNumbersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEcnsNumbersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEcnsNumbersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEcnsNumbersQuery(baseOptions?: Apollo.QueryHookOptions<GetEcnsNumbersQuery, GetEcnsNumbersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEcnsNumbersQuery, GetEcnsNumbersQueryVariables>(GetEcnsNumbersDocument, options);
      }
export function useGetEcnsNumbersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEcnsNumbersQuery, GetEcnsNumbersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEcnsNumbersQuery, GetEcnsNumbersQueryVariables>(GetEcnsNumbersDocument, options);
        }
export type GetEcnsNumbersQueryHookResult = ReturnType<typeof useGetEcnsNumbersQuery>;
export type GetEcnsNumbersLazyQueryHookResult = ReturnType<typeof useGetEcnsNumbersLazyQuery>;
export type GetEcnsNumbersQueryResult = Apollo.QueryResult<GetEcnsNumbersQuery, GetEcnsNumbersQueryVariables>;
export function refetchGetEcnsNumbersQuery(variables?: GetEcnsNumbersQueryVariables) {
      return { query: GetEcnsNumbersDocument, variables: variables }
    }
export const GetEcnDocument = gql`
    query getEcn($id: UUID!) {
  ecn(id: $id) {
    ...Ecn
  }
}
    ${EcnFragmentDoc}`;

/**
 * __useGetEcnQuery__
 *
 * To run a query within a React component, call `useGetEcnQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEcnQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEcnQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEcnQuery(baseOptions: Apollo.QueryHookOptions<GetEcnQuery, GetEcnQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEcnQuery, GetEcnQueryVariables>(GetEcnDocument, options);
      }
export function useGetEcnLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEcnQuery, GetEcnQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEcnQuery, GetEcnQueryVariables>(GetEcnDocument, options);
        }
export type GetEcnQueryHookResult = ReturnType<typeof useGetEcnQuery>;
export type GetEcnLazyQueryHookResult = ReturnType<typeof useGetEcnLazyQuery>;
export type GetEcnQueryResult = Apollo.QueryResult<GetEcnQuery, GetEcnQueryVariables>;
export function refetchGetEcnQuery(variables: GetEcnQueryVariables) {
      return { query: GetEcnDocument, variables: variables }
    }
export const GetDefaultTaskDocument = gql`
    query getDefaultTask($id: UUID) {
  defaultTask(id: $id) {
    ...DefaultEcnTask
  }
}
    ${DefaultEcnTaskFragmentDoc}`;

/**
 * __useGetDefaultTaskQuery__
 *
 * To run a query within a React component, call `useGetDefaultTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDefaultTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDefaultTaskQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDefaultTaskQuery(baseOptions?: Apollo.QueryHookOptions<GetDefaultTaskQuery, GetDefaultTaskQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDefaultTaskQuery, GetDefaultTaskQueryVariables>(GetDefaultTaskDocument, options);
      }
export function useGetDefaultTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDefaultTaskQuery, GetDefaultTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDefaultTaskQuery, GetDefaultTaskQueryVariables>(GetDefaultTaskDocument, options);
        }
export type GetDefaultTaskQueryHookResult = ReturnType<typeof useGetDefaultTaskQuery>;
export type GetDefaultTaskLazyQueryHookResult = ReturnType<typeof useGetDefaultTaskLazyQuery>;
export type GetDefaultTaskQueryResult = Apollo.QueryResult<GetDefaultTaskQuery, GetDefaultTaskQueryVariables>;
export function refetchGetDefaultTaskQuery(variables?: GetDefaultTaskQueryVariables) {
      return { query: GetDefaultTaskDocument, variables: variables }
    }
export const GetDefaultTasksDocument = gql`
    query getDefaultTasks {
  defaultTasks {
    ...DefaultEcnTask
  }
}
    ${DefaultEcnTaskFragmentDoc}`;

/**
 * __useGetDefaultTasksQuery__
 *
 * To run a query within a React component, call `useGetDefaultTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDefaultTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDefaultTasksQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDefaultTasksQuery(baseOptions?: Apollo.QueryHookOptions<GetDefaultTasksQuery, GetDefaultTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDefaultTasksQuery, GetDefaultTasksQueryVariables>(GetDefaultTasksDocument, options);
      }
export function useGetDefaultTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDefaultTasksQuery, GetDefaultTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDefaultTasksQuery, GetDefaultTasksQueryVariables>(GetDefaultTasksDocument, options);
        }
export type GetDefaultTasksQueryHookResult = ReturnType<typeof useGetDefaultTasksQuery>;
export type GetDefaultTasksLazyQueryHookResult = ReturnType<typeof useGetDefaultTasksLazyQuery>;
export type GetDefaultTasksQueryResult = Apollo.QueryResult<GetDefaultTasksQuery, GetDefaultTasksQueryVariables>;
export function refetchGetDefaultTasksQuery(variables?: GetDefaultTasksQueryVariables) {
      return { query: GetDefaultTasksDocument, variables: variables }
    }
export const GetRolesDocument = gql`
    query getRoles {
  roles {
    id
    name
    userSet {
      id
      displayName
    }
  }
}
    `;

/**
 * __useGetRolesQuery__
 *
 * To run a query within a React component, call `useGetRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRolesQuery(baseOptions?: Apollo.QueryHookOptions<GetRolesQuery, GetRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
      }
export function useGetRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRolesQuery, GetRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
        }
export type GetRolesQueryHookResult = ReturnType<typeof useGetRolesQuery>;
export type GetRolesLazyQueryHookResult = ReturnType<typeof useGetRolesLazyQuery>;
export type GetRolesQueryResult = Apollo.QueryResult<GetRolesQuery, GetRolesQueryVariables>;
export function refetchGetRolesQuery(variables?: GetRolesQueryVariables) {
      return { query: GetRolesDocument, variables: variables }
    }
export const GetCurrentEcnNumberDocument = gql`
    query getCurrentEcnNumber {
  getCurrentEcnNumber
}
    `;

/**
 * __useGetCurrentEcnNumberQuery__
 *
 * To run a query within a React component, call `useGetCurrentEcnNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentEcnNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentEcnNumberQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentEcnNumberQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentEcnNumberQuery, GetCurrentEcnNumberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentEcnNumberQuery, GetCurrentEcnNumberQueryVariables>(GetCurrentEcnNumberDocument, options);
      }
export function useGetCurrentEcnNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentEcnNumberQuery, GetCurrentEcnNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentEcnNumberQuery, GetCurrentEcnNumberQueryVariables>(GetCurrentEcnNumberDocument, options);
        }
export type GetCurrentEcnNumberQueryHookResult = ReturnType<typeof useGetCurrentEcnNumberQuery>;
export type GetCurrentEcnNumberLazyQueryHookResult = ReturnType<typeof useGetCurrentEcnNumberLazyQuery>;
export type GetCurrentEcnNumberQueryResult = Apollo.QueryResult<GetCurrentEcnNumberQuery, GetCurrentEcnNumberQueryVariables>;
export function refetchGetCurrentEcnNumberQuery(variables?: GetCurrentEcnNumberQueryVariables) {
      return { query: GetCurrentEcnNumberDocument, variables: variables }
    }
export const GetDraftEcnDocument = gql`
    query getDraftEcn($id: UUID!) {
  draftEcn(id: $id) {
    ...DraftEcn
  }
}
    ${DraftEcnFragmentDoc}`;

/**
 * __useGetDraftEcnQuery__
 *
 * To run a query within a React component, call `useGetDraftEcnQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDraftEcnQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDraftEcnQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDraftEcnQuery(baseOptions: Apollo.QueryHookOptions<GetDraftEcnQuery, GetDraftEcnQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDraftEcnQuery, GetDraftEcnQueryVariables>(GetDraftEcnDocument, options);
      }
export function useGetDraftEcnLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDraftEcnQuery, GetDraftEcnQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDraftEcnQuery, GetDraftEcnQueryVariables>(GetDraftEcnDocument, options);
        }
export type GetDraftEcnQueryHookResult = ReturnType<typeof useGetDraftEcnQuery>;
export type GetDraftEcnLazyQueryHookResult = ReturnType<typeof useGetDraftEcnLazyQuery>;
export type GetDraftEcnQueryResult = Apollo.QueryResult<GetDraftEcnQuery, GetDraftEcnQueryVariables>;
export function refetchGetDraftEcnQuery(variables: GetDraftEcnQueryVariables) {
      return { query: GetDraftEcnDocument, variables: variables }
    }
export const GetProductOriginsDocument = gql`
    query getProductOrigins {
  productOrigins {
    ...ProductOriginOption
  }
}
    ${ProductOriginOptionFragmentDoc}`;

/**
 * __useGetProductOriginsQuery__
 *
 * To run a query within a React component, call `useGetProductOriginsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductOriginsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductOriginsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProductOriginsQuery(baseOptions?: Apollo.QueryHookOptions<GetProductOriginsQuery, GetProductOriginsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductOriginsQuery, GetProductOriginsQueryVariables>(GetProductOriginsDocument, options);
      }
export function useGetProductOriginsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductOriginsQuery, GetProductOriginsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductOriginsQuery, GetProductOriginsQueryVariables>(GetProductOriginsDocument, options);
        }
export type GetProductOriginsQueryHookResult = ReturnType<typeof useGetProductOriginsQuery>;
export type GetProductOriginsLazyQueryHookResult = ReturnType<typeof useGetProductOriginsLazyQuery>;
export type GetProductOriginsQueryResult = Apollo.QueryResult<GetProductOriginsQuery, GetProductOriginsQueryVariables>;
export function refetchGetProductOriginsQuery(variables?: GetProductOriginsQueryVariables) {
      return { query: GetProductOriginsDocument, variables: variables }
    }
export const GetDraftsEcnsDocument = gql`
    query getDraftsEcns($options: DraftEcnListOptionsInputType) {
  draftsEcns(options: $options) {
    items {
      ...DraftEcnList
    }
    count
    page
  }
}
    ${DraftEcnListFragmentDoc}`;

/**
 * __useGetDraftsEcnsQuery__
 *
 * To run a query within a React component, call `useGetDraftsEcnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDraftsEcnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDraftsEcnsQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetDraftsEcnsQuery(baseOptions?: Apollo.QueryHookOptions<GetDraftsEcnsQuery, GetDraftsEcnsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDraftsEcnsQuery, GetDraftsEcnsQueryVariables>(GetDraftsEcnsDocument, options);
      }
export function useGetDraftsEcnsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDraftsEcnsQuery, GetDraftsEcnsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDraftsEcnsQuery, GetDraftsEcnsQueryVariables>(GetDraftsEcnsDocument, options);
        }
export type GetDraftsEcnsQueryHookResult = ReturnType<typeof useGetDraftsEcnsQuery>;
export type GetDraftsEcnsLazyQueryHookResult = ReturnType<typeof useGetDraftsEcnsLazyQuery>;
export type GetDraftsEcnsQueryResult = Apollo.QueryResult<GetDraftsEcnsQuery, GetDraftsEcnsQueryVariables>;
export function refetchGetDraftsEcnsQuery(variables?: GetDraftsEcnsQueryVariables) {
      return { query: GetDraftsEcnsDocument, variables: variables }
    }
export const GetPartsNumbersDocument = gql`
    query getPartsNumbers {
  partsNumbers {
    displayName
    externalId
  }
}
    `;

/**
 * __useGetPartsNumbersQuery__
 *
 * To run a query within a React component, call `useGetPartsNumbersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartsNumbersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartsNumbersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPartsNumbersQuery(baseOptions?: Apollo.QueryHookOptions<GetPartsNumbersQuery, GetPartsNumbersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartsNumbersQuery, GetPartsNumbersQueryVariables>(GetPartsNumbersDocument, options);
      }
export function useGetPartsNumbersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartsNumbersQuery, GetPartsNumbersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartsNumbersQuery, GetPartsNumbersQueryVariables>(GetPartsNumbersDocument, options);
        }
export type GetPartsNumbersQueryHookResult = ReturnType<typeof useGetPartsNumbersQuery>;
export type GetPartsNumbersLazyQueryHookResult = ReturnType<typeof useGetPartsNumbersLazyQuery>;
export type GetPartsNumbersQueryResult = Apollo.QueryResult<GetPartsNumbersQuery, GetPartsNumbersQueryVariables>;
export function refetchGetPartsNumbersQuery(variables?: GetPartsNumbersQueryVariables) {
      return { query: GetPartsNumbersDocument, variables: variables }
    }
export const CreateEcnDocument = gql`
    mutation createEcn($input: CreateEcnMutationInput!) {
  createEcn(input: $input) {
    ecn {
      id
    }
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type CreateEcnMutationFn = Apollo.MutationFunction<CreateEcnMutation, CreateEcnMutationVariables>;

/**
 * __useCreateEcnMutation__
 *
 * To run a mutation, you first call `useCreateEcnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEcnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEcnMutation, { data, loading, error }] = useCreateEcnMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEcnMutation(baseOptions?: Apollo.MutationHookOptions<CreateEcnMutation, CreateEcnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEcnMutation, CreateEcnMutationVariables>(CreateEcnDocument, options);
      }
export type CreateEcnMutationHookResult = ReturnType<typeof useCreateEcnMutation>;
export type CreateEcnMutationResult = Apollo.MutationResult<CreateEcnMutation>;
export type CreateEcnMutationOptions = Apollo.BaseMutationOptions<CreateEcnMutation, CreateEcnMutationVariables>;
export const UpdateEcnDocument = gql`
    mutation updateEcn($input: UpdateEcnMutationInput!) {
  updateEcn(input: $input) {
    ecn {
      id
    }
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type UpdateEcnMutationFn = Apollo.MutationFunction<UpdateEcnMutation, UpdateEcnMutationVariables>;

/**
 * __useUpdateEcnMutation__
 *
 * To run a mutation, you first call `useUpdateEcnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEcnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEcnMutation, { data, loading, error }] = useUpdateEcnMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEcnMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEcnMutation, UpdateEcnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEcnMutation, UpdateEcnMutationVariables>(UpdateEcnDocument, options);
      }
export type UpdateEcnMutationHookResult = ReturnType<typeof useUpdateEcnMutation>;
export type UpdateEcnMutationResult = Apollo.MutationResult<UpdateEcnMutation>;
export type UpdateEcnMutationOptions = Apollo.BaseMutationOptions<UpdateEcnMutation, UpdateEcnMutationVariables>;
export const EcnPricingTaskDocument = gql`
    mutation ecnPricingTask($input: PricingTaskMutationInput!) {
  ecnPricingTask(input: $input) {
    ecn {
      id
    }
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type EcnPricingTaskMutationFn = Apollo.MutationFunction<EcnPricingTaskMutation, EcnPricingTaskMutationVariables>;

/**
 * __useEcnPricingTaskMutation__
 *
 * To run a mutation, you first call `useEcnPricingTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEcnPricingTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ecnPricingTaskMutation, { data, loading, error }] = useEcnPricingTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEcnPricingTaskMutation(baseOptions?: Apollo.MutationHookOptions<EcnPricingTaskMutation, EcnPricingTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EcnPricingTaskMutation, EcnPricingTaskMutationVariables>(EcnPricingTaskDocument, options);
      }
export type EcnPricingTaskMutationHookResult = ReturnType<typeof useEcnPricingTaskMutation>;
export type EcnPricingTaskMutationResult = Apollo.MutationResult<EcnPricingTaskMutation>;
export type EcnPricingTaskMutationOptions = Apollo.BaseMutationOptions<EcnPricingTaskMutation, EcnPricingTaskMutationVariables>;
export const EcnForecastTaskDocument = gql`
    mutation ecnForecastTask($input: ForecastTaskMutationInput!) {
  ecnForecastTask(input: $input) {
    ecn {
      id
    }
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type EcnForecastTaskMutationFn = Apollo.MutationFunction<EcnForecastTaskMutation, EcnForecastTaskMutationVariables>;

/**
 * __useEcnForecastTaskMutation__
 *
 * To run a mutation, you first call `useEcnForecastTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEcnForecastTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ecnForecastTaskMutation, { data, loading, error }] = useEcnForecastTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEcnForecastTaskMutation(baseOptions?: Apollo.MutationHookOptions<EcnForecastTaskMutation, EcnForecastTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EcnForecastTaskMutation, EcnForecastTaskMutationVariables>(EcnForecastTaskDocument, options);
      }
export type EcnForecastTaskMutationHookResult = ReturnType<typeof useEcnForecastTaskMutation>;
export type EcnForecastTaskMutationResult = Apollo.MutationResult<EcnForecastTaskMutation>;
export type EcnForecastTaskMutationOptions = Apollo.BaseMutationOptions<EcnForecastTaskMutation, EcnForecastTaskMutationVariables>;
export const NewModCancelledPartsPurchaseTaskDocument = gql`
    mutation newModCancelledPartsPurchaseTask($input: NewModCancelledPartsPurchaseTaskMutationInput!) {
  newModCancelledPartsPurchaseTask(input: $input) {
    ecn {
      id
    }
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type NewModCancelledPartsPurchaseTaskMutationFn = Apollo.MutationFunction<NewModCancelledPartsPurchaseTaskMutation, NewModCancelledPartsPurchaseTaskMutationVariables>;

/**
 * __useNewModCancelledPartsPurchaseTaskMutation__
 *
 * To run a mutation, you first call `useNewModCancelledPartsPurchaseTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewModCancelledPartsPurchaseTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newModCancelledPartsPurchaseTaskMutation, { data, loading, error }] = useNewModCancelledPartsPurchaseTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNewModCancelledPartsPurchaseTaskMutation(baseOptions?: Apollo.MutationHookOptions<NewModCancelledPartsPurchaseTaskMutation, NewModCancelledPartsPurchaseTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NewModCancelledPartsPurchaseTaskMutation, NewModCancelledPartsPurchaseTaskMutationVariables>(NewModCancelledPartsPurchaseTaskDocument, options);
      }
export type NewModCancelledPartsPurchaseTaskMutationHookResult = ReturnType<typeof useNewModCancelledPartsPurchaseTaskMutation>;
export type NewModCancelledPartsPurchaseTaskMutationResult = Apollo.MutationResult<NewModCancelledPartsPurchaseTaskMutation>;
export type NewModCancelledPartsPurchaseTaskMutationOptions = Apollo.BaseMutationOptions<NewModCancelledPartsPurchaseTaskMutation, NewModCancelledPartsPurchaseTaskMutationVariables>;
export const NewModCancelPartsTaskDocument = gql`
    mutation newModCancelPartsTask($input: NewModCancelPartsTaskMutationInput!) {
  newModCancelPartsTask(input: $input) {
    ecn {
      id
    }
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type NewModCancelPartsTaskMutationFn = Apollo.MutationFunction<NewModCancelPartsTaskMutation, NewModCancelPartsTaskMutationVariables>;

/**
 * __useNewModCancelPartsTaskMutation__
 *
 * To run a mutation, you first call `useNewModCancelPartsTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewModCancelPartsTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newModCancelPartsTaskMutation, { data, loading, error }] = useNewModCancelPartsTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNewModCancelPartsTaskMutation(baseOptions?: Apollo.MutationHookOptions<NewModCancelPartsTaskMutation, NewModCancelPartsTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NewModCancelPartsTaskMutation, NewModCancelPartsTaskMutationVariables>(NewModCancelPartsTaskDocument, options);
      }
export type NewModCancelPartsTaskMutationHookResult = ReturnType<typeof useNewModCancelPartsTaskMutation>;
export type NewModCancelPartsTaskMutationResult = Apollo.MutationResult<NewModCancelPartsTaskMutation>;
export type NewModCancelPartsTaskMutationOptions = Apollo.BaseMutationOptions<NewModCancelPartsTaskMutation, NewModCancelPartsTaskMutationVariables>;
export const ProductSupportTaskDocument = gql`
    mutation productSupportTask($input: ProductSupportTaskMutationInput!) {
  productSupportTask(input: $input) {
    ecn {
      id
    }
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type ProductSupportTaskMutationFn = Apollo.MutationFunction<ProductSupportTaskMutation, ProductSupportTaskMutationVariables>;

/**
 * __useProductSupportTaskMutation__
 *
 * To run a mutation, you first call `useProductSupportTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductSupportTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productSupportTaskMutation, { data, loading, error }] = useProductSupportTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProductSupportTaskMutation(baseOptions?: Apollo.MutationHookOptions<ProductSupportTaskMutation, ProductSupportTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProductSupportTaskMutation, ProductSupportTaskMutationVariables>(ProductSupportTaskDocument, options);
      }
export type ProductSupportTaskMutationHookResult = ReturnType<typeof useProductSupportTaskMutation>;
export type ProductSupportTaskMutationResult = Apollo.MutationResult<ProductSupportTaskMutation>;
export type ProductSupportTaskMutationOptions = Apollo.BaseMutationOptions<ProductSupportTaskMutation, ProductSupportTaskMutationVariables>;
export const EcnMarkAsSeenDocument = gql`
    mutation ecnMarkAsSeen($input: EcnMarkAsSeenMutationInput!) {
  ecnMarkAsSeen(input: $input) {
    ecn {
      id
    }
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type EcnMarkAsSeenMutationFn = Apollo.MutationFunction<EcnMarkAsSeenMutation, EcnMarkAsSeenMutationVariables>;

/**
 * __useEcnMarkAsSeenMutation__
 *
 * To run a mutation, you first call `useEcnMarkAsSeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEcnMarkAsSeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ecnMarkAsSeenMutation, { data, loading, error }] = useEcnMarkAsSeenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEcnMarkAsSeenMutation(baseOptions?: Apollo.MutationHookOptions<EcnMarkAsSeenMutation, EcnMarkAsSeenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EcnMarkAsSeenMutation, EcnMarkAsSeenMutationVariables>(EcnMarkAsSeenDocument, options);
      }
export type EcnMarkAsSeenMutationHookResult = ReturnType<typeof useEcnMarkAsSeenMutation>;
export type EcnMarkAsSeenMutationResult = Apollo.MutationResult<EcnMarkAsSeenMutation>;
export type EcnMarkAsSeenMutationOptions = Apollo.BaseMutationOptions<EcnMarkAsSeenMutation, EcnMarkAsSeenMutationVariables>;
export const DraftEcnDocument = gql`
    mutation draftEcn($input: DraftEcnMutationInput!) {
  draftEcn(input: $input) {
    draftEcn {
      id
      data
      blueprints {
        ...DraftBlueprintEcn
      }
    }
    errors {
      ...Error
    }
  }
}
    ${DraftBlueprintEcnFragmentDoc}
${ErrorFragmentDoc}`;
export type DraftEcnMutationFn = Apollo.MutationFunction<DraftEcnMutation, DraftEcnMutationVariables>;

/**
 * __useDraftEcnMutation__
 *
 * To run a mutation, you first call `useDraftEcnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDraftEcnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [draftEcnMutation, { data, loading, error }] = useDraftEcnMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDraftEcnMutation(baseOptions?: Apollo.MutationHookOptions<DraftEcnMutation, DraftEcnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DraftEcnMutation, DraftEcnMutationVariables>(DraftEcnDocument, options);
      }
export type DraftEcnMutationHookResult = ReturnType<typeof useDraftEcnMutation>;
export type DraftEcnMutationResult = Apollo.MutationResult<DraftEcnMutation>;
export type DraftEcnMutationOptions = Apollo.BaseMutationOptions<DraftEcnMutation, DraftEcnMutationVariables>;
export const DeleteDraftEcnDocument = gql`
    mutation deleteDraftEcn($input: DeleteDraftEcnMutationInput!) {
  deleteDraftEcn(input: $input) {
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type DeleteDraftEcnMutationFn = Apollo.MutationFunction<DeleteDraftEcnMutation, DeleteDraftEcnMutationVariables>;

/**
 * __useDeleteDraftEcnMutation__
 *
 * To run a mutation, you first call `useDeleteDraftEcnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDraftEcnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDraftEcnMutation, { data, loading, error }] = useDeleteDraftEcnMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteDraftEcnMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDraftEcnMutation, DeleteDraftEcnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDraftEcnMutation, DeleteDraftEcnMutationVariables>(DeleteDraftEcnDocument, options);
      }
export type DeleteDraftEcnMutationHookResult = ReturnType<typeof useDeleteDraftEcnMutation>;
export type DeleteDraftEcnMutationResult = Apollo.MutationResult<DeleteDraftEcnMutation>;
export type DeleteDraftEcnMutationOptions = Apollo.BaseMutationOptions<DeleteDraftEcnMutation, DeleteDraftEcnMutationVariables>;
export const NotificateTasksForUserDocument = gql`
    mutation notificateTasksForUser($input: NotificateTasksForUserInput!) {
  notificateTasksForUser(input: $input) {
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type NotificateTasksForUserMutationFn = Apollo.MutationFunction<NotificateTasksForUserMutation, NotificateTasksForUserMutationVariables>;

/**
 * __useNotificateTasksForUserMutation__
 *
 * To run a mutation, you first call `useNotificateTasksForUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotificateTasksForUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notificateTasksForUserMutation, { data, loading, error }] = useNotificateTasksForUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNotificateTasksForUserMutation(baseOptions?: Apollo.MutationHookOptions<NotificateTasksForUserMutation, NotificateTasksForUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotificateTasksForUserMutation, NotificateTasksForUserMutationVariables>(NotificateTasksForUserDocument, options);
      }
export type NotificateTasksForUserMutationHookResult = ReturnType<typeof useNotificateTasksForUserMutation>;
export type NotificateTasksForUserMutationResult = Apollo.MutationResult<NotificateTasksForUserMutation>;
export type NotificateTasksForUserMutationOptions = Apollo.BaseMutationOptions<NotificateTasksForUserMutation, NotificateTasksForUserMutationVariables>;
export const UpdateEffectiveDateDocument = gql`
    mutation updateEffectiveDate($id: UUID!, $effectiveDate: Date!) {
  updateEffectiveDate(id: $id, effectiveDate: $effectiveDate) {
    ecn {
      id
    }
  }
}
    `;
export type UpdateEffectiveDateMutationFn = Apollo.MutationFunction<UpdateEffectiveDateMutation, UpdateEffectiveDateMutationVariables>;

/**
 * __useUpdateEffectiveDateMutation__
 *
 * To run a mutation, you first call `useUpdateEffectiveDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEffectiveDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEffectiveDateMutation, { data, loading, error }] = useUpdateEffectiveDateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      effectiveDate: // value for 'effectiveDate'
 *   },
 * });
 */
export function useUpdateEffectiveDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEffectiveDateMutation, UpdateEffectiveDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEffectiveDateMutation, UpdateEffectiveDateMutationVariables>(UpdateEffectiveDateDocument, options);
      }
export type UpdateEffectiveDateMutationHookResult = ReturnType<typeof useUpdateEffectiveDateMutation>;
export type UpdateEffectiveDateMutationResult = Apollo.MutationResult<UpdateEffectiveDateMutation>;
export type UpdateEffectiveDateMutationOptions = Apollo.BaseMutationOptions<UpdateEffectiveDateMutation, UpdateEffectiveDateMutationVariables>;
export const GetEcnTaskCommentsDocument = gql`
    query getEcnTaskComments($options: EcnTaskCommentListOptionsInputType) {
  taskComments(options: $options) {
    items {
      ...EcnTaskComment
    }
    count
  }
}
    ${EcnTaskCommentFragmentDoc}`;

/**
 * __useGetEcnTaskCommentsQuery__
 *
 * To run a query within a React component, call `useGetEcnTaskCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEcnTaskCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEcnTaskCommentsQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetEcnTaskCommentsQuery(baseOptions?: Apollo.QueryHookOptions<GetEcnTaskCommentsQuery, GetEcnTaskCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEcnTaskCommentsQuery, GetEcnTaskCommentsQueryVariables>(GetEcnTaskCommentsDocument, options);
      }
export function useGetEcnTaskCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEcnTaskCommentsQuery, GetEcnTaskCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEcnTaskCommentsQuery, GetEcnTaskCommentsQueryVariables>(GetEcnTaskCommentsDocument, options);
        }
export type GetEcnTaskCommentsQueryHookResult = ReturnType<typeof useGetEcnTaskCommentsQuery>;
export type GetEcnTaskCommentsLazyQueryHookResult = ReturnType<typeof useGetEcnTaskCommentsLazyQuery>;
export type GetEcnTaskCommentsQueryResult = Apollo.QueryResult<GetEcnTaskCommentsQuery, GetEcnTaskCommentsQueryVariables>;
export function refetchGetEcnTaskCommentsQuery(variables?: GetEcnTaskCommentsQueryVariables) {
      return { query: GetEcnTaskCommentsDocument, variables: variables }
    }
export const EcnTaskCommentDocument = gql`
    mutation ecnTaskComment($input: EcnTaskCommentMutationInput!) {
  ecnTaskComment(input: $input) {
    ecnTaskComment {
      ...EcnTaskComment
    }
    errors {
      ...Error
    }
  }
}
    ${EcnTaskCommentFragmentDoc}
${ErrorFragmentDoc}`;
export type EcnTaskCommentMutationFn = Apollo.MutationFunction<EcnTaskCommentMutation, EcnTaskCommentMutationVariables>;

/**
 * __useEcnTaskCommentMutation__
 *
 * To run a mutation, you first call `useEcnTaskCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEcnTaskCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ecnTaskCommentMutation, { data, loading, error }] = useEcnTaskCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEcnTaskCommentMutation(baseOptions?: Apollo.MutationHookOptions<EcnTaskCommentMutation, EcnTaskCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EcnTaskCommentMutation, EcnTaskCommentMutationVariables>(EcnTaskCommentDocument, options);
      }
export type EcnTaskCommentMutationHookResult = ReturnType<typeof useEcnTaskCommentMutation>;
export type EcnTaskCommentMutationResult = Apollo.MutationResult<EcnTaskCommentMutation>;
export type EcnTaskCommentMutationOptions = Apollo.BaseMutationOptions<EcnTaskCommentMutation, EcnTaskCommentMutationVariables>;
export const PartsArrivalTaskDocument = gql`
    mutation partsArrivalTask($input: PartsArrivalTaskMutationInput!) {
  partsArrivalTask(input: $input) {
    ecn {
      id
    }
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type PartsArrivalTaskMutationFn = Apollo.MutationFunction<PartsArrivalTaskMutation, PartsArrivalTaskMutationVariables>;

/**
 * __usePartsArrivalTaskMutation__
 *
 * To run a mutation, you first call `usePartsArrivalTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartsArrivalTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partsArrivalTaskMutation, { data, loading, error }] = usePartsArrivalTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartsArrivalTaskMutation(baseOptions?: Apollo.MutationHookOptions<PartsArrivalTaskMutation, PartsArrivalTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PartsArrivalTaskMutation, PartsArrivalTaskMutationVariables>(PartsArrivalTaskDocument, options);
      }
export type PartsArrivalTaskMutationHookResult = ReturnType<typeof usePartsArrivalTaskMutation>;
export type PartsArrivalTaskMutationResult = Apollo.MutationResult<PartsArrivalTaskMutation>;
export type PartsArrivalTaskMutationOptions = Apollo.BaseMutationOptions<PartsArrivalTaskMutation, PartsArrivalTaskMutationVariables>;
export const EcnFilesDocument = gql`
    mutation ecnFiles($ecnId: UUID!, $files: [Upload!]!) {
  ecnFiles(ecnId: $ecnId, files: $files) {
    ecnFiles {
      id
      file
    }
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type EcnFilesMutationFn = Apollo.MutationFunction<EcnFilesMutation, EcnFilesMutationVariables>;

/**
 * __useEcnFilesMutation__
 *
 * To run a mutation, you first call `useEcnFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEcnFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ecnFilesMutation, { data, loading, error }] = useEcnFilesMutation({
 *   variables: {
 *      ecnId: // value for 'ecnId'
 *      files: // value for 'files'
 *   },
 * });
 */
export function useEcnFilesMutation(baseOptions?: Apollo.MutationHookOptions<EcnFilesMutation, EcnFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EcnFilesMutation, EcnFilesMutationVariables>(EcnFilesDocument, options);
      }
export type EcnFilesMutationHookResult = ReturnType<typeof useEcnFilesMutation>;
export type EcnFilesMutationResult = Apollo.MutationResult<EcnFilesMutation>;
export type EcnFilesMutationOptions = Apollo.BaseMutationOptions<EcnFilesMutation, EcnFilesMutationVariables>;
export const DeleteEcnFileDocument = gql`
    mutation deleteEcnFile($id: UUID!) {
  deleteEcnFile(id: $id) {
    ok
    id
  }
}
    `;
export type DeleteEcnFileMutationFn = Apollo.MutationFunction<DeleteEcnFileMutation, DeleteEcnFileMutationVariables>;

/**
 * __useDeleteEcnFileMutation__
 *
 * To run a mutation, you first call `useDeleteEcnFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEcnFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEcnFileMutation, { data, loading, error }] = useDeleteEcnFileMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEcnFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEcnFileMutation, DeleteEcnFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEcnFileMutation, DeleteEcnFileMutationVariables>(DeleteEcnFileDocument, options);
      }
export type DeleteEcnFileMutationHookResult = ReturnType<typeof useDeleteEcnFileMutation>;
export type DeleteEcnFileMutationResult = Apollo.MutationResult<DeleteEcnFileMutation>;
export type DeleteEcnFileMutationOptions = Apollo.BaseMutationOptions<DeleteEcnFileMutation, DeleteEcnFileMutationVariables>;
export const EcnAnalyticsDocument = gql`
    query ecnAnalytics($filters: AnalyticsFilters!) {
  ecnAnalytics(filters: $filters) {
    byStatus {
      label
      count
    }
    accumulatedInProgressByEcn {
      label
      count
    }
    accumulatedWithoutEffectiveDateByEcn {
      label
      count
    }
    byEffectiveDate {
      label
      count
    }
    byWarrantyPriorityInProgress {
      label
      count
    }
    byWarrantyPriorityInProgress {
      label
      count
    }
    byWarrantyPriority {
      label
      count
    }
    byEffectiveDateAndSeasonPriority {
      label
      lowCount
      mediumCount
      highCount
    }
    byPartType {
      label
      count
    }
    accumulatedInProgress {
      min
      max
      avg
    }
    accumulatedWithoutEffectiveDate {
      min
      max
      avg
    }
    bySeasonPriority {
      label
      count
    }
  }
}
    `;

/**
 * __useEcnAnalyticsQuery__
 *
 * To run a query within a React component, call `useEcnAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEcnAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEcnAnalyticsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useEcnAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<EcnAnalyticsQuery, EcnAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EcnAnalyticsQuery, EcnAnalyticsQueryVariables>(EcnAnalyticsDocument, options);
      }
export function useEcnAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EcnAnalyticsQuery, EcnAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EcnAnalyticsQuery, EcnAnalyticsQueryVariables>(EcnAnalyticsDocument, options);
        }
export type EcnAnalyticsQueryHookResult = ReturnType<typeof useEcnAnalyticsQuery>;
export type EcnAnalyticsLazyQueryHookResult = ReturnType<typeof useEcnAnalyticsLazyQuery>;
export type EcnAnalyticsQueryResult = Apollo.QueryResult<EcnAnalyticsQuery, EcnAnalyticsQueryVariables>;
export function refetchEcnAnalyticsQuery(variables: EcnAnalyticsQueryVariables) {
      return { query: EcnAnalyticsDocument, variables: variables }
    }
export const CancelEcnDocument = gql`
    mutation cancelEcn($id: UUID!) {
  cancelEcn(id: $id) {
    ok
  }
}
    `;
export type CancelEcnMutationFn = Apollo.MutationFunction<CancelEcnMutation, CancelEcnMutationVariables>;

/**
 * __useCancelEcnMutation__
 *
 * To run a mutation, you first call `useCancelEcnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelEcnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelEcnMutation, { data, loading, error }] = useCancelEcnMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelEcnMutation(baseOptions?: Apollo.MutationHookOptions<CancelEcnMutation, CancelEcnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelEcnMutation, CancelEcnMutationVariables>(CancelEcnDocument, options);
      }
export type CancelEcnMutationHookResult = ReturnType<typeof useCancelEcnMutation>;
export type CancelEcnMutationResult = Apollo.MutationResult<CancelEcnMutation>;
export type CancelEcnMutationOptions = Apollo.BaseMutationOptions<CancelEcnMutation, CancelEcnMutationVariables>;
export const SetEcnFavoriteDocument = gql`
    mutation setEcnFavorite($id: UUID!, $favorite: Boolean!) {
  setEcnFavorite(id: $id, favorite: $favorite) {
    ok
  }
}
    `;
export type SetEcnFavoriteMutationFn = Apollo.MutationFunction<SetEcnFavoriteMutation, SetEcnFavoriteMutationVariables>;

/**
 * __useSetEcnFavoriteMutation__
 *
 * To run a mutation, you first call `useSetEcnFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetEcnFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setEcnFavoriteMutation, { data, loading, error }] = useSetEcnFavoriteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      favorite: // value for 'favorite'
 *   },
 * });
 */
export function useSetEcnFavoriteMutation(baseOptions?: Apollo.MutationHookOptions<SetEcnFavoriteMutation, SetEcnFavoriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetEcnFavoriteMutation, SetEcnFavoriteMutationVariables>(SetEcnFavoriteDocument, options);
      }
export type SetEcnFavoriteMutationHookResult = ReturnType<typeof useSetEcnFavoriteMutation>;
export type SetEcnFavoriteMutationResult = Apollo.MutationResult<SetEcnFavoriteMutation>;
export type SetEcnFavoriteMutationOptions = Apollo.BaseMutationOptions<SetEcnFavoriteMutation, SetEcnFavoriteMutationVariables>;
export const MakeEcnEffectiveDocument = gql`
    mutation makeEcnEffective($input: MakeEcnEffectiveMutationInput!) {
  makeEcnEffective(input: $input) {
    ecn {
      id
    }
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type MakeEcnEffectiveMutationFn = Apollo.MutationFunction<MakeEcnEffectiveMutation, MakeEcnEffectiveMutationVariables>;

/**
 * __useMakeEcnEffectiveMutation__
 *
 * To run a mutation, you first call `useMakeEcnEffectiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeEcnEffectiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeEcnEffectiveMutation, { data, loading, error }] = useMakeEcnEffectiveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMakeEcnEffectiveMutation(baseOptions?: Apollo.MutationHookOptions<MakeEcnEffectiveMutation, MakeEcnEffectiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MakeEcnEffectiveMutation, MakeEcnEffectiveMutationVariables>(MakeEcnEffectiveDocument, options);
      }
export type MakeEcnEffectiveMutationHookResult = ReturnType<typeof useMakeEcnEffectiveMutation>;
export type MakeEcnEffectiveMutationResult = Apollo.MutationResult<MakeEcnEffectiveMutation>;
export type MakeEcnEffectiveMutationOptions = Apollo.BaseMutationOptions<MakeEcnEffectiveMutation, MakeEcnEffectiveMutationVariables>;
export const CreateEcnListExportDocument = gql`
    mutation createEcnListExport($filters: EcnListType2OptionsInputType2) {
  createEcnListExport(filters: $filters) {
    job {
      id
    }
  }
}
    `;
export type CreateEcnListExportMutationFn = Apollo.MutationFunction<CreateEcnListExportMutation, CreateEcnListExportMutationVariables>;

/**
 * __useCreateEcnListExportMutation__
 *
 * To run a mutation, you first call `useCreateEcnListExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEcnListExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEcnListExportMutation, { data, loading, error }] = useCreateEcnListExportMutation({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCreateEcnListExportMutation(baseOptions?: Apollo.MutationHookOptions<CreateEcnListExportMutation, CreateEcnListExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEcnListExportMutation, CreateEcnListExportMutationVariables>(CreateEcnListExportDocument, options);
      }
export type CreateEcnListExportMutationHookResult = ReturnType<typeof useCreateEcnListExportMutation>;
export type CreateEcnListExportMutationResult = Apollo.MutationResult<CreateEcnListExportMutation>;
export type CreateEcnListExportMutationOptions = Apollo.BaseMutationOptions<CreateEcnListExportMutation, CreateEcnListExportMutationVariables>;
export const ValidExternalIdDocument = gql`
    query validExternalId($externalId: String!, $ignoreId: UUID) {
  validExternalId(externalId: $externalId, ignoreId: $ignoreId)
}
    `;

/**
 * __useValidExternalIdQuery__
 *
 * To run a query within a React component, call `useValidExternalIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidExternalIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidExternalIdQuery({
 *   variables: {
 *      externalId: // value for 'externalId'
 *      ignoreId: // value for 'ignoreId'
 *   },
 * });
 */
export function useValidExternalIdQuery(baseOptions: Apollo.QueryHookOptions<ValidExternalIdQuery, ValidExternalIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidExternalIdQuery, ValidExternalIdQueryVariables>(ValidExternalIdDocument, options);
      }
export function useValidExternalIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidExternalIdQuery, ValidExternalIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidExternalIdQuery, ValidExternalIdQueryVariables>(ValidExternalIdDocument, options);
        }
export type ValidExternalIdQueryHookResult = ReturnType<typeof useValidExternalIdQuery>;
export type ValidExternalIdLazyQueryHookResult = ReturnType<typeof useValidExternalIdLazyQuery>;
export type ValidExternalIdQueryResult = Apollo.QueryResult<ValidExternalIdQuery, ValidExternalIdQueryVariables>;
export function refetchValidExternalIdQuery(variables: ValidExternalIdQueryVariables) {
      return { query: ValidExternalIdDocument, variables: variables }
    }
export const EcnHistoryDocument = gql`
    query ecnHistory($id: UUID!, $options: HistoricalEcnListOptionsInputType) {
  ecnHistory(id: $id, options: $options) {
    count
    items {
      ...HistoricalEcn
    }
  }
}
    ${HistoricalEcnFragmentDoc}`;

/**
 * __useEcnHistoryQuery__
 *
 * To run a query within a React component, call `useEcnHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useEcnHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEcnHistoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useEcnHistoryQuery(baseOptions: Apollo.QueryHookOptions<EcnHistoryQuery, EcnHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EcnHistoryQuery, EcnHistoryQueryVariables>(EcnHistoryDocument, options);
      }
export function useEcnHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EcnHistoryQuery, EcnHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EcnHistoryQuery, EcnHistoryQueryVariables>(EcnHistoryDocument, options);
        }
export type EcnHistoryQueryHookResult = ReturnType<typeof useEcnHistoryQuery>;
export type EcnHistoryLazyQueryHookResult = ReturnType<typeof useEcnHistoryLazyQuery>;
export type EcnHistoryQueryResult = Apollo.QueryResult<EcnHistoryQuery, EcnHistoryQueryVariables>;
export function refetchEcnHistoryQuery(variables: EcnHistoryQueryVariables) {
      return { query: EcnHistoryDocument, variables: variables }
    }
export const EcnHistoryDiffDocument = gql`
    query ecnHistoryDiff($id: UUID!) {
  ecnHistoryDiff(id: $id) {
    changes {
      field
      old
      new
      verboseField
    }
    changedFields
    date
    updatedBy {
      ...MinimalUser
    }
  }
}
    ${MinimalUserFragmentDoc}`;

/**
 * __useEcnHistoryDiffQuery__
 *
 * To run a query within a React component, call `useEcnHistoryDiffQuery` and pass it any options that fit your needs.
 * When your component renders, `useEcnHistoryDiffQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEcnHistoryDiffQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEcnHistoryDiffQuery(baseOptions: Apollo.QueryHookOptions<EcnHistoryDiffQuery, EcnHistoryDiffQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EcnHistoryDiffQuery, EcnHistoryDiffQueryVariables>(EcnHistoryDiffDocument, options);
      }
export function useEcnHistoryDiffLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EcnHistoryDiffQuery, EcnHistoryDiffQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EcnHistoryDiffQuery, EcnHistoryDiffQueryVariables>(EcnHistoryDiffDocument, options);
        }
export type EcnHistoryDiffQueryHookResult = ReturnType<typeof useEcnHistoryDiffQuery>;
export type EcnHistoryDiffLazyQueryHookResult = ReturnType<typeof useEcnHistoryDiffLazyQuery>;
export type EcnHistoryDiffQueryResult = Apollo.QueryResult<EcnHistoryDiffQuery, EcnHistoryDiffQueryVariables>;
export function refetchEcnHistoryDiffQuery(variables: EcnHistoryDiffQueryVariables) {
      return { query: EcnHistoryDiffDocument, variables: variables }
    }
export const GetEcnsDocument = gql`
    query getEcns($options: EcnListType2OptionsInputType2) {
  ecns(options: $options) {
    items {
      ...EcnList
    }
    count
    page
  }
}
    ${EcnListFragmentDoc}`;

/**
 * __useGetEcnsQuery__
 *
 * To run a query within a React component, call `useGetEcnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEcnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEcnsQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetEcnsQuery(baseOptions?: Apollo.QueryHookOptions<GetEcnsQuery, GetEcnsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEcnsQuery, GetEcnsQueryVariables>(GetEcnsDocument, options);
      }
export function useGetEcnsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEcnsQuery, GetEcnsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEcnsQuery, GetEcnsQueryVariables>(GetEcnsDocument, options);
        }
export type GetEcnsQueryHookResult = ReturnType<typeof useGetEcnsQuery>;
export type GetEcnsLazyQueryHookResult = ReturnType<typeof useGetEcnsLazyQuery>;
export type GetEcnsQueryResult = Apollo.QueryResult<GetEcnsQuery, GetEcnsQueryVariables>;
export function refetchGetEcnsQuery(variables?: GetEcnsQueryVariables) {
      return { query: GetEcnsDocument, variables: variables }
    }